webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	module.exports = __webpack_require__(326);


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(327);
	__webpack_require__(937);
	
	// Load site config THEN bootstrap the app
	angular.lazy('app').resolve(['$q', '$http', function ($q, $http) {
	    return $http.get(window.ushahidi.apiUrl + '/config').then(function (response) {
	        window.ushahidi.bootstrapConfig = response.data.results;
	    });
	}]).loading(function () {
	    // Show loading
	    angular.element(document.getElementById('bootstrap-loading')).removeClass('hidden');
	}).error(function () {
	    // Show error
	    angular.element(document.getElementById('bootstrap-error')).removeClass('hidden');
	}).done(function () {
	    // Hide loading
	    angular.element(document.getElementById('bootstrap-loading')).addClass('hidden');
	}).bootstrap();

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(328);
	__webpack_require__(330);
	__webpack_require__(332);
	__webpack_require__(334);
	__webpack_require__(335);
	__webpack_require__(336);
	__webpack_require__(338);
	__webpack_require__(339);
	__webpack_require__(341);
	__webpack_require__(342);
	__webpack_require__(344);
	__webpack_require__(346);
	__webpack_require__(347);
	__webpack_require__(348);
	window.d3 = __webpack_require__(350); // Required for nvd3
	__webpack_require__(351);
	__webpack_require__(364);
	__webpack_require__(366);
	
	// Load ushahidi modules
	__webpack_require__(367);
	__webpack_require__(678);
	__webpack_require__(828);
	
	// Load platform-pattern-library CSS
	__webpack_require__(887);
	__webpack_require__(915);
	__webpack_require__(922);
	
	// Stub ngRaven module incase its not configured
	angular.module('ngRaven', []);
	
	// Make sure we have a window.ushahidi object
	window.ushahidi = window.ushahidi || {};
	
	// this 'environment variable' will be set within the gulpfile
	var backendUrl = window.ushahidi.backendUrl = (window.ushahidi.backendUrl || ("undefined")).replace(/\/$/, ''),
	    intercomAppId = window.ushahidi.intercomAppId = window.ushahidi.intercomAppId || '',
	    appStoreId = window.ushahidi.appStoreId = window.ushahidi.appStoreId || '',
	    apiUrl = window.ushahidi.apiUrl = backendUrl + '/api/v3',
	    claimedAnonymousScopes = ['posts', 'media', 'forms', 'api', 'tags', 'savedsearches', 'sets', 'users', 'stats', 'layers', 'config', 'messages', 'notifications', 'webhooks', 'contacts', 'roles', 'permissions', 'csv', 'tos'];
	
	angular.module('app', ['checklist-model', 'monospaced.elastic', 'ngRoute', 'ngResource', 'LocalStorageModule', 'pascalprecht.translate', 'ui.bootstrap.pagination', 'angular-datepicker', 'angular.filter', 'ng-showdown', 'ngGeolocation', 'nvd3', 'angular-cache', 'ngRaven', 'ushahidi.common', 'ushahidi.main', 'ushahidi.settings']).constant('CONST', {
	    BACKEND_URL: backendUrl,
	    API_URL: apiUrl,
	    INTERCOM_APP_ID: intercomAppId,
	    APP_STORE_ID: appStoreId,
	    DEFAULT_LOCALE: 'en_US',
	    OAUTH_CLIENT_ID: 'ushahidiui',
	    OAUTH_CLIENT_SECRET: '35e7f0bca957836d05ca0492211b0ac707671261',
	    CLAIMED_ANONYMOUS_SCOPES: claimedAnonymousScopes,
	    CLAIMED_USER_SCOPES: claimedAnonymousScopes.concat('dataproviders'),
	    MAPBOX_API_KEY: window.ushahidi.mapboxApiKey || 'pk.eyJ1IjoidXNoYWhpZGkiLCJhIjoiY2lxaXUzeHBvMDdndmZ0bmVmOWoyMzN6NiJ9.CX56ZmZJv0aUsxvH5huJBw', // Default OSS mapbox api key
	    TOS_RELEASE_DATE: new Date(window.ushahidi.tosReleaseDate).toJSON() ? new Date(window.ushahidi.tosReleaseDate) : false // Date in UTC
	}).config(['$compileProvider', function ($compileProvider) {
	    $compileProvider.debugInfoEnabled(false);
	}]).factory('_', function () {
	    return __webpack_require__(929);
	}).factory('d3', function () {
	    return window.d3;
	}).factory('URI', function () {
	    return __webpack_require__(930);
	}).factory('Leaflet', function () {
	    var L = __webpack_require__(934);
	    // Load leaflet plugins here too
	    __webpack_require__(935);
	    __webpack_require__(936);
	    return L;
	}).factory('moment', function () {
	    return __webpack_require__(549);
	}).factory('BootstrapConfig', ['_', function (_) {
	    return window.ushahidi.bootstrapConfig ? _.indexBy(window.ushahidi.bootstrapConfig, 'id') : { map: {}, site: {}, features: {} };
	}]).run(function () {
	    // Once bootstrapped, show the app
	    angular.element(document.getElementById('bootstrap-app')).removeClass('hidden');
	    angular.element(document.getElementById('bootstrap-loading')).addClass('hidden');
	});

/***/ }),
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(352);
	__webpack_require__(353);
	__webpack_require__(354);
	__webpack_require__(355);
	__webpack_require__(356);
	// Models
	// Uncomment as needed
	__webpack_require__(357);
	// require('nvd3/src/models/boxPlot');
	// require('nvd3/src/models/boxPlotChart');
	// require('nvd3/src/models/bullet');
	// require('nvd3/src/models/bulletChart');
	// require('nvd3/src/models/candlestickBar');
	// require('nvd3/src/models/cumulativeLineChart');
	// require('nvd3/src/models/discreteBar');
	// require('nvd3/src/models/discreteBarChart');
	// require('nvd3/src/models/distribution');
	// require('nvd3/src/models/forceDirectedGraph');
	// require('nvd3/src/models/furiousLegend');
	// require('nvd3/src/models/historicalBar');
	// require('nvd3/src/models/historicalBarChart');
	__webpack_require__(358);
	__webpack_require__(359);
	__webpack_require__(360);
	// require('nvd3/src/models/linePlusBarChart');
	// require('nvd3/src/models/lineWithFocusChart');
	// require('nvd3/src/models/multiBar');
	// require('nvd3/src/models/multiBarChart');
	__webpack_require__(361);
	__webpack_require__(362);
	// require('nvd3/src/models/multiChart');
	// require('nvd3/src/models/ohlcBar');
	// require('nvd3/src/models/parallelCoordinates');
	// require('nvd3/src/models/pie');
	// require('nvd3/src/models/pieChart');
	__webpack_require__(363);
	// require('nvd3/src/models/scatterChart');
	// require('nvd3/src/models/sparkline');
	// require('nvd3/src/models/sparklinePlus');
	// require('nvd3/src/models/stackedArea');
	// require('nvd3/src/models/stackedAreaChart');
	// require('nvd3/src/models/sunburst');
	// require('nvd3/src/models/sunburstChart');

/***/ }),
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('ushahidi.common', ['ushahidi.common.adaptive-input', 'ushahidi.common.dropdown', 'ushahidi.common.modal', 'ushahidi.common.custom-on-change', 'ushahidi.user-profile'])
	
	// Authentication
	.service('Authentication', __webpack_require__(368)).service('Registration', __webpack_require__(369)).service('Session', __webpack_require__(370)).service('PasswordReset', __webpack_require__(406)).service('TermsOfService', __webpack_require__(407)).directive('login', __webpack_require__(408)).directive('register', __webpack_require__(410)).directive('passwordReset', __webpack_require__(413)).directive('passwordResetConfirm', __webpack_require__(415)).directive('termsOfService', __webpack_require__(417)).config(__webpack_require__(419)).run(__webpack_require__(420))
	
	// Notifications
	.service('Notify', __webpack_require__(421)).service('SliderService', __webpack_require__(460)).directive('ushSlider', __webpack_require__(461))
	
	// API Endpoint wrappers
	.service('ConfigEndpoint', __webpack_require__(463)).service('UserEndpoint', __webpack_require__(464)).service('FormEndpoint', __webpack_require__(465)).service('FormAttributeEndpoint', __webpack_require__(466)).service('FormRoleEndpoint', __webpack_require__(467)).service('FormStageEndpoint', __webpack_require__(468)).service('TagEndpoint', __webpack_require__(469)).service('RoleEndpoint', __webpack_require__(470)).service('WebhookEndpoint', __webpack_require__(471)).service('PermissionEndpoint', __webpack_require__(472)).service('DataProviderEndpoint', __webpack_require__(473)).service('MediaEndpoint', __webpack_require__(474)).service('MessageEndpoint', __webpack_require__(475)).service('PostEndpoint', __webpack_require__(476)).service('CollectionEndpoint', __webpack_require__(477)).service('SavedSearchEndpoint', __webpack_require__(478)).service('DataImportEndpoint', __webpack_require__(479)).service('ContactEndpoint', __webpack_require__(480)).service('NotificationEndpoint', __webpack_require__(481)).service('TermsOfServiceEndpoint', __webpack_require__(482))
	
	// Other services
	.service('ViewHelper', __webpack_require__(483)).service('Features', __webpack_require__(484)).service('Util', __webpack_require__(485)).service('Maps', __webpack_require__(486)).service('Geocoding', __webpack_require__(487)).service('Languages', __webpack_require__(488)).service('IconManager', __webpack_require__(489)).service('FontAwesomeIcons', __webpack_require__(490)).service('MainsheetService', __webpack_require__(491)).service('ModalService', __webpack_require__(492)).service('TranslationService', __webpack_require__(493))
	// Controllers
	.controller('navigation', __webpack_require__(494)).controller('PageMetadata', __webpack_require__(495)).controller('intercom', __webpack_require__(496))
	
	// Global directives
	.directive('publishSelector', __webpack_require__(497)).directive('listingToolbar', __webpack_require__(499)).directive('iconPicker', __webpack_require__(501)).directive('colorPicker', __webpack_require__(503)).directive('firstTimeConfig', __webpack_require__(505)).directive('ushMainsheetContainer', __webpack_require__(507)).directive('ushModalContainer', __webpack_require__(509)).directive('modalBody', __webpack_require__(511)).directive('layoutClass', __webpack_require__(512)).directive('embedOnly', __webpack_require__(513)).directive('ushLogo', __webpack_require__(514)).directive('filterSearchbar', __webpack_require__(516)).directive('filterRole', __webpack_require__(518)).directive('overflowToggle', __webpack_require__(520)).directive('focus', __webpack_require__(521)).directive('modeBar', __webpack_require__(522)).directive('fileUpload', __webpack_require__(525)).directive('roleSelector', __webpack_require__(527)).directive('addCategory', __webpack_require__(529)).directive('languageSwitch', __webpack_require__(531))
	
	// Event actions
	.constant('EVENT', {
	    ACTIONS: {
	        EDIT: 'edit',
	        DELETE: 'delete'
	    }
	}).config(__webpack_require__(533)).run(__webpack_require__(535)).config(__webpack_require__(537)).config(__webpack_require__(538)).run(__webpack_require__(545))
	// Use language settings from config
	.run(__webpack_require__(546)).run(['$templateCache', function ($templateCache) {
	    $templateCache.put('common/directives/mode-bar/ushahidi-logo.html', __webpack_require__(665));
	}]);
	
	// Load submodules
	__webpack_require__(666);
	__webpack_require__(667);
	__webpack_require__(668);
	__webpack_require__(670);
	__webpack_require__(671);

/***/ }),
/* 368 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$rootScope', '$http', '$q', 'Util', 'CONST', 'Session', 'RoleEndpoint', 'UserEndpoint', '_', 'ModalService', function ($rootScope, $http, $q, Util, CONST, Session, RoleEndpoint, UserEndpoint, _, ModalService) {
	
	    // check whether we have initially an old access_token and userId
	    // and assume that, if yes, we are still loggedin
	    var loginStatus = !!Session.getSessionDataEntry('accessToken') && !!Session.getSessionDataEntry('userId'),
	        setToLoginState = function setToLoginState(userData) {
	        Session.setSessionDataEntries({
	            userId: userData.id,
	            realname: userData.realname,
	            email: userData.email,
	            role: userData.role,
	            permissions: userData.permissions,
	            gravatar: userData.gravatar,
	            language: userData.language
	        });
	        loginStatus = true;
	    },
	        setToLogoutState = function setToLogoutState() {
	        Session.clearSessionData();
	        UserEndpoint.invalidateCache();
	        loginStatus = false;
	    };
	
	    return {
	
	        login: function login(username, password) {
	            var payload = {
	                username: username,
	                password: password,
	                grant_type: 'password',
	                client_id: CONST.OAUTH_CLIENT_ID,
	                client_secret: CONST.OAUTH_CLIENT_SECRET,
	                scope: CONST.CLAIMED_USER_SCOPES.join(' ')
	            },
	                deferred = $q.defer(),
	                handleRequestError = function handleRequestError() {
	                deferred.reject();
	                setToLogoutState();
	                $rootScope.$broadcast('event:authentication:login:failed');
	            },
	                handleRequestSuccess = function handleRequestSuccess(authResponse) {
	                var accessToken = authResponse.data.access_token;
	                Session.setSessionDataEntry('accessToken', accessToken);
	
	                $http.get(Util.apiUrl('/users/me')).then(function (userDataResponse) {
	                    RoleEndpoint.query({ name: userDataResponse.data.role }).$promise.then(function (results) {
	                        userDataResponse.data.permissions = !_.isEmpty(results) ? results[0].permissions : [];
	                        return userDataResponse;
	                    }).catch(function (errors) {
	                        userDataResponse.data.permissions = [];
	                        return userDataResponse;
	                    }).finally(function () {
	                        setToLoginState(userDataResponse.data);
	                        $rootScope.$broadcast('event:authentication:login:succeeded');
	                        deferred.resolve();
	                    });
	                }, handleRequestError);
	            };
	
	            $http.post(Util.url('/oauth/token'), payload).then(handleRequestSuccess, handleRequestError);
	
	            return deferred.promise;
	        },
	
	        logout: function logout(silent) {
	            //TODO: ASK THE BACKEND TO DESTROY SESSION
	
	            setToLogoutState();
	            if (!silent) {
	                $rootScope.$broadcast('event:authentication:logout:succeeded');
	            }
	        },
	
	        getLoginStatus: function getLoginStatus() {
	            return loginStatus;
	        },
	
	        openLogin: function openLogin() {
	
	            ModalService.openTemplate('<login></login>', 'nav.login', false, false, false, false);
	        }
	    };
	}];

/***/ }),
/* 369 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$rootScope', '$http', '$q', 'Util', '$location', 'ModalService', function ($rootScope, $http, $q, Util, $location, ModalService) {
	
	    return {
	
	        register: function register(realname, email, password) {
	            var payload = {
	                realname: realname,
	                email: email,
	                password: password
	            },
	                deferred = $q.defer(),
	                handleRequestError = function handleRequestError(response) {
	                deferred.reject(response);
	                $rootScope.$broadcast('event:registration:register:failed');
	            },
	                handleRequestSuccess = function handleRequestSuccess(response) {
	                $rootScope.$broadcast('event:registration:register:succeeded');
	                deferred.resolve(response);
	            };
	
	            $http.post(Util.apiUrl('/register'), payload).then(handleRequestSuccess, handleRequestError);
	
	            return deferred.promise;
	        },
	
	        openRegister: function openRegister() {
	            ModalService.openTemplate('<register></register>', 'nav.register', false, false, true, false);
	        }
	    };
	}];

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _keys = __webpack_require__(371);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = ['localStorageService', function (localStorageService) {
	
	    this.clearedSessionData = {
	        userId: undefined,
	        realname: undefined,
	        email: undefined,
	        accessToken: undefined,
	        role: undefined,
	        permissions: undefined,
	        loginPath: undefined,
	        gravatar: undefined
	    };
	
	    this.sessionData = angular.copy(this.clearedSessionData);
	
	    var that = this;
	
	    var loadSessionData = function loadSessionData() {
	        var newSessionData = {};
	        (0, _keys2.default)(that.sessionData).forEach(function (key) {
	            newSessionData[key] = localStorageService.get(key);
	        });
	        that.sessionData = newSessionData;
	    };
	
	    var setSessionDataEntries = function setSessionDataEntries(entries) {
	        (0, _keys2.default)(entries).forEach(function (key) {
	            localStorageService.set(key, entries[key]);
	        });
	        var newSessionData = angular.extend({}, that.sessionData, entries);
	        that.sessionData = newSessionData;
	    };
	
	    var setSessionDataEntry = function setSessionDataEntry(key, value) {
	        that.sessionData[key] = value;
	        localStorageService.set(key, value);
	    };
	
	    var getSessionDataEntry = function getSessionDataEntry(key) {
	        return that.sessionData[key];
	    };
	
	    var getSessionData = function getSessionData() {
	        return that.sessionData;
	    };
	
	    var clearSessionData = function clearSessionData() {
	        (0, _keys2.default)(that.sessionData).forEach(function (key) {
	            localStorageService.remove(key);
	        });
	        that.sessionData = angular.copy(that.clearedSessionData);
	    };
	
	    // load already saved session data from earlierer session
	    // from local storage when session service is intialized loadSessionData();
	    loadSessionData();
	
	    return {
	        setSessionDataEntry: setSessionDataEntry,
	        setSessionDataEntries: setSessionDataEntries,
	        getSessionDataEntry: getSessionDataEntry,
	        getSessionData: getSessionData,
	        clearSessionData: clearSessionData
	    };
	}];

/***/ }),
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$http', 'Util', 'ModalService', function ($http, Util, ModalService) {
	
	    return {
	
	        reset: function reset(email) {
	            var payload = {
	                email: email
	            };
	
	            return $http.post(Util.apiUrl('/passwordreset'), payload);
	        },
	
	        resetConfirm: function resetConfirm(token, password) {
	            var payload = {
	                token: token,
	                password: password
	            };
	
	            return $http.post(Util.apiUrl('/passwordreset/confirm'), payload);
	        },
	
	        openReset: function openReset() {
	            ModalService.openTemplate('<password-reset></password-reset>', 'nav.forgotyourpassword', false, false, true, false);
	        },
	
	        openResetConfirm: function openResetConfirm(scope) {
	            ModalService.openTemplate('<password-reset-confirm></password-reset-confirm>', 'nav.resetpassword', false, scope, true, false);
	        }
	    };
	}];

/***/ }),
/* 407 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$http', 'Util', 'ModalService', 'Session', 'TermsOfServiceEndpoint', 'CONST', '$rootScope', '$q', 'Notify', 'moment', function ($http, Util, ModalService, Session, TermsOfServiceEndpoint, CONST, $rootScope, $q, Notify, moment) {
	
	    return {
	
	        getTosEntry: function getTosEntry() {
	            // If no TOS date definied, just skip
	            if (!CONST.TOS_RELEASE_DATE) {
	                return $q.resolve(true);
	            }
	
	            return TermsOfServiceEndpoint.get().$promise.then(function (tosEntry) {
	                return tosCheck(tosEntry);
	            });
	        }
	    };
	
	    function tosCheck(tosEntry) {
	        var deferred = $q.defer();
	
	        // If the tos agreement date is after the to the release date, then resolve
	        // Otherwise (the tos agreement is before the release date or the user has never signed) We need to show the ToS modal
	        if (tosEntry.results.length && moment(tosEntry.results[0].agreement_date).isAfter(CONST.TOS_RELEASE_DATE)) {
	            deferred.resolve();
	        } else {
	            Notify.confirmTos().then(function () {
	                deferred.resolve();
	            }, function () {
	                deferred.reject();
	            });
	        }
	
	        return deferred.promise;
	    }
	}];

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = Login;
	
	Login.$inject = [];
	function Login() {
	    return {
	        restrict: 'E',
	        scope: {},
	        controller: LoginController,
	        template: __webpack_require__(409)
	    };
	}
	LoginController.$inject = ['$scope', 'Authentication', 'PasswordReset', '$location', 'ConfigEndpoint'];
	function LoginController($scope, Authentication, PasswordReset, $location, ConfigEndpoint) {
	    $scope.email = '';
	    $scope.password = '';
	    $scope.failed = false;
	    $scope.processing = false;
	    $scope.loginSubmit = loginSubmit;
	    $scope.cancel = cancel;
	    $scope.forgotPassword = forgotPassword;
	    $scope.showCancel = false;
	
	    activate();
	
	    function activate() {
	        // If we're already logged in
	        if (Authentication.getLoginStatus()) {
	            $scope.$parent.closeModal();
	        }
	
	        ConfigEndpoint.get({ id: 'site' }, function (site) {
	            $scope.showCancel = !site.private;
	        });
	    }
	
	    function clearLoginForm() {
	        $scope.failed = true;
	        $scope.processing = false;
	        $scope.email = '';
	        $scope.password = '';
	    }
	
	    function cancel() {
	        clearLoginForm();
	        $scope.$parent.closeModal();
	    }
	
	    function finishedLogin() {
	        $scope.failed = false;
	        $scope.processing = false;
	        $scope.$parent.closeModal();
	    }
	
	    function loginSubmit(email, password) {
	        $scope.processing = true;
	
	        Authentication.login(email, password).then(finishedLogin, clearLoginForm);
	    }
	
	    function forgotPassword() {
	        PasswordReset.openReset();
	    }
	}

/***/ }),
/* 409 */
/***/ (function(module, exports) {

	module.exports = "<form ng-submit=\"loginSubmit(email, password)\" name=loginForm> <div class=modal-body> <div class=\"alert error login-failed\" role=alert ng-show=failed> <p translate>notify.login.failed</p> </div> <div class=form-field> <label for=email translate>user.email</label> <input type=text id=email ng-model=email ng-disabled=processing placeholder=name@domain.com required> </div> <div class=form-field> <label for=password translate>user.password</label> <input id=password type=password ng-model=password ng-disabled=processing required> <p><a ng-click=forgotPassword() translate>nav.forgotyourpassword</a></p> </div> </div> <div class=modal-actions> <div class=form-field> <button type=button class=button-link ng-click=cancel() ng-show=showCancel translate=app.cancel>Cancel</button> <button type=submit class=button-alpha ng-disabled=\"loginForm.$invalid || processing\" translate=nav.login>Login</button> </div> </div> </form> ";

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = RegisterDirective;
	
	RegisterDirective.$inject = [];
	function RegisterDirective() {
	    return {
	        restrict: 'E',
	        scope: {},
	        controller: RegisterController,
	        template: __webpack_require__(411)
	    };
	}
	RegisterController.$inject = ['$scope', '$translate', 'Authentication', 'Registration', 'Notify'];
	function RegisterController($scope, $translate, Authentication, Registration, Notify) {
	    $scope.failed = false;
	    $scope.processing = false;
	    $scope.realname = '';
	    $scope.email = '';
	    $scope.password = '';
	
	    $scope.registerSubmit = registerSubmit;
	    $scope.cancel = cancel;
	
	    activate();
	
	    function activate() {
	        // If we're already logged in
	        if (Authentication.getLoginStatus()) {
	            $scope.$parent.closeModal();
	        }
	    }
	
	    function registerSubmit() {
	        $scope.processing = true;
	
	        Registration.register($scope.realname, $scope.email, $scope.password).then(registerSuccess, registerFailed);
	    }
	
	    function registerSuccess() {
	        $scope.failed = false;
	        $scope.processing = false;
	
	        Notify.success('notify.register.success');
	        Authentication.openLogin();
	    }
	
	    function registerFailed(errorResponse) {
	        $scope.failed = true;
	        $scope.processing = false;
	
	        angular.forEach(errorResponse.data.errors, function (error) {
	            if (!error.source || !error.source.pointer) {
	                return;
	            }
	
	            // @todo parse jsonpath properly
	            var index = error.source.pointer.replace('/', '');
	            if ($scope.form[index]) {
	                $scope.form[index].$setValidity(error.title, false);
	                // Clear validation on next change
	                $scope.form[index].$validators[error.title] = function () {
	                    return true;
	                };
	            }
	        });
	
	        Notify.apiErrors(errorResponse);
	    }
	
	    function cancel() {
	        $scope.$parent.closeModal();
	    }
	}

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<form name=form ng-submit=registerSubmit()> <div class=modal-body> <div class=\"alert error register-failed\" role=alert ng-show=failed> <p translate>notify.register.failed</p> </div> <div class=form-field ng-class=\"{ 'error': form.full_name.$invalid && form.full_name.$dirty, 'success': form.full_name.$valid }\"> <label class=input-label for=full_name translate>user.full_name</label> <input id=full_name name=full_name type=text ng-disabled=state.processing placeholder=\"{{ 'user_create.full_name'|translate }}\" ng-maxlength=150 ng-model=realname required> <div ng-repeat=\"(error, value) in form.full_name.$error\" ng-show=form.full_name.$dirty class=\"alert error\"> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#warning></use> </svg> <span translate=\"{{'user.valid.full_name.' + error}}\" translate-default={{error}}></span> </div> </div> <div class=form-field ng-class=\"{ 'success': !form.email.$invalid && form.email.$dirty, 'error' : form.email.$invalid && form.email.$dirty}\"> <label for=email class=input-label translate>user.email</label> <input type=email id=email name=email ng-model=email ng-disabled=processing ng-maxlength=150 required> <div ng-repeat=\"(error, value) in form.email.$error\" ng-show=form.email.$dirty class=\"alert error\"> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#warning></use> </svg> <span translate=\"{{'user.valid.email.' + error}}\" translate-default={{error}}></span> </div> </div> <div class=form-field ng-class=\"{ 'success': !form.password.$invalid && form.password.$dirty, 'error' : form.password.$invalid && form.password.$dirty}\"> <label class=input-label for=password translate>user.password</label> <input id=password type=password name=password ng-minlength=7 ng-maxlength=72 ng-model=password ng-disabled=processing required> <div ng-repeat=\"(error, value) in form.password.$error\" ng-show=form.password.$dirty class=\"alert error\"> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#warning></use> </svg> <span translate=\"{{'user.valid.password.' + error}}\" translate-default={{error}}></span> </div> </div> </div> <div class=modal-actions> <div class=form-field> <button type=button class=button-link ng-click=cancel() translate=app.cancel>Cancel</button> <button type=submit class=button-alpha ng-disabled=\"form.$invalid || processing\" translate=nav.register>Sign up</button> </div> </div> </form> ";

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "44fed91f69f09c95876314a8e23f311e.svg";

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = PasswordResetDirective;
	
	PasswordResetDirective.$inject = [];
	function PasswordResetDirective() {
	    return {
	        restrict: 'E',
	        scope: true,
	        controller: PasswordResetController,
	        template: __webpack_require__(414)
	    };
	}
	PasswordResetController.$inject = ['$scope', 'PasswordReset', 'Authentication'];
	function PasswordResetController($scope, PasswordReset, Authentication) {
	    $scope.processing = false;
	    $scope.email = '';
	
	    $scope.submit = submit;
	    $scope.cancel = cancel;
	
	    activate();
	
	    function activate() {
	        // If we're already logged in
	        if (Authentication.getLoginStatus()) {
	            $scope.$parent.closeModal();
	        }
	    }
	
	    $scope.processing = false;
	
	    function resetDone() {
	        $scope.processing = false;
	        PasswordReset.openResetConfirm();
	    }
	
	    function submit() {
	        $scope.processing = true;
	
	        PasswordReset.reset($scope.email).finally(resetDone);
	    }
	
	    function cancel() {
	        $scope.$parent.closeModal();
	    }
	}

/***/ }),
/* 414 */
/***/ (function(module, exports) {

	module.exports = "<div class=modal-body> <form class=panel-body name=form ng-submit=submit()> <p translate>user.passwordreset_instructions</p> <div class=form-field> <label for=email class=input-label translate> user.email </label> <input type=text id=email name=email ng-model=email ng-disabled=processing required> </div> <div class=form-field> <button type=button class=button-link ng-click=cancel() translate=app.cancel>Cancel</button> <button type=submit class=button-primary ng-disabled=\"form.$invalid || processing\"> <div class=loading ng-show=processing><div class=line></div><div class=line></div><div class=line></div></div> <span translate>nav.resetmypassword</span> </button> </div> </form> </div> ";

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = PasswordResetConfirmDirective;
	
	PasswordResetConfirmDirective.$inject = [];
	function PasswordResetConfirmDirective() {
	    return {
	        restrict: 'E',
	        scope: true,
	        controller: PasswordResetConfirmController,
	        template: __webpack_require__(416)
	    };
	}
	PasswordResetConfirmController.$inject = ['$scope', '$translate', 'PasswordReset', 'Authentication', 'Notify'];
	function PasswordResetConfirmController($scope, $translate, PasswordReset, Authentication, Notify) {
	    $scope.failed = false;
	    $scope.processing = false;
	    $scope.token = $scope.token || '';
	    $scope.hasToken = false;
	    $scope.password = '';
	
	    $scope.submit = submit;
	    $scope.cancel = cancel;
	
	    activate();
	
	    function activate() {
	        // If we're already logged in
	        if (Authentication.getLoginStatus()) {
	            $scope.$parent.closeModal();
	        }
	        $scope.hasToken = !!$scope.token;
	    }
	
	    function resetSuccess() {
	        $scope.processing = false;
	
	        Notify.notify('notify.passwordreset.success');
	        Authentication.openLogin();
	    }
	
	    function resetFailed(errorResponse) {
	        $scope.failed = true;
	        $scope.processing = false;
	
	        Notify.apiErrors(errorResponse);
	    }
	
	    function submit() {
	        $scope.processing = true;
	
	        PasswordReset.resetConfirm($scope.token, $scope.password).then(resetSuccess, resetFailed);
	    }
	
	    function cancel() {
	        $scope.$parent.closeModal();
	    }
	}

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=modal-body> <form class=panel-body name=form ng-submit=submit()> <div class=\"alert error register-failed\" ng-show=failed> <p translate>notify.passwordreset.failed</p> </div> <div class=form-field ng-show=!hasToken> <p translate>user.passwordreset_confirm_instructions</p> <label for=token class=input-label translate> user.token </label> <input type=text id=token name=token ng-model=token ng-disabled=processing required> </div> <div class=form-field ng-class=\"{ 'success': !form.password.$invalid && form.password.$dirty, 'error' : form.password.$invalid && form.password.$dirty}\"> <label class=input-label for=password translate>user.new_password</label> <input id=password type=password name=password ng-minlength=7 ng-maxlength=72 ng-model=password ng-disabled=processing required> <div ng-repeat=\"(error, value) in form.password.$error\" ng-show=form.password.$dirty class=\"alert error\"> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#warning></use> </svg> <span translate=\"{{'user.valid.password.' + error}}\" translate-default={{error}}></span> </div> </div> <div class=form-field> <button type=button class=button-link ng-click=cancel() translate=app.cancel>Cancel</button> <button type=submit class=button-primary ng-disabled=\"form.$invalid || processing\"> <div class=loading ng-show=processing><div class=line></div><div class=line></div><div class=line></div></div> <span translate>nav.resetpassword</span> </button> </div> </form> </div> ";

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = TermsOfServiceDirective;
	
	TermsOfServiceDirective.$inject = [];
	function TermsOfServiceDirective() {
	    return {
	        restrict: 'E',
	        scope: {},
	        controller: TosController,
	        template: __webpack_require__(418)
	    };
	}
	
	TosController.$inject = ['$scope', 'Authentication', 'TermsOfService', 'ModalService', 'TermsOfServiceEndpoint', 'Session', 'CONST'];
	function TosController($scope, Authentication, TermsOfService, ModalService, TermsOfServiceEndpoint, Session, CONST) {
	    $scope.terms = {
	        accept: false
	    };
	
	    $scope.tosSubmit = function () {
	        if (!$scope.terms.accept) {
	            return;
	        }
	
	        TermsOfServiceEndpoint.save({ tos_version_date: CONST.TOS_RELEASE_DATE }).$promise.then(function (tosSessionData) {
	            // Don't really need this if, but it's just a backup so that you can't access the site if tos is not set properly
	            if (tosSessionData.agreement_date) {
	                $scope.$parent.confirm();
	            }
	        });
	    };
	}

/***/ }),
/* 418 */
/***/ (function(module, exports) {

	module.exports = "<div class=modal-body> <form class=panel-body name=form ng-submit=tosSubmit()> <h2 translate=terms_of_service.title>Ushahidi Terms of Service</h2> <p translate=terms_of_service.terms_of_service>We have updated our <a href=https://www.ushahidi.com/terms-of-service target=_blank>Terms and Conditions</a> and <a href=https://www.ushahidi.com/privacy-policy target=_blank>Privacy Policy</a>. Please review these documents carefully and accept the terms in order to continue to use Ushahidi's services.</p> <div class=\"form-field radio\"> <label> <input type=checkbox ng-model=terms.accept ng-value=true translate=terms_of_service.agree required> I agree to Ushahidi's Terms of Service. </label> </div> <div class=modal-actions> <div class=form-field> <button type=submit class=button-alpha ng-disabled=form.$invalid translate=terms_of_service.accept_and_continue>Accept and Continue</button> </div> </div> </form> </div> ";

/***/ }),
/* 419 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = AuthInterceptorConfig;
	
	AuthInterceptorConfig.$inject = ['$provide', '$httpProvider'];
	function AuthInterceptorConfig($provide, $httpProvider) {
	    // register the interceptor as a service
	    $provide.factory('authInterceptor', AuthInterceptor);
	    $httpProvider.interceptors.push('authInterceptor');
	}
	
	AuthInterceptor.$inject = ['$rootScope', '$injector', '$q', 'CONST', 'Session', '_'];
	function AuthInterceptor($rootScope, $injector, $q, CONST, Session, _) {
	    var ongoingRequest = null;
	
	    return {
	        request: request,
	        responseError: responseError
	    };
	
	    function getClientCredsToken(config) {
	        var deferred = $q.defer(),
	            payload = {
	            grant_type: 'client_credentials',
	            client_id: CONST.OAUTH_CLIENT_ID,
	            client_secret: CONST.OAUTH_CLIENT_SECRET,
	            scope: CONST.CLAIMED_ANONYMOUS_SCOPES.join(' ')
	        };
	
	        function handleRequestSuccess(authResponse) {
	            var accessToken = authResponse.data.access_token;
	            Session.setSessionDataEntry('accessToken', accessToken);
	            config.headers.Authorization = 'Bearer ' + accessToken;
	            deferred.resolve(config);
	        }
	
	        $injector.invoke(['$http', 'Util', function ($http, Util) {
	            // $http is already constructed at the time and you may
	            // use it, just as any other service registered in your
	            // app module and modules on which app depends on.
	            // http://stackoverflow.com/a/19954545/567126
	            $http.post(Util.url('/oauth/token'), payload).then(handleRequestSuccess, deferred.reject);
	        }]);
	
	        return deferred.promise;
	    }
	
	    function request(config) {
	        var deferred = $q.defer();
	
	        if (_.has(config, 'params') && config.params.ignore403) {
	            delete config.params.ignore403;
	            config.ignorable = true;
	        }
	
	        if (config.url.indexOf(CONST.API_URL) === -1) {
	            deferred.resolve(config);
	            return deferred.promise;
	        }
	
	        var accessToken = Session.getSessionDataEntry('accessToken');
	
	        if (accessToken !== undefined && accessToken !== null) {
	            // if we already have an accessToken,
	            // we will set it straight ahead
	            // and resolve the promise for the config hash
	            config.headers.Authorization = 'Bearer ' + accessToken;
	            deferred.resolve(config);
	        } else {
	            // otherwise, we will ask the backend
	            // via the client credentials oauth flow
	            // for an anonymous accessToken
	            // (for some resources, of course,
	            // this authorization level is not enough
	            // and a 403 or 401 will be thrown
	            // which results in showing the login page)
	
	            // BUT only if there's no ongoing request in this interceptor
	            // (otherwise N simultaneous queries will produce N token requests)
	            if (!ongoingRequest) {
	                ongoingRequest = getClientCredsToken(config);
	                ongoingRequest.then(deferred.resolve, deferred.reject);
	                ongoingRequest.finally(function () {
	                    ongoingRequest = null; // clean up
	                });
	            } else {
	                // In case another request is already ongoing, extract its
	                // authentication header once its resolved, and apply it to
	                // the request currently being intercepted
	                ongoingRequest.then(function (otherConfig) {
	                    config.headers.Authorization = otherConfig.headers.Authorization;
	                    deferred.resolve(config);
	                }, deferred.reject);
	            }
	        }
	        return deferred.promise;
	    }
	
	    function responseError(rejection) {
	        var deferred = $q.defer();
	
	        // When a request is rejected there are
	        // a few possible reasons. If its a 401
	        // either our token expired, or we didn't have one.
	        if (rejection.status === 401) {
	            $injector.invoke(['Authentication', '$http', function (Authentication, $http) {
	                // Check if were were logged in
	                if (Authentication.getLoginStatus()) {
	                    // If we were, trigger an unauthorized
	                    // event and show the login page
	                    $rootScope.$broadcast('event:unauthorized');
	                    deferred.reject(rejection);
	                } else {
	                    // If we weren't logged in to start with
	                    // we probably just need to get a new token
	                    getClientCredsToken(rejection.config).then(function (config) {
	                        deferred.resolve($http(config));
	                    }, deferred.reject);
	                }
	            }]);
	            // If its a 403 we've got a token, but it can't get us what we needed
	        } else if (rejection.status === 403) {
	            // In the short term, we will handle failures for
	            // associated entities - for example posts that contain unviewable tags -
	            // we will ignore the error. In future this will be rectified under issue:
	            // https://github.com/ushahidi/platform/issues/793
	            if (!rejection.config.ignorable) {
	                // Trigger a forbidden event and show an error page
	                $rootScope.$broadcast('event:forbidden');
	            }
	            deferred.reject(rejection);
	            // For anything else, just forward the rejection
	        } else {
	            deferred.reject(rejection);
	        }
	        return deferred.promise;
	    }
	}

/***/ }),
/* 420 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = AuthenticationEvents;
	
	AuthenticationEvents.$inject = ['$rootScope', '$location', 'Authentication', 'Session', '_', '$route', 'TermsOfService'];
	function AuthenticationEvents($rootScope, $location, Authentication, Session, _, $route, TermsOfService) {
	    $rootScope.currentUser = null;
	    $rootScope.loggedin = false;
	
	    activate();
	
	    function activate() {
	        if (Authentication.getLoginStatus()) {
	            doLogin(false, true);
	        }
	    }
	
	    function loadSessionData() {
	        $rootScope.currentUser = Session.getSessionData();
	    }
	
	    function doLogin(redirect, noReload) {
	        TermsOfService.getTosEntry().then(function () {
	            loadSessionData();
	            $rootScope.loggedin = true;
	            if (redirect) {
	                $location.url(redirect);
	            }
	            noReload || $route.reload();
	        });
	    }
	
	    function doLogout(redirect) {
	        $rootScope.currentUser = null;
	        $rootScope.loggedin = false;
	        if (redirect) {
	            $location.url(redirect);
	        }
	        $route.reload();
	    }
	
	    // todo: move to service
	    $rootScope.hasManagePermission = function () {
	        return $rootScope.isAdmin() ? true : (($rootScope.currentUser || {}).permissions || {}).length > 0;
	    };
	
	    // todo: move to service
	    $rootScope.hasManageSettingsPermission = function () {
	        return $rootScope.isAdmin() ? true : _.intersection(($rootScope.currentUser || {}).permissions, ['Manage Users', 'Manage Settings', 'Bulk Data Import']).length > 0;
	    };
	
	    // todo: move to service
	    $rootScope.hasPermission = function (permission) {
	        return $rootScope.isAdmin() ? true : _.contains(($rootScope.currentUser || {}).permissions, permission);
	    };
	
	    // todo: move to service
	    $rootScope.isAdmin = function () {
	        return ($rootScope.currentUser || {}).role === 'admin';
	    };
	
	    $rootScope.$on('event:authentication:login:succeeded', function () {
	        doLogin(Session.getSessionDataEntry('loginPath'));
	    });
	
	    $rootScope.$on('event:authentication:logout:succeeded', function () {
	        doLogout();
	    });
	
	    // Don't think this is needed. We should already be logged out before this event
	    // $rootScope.$on('event:authentication:login:failed', function () {
	    //     doLogout();
	    // });
	
	    $rootScope.$on('event:unauthorized', function () {
	        if ($location.url() !== '/login') {
	            Session.setSessionDataEntry('loginPath', $location.url());
	        }
	        Authentication.logout(true);
	        doLogout();
	        Authentication.openLogin();
	    });
	
	    $rootScope.$on('event:forbidden', function () {
	        if (Authentication.getLoginStatus()) {
	            // We're logged in hit forbidden page
	            $location.url('/forbidden');
	        } else {
	            // We're logged out, redirect to login
	            if ($location.url() !== '/login') {
	                Session.setSessionDataEntry('loginPath', $location.url());
	                // We're logged in hit forbidden page
	                $location.url('/forbidden');
	            }
	            Authentication.openLogin();
	        }
	    });
	}

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof2 = __webpack_require__(422);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = Notify;
	
	var scope;
	var iconicSprite = __webpack_require__(412);
	Notify.$inject = ['_', '$q', '$rootScope', '$translate', 'SliderService', 'ModalService'];
	function Notify(_, $q, $rootScope, $translate, SliderService, ModalService) {
	    return {
	        notify: notify,
	        error: error,
	        errors: errors,
	        errorsPretranslated: errorsPretranslated,
	        apiErrors: apiErrors,
	        success: success,
	        confirm: confirm,
	        confirmModal: confirmModal,
	        confirmDelete: confirmDelete,
	        limit: limit,
	        confirmTos: confirmTos
	    };
	
	    function notify(message, translateValues) {
	        function showSlider(message) {
	            SliderService.openTemplate('<p>' + message + '</p>');
	        }
	
	        $translate(message, translateValues).then(showSlider, showSlider);
	    }
	
	    function error(errorText, translateValues) {
	        function showSlider(errorText) {
	            SliderService.openTemplate('<p>' + errorText + '</p>', 'warning', 'error', null, false);
	        }
	
	        $translate(errorText, translateValues).then(showSlider, showSlider);
	    }
	
	    function errorsPretranslated(errorTexts) {
	        var scope = getScope();
	        scope.errors = errorTexts;
	        SliderService.openTemplate(__webpack_require__(458), 'warning', 'error', scope, false);
	    }
	
	    function errors(errorTexts, translateValues) {
	        var scope = getScope();
	
	        $translate(errorTexts, translateValues).then(function (errors) {
	            scope.errors = errors;
	            SliderService.openTemplate(__webpack_require__(458), 'warning', 'error', scope, false);
	        });
	    }
	
	    function apiErrors(errorResponse) {
	        var scope = getScope();
	        scope.errors = _.pluck(errorResponse.data && errorResponse.data.errors, 'message');
	
	        if (!scope.errors) {
	            return;
	        }
	
	        SliderService.openTemplate(__webpack_require__(458), 'warning', 'error', scope, false);
	    }
	
	    function success(successText, translateValues) {
	        function showSlider(successText) {
	            SliderService.openTemplate('<p>' + successText + '</p>', 'thumb-up', 'confirmation');
	        }
	
	        $translate(successText, translateValues).then(showSlider, showSlider);
	    }
	
	    function confirm(confirmText, translateValues) {
	        var deferred = $q.defer();
	
	        var scope = getScope();
	        scope.cancel = function () {
	            deferred.reject();
	            SliderService.close();
	        };
	        scope.confirm = function () {
	            deferred.resolve();
	            SliderService.close();
	        };
	
	        function showSlider(confirmText) {
	            scope.confirmText = confirmText;
	            SliderService.openTemplate('<p>{{ confirmText }}</p>' + '    <button class="button-flat" ng-click="$parent.cancel()" translate="message.button.cancel">Cancel</button>' + '    <button class="button-beta button-flat" ng-click="$parent.confirm()" translate="message.button.default">OK</button>', false, false, scope, false, false);
	        }
	
	        $translate(confirmText, translateValues).then(showSlider, showSlider);
	
	        return deferred.promise;
	    }
	
	    function confirmModal(confirmText, translateValues) {
	        var deferred = $q.defer();
	
	        var scope = getScope();
	        scope.cancel = function () {
	            deferred.reject();
	            ModalService.close();
	        };
	        scope.confirm = function () {
	            deferred.resolve();
	            ModalService.close();
	        };
	
	        function showSlider(confirmText) {
	            scope.confirmText = confirmText;
	            ModalService.openTemplate('<div class="form-field">' + '<p><i translate>notify.default.proceed_warning</i></p>' + '    <button class="button-flat" ng-click="$parent.cancel()" translate="message.button.cancel">Cancel</button>' + '    <button class="button-beta button-flat" ng-click="$parent.confirm()" translate="message.button.default">OK</button>' + '</div>', confirmText, false, scope, false, false);
	        }
	
	        $translate(confirmText, translateValues).then(showSlider, showSlider);
	
	        return deferred.promise;
	    }
	
	    function confirmTos() {
	        var deferred = $q.defer();
	        var scope = getScope();
	
	        scope.confirm = function () {
	            deferred.resolve();
	            ModalService.close();
	        };
	
	        ModalService.openTemplate('<terms-of-service></terms-of-service>', ' ', false, scope, false, false);
	
	        return deferred.promise;
	    }
	
	    function confirmDelete(confirmText, confirmWarningText, translateValues) {
	        var deferred = $q.defer();
	        var scope = getScope();
	
	        if ((typeof confirmWarningText === 'undefined' ? 'undefined' : (0, _typeof3.default)(confirmWarningText)) === 'object') {
	            translateValues = confirmWarningText;
	            confirmWarningText = false;
	        }
	
	        $translate(confirmText, translateValues).then(show, show);
	
	        function show(confirmText) {
	            scope.confirmText = confirmText;
	            scope.confirmWarningText = confirmWarningText || 'notify.default.proceed_warning';
	            // If modal is already open?
	            if (ModalService.getState()) {
	                scope.cancel = function () {
	                    deferred.reject();
	                    SliderService.close();
	                };
	                scope.confirm = function () {
	                    deferred.resolve();
	                    SliderService.close();
	                };
	                // Open in slider
	                SliderService.openTemplate('<p>{{ confirmText }}</p>' + '<p><i translate="{{confirmWarningText}}"></i></p>' + '    <button class="button-flat" ng-click="$parent.cancel()" translate="message.button.cancel">Cancel</button>' + '    <button class="button-destructive button-flat" ng-click="$parent.confirm()">' + '    <svg class="iconic"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + iconicSprite + '#trash"></use></svg>' + '    <span translate="app.delete">Delete</span>' + '    </button>', false, false, scope, false, false);
	            } else {
	                scope.cancel = function () {
	                    deferred.reject();
	                    ModalService.close();
	                };
	                scope.confirm = function () {
	                    deferred.resolve();
	                    ModalService.close();
	                };
	                // Otherwise confirm in modal
	                ModalService.openTemplate('<div class="form-field">' + '<p><i translate="{{confirmWarningText}}"></i></p>' + '    <button class="button-beta button-flat" ng-click="$parent.cancel()">Cancel</button>' + '    <button class="button-destructive button-flat" ng-click="$parent.confirm()">' + '    <svg class="iconic"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + iconicSprite + '#trash"></use></svg>' + '    <span translate="app.delete">Delete</span>' + '    </button>' + '</div>', confirmText, false, scope, false, false);
	            }
	        }
	
	        return deferred.promise;
	    }
	
	    function limit(message, translateValues) {
	        var scope = getScope();
	
	        $translate(message, translateValues).then(showSlider, showSlider);
	
	        function showSlider(message) {
	            scope.message = message;
	            SliderService.openTemplate(__webpack_require__(459), 'warning', 'error', scope, true, false);
	        }
	    }
	
	    function getScope() {
	        if (scope) {
	            scope.$destroy();
	        }
	        scope = $rootScope.$new();
	        return scope;
	    }
	}

/***/ }),
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */
/***/ (function(module, exports) {

	module.exports = "<p ng-repeat=\"error in errors\"> {{error}} </p> ";

/***/ }),
/* 459 */
/***/ (function(module, exports) {

	module.exports = "<p>{{ message }}</p> <div class=form-field> <a class=\"button button-beta button-flat\" ng-click=close() href=/settings/plan translate>limit.upgrade</a> <button class=\"button-flat message-trigger\" ng-click=close() translate=message.button.dismiss> Dismiss </button> </div> ";

/***/ }),
/* 460 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = SliderService;
	
	SliderService.$inject = ['$rootScope', '$q', '$templateRequest'];
	function SliderService($rootScope, $q, $templateRequest) {
	    var deferredOpen = $q.defer(),
	        deferredClose = $q.defer();
	
	    return {
	        open: openTemplate,
	        openTemplate: openTemplate,
	        close: close,
	        onOpen: onOpen,
	        onClose: onClose
	    };
	
	    function openTemplate(template, icon, iconClass, scope, closeOnTimeout, showCloseButton, closeOnNavigate) {
	        deferredOpen.promise.then(function () {
	            $rootScope.$emit('slider:open', template, icon, iconClass, scope, closeOnTimeout, showCloseButton, closeOnNavigate);
	        });
	    }
	
	    function close() {
	        deferredClose.promise.then(function () {
	            $rootScope.$emit('slider:close');
	        });
	    }
	
	    function onOpen(callback, scope) {
	        var handler = $rootScope.$on('slider:open', callback);
	        if (scope) {
	            scope.$on('$destroy', handler);
	        }
	        deferredOpen.resolve();
	    }
	
	    function onClose(callback, scope) {
	        var handler = $rootScope.$on('slider:close', callback);
	        if (scope) {
	            scope.$on('$destroy', handler);
	        }
	        deferredClose.resolve();
	    }
	}

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Ushahidi Angular Confirmation Message directive
	 * Based on the Angular Bootstrap Modal directive
	 */
	module.exports = Slider;
	Slider.$inject = ['$timeout', '$compile', 'SliderService', 'ModalService'];
	function Slider($timeout, $compile, SliderService, ModalService) {
	    return {
	        restrict: 'E',
	        template: __webpack_require__(462),
	        scope: {
	            insideModal: '@?'
	        },
	        link: SliderLink
	    };
	
	    function SliderLink($scope, $element) {
	        $scope.classVisible = false;
	        $scope.icon = false;
	        $scope.iconClass = {};
	        $scope.showCloseButton = true;
	        $scope.closeOnNavigate = false;
	        // Callbacks
	        $scope.closeButtonClicked = closeButtonClicked;
	
	        var templateScope;
	        var closeTimeout = null;
	        var iconPath = __webpack_require__(412);
	        // content element
	        var sliderContent = $element.find('slider-content');
	
	        // Run clean up on scope destroy (probably never happens)
	        $scope.$on('$destroy', cleanUp);
	
	        // Close slider on navigation if feature enabled
	        $scope.$on('$locationChangeStart', navigateClose);
	
	        // Bind to modal service open/close events
	        SliderService.onOpen(open, $scope);
	        SliderService.onClose(close, $scope);
	
	        function open(ev, template, icon, iconClass, scope, closeOnTimeout, showCloseButton, closeOnNavigate) {
	            // If we're inside a modal, modal must be open
	            if (typeof $scope.insideModal !== 'undefined' !== ModalService.getState()) {
	                // Ignore, the other slider can open
	                return;
	            }
	
	            // Clean up any previous content
	            cleanUp();
	            // Create new scope and keep it to destroy when done with the
	            templateScope = scope ? scope.$new() : $scope.$new();
	
	            // Inject close function onto template scope
	            templateScope.close = close;
	
	            sliderContent.html(template);
	            $compile(sliderContent)(templateScope);
	
	            $scope.icon = icon ? iconPath + '#' + icon : icon;
	            $scope.iconClass = {};
	            if (iconClass) {
	                $scope.iconClass[iconClass] = true;
	            }
	
	            // If showCloseButton isn't passed, default to true
	            if (typeof showCloseButton === 'undefined') {
	                $scope.showCloseButton = true;
	            } else {
	                $scope.showCloseButton = showCloseButton;
	            }
	
	            // If closeOnNavigate isn't passed, default to false
	            if (typeof closeOnNavigate === 'undefined') {
	                $scope.closeOnNavigate = false;
	            } else {
	                $scope.closeOnNavigate = closeOnNavigate;
	            }
	
	            // Default closeOnTimeout to true
	            closeOnTimeout = typeof closeOnTimeout !== 'undefined' ? closeOnTimeout : true;
	
	            // .. and finally open the slider!!
	            $scope.classVisible = true;
	            // Set timeout to close in 5s
	            if (closeOnTimeout) {
	                closeTimeout = $timeout(close, 5000);
	            }
	        }
	
	        function close() {
	            // If we're inside a modal *and* the modal isn't open
	            if ($scope.insideModal && !ModalService.getState()) {
	                // Ignore, the other slider can open
	                return;
	            }
	            // @todo fade out
	            $scope.classVisible = false;
	            cleanUp();
	        }
	
	        function cleanUp() {
	            if (templateScope) {
	                templateScope.$destroy();
	            }
	            if (closeTimeout) {
	                $timeout.cancel(closeTimeout);
	            }
	            sliderContent.html('');
	        }
	
	        function navigateClose() {
	            if ($scope.closeOnNavigate) {
	                close();
	            }
	        }
	
	        function closeButtonClicked(context) {
	            close();
	        }
	    }
	}

/***/ }),
/* 462 */
/***/ (function(module, exports) {

	module.exports = "<div class=message ng-class=\"{'active': classVisible}\"> <div class=message-image ng-class=iconClass ng-if=icon> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=\"{{ icon }}\"></use> </svg> </div> <div class=message-body> <slider-content></slider-content> <button class=\"button-flat message-trigger\" ng-show=showCloseButton ng-click=closeButtonClicked() translate=message.button.dismiss> Dismiss </button> </div> </div> ";

/***/ }),
/* 463 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$resource', 'Util', '_', 'CacheFactory', '$rootScope', 'UserEndpoint', 'Authentication', 'Session', '$q', function ($resource, Util, _, CacheFactory, $rootScope, UserEndpoint, Authentication, Session, $q) {
	    var cache;
	    if (!(cache = CacheFactory.get('configCache'))) {
	        cache = new CacheFactory('configCache', { storageMode: 'memory' });
	    }
	
	    var ConfigEndpoint = $resource(Util.apiUrl('/config/:id'), {
	        'id': '@id'
	    }, {
	        get: {
	            method: 'GET',
	            transformResponse: function transformResponse(data /*, header*/) {
	                return Util.transformResponse(data);
	            },
	            cache: cache
	        },
	        update: {
	            method: 'PUT',
	            transformResponse: function transformResponse(data /*, header*/) {
	                return Util.transformResponse(data);
	            }
	        }
	    });
	
	    ConfigEndpoint.invalidateCache = function () {
	        return cache.removeAll();
	    };
	
	    ConfigEndpoint.getFresh = function (params) {
	        cache.remove(Util.apiUrl('/config/' + params.id));
	        return ConfigEndpoint.get(params);
	    };
	    /**
	     * saveCache is responsible for both creation and update of an entity
	     * the switch between update and save is determined based on the presence of
	     * the entity's id.
	     * When we get a full entity for edit we use getFresh to ensure it's the most
	     * up to date. Once the save takes place we need to invalidate the associated:w
	     *
	     * cache to ensure that the query - where appropriate - is cleared.
	     *
	     */
	    ConfigEndpoint.saveCache = function (item) {
	        var persist = item.id ? ConfigEndpoint.update : ConfigEndpoint.save;
	
	        cache.removeAll();
	        return persist(item);
	    };
	
	    return ConfigEndpoint;
	}];

/***/ }),
/* 464 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$resource', '$rootScope', 'Util', 'CacheFactory', function ($resource, $rootScope, Util, CacheFactory) {
	    var cache;
	
	    if (!(cache = CacheFactory.get('userCache'))) {
	        cache = new CacheFactory('userCache');
	    }
	
	    var UserEndpoint = $resource(Util.apiUrl('/users/:id'), {
	        id: '@id'
	    }, {
	        query: {
	            method: 'GET',
	            isArray: false,
	            paramSerializer: '$httpParamSerializerJQLike',
	            transformResponse: function transformResponse(data /*, header*/) {
	                return angular.fromJson(data);
	            },
	            cache: cache
	        },
	        get: {
	            method: 'GET',
	            cache: cache
	        },
	        update: {
	            method: 'PUT'
	        },
	        deleteEntity: {
	            method: 'DELETE'
	        }
	    });
	
	    UserEndpoint.getFresh = function (params) {
	        cache.remove(Util.apiUrl('/users/' + params.id));
	        return UserEndpoint.get(params);
	    };
	
	    UserEndpoint.invalidateCache = function () {
	        return cache.removeAll();
	    };
	
	    UserEndpoint.queryFresh = function (params) {
	        cache.removeAll();
	        return UserEndpoint.query(params);
	    };
	
	    UserEndpoint.saveCache = function (item) {
	        var persist = item.id ? UserEndpoint.update : UserEndpoint.save;
	        cache.removeAll();
	        return persist(item);
	    };
	
	    UserEndpoint.delete = function (item) {
	        cache.removeAll();
	        var result = UserEndpoint.deleteEntity(item);
	        return result;
	    };
	
	    return UserEndpoint;
	}];

/***/ }),
/* 465 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$resource', 'Util', 'CacheFactory', function ($resource, Util, CacheFactory) {
	    var cache;
	
	    if (!(cache = CacheFactory.get('formCache'))) {
	        cache = new CacheFactory('formCache');
	    }
	
	    var FormEndpoint = $resource(Util.apiUrl('/forms/:id'), {
	        id: '@id'
	    }, {
	        query: {
	            method: 'GET',
	            isArray: true,
	            cache: cache,
	            transformResponse: function transformResponse(data /*, header*/) {
	                return Util.transformResponse(data).results;
	            }
	        },
	        get: {
	            method: 'GET',
	            cache: cache
	        },
	        update: {
	            method: 'PUT'
	        },
	        deleteEntity: {
	            method: 'DELETE'
	        }
	    });
	
	    FormEndpoint.getFresh = function (params) {
	        cache.remove(Util.apiUrl('/forms/' + params.id));
	        return FormEndpoint.get(params);
	    };
	
	    FormEndpoint.invalidateCache = function () {
	        return cache.removeAll();
	    };
	
	    FormEndpoint.queryFresh = function () {
	        cache.removeAll();
	        return FormEndpoint.query();
	    };
	
	    FormEndpoint.saveCache = function (item) {
	        var persist = item.id ? FormEndpoint.update : FormEndpoint.save;
	        cache.removeAll();
	        var result = persist(item);
	        return result;
	    };
	
	    FormEndpoint.delete = function (item) {
	        cache.removeAll();
	        return FormEndpoint.deleteEntity(item);
	    };
	
	    return FormEndpoint;
	}];

/***/ }),
/* 466 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$resource', 'Util', 'CacheFactory', function ($resource, Util, CacheFactory) {
	    var cache;
	
	    if (!(cache = CacheFactory.get('attrCache'))) {
	        cache = new CacheFactory('attrCache');
	    }
	
	    var FormAttributeEndpoint = $resource(Util.apiUrl('/forms/:formId/attributes/:id'), {
	        formId: '@formId',
	        id: '@id',
	        order: 'asc',
	        orderby: 'priority'
	    }, {
	        query: {
	            method: 'GET',
	            isArray: true,
	            transformResponse: function transformResponse(data /*, header*/) {
	                return Util.transformResponse(data).results;
	            },
	            cache: cache
	        },
	        get: {
	            method: 'GET',
	            cache: cache
	        },
	        update: {
	            method: 'PUT'
	        },
	        deleteEntity: {
	            method: 'DELETE'
	        }
	    });
	
	    FormAttributeEndpoint.getFresh = function (params) {
	        cache.remove(Util.apiUrl('/forms/' + params.formId + '/attributes/' + params.id));
	        return FormAttributeEndpoint.get(params);
	    };
	
	    FormAttributeEndpoint.queryFresh = function (params) {
	        cache.removeAll();
	        return FormAttributeEndpoint.query(params);
	    };
	
	    FormAttributeEndpoint.saveCache = function (item) {
	        var persist = item.id ? FormAttributeEndpoint.update : FormAttributeEndpoint.save;
	
	        cache.removeAll();
	        return persist(item);
	    };
	
	    FormAttributeEndpoint.invalidateCache = function () {
	        return cache.removeAll();
	    };
	
	    FormAttributeEndpoint.delete = function (item) {
	        cache.removeAll();
	        return FormAttributeEndpoint.deleteEntity(item);
	    };
	
	    return FormAttributeEndpoint;
	}];

/***/ }),
/* 467 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$resource', 'Util', 'CacheFactory', function ($resource, Util, CacheFactory) {
	    var cache;
	
	    if (!(cache = CacheFactory.get('formRoleCache'))) {
	        cache = new CacheFactory('formRoleCache');
	    }
	
	    var FormRoleEndpoint = $resource(Util.apiUrl('/forms/:formId/roles/'), {
	        formId: '@formId',
	        order: 'asc',
	        orderby: 'role_id'
	    }, {
	        query: {
	            method: 'GET',
	            isArray: true,
	            transformResponse: function transformResponse(data /*, header*/) {
	                return Util.transformResponse(data).results;
	            },
	            cache: cache
	        },
	        get: {
	            method: 'GET',
	            cache: cache
	        },
	        update: {
	            method: 'PUT'
	        }
	    });
	
	    FormRoleEndpoint.getFresh = function (params) {
	        cache.remove(Util.apiUrl('/forms/' + params.formId + '/roles/'));
	        return FormRoleEndpoint.get(params);
	    };
	
	    FormRoleEndpoint.invalidateCache = function () {
	        return cache.removeAll();
	    };
	
	    FormRoleEndpoint.queryFresh = function (params) {
	        cache.removeAll();
	        return FormRoleEndpoint.query(params);
	    };
	
	    FormRoleEndpoint.saveCache = function (item) {
	        var persist = FormRoleEndpoint.update;
	        cache.removeAll();
	        var result = persist(item);
	        return result;
	    };
	
	    return FormRoleEndpoint;
	}];

/***/ }),
/* 468 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$resource', 'Util', 'CacheFactory', function ($resource, Util, CacheFactory) {
	    var cache;
	
	    if (!(cache = CacheFactory.get('stageCache'))) {
	        cache = new CacheFactory('stageCache');
	    }
	
	    var FormStageEndpoint = $resource(Util.apiUrl('/forms/:formId/stages/:id'), {
	        formId: '@formId',
	        id: '@id',
	        order: 'asc',
	        orderby: 'priority'
	    }, {
	        query: {
	            method: 'GET',
	            isArray: true,
	            transformResponse: function transformResponse(data /*, header*/) {
	                return Util.transformResponse(data).results;
	            },
	            cache: cache
	        },
	        get: {
	            method: 'GET',
	            cache: cache
	        },
	        update: {
	            method: 'PUT'
	        },
	        deleteEntity: {
	            method: 'DELETE'
	        }
	    });
	
	    FormStageEndpoint.getFresh = function (params) {
	        cache.remove(Util.apiUrl('/forms/' + params.formId + '/stages/' + params.id));
	        return FormStageEndpoint.get(params);
	    };
	
	    FormStageEndpoint.invalidateCache = function () {
	        return cache.removeAll();
	    };
	
	    FormStageEndpoint.queryFresh = function (params) {
	        cache.removeAll();
	        return FormStageEndpoint.query(params);
	    };
	
	    FormStageEndpoint.saveCache = function (item) {
	        var persist = item.id ? FormStageEndpoint.update : FormStageEndpoint.save;
	        cache.removeAll();
	        var result = persist(item);
	        return result;
	    };
	
	    FormStageEndpoint.delete = function (item) {
	        cache.removeAll();
	        return FormStageEndpoint.deleteEntity(item);
	    };
	
	    return FormStageEndpoint;
	}];

/***/ }),
/* 469 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$resource', '$rootScope', 'Util', 'CacheFactory', function ($resource, $rootScope, Util, CacheFactory) {
	    var cache;
	    if (!(cache = CacheFactory.get('tagCache'))) {
	        cache = new CacheFactory('tagCache');
	    }
	
	    var TagEndpoint = $resource(Util.apiUrl('/tags/:id'), {
	        id: '@id'
	    }, {
	        query: {
	            method: 'GET',
	            isArray: true,
	            cache: cache,
	            transformResponse: function transformResponse(data /*, header*/) {
	                return Util.transformResponse(data).results;
	            }
	        },
	        update: {
	            method: 'PUT'
	        },
	        get: {
	            method: 'GET',
	            cache: cache,
	            params: { 'ignore403': '@ignore403' }
	        },
	        deleteEntity: {
	            method: 'DELETE'
	        }
	    });
	
	    TagEndpoint.getFresh = function (params) {
	        cache.remove(Util.apiUrl('/tags/' + params.id));
	        return TagEndpoint.get(params);
	    };
	
	    TagEndpoint.queryFresh = function (params) {
	        cache.removeAll();
	        return TagEndpoint.query(params);
	    };
	
	    TagEndpoint.invalidateCache = function () {
	        return cache.removeAll();
	    };
	
	    TagEndpoint.saveCache = function (item) {
	        var persist = item.id ? TagEndpoint.update : TagEndpoint.save;
	        cache.removeAll();
	        var result = persist(item);
	        return result;
	    };
	
	    TagEndpoint.delete = function (item) {
	        cache.removeAll();
	        var result = TagEndpoint.deleteEntity(item);
	        return result;
	    };
	
	    $rootScope.$on('event:authentication:logout:succeeded', function () {
	        TagEndpoint.queryFresh();
	    });
	    $rootScope.$on('event:authentication:login:succeeded', function () {
	        TagEndpoint.queryFresh();
	    });
	
	    return TagEndpoint;
	}];

/***/ }),
/* 470 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$resource', 'Util', 'CacheFactory', function ($resource, Util, CacheFactory) {
	    var cache;
	
	    if (!(cache = CacheFactory.get('roleCache'))) {
	        cache = new CacheFactory('roleCache');
	    }
	
	    var RoleEndpoint = $resource(Util.apiUrl('/roles/:id'), {
	        id: '@id'
	    }, {
	        query: {
	            method: 'GET',
	            isArray: true,
	            transformResponse: function transformResponse(data /*, header*/) {
	                return Util.transformResponse(data).results;
	            }
	        },
	        get: {
	            method: 'GET',
	            cache: cache
	        },
	        update: {
	            method: 'PUT'
	        },
	        deleteEntity: {
	            method: 'DELETE'
	        }
	    });
	
	    RoleEndpoint.getFresh = function (params) {
	        cache.remove(Util.apiUrl('/roles/' + params.id));
	        return RoleEndpoint.get(params);
	    };
	
	    RoleEndpoint.invalidateCache = function () {
	        return cache.removeAll();
	    };
	
	    RoleEndpoint.queryFresh = function () {
	        cache.removeAll();
	        return RoleEndpoint.query();
	    };
	
	    RoleEndpoint.saveCache = function (item) {
	        var persist = item.id ? RoleEndpoint.update : RoleEndpoint.save;
	        cache.removeAll();
	        var result = persist(item);
	        return result;
	    };
	
	    RoleEndpoint.delete = function (item) {
	        cache.removeAll();
	        return RoleEndpoint.deleteEntity(item);
	    };
	
	    return RoleEndpoint;
	}];

/***/ }),
/* 471 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$resource', 'Util', 'CacheFactory', function ($resource, Util, CacheFactory) {
	    var cache;
	
	    if (!(cache = CacheFactory.get('webhookCache'))) {
	        cache = new CacheFactory('webhookCache');
	    }
	
	    var WebhookEndpoint = $resource(Util.apiUrl('/webhooks/:id'), {
	        id: '@id'
	    }, {
	        query: {
	            method: 'GET',
	            isArray: true,
	            transformResponse: function transformResponse(data /*, header*/) {
	                return Util.transformResponse(data).results;
	            }
	        },
	        get: {
	            method: 'GET',
	            cache: cache
	        },
	        update: {
	            method: 'PUT'
	        },
	        deleteEntity: {
	            method: 'DELETE'
	        }
	    });
	
	    WebhookEndpoint.getFresh = function (params) {
	        cache.remove(Util.apiUrl('/webhooks/' + params.id));
	        return WebhookEndpoint.get(params);
	    };
	
	    WebhookEndpoint.invalidateCache = function () {
	        return cache.removeAll();
	    };
	
	    WebhookEndpoint.queryFresh = function () {
	        cache.removeAll();
	        return WebhookEndpoint.query();
	    };
	
	    WebhookEndpoint.saveCache = function (item) {
	        var persist = item.id ? WebhookEndpoint.update : WebhookEndpoint.save;
	        cache.removeAll();
	        var result = persist(item);
	        return result;
	    };
	
	    WebhookEndpoint.delete = function (item) {
	        cache.removeAll();
	        return WebhookEndpoint.deleteEntity(item);
	    };
	
	    return WebhookEndpoint;
	}];

/***/ }),
/* 472 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$resource', 'Util', 'CacheFactory', function ($resource, Util, CacheFactory) {
	    var cache;
	
	    if (!(cache = CacheFactory.get('permissionCache'))) {
	        cache = new CacheFactory('permissionCache');
	    }
	
	    var PermissionEndpoint = $resource(Util.apiUrl('/permissions/:id'), {
	        id: '@id'
	    }, {
	        query: {
	            method: 'GET',
	            transpermissionResponse: function transpermissionResponse(data /*, header*/) {
	                return Util.transformResponse(data).results;
	            }
	        },
	        get: {
	            method: 'GET',
	            cache: cache
	        }
	    });
	
	    PermissionEndpoint.getFresh = function (params) {
	        cache.remove(Util.apiUrl('/permissions/' + params.id));
	        return PermissionEndpoint.get(params);
	    };
	
	    PermissionEndpoint.invalidateCache = function () {
	        return cache.removeAll();
	    };
	
	    PermissionEndpoint.queryFresh = function () {
	        cache.removeAll();
	        return PermissionEndpoint.query();
	    };
	
	    return PermissionEndpoint;
	}];

/***/ }),
/* 473 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$resource', '$rootScope', 'Util', 'CacheFactory', function ($resource, $rootScope, Util, CacheFactory) {
	
	    var cache;
	
	    if (!(cache = CacheFactory.get('providerCache'))) {
	        cache = new CacheFactory('providerCache');
	    }
	
	    var DataProviderEndpoint = $resource(Util.apiUrl('/dataproviders/:id'), {
	        id: '@id'
	    }, {
	        query: {
	            method: 'GET',
	            isArray: false,
	            transformResponse: function transformResponse(data /*, header*/) {
	                return angular.fromJson(data);
	            },
	            cache: cache
	        },
	        get: {
	            method: 'GET',
	            cache: cache
	        },
	        update: {
	            method: 'PUT'
	        },
	        options: {
	            method: 'OPTIONS'
	        },
	        deleteEntity: {
	            method: 'DELETE'
	        }
	    });
	
	    DataProviderEndpoint.getFresh = function (params) {
	        cache.remove(Util.apiUrl('/dataproviders/' + params.id));
	        return DataProviderEndpoint.get(params);
	    };
	
	    DataProviderEndpoint.queryFresh = function () {
	        cache.removeAll();
	        return DataProviderEndpoint.query();
	    };
	
	    DataProviderEndpoint.invalidateCache = function () {
	        return cache.removeAll();
	    };
	
	    DataProviderEndpoint.saveCache = function (item) {
	        var persist = item.id ? DataProviderEndpoint.update : DataProviderEndpoint.save;
	        cache.removeAll();
	        var result = persist(item);
	        return result;
	    };
	
	    DataProviderEndpoint.delete = function (item) {
	        cache.removeAll();
	        var result = DataProviderEndpoint.deleteEntity(item);
	        return result;
	    };
	
	    return DataProviderEndpoint;
	}];

/***/ }),
/* 474 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$resource', '$rootScope', 'Util', function ($resource, $rootScope, Util) {
	
	    var MediaEndpoint = $resource(Util.apiUrl('/media/:id'), {
	        id: '@id'
	    }, {
	        query: {
	            method: 'GET',
	            isArray: true,
	            transformResponse: function transformResponse(data /*, header*/) {
	                return Util.transformResponse(data).results;
	            }
	        },
	        update: {
	            method: 'PUT'
	        }
	    });
	
	    return MediaEndpoint;
	}];

/***/ }),
/* 475 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$resource', 'Util', function ($resource, Util) {
	
	    var MessageEndpoint = $resource(Util.apiUrl('/messages/:id'), {
	        id: '@id'
	    }, {
	        query: {
	            method: 'GET',
	            isArray: true,
	            transformResponse: function transformResponse(data /*, header*/) {
	                return angular.fromJson(data);
	            }
	        },
	        get: {
	            method: 'GET'
	        },
	        allInThread: {
	            method: 'GET',
	            params: {
	                contact: '@contact',
	                offset: '@offset',
	                limit: '@limit',
	                order: 'asc',
	                orderby: 'created'
	            },
	            isArray: false,
	            transformResponse: function transformResponse(data /*, header*/) {
	                return angular.fromJson(data);
	            }
	        },
	        save: {
	            method: 'POST'
	        }
	    });
	
	    return MessageEndpoint;
	}];

/***/ }),
/* 476 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$resource', '$rootScope', 'Util', '_', '$http', function ($resource, $rootScope, Util, _, $http) {
	
	    var PostEndpoint = $resource(Util.apiUrl('/posts/:id/:extra'), {
	        id: '@id'
	    }, {
	        query: {
	            method: 'GET',
	            isArray: false,
	            paramSerializer: '$httpParamSerializerJQLike',
	            params: {
	                order: 'desc',
	                orderby: 'post_date'
	            }
	        },
	        get: {
	            method: 'GET',
	            transformResponse: function transformResponse(data /*, header*/) {
	                data = angular.fromJson(data);
	                // Ensure values is always an object
	                if (_.isArray(data.values)) {
	                    data.values = _.object(data.values);
	                }
	                if (!_.isArray(data.published_to)) {
	                    data.published_to = [];
	                }
	                return data;
	            }
	        },
	        update: {
	            method: 'PUT'
	        },
	        options: {
	            method: 'OPTIONS'
	        },
	        geojson: {
	            method: 'GET',
	            url: Util.apiUrl('/posts/:id/geojson'),
	            isArray: false,
	            paramSerializer: '$httpParamSerializerJQLike',
	            cancellable: true
	        },
	        stats: {
	            method: 'GET',
	            url: Util.apiUrl('/posts/:id/stats'),
	            isArray: false,
	            paramSerializer: '$httpParamSerializerJQLike'
	        },
	        collections: {
	            method: 'GET',
	            url: Util.apiUrl('/posts/:id/collections'),
	            isArray: true
	        }
	    });
	
	    PostEndpoint.export = function (filters) {
	        var config = {
	            params: filters,
	            paramSerializer: '$httpParamSerializerJQLike'
	        };
	
	        return $http.get(Util.apiUrl('/posts/export'), config);
	    };
	
	    $rootScope.$on('event:authentication:logout:succeeded', function () {
	        PostEndpoint.query();
	    });
	
	    return PostEndpoint;
	}];

/***/ }),
/* 477 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$resource', 'Util', '_', function ($resource, Util, _) {
	
	    var CollectionEndpoint = $resource(Util.apiUrl('/collections/:collectionId'), {
	        collectionId: '@collectionId'
	    }, {
	        query: {
	            method: 'GET',
	            isArray: true,
	            transformResponse: function transformResponse(data /*, header*/) {
	                return angular.fromJson(data).results;
	            }
	        },
	        get: {
	            method: 'GET'
	        },
	        update: {
	            method: 'PUT'
	        },
	        editableByMe: {
	            method: 'GET',
	            isArray: true,
	            // uncomment line below once implemented server-side
	            // for now, _.filter in the transformResponse function replaces the back-end implementation
	            //  url: Util.apiUrl('/collections?user_id=me'),
	            params: { editableBy: 'me' }, // Hack to differentiate cache key from full query
	            transformResponse: function transformResponse(data /*, header*/) {
	                return _.filter(angular.fromJson(data).results, function (result) {
	                    return _.includes(result.allowed_privileges, 'update');
	                });
	            }
	        },
	        addPost: {
	            method: 'POST',
	            url: Util.apiUrl('/collections/:collectionId/posts')
	        },
	        removePost: {
	            method: 'DELETE',
	            url: Util.apiUrl('/collections/:collectionId/posts/:id')
	        },
	        delete: {
	            method: 'DELETE'
	        }
	    });
	
	    return CollectionEndpoint;
	}];

/***/ }),
/* 478 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$resource', 'Util', function ($resource, Util) {
	
	    var SavedSearchEndpoint = $resource(Util.apiUrl('/savedsearches/:id'), {
	        id: '@id'
	    }, {
	        query: {
	            method: 'GET',
	            isArray: true,
	            transformResponse: function transformResponse(data /*, header*/) {
	                return angular.fromJson(data).results;
	            }
	        },
	        get: {
	            method: 'GET'
	        },
	        update: {
	            method: 'PUT'
	        },
	        delete: {
	            method: 'DELETE'
	        }
	    });
	
	    return SavedSearchEndpoint;
	}];

/***/ }),
/* 479 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$q', '$http', '$resource', '$rootScope', 'Util', function ($q, $http, $resource, $rootScope, Util) {
	
	    var DataImportEndpoint = $resource(Util.apiUrl('/csv/:id/:action'), {
	        id: '@id',
	        action: '@action'
	    }, {
	        get: {
	            method: 'GET'
	        },
	        update: {
	            method: 'PUT'
	        },
	        delete: {
	            method: 'DELETE'
	        },
	        import: {
	            method: 'POST'
	        }
	    });
	
	    DataImportEndpoint.upload = function (formData) {
	        var dfd = $q.defer();
	        $http.post(Util.apiUrl('/csv'), formData, {
	            headers: {
	                'Content-Type': undefined
	            }
	        }).then(function (response) {
	            dfd.resolve(Util.transformResponse(response.data));
	        }, function (errorResponse) {
	            dfd.reject(errorResponse);
	        });
	        return dfd.promise;
	    };
	
	    return DataImportEndpoint;
	}];

/***/ }),
/* 480 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$resource', 'Util', '_', function ($resource, Util, _) {
	
	    var ContactEndpoint = $resource(Util.apiUrl('/contacts/:id'), {
	        id: '@id'
	    }, {
	        query: {
	            method: 'GET',
	            isArray: true,
	            transformResponse: function transformResponse(data /*, header*/) {
	                return angular.fromJson(data).results;
	            }
	        },
	        get: {
	            method: 'GET',
	            params: { 'ignore403': '@ignore403' }
	        },
	        update: {
	            method: 'PUT'
	        }
	    });
	
	    return ContactEndpoint;
	}];

/***/ }),
/* 481 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$resource', 'Util', function ($resource, Util) {
	
	    var NotificationEndpoint = $resource(Util.apiUrl('/notifications/:id'), {
	        id: '@id'
	    }, {
	        query: {
	            method: 'GET',
	            isArray: true,
	            transformResponse: function transformResponse(data /*, header*/) {
	                return angular.fromJson(data).results;
	            }
	        },
	        get: {
	            method: 'GET',
	            // Short term fix to handle boucing to login when unviewable
	            // notification is returned
	            params: { 'ignore403': '@ignore403' }
	        },
	        update: {
	            method: 'PUT'
	        },
	        delete: {
	            method: 'DELETE'
	        }
	    });
	
	    return NotificationEndpoint;
	}];

/***/ }),
/* 482 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$resource', 'Util', function ($resource, Util) {
	
	    var TermsOfServiceEndpoint = $resource(Util.apiUrl('/tos/'), {}, {
	        get: {
	            method: 'GET'
	        }
	    });
	
	    return TermsOfServiceEndpoint;
	}];

/***/ }),
/* 483 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$translate', function ($translate) {
	    var allViews = [{
	        name: 'map',
	        display_name: $translate.instant('views.map')
	    }, {
	        name: 'list',
	        display_name: $translate.instant('views.list')
	    }];
	
	    function views() {
	        return allViews;
	    }
	
	    return {
	        views: views
	    };
	}];

/***/ }),
/* 484 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['ConfigEndpoint', 'Util', '$q', function (ConfigEndpoint, Util, $q) {
	
	    var Features = {
	        features: undefined,
	        loadFeatures: function loadFeatures() {
	            var deferred = $q.defer();
	            if (Features.features) {
	                deferred.resolve(Features.features);
	            } else {
	                ConfigEndpoint.getFresh({ id: 'features' }).$promise.then(function (features) {
	                    Features.features = features;
	                    deferred.resolve(Features.features);
	                });
	            }
	            return deferred.promise;
	        },
	        isFeatureEnabled: function isFeatureEnabled(feature) {
	            return Features.features[feature].enabled;
	        },
	        isViewEnabled: function isViewEnabled(view) {
	            return Features.features.views[view];
	        },
	        getLimit: function getLimit(feature) {
	            return Features.features.limits[feature];
	        }
	    };
	
	    return Util.bindAllFunctionsToSelf(Features);
	}];

/***/ }),
/* 485 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['_', 'CONST', '$window', function (_, CONST, $window) {
	
	    var Util = {
	        currentUrl: function currentUrl() {
	            return $window.location.href;
	        },
	        url: function url(relative_url) {
	            return CONST.BACKEND_URL + relative_url;
	        },
	        apiUrl: function apiUrl(relative_url) {
	            return CONST.API_URL + relative_url;
	        },
	        deploymentUrl: function deploymentUrl(relative_url) {
	            var pattern = /^(?:https?:\/\/)?(?:[^@\/\n]+@)?(?:www\.)?([^:\/\n]+)/g;
	            var deploymentUrl = pattern.exec(this.apiUrl(relative_url));
	            return deploymentUrl[0].replace('api.', '');
	        },
	        transformResponse: function transformResponse(response, omitKeys) {
	            omitKeys = (omitKeys || []).concat(['allowed_methods']);
	            return _.omit(angular.fromJson(response), omitKeys);
	        },
	        // Generates a simple UUID for use on html tags when a unique ID is required
	        // Usually applicable where you want to be able to select an element by its ID
	        // but there is no id available
	        simpluUUID: function simpluUUID() {
	            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	                var r = Math.random() * 16 | 0,
	                    v = c === 'x' ? r : r & 0x3 | 0x8;
	                return v.toString(16);
	            });
	        },
	        bindAllFunctionsToSelf: function bindAllFunctionsToSelf(object) {
	            // bind all functions on self to use self as their 'this' context
	            var functions = _.functions(object);
	            if (functions.length) {
	                _.bindAll.apply(_, [object].concat(functions));
	            }
	            return object;
	        },
	
	        /*
	         * This function returns a map of csv columns to post_type fields.
	         * It checks for the presences of the columns names in the set of attribute labels.
	         * If the column is not present the entry is set to undefined.
	         *
	         * The match is case insensistive.
	         */
	        autoMap: function autoMap(columns, attributes, mapSize) {
	            // Get set of labels
	            var attributeLabels = _.map(attributes, function (attribute) {
	                return attribute.label.toLowerCase();
	            });
	
	            // Create map of labels to attribute keys
	            var attributeKeys = _.pluck(attributes, 'key');
	            var attributeMap = _.object(attributeLabels, attributeKeys);
	
	            // Check if a column name appears in the set of labels, if it does set a mapping
	            // to the attribute, otherwise set the mapping to undefined.
	            return _.map(columns, function (item, index) {
	                var column = item.toLowerCase().trim();
	                return _.contains(attributeLabels, column) ? attributeMap[item] : undefined;
	            });
	        }
	    };
	
	    return Util.bindAllFunctionsToSelf(Util);
	}];

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = Maps;
	
	Maps.$inject = ['ConfigEndpoint', 'Leaflet', '_', 'CONST'];
	function Maps(ConfigEndpoint, L, _, CONST) {
	    var layers = {
	        baselayers: {
	            satellite: {
	                name: 'Satellite',
	                url: 'https://api.tiles.mapbox.com/v4/{mapid}/{z}/{x}/{y}.png?access_token={apikey}',
	                layerOptions: {
	                    apikey: CONST.MAPBOX_API_KEY,
	                    mapid: 'mapbox.satellite',
	                    attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a>, &copy; <a href="https://www.mapbox.com/about/maps/"">Mapbox</a> | <a href="https://www.mapbox.com/feedback/" target="_blank">Improve the underlying map</a>'
	                }
	            },
	            streets: {
	                name: 'Streets',
	                url: 'https://api.tiles.mapbox.com/v4/{mapid}/{z}/{x}/{y}.png?access_token={apikey}',
	                layerOptions: {
	                    apikey: CONST.MAPBOX_API_KEY,
	                    mapid: 'mapbox.streets',
	                    attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a>, &copy; <a href="https://www.mapbox.com/about/maps/"">Mapbox</a> | <a href="https://www.mapbox.com/feedback/" target="_blank">Improve the underlying map</a>'
	                }
	            },
	            hOSM: {
	                name: 'Humanitarian',
	                url: 'http://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png',
	                layerOptions: {
	                    attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a>, &copy; <a href="http://hot.openstreetmap.org/">Humanitarian OpenStreetMap</a> | <a href="https://www.mapbox.com/feedback/" target="_blank">Improve the underlying map</a>'
	                }
	            }
	        }
	    };
	
	    return {
	        createMap: createMap,
	        getLeafletConfig: getLeafletConfig,
	        getBaseLayers: getBaseLayers,
	        pointToLayer: pointToLayer,
	        getConfig: getConfig,
	        getLayer: getLayer,
	        pointIcon: pointIcon
	    };
	
	    function createMap(element) {
	        return getLeafletConfig().then(function (config) {
	            var map = L.map(element, config);
	
	            map.attributionControl.setPrefix(false);
	            map.zoomControl.setPosition('bottomleft');
	            map.setMaxBounds([[-90, -360], [90, 360]]);
	            map.on('popupopen', function (e) {
	                var px = map.project(e.popup._latlng); // find the pixel location on the map where the popup anchor is
	                px.y -= e.popup._container.clientHeight / 2; // find the height of the popup container, divide by 2, subtract from the Y axis of marker location
	                map.panTo(map.unproject(px), { animate: true }); // pan to new center
	            });
	
	            // Add a layer control
	            // L.control.layers(getBaseLayersForControl(), {}).addTo(map);
	
	            return map;
	        });
	    }
	
	    function getLeafletConfig() {
	        return getConfig().then(function (config) {
	            var defaultLayer = layers.baselayers[config.default_view.baselayer];
	
	            return angular.extend(defaultConfig(), {
	                layers: [L.tileLayer(defaultLayer.url, defaultLayer.layerOptions)],
	                center: [config.default_view.lat, config.default_view.lon],
	                zoom: config.default_view.zoom,
	                clustering: config.clustering
	            });
	        });
	    }
	
	    function getBaseLayers() {
	        return layers.baselayers;
	    }
	
	    /* jshint ignore:start */
	    function getBaseLayersForControl() {
	        return _.chain(layers.baselayers).values().indexBy('name').mapObject(function (layer) {
	            return L.tileLayer(layer.url, layer.layerOptions);
	        }).value();
	    }
	    /* jshint ignore:end */
	
	    function getLayer(layerKey) {
	        var layer = layers.baselayers[layerKey];
	        return L.tileLayer(layer.url, layer.layerOptions);
	    }
	
	    function getConfig(fresh) {
	        return ConfigEndpoint[fresh ? 'getFresh' : 'get']({ id: 'map' }).$promise.then(function (config) {
	            // Handle legacy layers
	            if (config.default_view.baselayer === 'MapQuest') {
	                config.default_view.baselayer = 'streets';
	            }
	            if (config.default_view.baselayer === 'MapQuestAerial') {
	                config.default_view.baselayer = 'satellite';
	            }
	            return config;
	        });
	    }
	
	    function defaultConfig() {
	        return {
	            scrollWheelZoom: false,
	            center: [-1.2833, 36.8167], // Default to centered on Nairobi
	            zoom: 8,
	            layers: [L.tileLayer(layers.baselayers.streets.url, layers.baselayers.streets.layerOptions)]
	        };
	    }
	
	    function pointToLayer(feature, latlng) {
	        return L.marker(latlng, {
	            icon: pointIcon(feature.properties['marker-color'])
	        });
	    }
	
	    // Icon configuration
	    function pointIcon(color, size, className) {
	        // Test string to make sure that it does not contain injection
	        color = color && /^[a-zA-Z0-9#]+$/.test(color) ? color : '#959595';
	        size = size || [32, 32];
	        var iconicSprite = __webpack_require__(412);
	
	        return L.divIcon({
	            className: 'custom-map-marker ' + className,
	            html: '<svg class="iconic" style="fill:' + color + ';"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + iconicSprite + '#map-marker"></use></svg><span class="iconic-bg" style="background-color:' + color + ';""></span>',
	            iconSize: size,
	            iconAnchor: [size[0] / 2, size[1]],
	            popupAnchor: [0, 0 - size[1]]
	        });
	    }
	}

/***/ }),
/* 487 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$q', '$http', '_', function ($q, $http, _) {
	    return {
	        searchCoordinates: searchCoordinates,
	        searchAllInfo: searchAllInfo
	    };
	
	    function searchCoordinates(location_name) {
	        return build_query(location_name).then(function (results) {
	            if (results && results[0]) {
	                if (results[0].lat && results[0].lon) {
	                    return [parseFloat(results[0].lat), parseFloat(results[0].lon)];
	                }
	            }
	
	            return null;
	        });
	    }
	
	    function searchAllInfo(location_name) {
	        return build_query(location_name).then(function (results) {
	            if (results && results[0]) {
	                return results;
	            }
	            return null;
	        });
	    }
	
	    function build_query(location_name) {
	        if (window.googlePlaces) {
	            /* google maps */
	            return google_places_search(location_name);
	        } else {
	            /* osm nominatim */
	            return osm_geosearch(location_name);
	        }
	    }
	
	    function osm_geosearch(location_name) {
	        return $http({
	            method: 'GET',
	            url: '//nominatim.openstreetmap.org/search',
	            params: { q: location_name, format: 'json' }
	        }).then(function (response) {
	            return response.data;
	        }, function () {
	            // noop
	        });
	    }
	
	    function google_places_search(location_name) {
	        var deferred = $q.defer();
	        window.googlePlaces.textSearch({ query: location_name }, function (results) {
	            deferred.resolve(_.map(results, function (result) {
	                return {
	                    display_name: result.name + ' - ' + result.formatted_address,
	                    lat: result.geometry.location.lat(),
	                    lon: result.geometry.location.lng()
	                };
	            }));
	        });
	        return deferred.promise;
	    }
	}];

/***/ }),
/* 488 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['Util', '$http', function (Util, $http) {
	
	    // Get translated languages if they have been downloaded from https://www.transifex.com/api/2/languages
	    var languages = $http.get('locales/languages.json').then(function (response) {
	        return response.data.languages;
	    }, function () {
	        // fallback to en pulled from https://www.transifex.com/api/2/languages
	        // Language codes have _ replaced with -
	        return [{
	            'rtl': false,
	            'pluralequation': 'language.pluralequation',
	            'code': 'en',
	            'name': 'English',
	            'nplurals': 2
	        }];
	    });
	
	    return languages;
	}];

/***/ }),
/* 489 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['FontAwesomeIcons', 'Util', '_', 'Notify', function (FontAwesomeIcons, Util, _, Notify) {
	
	    var iconSets = {
	        fontAwesome: FontAwesomeIcons.getIconSet(),
	        noun: {}
	    };
	
	    var IconManager = {
	
	        getIconSetArray: function getIconSetArray(iconLibName) {
	            var iconSetArray = [];
	            var iconLibNames = iconLibName.split(' ');
	
	            // @todo: simplify this to reduce loops
	            // push array construction to the endpoint
	            // and/or store values with prefix already attached
	            _.each(iconLibNames, function (libName) {
	                var classPrefix = iconSets[libName].iconClass + ' ' + iconSets[libName].iconClassPrefix;
	                _.each(iconSets[libName].icons, function (icon) {
	                    iconSetArray.push(classPrefix + icon);
	                });
	            });
	
	            return iconSetArray;
	        }
	    };
	
	    return Util.bindAllFunctionsToSelf(IconManager);
	}];

/***/ }),
/* 490 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['Util', '$q', function (Util, $q) {
	
	    var FontAwesomeIcons = {
	        getIconSet: function getIconSet() {
	            return {
	                // @todo: Move icon classes definition into
	                // separate dir/js
	                iconClass: 'fa',
	                iconClassPrefix: 'fa-',
	                icons: ['adjust', 'anchor', 'archive', 'area-chart', 'arrows', 'arrows-h', 'arrows-v', 'automobile', 'asterisk', 'at', 'ban', 'bank', 'bar-chart-o', 'barcode', 'bars', 'beer', 'bell', 'bell-o', 'bell-slash', 'bell-slash-o', 'bicycle', 'binoculars', 'birthday-cake', 'bolt', 'bomb', 'book', 'bookmark', 'bookmark-o', 'briefcase', 'bug', 'building', 'building-o', 'bullhorn', 'bullseye', 'bus', 'cab', 'calculator', 'calendar', 'calendar-o', 'camera', 'camera-retro', 'car', 'caret-square-o-down', 'caret-square-o-left', 'caret-square-o-right', 'caret-square-o-up', 'cc', 'cc-amex', 'cc-discover', 'cc-mastercard', 'cc-paypal', 'cc-stripe', 'cc-visa', 'certificate', 'check', 'check-circle', 'check-circle-o', 'child', 'circle', 'circle-o', 'circle-thin', 'clock-o', 'cloud', 'cloud-download', 'cloud-upload', 'code', 'code-fork', 'coffee', 'cog', 'cogs', 'comment', 'comment-o', 'comments', 'comments-o', 'compass', 'copyright', 'credit-card', 'crop', 'crosshairs', 'cube', 'cubes', 'cutlery', 'dashboard', 'database', 'desktop', 'dot-circle-o', 'download', 'edit', 'ellipsis-h', 'ellipsis-v', 'envelope', 'envelope-o', 'envelope-square', 'eraser', 'exchange', 'exclamation', 'exclamation-circle', 'exclamation-triangle', 'external-link', 'external-link-square', 'eye', 'eye-slash', 'eyedropper', 'fax', 'female', 'fighter-jet', 'file-archive-o', 'file-audio-o', 'file-code-o', 'file-excel-o', 'file-image-o', 'file-movie-o', 'file-pdf-o', 'file-photo-o', 'file-picture-o', 'file-powerpoint-o', 'file-sound-o', 'file-video-o', 'file-word-o', 'file-zip-o', 'film', 'filter', 'fire', 'fire-extinguisher', 'flag', 'flag-checkered', 'flag-o', 'flash', 'flask', 'folder', 'folder-o', 'folder-open', 'folder-open-o', 'frown-o', 'futbol-o', 'gamepad', 'gavel', 'gear', 'gears', 'gift', 'glass', 'globe', 'graduation-cap', 'group', 'hdd-o', 'headphones', 'heart', 'heart-o', 'history', 'home', 'image', 'inbox', 'info', 'info-circle', 'institution', 'key', 'keyboard-o', 'language', 'laptop', 'leaf', 'legal', 'lemon-o', 'level-down', 'level-up', 'life-bouy', 'life-ring', 'life-saver', 'lightbulb-o', 'line-chart', 'location-arrow', 'lock', 'magic', 'magnet', 'mail-forward', 'mail-reply', 'mail-reply-all', 'male', 'map-marker', 'meh-o', 'microphone', 'microphone-slash', 'minus', 'minus-circle', 'minus-square', 'minus-square-o', 'mobile', 'mobile-phone', 'money', 'moon-o', 'mortar-board', 'music', 'navicon', 'newspaper-o', 'paint-brush', 'paper-plane', 'paper-plane-o', 'paw', 'pencil', 'pencil-square', 'pencil-square-o', 'phone', 'phone-square', 'photo', 'picture-o', 'pie-chart', 'plane', 'plug', 'plus', 'plus-circle', 'plus-square', 'plus-square-o', 'power-off', 'print', 'puzzle-piece', 'qrcode', 'question', 'question-circle', 'quote-left', 'quote-right', 'random', 'refresh', 'reorder', 'reply', 'reply-all', 'retweet', 'road', 'rocket', 'rss', 'rss-square', 'search', 'search-minus', 'search-plus', 'send', 'send-o', 'share', 'share-alt', 'share-alt-square', 'share-square', 'share-square-o', 'shield', 'shopping-cart', 'sign-in', 'sign-out', 'signal', 'sitemap', 'sliders', 'smile-o', 'soccer-ball-o', 'sort', 'sort-alpha-asc', 'sort-alpha-desc', 'sort-amount-asc', 'sort-amount-desc', 'sort-asc', 'sort-desc', 'sort-down', 'sort-numeric-asc', 'sort-numeric-desc', 'sort-up', 'space-shuttle', 'spinner', 'spoon', 'square', 'square-o', 'star', 'star-half', 'star-half-empty', 'star-half-full', 'star-half-o', 'star-o', 'suitcase', 'sun-o', 'support', 'tablet', 'tachometer', 'tag', 'tags', 'tasks', 'taxi', 'terminal', 'thumb-tack', 'thumbs-down', 'thumbs-o-down', 'thumbs-o-up', 'thumbs-up', 'ticket', 'times', 'times-circle', 'times-circle-o', 'tint', 'toggle-down', 'toggle-left', 'toggle-off', 'toggle-on', 'toggle-right', 'toggle-up', 'trash', 'trash-o', 'tree', 'trophy', 'truck', 'tty', 'umbrella', 'university', 'unlock', 'unlock-alt', 'unsorted', 'upload', 'user', 'users', 'video-camera', 'volume-down', 'volume-off', 'volume-up', 'warning', 'wheelchair', 'wifi', 'wrench', 'check-square', 'check-square-o', 'bitcoin', 'btc', 'cny', 'dollar', 'eur', 'euro', 'gbp', 'ils', 'inr', 'jpy', 'krw', 'rmb', 'rouble', 'rub', 'ruble', 'rupee', 'shekel', 'sheqel', 'try', 'turkish-lira', 'usd', 'won', 'yen', 'align-center', 'align-justify', 'align-left', 'align-right', 'bold', 'chain', 'chain-broken', 'clipboard', 'columns', 'copy', 'cut', 'dedent', 'file', 'file-o', 'file-text', 'file-text-o', 'files-o', 'floppy-o', 'font', 'header', 'indent', 'italic', 'link', 'list', 'list-alt', 'list-ol', 'list-ul', 'outdent', 'paperclip', 'paragraph', 'paste', 'repeat', 'rotate-left', 'rotate-right', 'save', 'scissors', 'strikethrough', 'subscript', 'superscript', 'table', 'text-height', 'text-width', 'th', 'th-large', 'th-list', 'underline', 'undo', 'unlink', 'angle-double-down', 'angle-double-left', 'angle-double-right', 'angle-double-up', 'angle-down', 'angle-left', 'angle-right', 'angle-up', 'arrow-circle-down', 'arrow-circle-left', 'arrow-circle-o-down', 'arrow-circle-o-left', 'arrow-circle-o-right', 'arrow-circle-o-up', 'arrow-circle-right', 'arrow-circle-up', 'arrow-down', 'arrow-left', 'arrow-right', 'arrow-up', 'arrows-alt', 'caret-down', 'caret-left', 'caret-right', 'caret-up', 'chevron-circle-down', 'chevron-circle-left', 'chevron-circle-right', 'chevron-circle-up', 'chevron-down', 'chevron-left', 'chevron-right', 'chevron-up', 'hand-o-down', 'hand-o-left', 'hand-o-right', 'hand-o-up', 'long-arrow-down', 'long-arrow-left', 'long-arrow-right', 'long-arrow-up', 'backward', 'compress', 'eject', 'expand', 'fast-backward', 'fast-forward', 'forward', 'pause', 'play', 'play-circle', 'play-circle-o', 'step-backward', 'step-forward', 'stop', 'youtube-play', 'adn', 'android', 'angellist', 'apple', 'behance', 'behance-square', 'bitbucket', 'bitbucket-square', 'css3', 'delicious', 'digg', 'dribbble', 'dropbox', 'drupal', 'empire', 'facebook', 'facebook-square', 'flickr', 'foursquare', 'ge', 'git', 'git-square', 'github', 'github-alt', 'github-square', 'gittip', 'google', 'google-plus', 'google-plus-square', 'google-wallet', 'hacker-news', 'html5', 'instagram', 'ioxhost', 'joomla', 'jsfiddle', 'lastfm', 'lastfm-square', 'linkedin', 'linkedin-square', 'linux', 'maxcdn', 'meanpath', 'openid', 'pagelines', 'paypal', 'pied-piper', 'pied-piper-alt', 'pinterest', 'pinterest-square', 'qq', 'ra', 'rebel', 'reddit', 'reddit-square', 'renren', 'skype', 'slack', 'slideshare', 'soundcloud', 'spotify', 'stack-exchange', 'stack-overflow', 'steam', 'steam-square', 'stumbleupon', 'stumbleupon-circle', 'tencent-weibo', 'trello', 'tumblr', 'tumblr-square', 'twitch', 'twitter', 'twitter-square', 'vimeo-square', 'vine', 'vk', 'wechat', 'weibo', 'weixin', 'windows', 'wordpress', 'xing', 'xing-square', 'yahoo', 'yelp', 'youtube', 'youtube-square', 'ambulance', 'h-square', 'hospital-o', 'medkit', 'stethoscope', 'user-md'] };
	        }
	    };
	
	    return FontAwesomeIcons;
	}];

/***/ }),
/* 491 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = MainsheetService;
	
	MainsheetService.$inject = ['$rootScope', '$q'];
	
	function MainsheetService($rootScope, $q) {
	    var deferredOpen = $q.defer(),
	        deferredClose = $q.defer(),
	        isOpen = false;
	
	    return {
	        open: openTemplate,
	        openTemplate: openTemplate,
	        close: closeTemplate,
	        closeTemplate: closeTemplate,
	        getState: getState,
	        onOpen: onOpen,
	        onClose: onClose,
	        setState: setState
	    };
	
	    function openTemplate(template, title, scope) {
	        deferredOpen.promise.then(function () {
	            $rootScope.$emit('mainsheet:open', template, title, scope);
	        });
	    }
	
	    function closeTemplate() {
	        deferredClose.promise.then(function () {
	            $rootScope.$emit('mainsheet:close');
	        });
	    }
	
	    function getState() {
	        return isOpen;
	    }
	
	    function onOpen(callback, scope) {
	        var handler = $rootScope.$on('mainsheet:open', callback);
	        if (scope) {
	            scope.$on('$destroy', handler);
	        }
	        deferredOpen.resolve();
	    }
	
	    function onClose(callback, scope) {
	        var handler = $rootScope.$on('mainsheet:close', callback);
	        if (scope) {
	            scope.$on('$destroy', handler);
	        }
	        deferredClose.resolve();
	    }
	
	    function setState(open) {
	        $rootScope.$emit('mainsheet:statechange');
	        isOpen = open;
	    }
	}

/***/ }),
/* 492 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ModalService;
	
	ModalService.$inject = ['$rootScope', '$q', '$templateRequest'];
	function ModalService($rootScope, $q, $templateRequest) {
	    var deferredOpen = $q.defer(),
	        deferredClose = $q.defer(),
	        isOpen = false;
	
	    return {
	        open: openTemplate,
	        openTemplate: openTemplate,
	        close: close,
	        getState: getState,
	        // Methods only to be called form ModalContainer
	        onOpen: onOpen,
	        onClose: onClose,
	        setState: setState
	    };
	
	    function openTemplate(template, title, icon, scope, closeOnOverlayClick, showCloseButton) {
	        deferredOpen.promise.then(function () {
	            $rootScope.$emit('modal:open', template, title, icon, scope, closeOnOverlayClick, showCloseButton);
	        });
	    }
	
	    function close() {
	        deferredClose.promise.then(function () {
	            $rootScope.$emit('modal:close');
	        });
	    }
	
	    function getState() {
	        return isOpen;
	    }
	
	    function onOpen(callback, scope) {
	        var handler = $rootScope.$on('modal:open', callback);
	        if (scope) {
	            scope.$on('$destroy', handler);
	        }
	        deferredOpen.resolve();
	    }
	
	    function onClose(callback, scope) {
	        var handler = $rootScope.$on('modal:close', callback);
	        if (scope) {
	            scope.$on('$destroy', handler);
	        }
	        deferredClose.resolve();
	    }
	
	    function setState(open) {
	        isOpen = open;
	    }
	}

/***/ }),
/* 493 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$rootScope', '$q', '$translate', '$document', 'Languages', 'Session', 'Authentication', 'UserEndpoint', 'ConfigEndpoint', function ($rootScope, $q, $translate, $document, Languages, Session, Authentication, UserEndpoint, ConfigEndpoint) {
	    var translate = function translate(lang) {
	        $translate.use(lang).then(function (langKey) {
	            if (langKey) {
	                $translate.preferredLanguage(langKey);
	                Languages.then(function (languages) {
	                    angular.forEach(languages, function (language) {
	                        if (language.code === langKey) {
	                            $rootScope.rtlEnabled = language.rtl;
	                        }
	                    });
	                });
	            }
	        });
	        // Translating and setting page-title
	        $rootScope.$emit('setPageTitle', $translate.instant($document[0].title));
	    };
	
	    var setStartLanguage = function setStartLanguage() {
	        getLanguage().then(function (language) {
	            translate(language);
	        });
	    };
	
	    var getLanguage = function getLanguage(config) {
	        return $q(function (resolve, reject) {
	            if (Session.getSessionDataEntry('language')) {
	                resolve(Session.getSessionDataEntry('language'));
	                return;
	            }
	
	            var configRequest = $q.when(config ? config : ConfigEndpoint.get({ id: 'site' }).$promise);
	            var userRequest = $q.when(false);
	
	            if (Authentication.getLoginStatus()) {
	                userRequest = UserEndpoint.get({ id: 'me' }).$promise;
	            }
	
	            $q.all({
	                user: userRequest,
	                config: configRequest
	            }).then(function (result) {
	                if (result.user && result.user.language) {
	                    resolve(result.user.language);
	                } else if (result.config.language) {
	                    resolve(result.config.language);
	                } else {
	                    resolve('en');
	                }
	            });
	        });
	    };
	
	    var setLanguage = function setLanguage(code) {
	        Session.setSessionDataEntry('language', code);
	        if (Authentication.getLoginStatus()) {
	            UserEndpoint.get({ id: 'me' }).$promise.then(function (user) {
	                user.language = code;
	                UserEndpoint.update(user);
	            });
	        }
	    };
	
	    return {
	        translate: translate,
	        setStartLanguage: setStartLanguage,
	        getLanguage: getLanguage,
	        setLanguage: setLanguage
	    };
	}];

/***/ }),
/* 494 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = NavigationController;
	
	NavigationController.$inject = ['Authentication', 'ConfigEndpoint', 'BootstrapConfig', '$rootScope', 'Features'];
	function NavigationController(Authentication, ConfigEndpoint, BootstrapConfig, $rootScope, Features) {
	    var vm = this;
	
	    vm.site = BootstrapConfig;
	    vm.reloadSiteConfig = reloadSiteConfig;
	    //vm.canCreatePost = canCreatePost;
	    //vm.canRegister = canRegister;
	    //vm.logoutClick = logoutClick;
	
	    activate();
	
	    $rootScope.$on('event:update:header', reloadSiteConfig);
	
	    function activate() {
	
	        Features.loadFeatures().then(function () {
	            vm.activityIsAvailable = Features.isViewEnabled('activity');
	            vm.planIsAvailable = Features.isViewEnabled('plan');
	        });
	
	        reloadSiteConfig();
	    }
	
	    function reloadSiteConfig() {
	        ConfigEndpoint.get({ id: 'site' }).$promise.then(function (site) {
	            vm.site = site;
	        });
	    }
	
	    // Move to add post button (or associated service)
	    // function canCreatePost() {
	    //     return $rootScope.loggedin || !vm.site.private;
	    // };
	}

/***/ }),
/* 495 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$rootScope', '$location', '$window', '$scope', 'Authentication', 'ConfigEndpoint', function ($rootScope, $location, $window, $scope, Authentication, ConfigEndpoint) {
	    var USHAHIDI = 'Ushahidi';
	    $scope.siteTitle = USHAHIDI;
	    $scope.pageTitle = null;
	    $scope.pageDescription = null;
	    $scope.pageKeywords = null;
	    $scope.pageRobots = null;
	
	    $scope.appStoreId = $window.ushahidi.appStoreId;
	
	    $scope.currentFullUrl = $location.absUrl();
	
	    // Then update from server
	    $scope.reloadSiteConfig = function () {
	        ConfigEndpoint.get({ id: 'site' }).$promise.then(function (site) {
	            $scope.siteTitle = site.name ? site.name : USHAHIDI;
	        });
	    };
	
	    $rootScope.$on('event:update:header', function () {
	        $scope.reloadSiteConfig();
	    });
	    $scope.reloadSiteConfig();
	
	    $rootScope.$on('setPageTitle', function (event, title) {
	        $scope.pageTitle = null;
	
	        if (title && title.length) {
	            $scope.pageTitle = title + ' - ';
	        }
	    });
	
	    $rootScope.$on('setPageDescription', function (event, description) {
	        $scope.pageDescription = null;
	
	        if (description && description.length) {
	            $scope.pageDescription = description;
	        }
	    });
	
	    $rootScope.$on('setPageKeywords', function (event, keywords) {
	        $scope.pageKeywords = null;
	
	        if (keywords && keywords.length) {
	            $scope.pageKeywords = keywords;
	        }
	    });
	
	    $rootScope.$on('setPageRobots', function (event, robots) {
	        $scope.pageRobots = null;
	
	        if (robots) {
	            if (robots === true) {
	                $scope.pageRobots = 'index, follow';
	            } else if (robots === false) {
	                $scope.pageRobots = 'noindex, nofollow';
	            } else if (robots.length) {
	                $scope.pageRobots = robots;
	            }
	        }
	    });
	}];

/***/ }),
/* 496 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$scope', '$rootScope', 'UserEndpoint', 'ConfigEndpoint', '$q', '$window', '$location', function ($scope, $rootScope, UserEndpoint, ConfigEndpoint, $q, $window, $location) {
	    $rootScope.$on('event:authentication:login:succeeded', function () {
	        if ($window.self === $window.top) {
	            $scope.startIntercom();
	        }
	    });
	
	    $scope.startIntercom = function () {
	        if ($window.ushahidi.intercomAppId !== '') {
	            $q.all([ConfigEndpoint.get({ id: 'site' }).$promise, UserEndpoint.getFresh({ id: 'me' }).$promise]).then(function (results) {
	                var site = results[0];
	                var user = results[1];
	                var domain = $location.host();
	
	                $window.Intercom('boot', {
	                    app_id: $window.ushahidi.intercomAppId,
	                    email: user.email,
	                    created_at: user.created,
	                    user_id: domain + '_' + user.id,
	                    'deployment_url': domain,
	                    'realname': user.realname,
	                    'last_login': user.last_login,
	                    'role': user.role,
	                    company: {
	                        name: site.name,
	                        id: domain,
	                        created_at: 0, // Faking this because we don't have this data
	                        plan: site.tier
	                    }
	                });
	            });
	        }
	    };
	
	    $rootScope.$on('event:authentication:logout:succeeded', function () {
	        $scope.stopIntercom();
	    });
	
	    $scope.stopIntercom = function () {
	        if ($window.ushahidi.intercomAppId !== '') {
	            $window.Intercom('shutdown');
	        }
	    };
	}];

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Ushahidi Angular Role Selector directive
	 * Drop in directive for managing roles addition for users
	 * and posts
	 */
	
	module.exports = [function () {
	    var controller = ['$scope', '$rootScope', '$translate', 'Notify', 'RoleEndpoint', '_', function ($scope, $rootScope, $translate, Notify, RoleEndpoint, _) {
	        $scope.showRoles = !!$scope.post.published_to.length;
	
	        $scope.canSeeThis = function () {
	            if ($scope.post.published_to && $scope.post.published_to.length) {
	                return _.map($scope.post.published_to, function (role) {
	                    return $scope.roles[role].display_name;
	                }).join(', ');
	            } else if ($scope.post.status === 'draft') {
	                return $translate.instant('post.just_you');
	            } else {
	                return $translate.instant('post.everyone');
	            }
	        };
	
	        RoleEndpoint.query().$promise.then(function (roles) {
	            $scope.roles = _.indexBy(roles, 'name');
	        });
	
	        $scope.checkIfAllSelected = function () {
	            return $scope.roles.length === $scope.post.published_to.length;
	        };
	
	        $scope.toggleRole = function (role) {
	            if (role === 'draft' || role === '') {
	                $scope.post.published_to = [];
	                $scope.showRoles = false;
	            } else if ($scope.checkIfAllSelected()) {
	                // All check boxes selected, therefore publish to everyone
	                $scope.post.published_to = [];
	                $scope.showRoles = false;
	            }
	
	            $scope.post.status = role === 'draft' ? role : 'published';
	        };
	
	        $scope.toggleRolesView = function () {
	            $scope.showRoles = true;
	        };
	    }];
	    return {
	        restrict: 'E',
	        template: __webpack_require__(498),
	        scope: {
	            post: '='
	        },
	        controller: controller
	    };
	}];

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = " <fieldset dropdown auto-close=outsideClick class=\"custom-fieldset init\"> <legend data-toggle=dropdown-menu class=\"dropdown-trigger init\" dropdown-toggle> <span> <span class=custom-fieldset-value> {{canSeeThis()}} </span> <span translate=post.can_see_this> can see this </span> </span> <svg class=\"iconic chevron\"> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#chevron-bottom> </use></svg> </legend> <div class=\"dropdown-menu init\" dropdown-menu> <div class=form-fieldgroup dropdown> <div class=\"form-field radio\"> <input name={{post.id}} id={{post.id}}_draft value=draft type=radio ng-checked=\"post.status==='draft'\" ng-click=\"toggleRole('draft')\"> <label for={{post.id}}_draft translate=post.just_you>Just you</label> </div> <div class=\"form-field radio\"> <input name={{post.id}} id={{post.id}}_everyone value=\"\" type=radio ng-checked=\"post.status==='published' && post.published_to.length === 0\" ng-click=\"toggleRole('')\"> <label for={{post.id}}_everyone translate=post.everyone>Everyone</label> </div> <div class=\"form-field radio\"> <input name={{post.id}} id={{post.id}}_roles auto-close=disabled ng-checked=post.published_to.length value=roles type=radio ng-click=toggleRolesView()> <label for={{post.id}}_roles translate=post.specific_roles>Specific roles...</label> <div class=form-fieldgroup dropdown-menu ng-show=showRoles> <div class=\"form-field checkbox\" ng-repeat=\"role in roles\"> <input id={{role.id}} type=checkbox checklist-model=post.published_to checklist-value=role.name ng-click=toggleRole(role.name)> <label for={{role.id}}>{{role.display_name}}</label> </div> </div> </div> </div> </div> </fieldset> ";

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Ushahidi Listing Toolbar directive
	 * Drop in directive for managing listing toolbar operations
	 * Options are: select all, deselect all, delete, set visibility, add to collection
	 */
	
	module.exports = [function () {
	    var controller = ['$scope', '$rootScope', '$translate', '_', function ($scope, $rootScope, $translate, _) {
	
	        $scope.selectAll = function () {
	            // Add all entities to the array, but don't
	            // break references that already refer to this array
	            Array.prototype.splice.apply($scope.selectedSet, [0, $scope.selectedSet.length].concat(_.pluck($scope.entities, 'id')));
	        };
	
	        $scope.deselectAll = function () {
	            // Empty the array, but don't break references that already refer to this array
	            $scope.selectedSet.splice(0);
	        };
	    }];
	    return {
	        restrict: 'E',
	        template: __webpack_require__(500),
	        replace: true,
	        transclude: true,
	        scope: {
	            entities: '=',
	            selectedSet: '='
	        },
	        controller: controller
	    };
	}];

/***/ }),
/* 500 */
/***/ (function(module, exports) {

	module.exports = "<div class=listing-toolbar> <div class=listing-toolbar-summary> <strong translate=nav.selected_items translate-values=\"{ selectedItems : selectedSet.length }\"></strong> <button class=button-link ng-click=deselectAll() translate=nav.deselect>Deselect</button> <button class=button-link ng-click=selectAll() translate=nav.select_all>Select all</button> </div> <div class=listing-toolbar-actions> <ng-transclude></ng-transclude> </div> </div> ";

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Ushahidi Angular Icon Pocker directive
	 * Based on the Angular Bootstrap Icon Picker directive
	 */
	
	module.exports = ['IconManager', function (IconManager) {
	    return {
	        restrict: 'E',
	        template: __webpack_require__(502),
	        replace: true,
	        scope: {
	            model: '=?ngModel',
	            iconLibName: '='
	        },
	
	        link: function link($scope, $element, $attrs) {
	            $scope.iconSet = IconManager.getIconSetArray($attrs.iconLibName);
	
	            $scope.setIcon = function (icon) {
	                $scope.model = icon;
	            };
	        }
	    };
	}];

/***/ }),
/* 502 */
/***/ (function(module, exports) {

	module.exports = "<span dropdown> <button dropdown-toggle type=button class=\"button-secondary dropdown toggle-content-trigger\"> <span class={{model}}></span> </button> <ul class=\"dropdown-menu init toggle-content list-unstyled\" dropdown-menu> <li ng-repeat=\"icon in iconSet\" class=inline> <button type=button class=\"button-secondary inline\" ng-click=setIcon(icon)> <span class=\"{{ icon }}\"></span> </button> </li> </ul> </span> ";

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	* Ushahidi Angular Color Picker directive
	* Drop in directive for color picking
	*/
	
	module.exports = [function () {
	    var controller = ['$scope', '$translate', function ($scope, $translate) {
	        // Set default color
	        $scope.color = '#eee';
	        // Update local color when inbound color is changed
	        $scope.$watch('colorContainer.color', function () {
	            if ($scope.colorContainer.color) {
	                $scope.color = $scope.colorContainer.color.replace('#', '');
	            }
	        });
	
	        $scope.setColor = function (color) {
	            $scope.colorContainer.color = color.indexOf('#') > -1 ? color : '#' + color;
	        };
	    }];
	    return {
	        restrict: 'E',
	        replace: true,
	        template: __webpack_require__(504),
	        scope: {
	            colorContainer: '='
	        },
	        controller: controller
	    };
	}];

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<fieldset class=\"custom-fieldset init\" data-fieldset-type=color dropdown auto-close=outsideClick> <legend class=\"dropdown-trigger init active\" data-toggle=dropdown-menu dropdown-toggle> <span class=swatch ng-style=\"{ backgroundColor: colorContainer.color}\"></span> <span class=legend-label>Color</span> <svg class=\"iconic chevron\"> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> </legend> <div class=\"dropdown-menu init\" dropdown-menu> <div class=form-field> <label translate>color_picker.hex_value</label> <input type=text data-input-type=color ng-change=setColor(color) ng-model=color> </div> <div class=form-field> <button class=button-gamma data-button-type=color value=A51A1A style=border-top-color:#a51a1a ng-click=\"setColor('#A51A1A')\" translate>color_picker.red</button> <button class=button-gamma data-button-type=color value=E69327 style=border-top-color:#e69327 ng-click=\"setColor('#E69327')\" translate>color_picker.gold</button> <button class=button-gamma data-button-type=color value=2274B4 style=border-top-color:#2274b4 ng-click=\"setColor('#2274B4')\" translate>color_picker.blue</button> <button class=button-gamma data-button-type=color value=5BAA00 style=border-top-color:#5baa00 ng-click=\"setColor('#5BAA00')\" translate>color_picker.green</button> </div> </div> </fieldset> ";

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Ushahidi First Login Config
	 */
	
	module.exports = ['$q', '$http', '$rootScope', 'ConfigEndpoint', '_', 'Notify', 'Util', 'Languages', function ($q, $http, $rootScope, ConfigEndpoint, _, Notify, Util, Languages) {
	    return {
	        restrict: 'E',
	        template: __webpack_require__(506),
	        scope: true,
	        link: function link($scope, $element, $attrs) {
	            $scope.modalOpen = false;
	            $scope.site = {};
	            $scope.saving_config = false;
	            $scope.step = 'customize';
	            $scope.fileContainer = {
	                file: null
	            };
	
	            // Load config, and open modal if first time login
	            var checkConfig = function checkConfig() {
	                ConfigEndpoint.get({ id: 'site' }, function (site) {
	                    $scope.site = site;
	                    $scope.hasName = !!site.name;
	                    // Are we and admin, and is this the first login?
	                    if (_.contains(site.allowed_privileges, 'update') && site.first_login) {
	                        // .. then open the modal
	                        $scope.modalOpen = true;
	                    }
	                });
	            };
	
	            // If we're already logged in, check config immediately
	            if ($rootScope.loggedin) {
	                checkConfig();
	            }
	            // Otherwise, wait for a login event, then check config
	            $rootScope.$on('event:authentication:login:succeeded', function () {
	                checkConfig();
	            });
	
	            // Skip the customize step
	            $scope.skip = function () {
	                // Set the first login flag false, so we don't show this again
	                ConfigEndpoint.update({ id: 'site', first_login: false }, function () {
	                    $scope.step = 'first-post';
	                });
	            };
	            // Close the modal
	            $scope.closeModal = function () {
	                $scope.modalOpen = false;
	            };
	
	            $scope.clearHeader = function () {
	                $scope.site.image_header = null;
	            };
	
	            var updateSiteHeader = function updateSiteHeader() {
	                $rootScope.$broadcast('event:update:header');
	            };
	            var uploadHeaderImage = function uploadHeaderImage() {
	                var dfd = $q.defer();
	
	                if ($scope.fileContainer.file) {
	                    var formData = new FormData();
	                    formData.append('file', $scope.fileContainer.file);
	
	                    $http.post(Util.apiUrl('/media'), formData, {
	                        headers: {
	                            'Content-Type': undefined
	                        }
	                    }).then(function (response) {
	                        $scope.site.image_header = response.data.original_file_url;
	                        dfd.resolve();
	                    });
	                } else {
	                    dfd.resolve();
	                }
	
	                return dfd.promise;
	            };
	
	            $scope.updateConfig = function () {
	                $scope.saving_config = true;
	
	                // Set the first login flag false, so we don't show this again
	                $scope.site.first_login = false;
	
	                uploadHeaderImage().then(function () {
	                    ConfigEndpoint.saveCache($scope.site).$promise.then(function (result) {
	                        $scope.saving_config = false;
	                        $scope.step = 'first-post';
	                        updateSiteHeader();
	                    });
	                }, function (errorResponse) {
	                    Notify.apiErrors(errorResponse);
	                });
	            };
	        }
	    };
	}];

/***/ }),
/* 506 */
/***/ (function(module, exports) {

	module.exports = "<modal visible=modalOpen show-close-button=\"step == 'first-post'\" close-on-overlay-click=false> <form ng-show=\"step == 'customize'\" name=form> <h1 translate>settings.customize_your_new_deployment</h1> <div ng-hide=hasName> <label class=input-label for=site-settings-name ng-class=\"{ 'success': !form.name.$invalid && form.name.$dirty, 'error' : form.name.$invalid && form.name.$dirty }\" translate>settings.site_name</label> <input id=name name=name type=text ng-model=site.name ng-class=\"{'error': form.name.$invalid && form.name.$dirty}\" required> <p ng-repeat=\"(error, value) in form.name.$error\" ng-show=form.name.$dirty class=\"alert error\" translate=\"{{'settings.valid.name.' + error}}\"></p> </div> <div class=\"divider white\"></div> <label class=input-label for=site-settings-description translate>settings.site_description</label> <textarea id=site-settings-description type=text ng-model=site.description placeholder=\"{{'settings.site_description_placeholder' | translate}}\"></textarea> <div class=\"divider white\"></div> <label class=input-label for=appearance-header-image translate>settings.appearance_header_image</label> <p class=small translate>settings.appearance_header_image_instructions</p> <file-upload container=fileContainer> </file-upload> <div class=\"divider white\"></div> <button class=save ng-click=updateConfig() ng-disabled=\"form.$invalid || isUnchanged(site) || saving_config\"> <div class=loading ng-show=saving_config><div class=line></div><div class=line></div><div class=line></div></div> <span translate>settings.continue</span> </button> <a class=cta ng-click=skip() ng-show=hasName translate>settings.skip</a> </form> <div ng-show=\"step == 'first-post'\"> <h3 class=edit translate>settings.add_first_post</h3> <div class=\"divider padded\"></div> <p translate>settings.add_first_post_subtitle</p> <a class=\"button button-create\" ng-href=/posts/create ng-click=closeModal()> <span translate>settings.add_first_post</span> </a> <div class=\"divider padded\"></div> <p translate>settings.invite_people</p> <a class=\"button button-primary\" ng-href=/settings/users ng-click=closeModal()> <span translate>settings.add_new_users</span> </a> </div> </modal> ";

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = MainsheetContainer;
	
	MainsheetContainer.$inject = ['$rootScope', '$compile', 'MainsheetService'];
	
	function MainsheetContainer($rootScope, $compile, MainsheetService) {
	    return {
	        restrict: 'E',
	        scope: true,
	        template: __webpack_require__(508),
	        link: MainsheetContainerLink
	    };
	
	    function MainsheetContainerLink($scope, $element) {
	
	        $scope.closeMainsheet = closeMainsheet;
	        $scope.showMainsheet = false;
	        $scope.title = '';
	
	        var templateScope;
	
	        // Mainsheet content element
	        var mainsheetContent = $element.find('mainsheet-content');
	
	        // Bind to mainsheet service open/close events
	        MainsheetService.onOpen(openMainsheet, $scope);
	        MainsheetService.onClose(closeMainsheet, $scope);
	
	        function makeTemplateScope(scope) {
	            // If no scope was passed, create a child of our directive scope
	            if (!scope) {
	                // @todo should this just be $rootScope.$new() ??
	                return $scope.$new();
	            }
	            // If scope isn't actually a scope yet, make it into one
	            if (scope.constructor !== $rootScope.constructor) {
	                return angular.extend($rootScope.$new(), scope);
	            }
	            return scope.$new();
	        }
	
	        function openMainsheet(event, template, title, scope) {
	
	            // Clean up any previous mainsheet content
	            cleanUpMainsheet();
	
	            // Create new scope and keep it to destroy when done with the mainsheet
	            templateScope = makeTemplateScope(scope);
	
	            // Inject closeMainsheet function onto template scope
	            templateScope.closeMainsheet = closeMainsheet;
	
	            mainsheetContent.html(template);
	            $compile(mainsheetContent)(templateScope);
	
	            $scope.title = title;
	
	            $scope.showMainsheet = true;
	            MainsheetService.setState(true);
	        }
	
	        function closeMainsheet() {
	            $scope.showMainsheet = false;
	            MainsheetService.setState(false);
	            cleanUpMainsheet();
	        }
	
	        function cleanUpMainsheet() {
	            if (templateScope) {
	                templateScope.$destroy();
	            }
	            mainsheetContent.html('');
	        }
	    }
	}

/***/ }),
/* 508 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"mainsheet init active\" ng-show=showMainsheet style=display:block;opacity:1> <div class=mainsheet-window> <h3 class=mainsheet-heading ng-if=title> {{ title | translate }} </h3> <mainsheet-content></mainsheet-content> </div> <div class=mainsheet-overlay ng-click=closeMainsheet()></div> </div> ";

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Ushahidi Angular Modal directive
	 * Based on the Angular Bootstrap Modal directive
	 */
	module.exports = ModalContainer;
	
	ModalContainer.$inject = ['$timeout', '$rootScope', '$compile', 'ModalService'];
	function ModalContainer($timeout, $rootScope, $compile, ModalService) {
	    return {
	        restrict: 'E',
	        template: __webpack_require__(510),
	
	        scope: true,
	
	        link: ModalContainerLink
	    };
	
	    function ModalContainerLink($scope, $element) {
	        $scope.classVisible = false;
	        $scope.modalOffset = 0;
	        $scope.title = '';
	        $scope.icon = false;
	        $scope.closeOnOverlayClick = true; // Could move out of scope
	        $scope.showCloseButton = true;
	        // Callbacks
	        $scope.closeButtonClicked = closeButtonClicked;
	
	        var templateScope;
	        var iconPath = __webpack_require__(412);
	        // Modal content element
	        var modalContent = $element.find('modal-content');
	
	        // Bind to modal service open/close events
	        ModalService.onOpen(openModal, $scope);
	        ModalService.onClose(closeModal, $scope);
	
	        //var classChangePromise = null;
	        function makeTemplateScope(scope) {
	            // If no scope was passed, create a child of our directive scope
	            if (!scope) {
	                // @todo should this just be $rootScope.$new() ??
	                return $scope.$new();
	            }
	
	            // If scope isn't actually a scope yet, make it into one
	            if (scope.constructor !== $rootScope.constructor) {
	                return angular.extend($rootScope.$new(), scope);
	            }
	
	            return scope.$new();
	        }
	
	        function openModal(ev, template, title, icon, scope, closeOnOverlayClick, showCloseButton) {
	            // Clean up any previous modal content
	            cleanUpModal();
	            // Create new scope and keep it to destroy when done with the modal
	            templateScope = makeTemplateScope(scope);
	
	            // Inject closeModal function onto template scope
	            templateScope.closeModal = closeModal;
	
	            modalContent.html(template);
	            $compile(modalContent)(templateScope);
	
	            $scope.title = title;
	            $scope.icon = icon ? iconPath + '#' + icon : icon;
	
	            // If closeOnOverlayClick isn't passed, default to true
	            if (typeof closeOnOverlayClick === 'undefined') {
	                $scope.closeOnOverlayClick = true;
	            } else {
	                $scope.closeOnOverlayClick = closeOnOverlayClick;
	            }
	
	            // If showCloseButton isn't passed, default to true
	            if (typeof showCloseButton === 'undefined') {
	                $scope.showCloseButton = true;
	            } else {
	                $scope.showCloseButton = showCloseButton;
	            }
	
	            // @todo fade in
	            modalYPos();
	            $scope.classVisible = true;
	            ModalService.setState(true);
	            $rootScope.toggleModalVisible(true);
	
	            // if (classChangePromise) {
	            //     $timeout.cancel(classChangePromise);
	            // }
	        }
	
	        function closeModal() {
	            // @todo fade out
	            $scope.classVisible = false;
	            $rootScope.toggleModalVisible(false);
	            ModalService.setState(false);
	            cleanUpModal();
	
	            // if (classChangePromise) {
	            //     $timeout.cancel(classChangePromise);
	            // }
	
	            // classChangePromise = $timeout(function () {
	            //     $scope.classDetached = true;
	            // }, 400);
	        }
	
	        function cleanUpModal() {
	            if (templateScope) {
	                templateScope.$destroy();
	            }
	            modalContent.html('');
	        }
	
	        function closeButtonClicked(context) {
	            if (context === 'overlay' && $scope.closeOnOverlayClick !== true) {
	                return;
	            }
	
	            closeModal();
	        }
	
	        function modalYPos() {
	            // Set offset based on window position
	            // @todo move offset to a config param
	            var windowYpos = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
	            $scope.modalOffset = windowYpos + 40 + 'px';
	        }
	
	        // $scope.$on('$destroy', function (event) {
	        //     if (classChangePromise) {
	        //         $timeout.cancel(classChangePromise);
	        //     }
	        // });
	    }
	}

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div ng-show=classVisible class=modal style=display:block> <div class=modal-window ng-style=\"{ top : modalOffset }\"> <button class=\"button-beta button-flat modal-trigger modal-trigger-close\" ng-show=showCloseButton ng-click=closeButtonClicked()> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#x></use> </svg> <span class=hidden translate>modal.button.close</span> </button> <h3 class=modal-title ng-if=title> <svg class=iconic ng-if=icon> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=\"{{ icon }}\"></use> </svg> <span class=label> {{ title | translate }} </span> </h3> <modal-content></modal-content> <ush-slider inside-modal=true></ush-slider> </div> <div class=modal-overlay ng-click=\"closeButtonClicked('overlay')\"></div> </div> ";

/***/ }),
/* 511 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ModalBody;
	
	ModalBody.$inject = ['$window'];
	function ModalBody($window) {
	    return {
	        restrict: 'AC',
	        link: ModalBodyLink
	    };
	
	    function ModalBodyLink($scope, $element) {
	        activate();
	
	        function activate() {
	            $element.css('max-height', modalBodyHeight());
	        }
	
	        angular.element($window).bind('resize', handleResize);
	        // Unbind on destroy
	        $scope.$on('$destroy', function (event) {
	            angular.element($window).unbind('resize', handleResize);
	        });
	
	        function modalBodyHeight() {
	            return $window.innerHeight * 0.66 + 'px';
	        }
	
	        function handleResize() {
	            activate();
	
	            // Manual $digest required as resize event
	            // is outside of angular
	            $scope.$digest();
	        }
	    }
	}

/***/ }),
/* 512 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = LayoutClassDirective;
	
	LayoutClassDirective.$inject = [];
	function LayoutClassDirective() {
	    return {
	        restrict: 'E',
	        scope: {
	            layout: '@'
	        },
	        controller: LayoutClassController
	    };
	}
	
	LayoutClassController.$inject = ['$scope', '$rootScope', '$window', 'Util'];
	function LayoutClassController($scope, $rootScope, $window, Util) {
	    var isEmbed = $window.self !== $window.top ? true : false;
	    // In the case of map we omit the layout-a class
	    var isMap = Util.currentUrl() ? Util.currentUrl().indexOf('map') > 0 : false;
	
	    if (!isEmbed) {
	        $rootScope.setLayout('layout-' + $scope.layout);
	    } else if (isEmbed && isMap) {
	        $rootScope.setLayout('layout-embed');
	    } else {
	        // If we are in embed mode
	        // we must append the layout to the embed layout
	        $rootScope.setLayout('layout-embed layout-' + $scope.layout);
	    }
	}

/***/ }),
/* 513 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = EmbedOnlyDirective;
	
	EmbedOnlyDirective.$inject = [];
	function EmbedOnlyDirective() {
	    return {
	        restrict: 'A',
	        controller: EmbedOnlyController
	    };
	}
	
	EmbedOnlyController.$inject = ['$scope', '$element', '$attrs', '$rootScope', '_', '$window'];
	function EmbedOnlyController($scope, $element, $attrs, $rootScope, _, $window) {
	    var globalEmbed = $window.self !== $window.top ? true : false;
	
	    if (globalEmbed && $attrs.embedOnly === 'false') {
	        $element.addClass('hidden');
	    } else if (!globalEmbed && $attrs.embedOnly === 'true') {
	        $element.addClass('hidden');
	    }
	}

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = UshLogoDirective;
	
	UshLogoDirective.$inject = [];
	function UshLogoDirective() {
	    return {
	        restrict: 'E',
	        controller: UshLogoController,
	        replace: true,
	        template: __webpack_require__(515)
	    };
	}
	
	UshLogoController.$inject = [];
	function UshLogoController() {}

/***/ }),
/* 515 */
/***/ (function(module, exports) {

	module.exports = "<a embed-only=true href=https://www.ushahidi.com class=ushahidi-bug target=_blank> <ng-include include-replace src=\"'common/directives/mode-bar/ushahidi-logo.html'\"></ng-include> <span class=hidden>Powered by Ushahidi</span> </a> ";

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Ushahidi Angular Filter System Master directive
	 * Drop in directive master directive responsible for search
	 * and selection of appropriate sub directive
	 */
	
	module.exports = ['$timeout', function ($timeout) {
	    var link = function link($scope, $elem, $attrs, formControl) {
	        $scope.searchResultsVisible = false;
	        $scope.form = formControl;
	
	        $scope.showSearchResults = function () {
	            $scope.searchResultsVisible = true;
	        };
	
	        $scope.hideSearchResults = function () {
	            $timeout(function () {
	                $scope.searchResultsVisible = false;
	            }, 100);
	        };
	    };
	    return {
	        restrict: 'E',
	        replace: true,
	        template: __webpack_require__(517),
	        scope: {
	            model: '=',
	            placeholderEntity: '='
	        },
	        link: link,
	        require: '?^form'
	    };
	}];

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=searchbar-input dropdown auto-close=outsideClick> <div class=\"form-field search\"> <label class=hidden translate=toolbar.searchbar.search_entity>Search</label> <div class=input-with-icon> <input name=q type=search autocomplete=off placeholder=\"{{ 'toolbar.searchbar.search_entity' | translate:{ entity: placeholderText } }}\" ng-model=model ng-blur=hideSearchResults() ng-focus=showSearchResults() ng-keyup=showSearchResults()> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#magnifying-glass></use> </svg> </div> </div> <div class=\"searchbar-results dropdown-menu\" ng-class=\"{active: (searchResultsVisible && form.q.$viewValue.length > 0) }\"> <div class=form-field> <button type=submit class=button-plain> <span class=button-label> <span translate-values=\"{ entity: entityType }\" translate> toolbar.searchbar.search_all_entities_for </span> \"<em>{{ form.q.$viewValue }}</em>\" </span> </button> </div> </div> </div> ";

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Ushahidi Angular Filter System role directive
	 * Drop in directive responsible for role selection
	 * for filtering
	 */
	
	module.exports = [function () {
	    var controller = ['$scope', '$rootScope', '$translate', 'RoleEndpoint', function ($scope, $rootScope, $translate, RoleEndpoint) {
	        RoleEndpoint.query().$promise.then(function (roles) {
	            $scope.roles = roles;
	        });
	    }];
	    return {
	        restrict: 'E',
	        replace: true,
	        template: __webpack_require__(519),
	        scope: {
	            model: '='
	        },
	        controller: controller
	    };
	}];

/***/ }),
/* 519 */
/***/ (function(module, exports) {

	module.exports = "<fieldset> <legend translate>app.roles</legend> <div class=\"form-field checkbox\" ng-repeat=\"role in roles\"> <label> <input type=checkbox checklist-model=model checklist-value=role.name> {{role.display_name}} </label> </div> </fieldset> ";

/***/ }),
/* 520 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = OverflowToggleDirective;
	
	OverflowToggleDirective.$inject = ['$parse'];
	function OverflowToggleDirective($parse) {
	    return {
	        restrict: 'A',
	        link: OverflowToggleController
	    };
	
	    function OverflowToggleController($scope, $element, $attrs) {
	        var toggle = $element[0].querySelector('.form-field-toggle');
	        var hasOverflow = angular.bind({}, $parse($attrs.hasOverflow), $scope);
	
	        $scope.$watch(hasOverflow, function (hasOverflow) {
	            $element.toggleClass('has-overflow', hasOverflow);
	        });
	
	        angular.element(toggle).on('click', function () {
	            hasOverflow() ? $element.toggleClass('show-overflow') : '';
	        });
	    }
	}

/***/ }),
/* 521 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Focus directive.
	 * Use this to set focus on input fields that may otherwise not have focus when they become available.
	 */
	
	module.exports = Focus;
	
	Focus.$inject = ['$timeout'];
	
	function Focus($timeout) {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            scope.$watch(attrs.focus, function (value) {
	                if (value) {
	                    $timeout(function () {
	                        element[0].focus();
	                    });
	                }
	            });
	        }
	    };
	}

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = ['Features', 'Authentication', 'Registration', 'ModalService', '$rootScope', 'ConfigEndpoint', 'CollectionsService', function (Features, Authentication, Registration, ModalService, $rootScope, ConfigEndpoint, CollectionsService) {
	    return {
	        restrict: 'E',
	        replace: true,
	        scope: {
	            currentUser: '='
	        },
	        template: __webpack_require__(523),
	        link: function link($scope, $element, $attrs) {
	            $scope.baseUrl = 'views/';
	            $scope.activeMode = 'map';
	            $scope.moreActive = false;
	            $scope.isActivityAvailable = false;
	            $scope.canRegister = false;
	
	            $scope.hasManageSettingsPermission = $rootScope.hasManageSettingsPermission;
	            $scope.showMore = showMore;
	            $scope.viewCollectionListing = CollectionsService.showCollectionList;
	            $scope.viewAccountSettings = viewAccountSettings;
	            $scope.viewSupportLinks = viewSupportLinks;
	            $scope.login = Authentication.openLogin;
	            $scope.logout = Authentication.logout;
	            $scope.register = Registration.openRegister;
	
	            activate();
	
	            function activate() {
	                $scope.$on('$locationChangeStart', handleRouteChange);
	                $rootScope.$on('event:mode:change', handleModeChange);
	                $rootScope.$on('event:collection:show', handleCollectionShow);
	                $rootScope.$on('event:collection:close', handleCollectionClose);
	                $rootScope.$on('event:savedsearch:show', handleSavedSearchShow);
	                $rootScope.$on('event:savedsearch:close', handleSavedSearchClose);
	                $rootScope.$on('event:allposts:show', handleAllShow);
	
	                Features.loadFeatures().then(function () {
	                    $scope.isActivityAvailable = Features.isViewEnabled('activity');
	                });
	
	                ConfigEndpoint.get({ id: 'site' }, function (site) {
	                    $scope.canRegister = !site.private;
	                });
	            }
	
	            // Show account settings
	            function viewAccountSettings() {
	                ModalService.openTemplate('<account-settings></account-settings>', '', false, false, true, true);
	            }
	
	            // Show support links
	            function viewSupportLinks() {
	                ModalService.openTemplate(__webpack_require__(524), '', false, false, true, true);
	            }
	
	            // Add 'click' handler to toggle trigger
	            function showMore() {
	                $scope.moreActive = !$scope.moreActive;
	            }
	
	            function handleRouteChange() {
	                $scope.moreActive = false;
	            }
	
	            function handleModeChange(ev, mode) {
	                $scope.activeMode = mode;
	            }
	
	            function handleAllShow(ev, collection) {
	                $scope.baseUrl = 'views/';
	            }
	
	            function handleCollectionShow(ev, collection) {
	                $scope.baseUrl = 'collections/' + collection.id + '/';
	            }
	
	            function handleCollectionClose(ev, savedsearch) {
	                //$scope.baseUrl = 'views/';
	            }
	
	            function handleSavedSearchShow(ev, savedsearch) {
	                $scope.baseUrl = 'savedsearches/' + savedsearch.id + '/';
	            }
	
	            function handleSavedSearchClose(ev, savedsearch) {
	                //$scope.baseUrl = 'views/';
	            }
	        }
	    };
	}];

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=mode-bar ng-class=\"{ active : moreActive }\"> <nav> <ul class=deployment-menu> <li ng-class=\"{ active: activeMode === 'map' }\"> <a ng-href=\"{{baseUrl + 'map' }}\" class=view-map> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#map-marker></use> </svg> <translate>views.map</translate> </a> </li> <li ng-class=\"{ active: activeMode === 'list' }\"> <a ng-href=\"{{baseUrl + 'list' }}\" class=view-list> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#list-rich></use> </svg> <translate>views.list</translate> </a> </li> <li ng-if=\"isActivityAvailable || hasManageSettingsPermission()\" ng-class=\"{ active: activeMode === 'activity' }\" data-message=customize> <a href=/activity> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#pulse></use> </svg> <translate>views.activity</translate> </a> </li> <li> <a class=more-menu-trigger ng-class=\"{ active : moreActive }\" ng-click=showMore($event)> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#ellipses></use> </svg> <translate>nav.more</translate> </a> <ul> <li data-message=customize ng-show=hasManageSettingsPermission() ng-class=\"{ active: activeMode === 'settings' }\"> <a href=/settings> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#cog></use> </svg> <translate>nav.settings</translate> </a> </li> </ul> </li> </ul> <ul class=account-menu> <li> <a href=\"\" ng-click=viewSupportLinks()> <ng-include src=\"'common/directives/mode-bar/ushahidi-logo.html'\"></ng-include> <span class=label translate>app.support</span> </a> </li> <li ng-show=currentUser> <a ng-click=logout() data-modal=login> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#account-logout></use> </svg> <span class=label translate=nav.logout>Log out</span> </a> </li> <li ng-show=currentUser> <a ng-click=viewAccountSettings()> <img class=avatar ng-src=\"https://www.gravatar.com/avatar/{{ currentUser.gravatar || '00000000000000000000000000000000' }}?d=retro\" alt=\"{{ currentUser.realname }}\"/> <span class=label>{{currentUser.realname || currentUser.email}}</span> </a> </li> <li ng-show=\"!currentUser && canRegister\"> <a ng-click=register() data-modal=signup> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#person></use> </svg> <translate translate=nav.register>Sign up</translate> </a> </li> <li ng-hide=currentUser> <a ng-click=login() data-modal=login> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#account-login></use> </svg> <translate translate=nav.login>Log in</translate> </a> </li> <li> <a ng-click=viewCollectionListing()> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#grid-three-up></use> </svg> <span class=label translate>nav.collections</span> </a> </li> <li ng-if=todo> <a> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#bell></use> </svg> <span class=label><translate>nav.alerts</translate> <span class=badge>2</span></span> </a> </li> </ul> </nav> </div> ";

/***/ }),
/* 524 */
/***/ (function(module, exports) {

	module.exports = "<h3 class=modal-title translate> app.support </h3> <div class=modal-body> <dl> <dt class=list-item><a href=https://www.ushahidi.com/support target=_blank translate>app.documentation.title</a></dt> <dd translate>app.documentation.description</dd> <dt class=list-item><a href=https://github.com/ushahidi/platform/issues/new target=_blank translate>app.report_a_bug.title</a></dt> <dd translate>app.report_a_bug.description</dd> <dt class=list-item><a href=https://www.ushahidi.com/features target=_blank translate>app.features.title</a></dt> <dd translate>app.features.description</dd> </dl> </div> ";

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = FileUpload;
	
	function FileUpload() {
	    return {
	        restrict: 'E',
	        template: __webpack_require__(526),
	        replace: true,
	        scope: {
	            container: '=',
	            model: '='
	        },
	        controller: ['$scope', '$attrs', function ($scope, $attrs) {
	            $scope.required = typeof $attrs.required !== 'undefined';
	            $scope.uploadFile = function ($event) {
	                $scope.container.file = $event.target.files[0];
	                var reader = new FileReader();
	                reader.onload = function () {
	                    var dataURL = reader.result;
	                    $scope.container.dataURI = dataURL;
	                    $scope.container.changed = true;
	                    $scope.container.deleted = false;
	                    $scope.model = 'changed';
	                    $scope.$apply();
	                };
	                reader.readAsDataURL($event.target.files[0]);
	            };
	        }]
	    };
	}

/***/ }),
/* 526 */
/***/ (function(module, exports) {

	module.exports = "<input name=file type=file custom-on-change=uploadFile ng-required=\"{{ required }}\"/> ";

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = RoleSelectorDirective;
	
	RoleSelectorDirective.$inject = [];
	
	function RoleSelectorDirective() {
	    return {
	        restrict: 'E',
	        scope: {
	            model: '=',
	            title: '='
	        },
	        controller: RoleSelectorController,
	        template: __webpack_require__(528)
	    };
	}
	RoleSelectorController.$inject = ['$scope', 'RoleEndpoint', '$translate'];
	
	function RoleSelectorController($scope, RoleEndpoint, $translate) {
	    $scope.setEveryone = setEveryone;
	
	    activate();
	
	    function activate() {
	        // getting available roles from api
	        RoleEndpoint.query().$promise.then(function (roles) {
	            $scope.roles = roles;
	        });
	    }
	
	    // adding all available roles to model if user clicks 'Everyone'
	    function setEveryone() {
	        $scope.model.role = [];
	    }
	}

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = " <fieldset> <legend translate={{title}}></legend> <div class=\"form-field radio icon-input\" ng-class=\"{ 'checked': !model.role.length }\"> <label for=add_everyone> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#globe></use> </svg> <input name=add id=add_everyone ng-value=true checked=\"\" type=radio ng-model=everyone ng-click=setEveryone()> <span class=label translate=nav.everyone>Everyone</span> </label> </div> <div class=\"form-field radio icon-input\" ng-class=\"{ 'checked': model.role.length }\"> <label for=add_roles> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#people></use> </svg> <input class=init name=add id=add_roles ng-value=false ng-modaldata-fieldgroup-toggle=add_roles type=radio ng-model=everyone> <span translate=app.specific_roles>Specific roles...</span> </label> <div class=\"form-fieldgroup init\" data-fieldgroup-target=add_roles ng-class=\"{true:'', false:'active'}[everyone]\"> <div class=\"form-field checkbox\" ng-repeat=\"role in roles\"> <label> <input type=checkbox checklist-model=model.role checklist-value=role.name> {{role.display_name}} </label> </div> </div> </div> </fieldset> ";

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = AddCategoryDirective;
	
	AddCategoryDirective.$inject = [];
	
	function AddCategoryDirective() {
	    return {
	        restrict: 'E',
	        scope: {
	            formId: '=',
	            attribute: '=',
	            postValue: '='
	        },
	        controller: AddCategoryController,
	        template: __webpack_require__(530)
	    };
	}
	AddCategoryController.$inject = ['$rootScope', '$scope', 'TagEndpoint', 'FormAttributeEndpoint', 'Notify'];
	
	function AddCategoryController($rootScope, $scope, TagEndpoint, FormAttributeEndpoint, Notify) {
	    $scope.showInput = false;
	    $scope.categoryName = '';
	    $scope.category = {
	        type: 'category',
	        icon: 'tag',
	        color: '',
	        parent_id: null,
	        forms: [$scope.formId]
	    };
	
	    activate();
	
	    function activate() {
	        $scope.userCanAddCategory = $rootScope.hasPermission('Manage Settings');
	    }
	
	    $scope.showInputToggle = function () {
	        $scope.categoryName = '';
	        $scope.showInput = !$scope.showInput;
	    };
	
	    $scope.saveCategory = function ($event) {
	        $event.preventDefault();
	        $scope.category.tag = $scope.categoryName;
	        $scope.category.slug = $scope.categoryName;
	        TagEndpoint.saveCache($scope.category).$promise.then(function (response) {
	            if (response.id) {
	                // adding new tag to render it in checklist
	                $scope.attribute.options.push(response);
	                $scope.postValue.push(response.id);
	                // copying original attribute to be able to extract option.ids
	                var attribute = angular.copy($scope.attribute);
	                attribute.options = attribute.options.map(function (option) {
	                    return option.id;
	                });
	                //assigning values for saving
	                attribute.formId = $scope.formId;
	                FormAttributeEndpoint.saveCache(attribute).$promise.then(function (response) {
	                    // resetting input-value
	                    $scope.categoryName = '';
	                });
	                Notify.notify('category added', { response: response });
	            }
	        }, function (errorResponse) {
	            Notify.apiErrors(errorResponse);
	        });
	    };
	}

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"form-field inline\" ng-class=\"{'hidden': !showInput}\"> <label class=hidden translate=category.editor.name>Category name</label> <input type=text placeholder=\"{{'category.editor.name' | translate}}\" style=width:240px ng-model=categoryName /> <button type=button class=\"button-alpha button-flat\" ng-disabled=\"categoryName.length === 0\" ng-click=saveCategory($event);> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#check></use> </svg> <span class=hidden translate=app.add>Add</span> </button> <button type=button class=\"button-beta button-flat\" ng-click=showInputToggle()> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#trash></use> </svg> <span class=hidden translate=category.delete>Delete</span> </button> </div> <div class=\"form-field init\" ng-click=showInputToggle() ng-if=userCanAddCategory> <a data-toggle=add-label translate=app.add_new_category>+ Add new category</a> </div> ";

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = LanguageSwitchDirective;
	
	LanguageSwitchDirective.$inject = [];
	
	function LanguageSwitchDirective() {
	    return {
	        restrict: 'E',
	        scope: {
	            site: '=?'
	        },
	        controller: LanguageSwitchController,
	        template: __webpack_require__(532)
	    };
	}
	LanguageSwitchController.$inject = ['$scope', 'Languages', 'TranslationService'];
	function LanguageSwitchController($scope, Languages, TranslationService) {
	    $scope.changeLanguage = changeLanguage;
	    $scope.$on('event:authentication:login:succeeded', TranslationService.setStartLanguage);
	    $scope.$on('event:authentication:logout:succeeded', TranslationService.setStartLanguage);
	    activate();
	
	    function activate() {
	        Languages.then(function (languages) {
	            $scope.languages = languages;
	        });
	    }
	
	    function changeLanguage(code) {
	        TranslationService.setLanguage(code);
	        TranslationService.translate(code);
	    }
	}

/***/ }),
/* 532 */
/***/ (function(module, exports) {

	module.exports = "\t<div class=\"form-field select\"> <div class=custom-select> <select ng-model=site.language ng-options=\"lang.code as lang.name for lang in languages\" ng-change=changeLanguage(site.language)> <option value=\"\">Select language</option> </select> </div> </div>";

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = ['$translateProvider', function ($translateProvider) {
	    $translateProvider.useSanitizeValueStrategy('escaped');
	
	    $translateProvider.translations('en', __webpack_require__(534));
	
	    $translateProvider.useStaticFilesLoader({
	        prefix: 'locales/',
	        suffix: '.json'
	    });
	
	    $translateProvider.preferredLanguage('en');
	    $translateProvider.fallbackLanguage('en');
	}];

/***/ }),
/* 534 */
/***/ (function(module, exports) {

	module.exports = {"app":{"powered_by_ushahidi":"Powered by Ushahidi.","support":"Ushahidi Support","by":"by","submit":"Submit","submitting":"Submitting","submit_another":"Submit & Add Another","submit_response":"Submit a survey response","can_see_this":"can see this","collections":"Collections","create_collection":"Create collection","export_to_csv":"Export to CSV","create_new":"Create new","create_new_survey":"Create new survey","created_by":"Created by {{author}}","date_created":"Date created","date_updated":"Date updated","documentation":{"title":"Documentation","description":"Learn how to set up, configure, and manage your Ushahidi deployment."},"report_a_bug":{"title":"Report a bug","description":"Tell us when something doesn't work the way you expected."},"edit_collection":"Edit collection","features":{"title":"Features","description":"See what Ushahidi can do and how it works."},"forbidden":"Sorry, you're not allowed to do that.","get_notifications":"Get notifications","turn_off_notifications":"Turn off notifications","load_more":"Load more","loading":"Loading","more":"More","cancel":"Cancel","save":"Save","save_and_close":"Save &amp; close","add_and_close":"Add &amp; close","update_and_close":"Update &amp; close","saving":"Saving","settings":"Settings","share":"Share","specific_roles":"Specific roles...","general":"General","surveys":"Survey","add_survey":"Add Survey","edit_survey":"Edit Survey","data_sources":"Data Sources","import":"Import","users":"Users","edit_user":"Edit User","add_user":"Add User","edit":"Edit","roles":"Roles","edit_role":"Edit Role","add_role":"Add Role","webhooks":"Webhooks","edit_webhook":"Edit Webhook","add_webhook":"Add Webhook","categories":"Categories","edit_category":"Edit Category","add_category":"Add Category","categories_count":"{{count}} categories","plans":"Plans","delete":"Delete","description":"Description","color":"Color","search_users":"Search users","searching":"Searching","fields":"Fields","filter_by":"Filter by...","apply_filters":"Apply filters","show_more_less":"Show more/less","filters":"Filters","filter_by_survey":"Filter by survey","configure":"Configure","post":"Post","name":"Name","key":"Key","survey_web_address":"Your survey's web address","default_value":"Default value","tasks":"Tasks","return_to_all_posts":"Return to all posts","this_deplyment_is_private":"This deployment is private","private_deployment":"Private Deployment","mark_as":"Mark as","who_can_see_this_category":"Who can see this category?","this_category_is_child_to":"This category is a child to <strong>{{parent}}</strong>","nothing":"Nothing","who_can_see_this":"Who can see this?","add":"Add","add_new_category":"+ Add new category","sort_by":"Sort By","newest_first":"Newest first","oldest_first":"Oldest first"},"toolbar":{"searchbar":{"search_entity":"Search {{entity}}","search_all_entities_for":"Search all {{entity}} for "}},"color_picker":{"hex_value":"Hex Value","red":"Red","gold":"Gold","blue":"Blue","green":"Green"},"feature_limits":{"view_unavailable":"The {{value}} view isn't available on your current plan. <a href=\"/settings/plan\">Upgrade your plan</a> to get it!"},"limit":{"plan_limit":"Ushahidi Plan Limit","post_limit_reached":"You have reached the limit of published Posts for your plan.","admin_limit_reached":"You have reached the limit of admin users for your plan.","post_type_limit_reached":"You have reached the surveys limit for your plan.","upgrade":"Upgrade"},"activity":{"activity_over_time":"Activity over time","activity_by_volume":"Activity by volume","recent_activity_timeline":"Recent Activity timeline","new_post":"New Post","by":"By","context_body":"A summary of how people are interacting with {{site}}."},"form":{"add_field":"Add field","add_field_instructions":"Add instructions to this field","add_field_instructions_info":"These instructions will be presented as a tooltip to a user when filling in this field.","add_field_instructions_placeholder":"Instructions for field","add_post_type":"Add Survey","add_step":"Add Task","added_form_stage_attribute":"Saved field","field_allowed_relation_post_type":"Allowed surveys","choose_order_message":"Choose and order the fields that you would like to include in this survey","created_form_stage":"Saved task","currently_disabled":"This survey is currently disabled.","custom_structure":"Custom Structure","default_date_placeholder":"Default date","default_default_placeholder":"Default value","default_location_placeholder":"Nairobi, Kenya","delete_post_type":"Delete this survey","deleted_form":"Deleted Survey","deleted_form_stage":"Deleted Task","deleted_form_stage_attribute":"Deleted field","editable_by":"Editable By","edit_post_step":"Edit Task: {{step}}","edit_post_type":"Edit Survey: {{form}}","edit_post_types":"Edit Surveys","field_add_option":"Add","field_default":"Field Default","field_key":"Field Key","field_type":"Field Type","field_name":"Field Name","field_options":"Field Options","field_key_placeholder":"field-key","field_name_placeholder":"Title","field_option_placeholder":"Option 1","field_required":"This field is required","form_name":"Name","form_description":"Description","forms":"Forms","form_stage_settings_saved":"Saved settings","permission_public":"Public","permission_admin":"Admin","permission_self":"Only Me","post_type_settings":"Survey Settings","post_step_settings":"Task Settings","priority_changed":"Changed priority","save_and_close":"Save & Close","save_post_type":"Save Survey","save_post_step":"Save Task","saved_form":"Survey saved.","step_delete":"Delete","step_name":"Task Name","step_rename":"Rename","step_required":"This task is required","post_step":"Post","type":"type","visible_to":"Visible To"},"survey":{"delete_task":"Delete task","duplicate_task":"Duplicate task","show_this_task_to":"Show this task to everyone when published","show_this_task_to_desc":"When a survey response is published, data from this task will be displayed.","survey_name":"Survey name","describe_your_survey":"Describe your survey...","describe_this_task":"Describe this task...","untitled_task":"Untitled task","add_task":"Add task","title":"Title","field_allowed_relation_survey":"Allowed surveys","description":"Description","task_description":"Task description","post_fields":"Post fields","task_fields":"Task fields","show_task":"Show this task to everyone when the post is published","task_info":"You can add additional information to each post, like translations or verification, and assign them to people by adding <strong>Tasks</strong>. You can choose from pre-built tasks or create your own from scratch.","text_desc":"A sentence or less","textarea_desc":"Multiple sentences or paragraphs","decimal_desc":"A number with decimal places","integer_desc":"A whole number","location_desc":"A geographic location chosen via a map","date_desc":"A date with year, month, day","datetime_desc":"A date with time in hours and minutes","select_desc":"A drop down list of items","radio_desc":"Allows the user to choose only one of a predefined set of options.","checkbox_desc":"Allows the user to choose one or more of a predefined set of options.","relation_desc":"Create a relation between different surveys","upload_desc":"Allows image(s) to be uploaded to the post","video_desc":"Allows Youtube or Vimeo videos to be embed in the post","markdown_desc":"Allows the use of markdown syntax to style the field content.","tasks":"Tasks","show_field_description":"Show field description","add_field":"Add field","edit_field":"Edit field","build":"Build","configure":"Configure","require_section":"Require this task be completed before a post can be visible to the public","hide_author_information":"Hide author information","hide_author_information_desc":"Only people with permission to edit responses will be able to see who submitted them; and only when editing them.","share":"Share","task_name":"Task name","required_field":"Required","required":"Required","required_desc":"Require this task be completed before a post can be visible to the public.","require_field_desc":"Require this field be completed","name_this_task":"Name this task...","require_review":"Require posts be reviewed before they're published","require_review_desc":"New responses to this survey will be put 'under review', and therefore not immediately visible to the public. Users with permission to review the response can review and 'publish' them, which would then make them visible to everyone.","require_task":"Required","make_response_private":"Make responses private","response_private_desc":"Only people with permission to edit responses can see responses to this field","require_task_desc":"Require this task be completed before a post can be visible to the public","survey_permissions":"Survey permissions","who_can_add":"Who can add to this survey","who_can_contribute_to_task":"Who can contribute to fields in this task","delete":{"desc":"<strong>If you delete this survey</strong>, all of its posts will also be deleted. Proceed with caution.","delete":"Delete survey","delete_this":"Delete this survey","delete_this_field":"Delete this field","delete_field":"Delete field","desc_field":"<strong>If you delete this field</strong>, all of the data that was collected within it will also be deleted. Proceed with caution."},"name":"Survey name","color":{"color":"Color","hex":"Hex value","red":"Red","gold":"Gold","blue":"Blue","green":"Green"},"who":"Who can see this?","task":{"delete":{"desc":"<strong>If you delete this task</strong>, all of the data captured in it will also be deleted. Proceed with caution.","delete":"Delete task","delete_this":"Delete this task"}}},"global_filter":{"filter":"Filter","categories":{"categories":"Categories","all_categories":"All Categories"},"post_types":{"post_types":"Surveys","all_types":"All Types","unstructured":"Unstructured"},"post_statuses":{"post_statuses":"Status","all_statuses":"Any Status","draft":"Draft","published":"Published"},"post_stages":{"post_stages":"Current Task","all_stages":"All Tasks"},"collections":{"collections":"Collections","all_collections":"All Collections","search_collections":"Search Collections"},"filter_tabs":{"q":"Keyword","created_after":"Start date","created_before":"End date","date_after":"Start date","date_before":"End date","center_point":"Location","tags":"Category","form":"Survey","current_stage":"Current Task","set":"Collection","status":"Status","location_value":"Within {{km}} km of {{value}}","visible_to":"Visible to","user":"User","has_location":"Post-locations","all_posts":"Show all posts","unmapped":"Show unmapped posts","mapped":"Show posts with a location"},"more":"More","keyword":"Keyword","start_date":"Start Date","start_date_placeholder":"Jan 25, 2014","end_date":"End Date","end_date_placeholder":"April 25, 2014","location":"Location","location_placeholder":"Enter city or address","within_km":"Within","km":"Km","within_km_placeholder":"Distance","option_1":"within 1 km","option_2":"within 10 km","option_3":"within 50 km","option_4":"within 100 km","option_5":"within 500 km","clear_filters":"Clear Filters","apply_filters":"Apply","save_to_set":"Save to Set","search":"Search","date_range":"Date range","who_its_visible_to":"Who it's visible to","status":"Status"},"graph":{"all_posts":"Nothing; Show all posts","all":"All time","compare":"Compare...","compare_all":"Compare...","compare_status":"Compare status","compare_tags":"Compare categories","compare_form":"Compare surveys","compare_":"Compare ","created":"Created time","cumulative":"Show cumulative totals","cumulative_post_count":"Total post count","custom":"Custom date range","custom_display":"{{start || 'Beginning'}} to {{end || 'Now'}}","group_by_placeholder":"Graph","new_post_count":"New posts","none":"None","no_data":"No activity to show","post_count":"Post count","post_date":"Post created date","select_one":"Select one","week":"This week","month":"This month","updated":"Updated time"},"message":{"button":{"dismiss":"Dismiss","default":"Ok","cancel":"Cancel"}},"modal":{"button":{"close":"Close"}},"nav":{"about":"About","activity":"Activity","add_post":"Add Post","account_settings":"Account Settings","alerts":"Alerts","all":"All","author_tagline":"By {{author}}","appearance":"Appearance","back":"Back","category":"Category","categories":"Categories","clear":"Clear","collections":"Collections","comments":"Comments","data_sources":"Data Sources","data_import":"Data Import","deselect":"Deselect","edit_profile":"Edit Profile","edit_post_type":"Edit Survey","everyone":"Everyone","export":"Export","forbidden":"Access Denied","dashboard":"Dashboard","delete":"Delete","edit":"Edit","filters":"Filters","forgotyourpassword":"Forgot your password?","resetpassword":"Reset password","resetmypassword":"Reset my password","forms":"Forms","help":"Help","home":"Home","login":"Log in","logout":"Log out","registration":"Sign up","register":"Sign up","map_settings":"Map Settings","more":"More","notifications":"Notifications","only_author":"Only the author","only_you":"Only you","people":"People","permissions":"Permissions","plan_settings":"Plan","please_wait_loading":"Please wait. Loading...","plugins":"Plugins","posts":"Posts","posts_and_entities":"Surveys","profile":"My Profile","role":"Role","roles":"Roles","webhook":"Webhook","webhooks":"Webhooks","saved_searches":"Saved Searches","search":"Search","select_all":"Select all","selected_items":"{{selectedItems}} selected","settings":"Settings","survey_settings":"Survey settings","tags":"Categories","today":"Today","general":"General Settings","type":"Type","unknown":"Unknown","unselect_all":"Unselect All","user":"User","users":"Users","views":"Views","yesterday":"Yesterday"},"views":{"map":"Map","list":"Timeline","activity":"Activity"},"post":{"add_to_form":"Add to {{form}}","posts":"Posts","there_are_no_posts":"There are no posts","in_this_deployment":" in this deployment, yet.","by":"by","task_completed":"Task completed","everyone":"Everyone","just_you":"Just you","specific_roles":"Specific roles...","can_see_this":"can see this","add_post_type":"Add {{form_name}}","edit_post_type":"Edit {{form_name}}","messages":{"by_sms":"By SMS","by_email":"By Email","by_twitter":"By Twitter","reply":"Reply to Message thread","send":"Send New Message","save":"Save","title":"Conversation with author","associated_messages":"View messages associated with this post"},"post":"Post","message":"Message","message_thread":"Message Thread","all_posts":"All Posts","no_search_results":"Your search didn't match any posts","no_posts_yet":"There are no posts yet!","add_first_post":"Add the first post","create_post":"Create Post","create":"Create","change":"Change","posted_by":"Posted by","draft":"Under review","archived":"Archived","edited_by":"Edited by","export":"Export","select_all":"Select All","unselect_all":"Unselect All","per_page":"{{count}} posts","post_details":"Post Details","steps":"This post's tasks","mark_complete":"Mark as Complete","complete":"Complete","type_details":"{{type}} Details","edit_post":"Edit Post","history":"History","hide_form":"Hide {{form}}","hide_unknown_form":"Hide Unknown","publish":"Publish to...","publish_for_you":"You","publish_for_everyone":"Everyone","published":"Published","unpublished":"Unpublished","published_by":"Published by","can_see_this_post":"can see this post","location":"Location","categories":"Categories","status":"Status","type":"Type","view":"View","step":"Task","update":"Update","options":"Options","complete_draft":"Complete (Draft)","complete_published":"Complete (Published)","structure":"Structure","source":"via {{source}}","visible_to_public":"This post is visible to the public","visible_to_you":"This post is visible to just you and admins","visible_to_roles":"This post is visible to {{roles}}","show_only_form":"Show only {{form}}","show_only_unknown_form":"Show only Unknown","delete_post":"Delete post","delete_this_post":"Delete this post","delete_post_desc":"<strong>If you delete this post</strong>, all of its comments will also be deleted. Proceed with caution.","post_actions":{"edit":"Edit","delete":"Delete","export":"Export","put_under_review":"Put under review","archive":"Archive","publish":"Publish"},"created_at":"<strong>Created</strong> at","updated_at":"<strong>Last updated</strong> at","author":"Author","post_date":"Post date","change_author":"Change author","status_published":"Published","status_review":"Under review","status_archived":"Archived","modify":{"intro":"Select survey:","no_task_values":"There are currently no saved values for this task.","create_type":"Create {{type}}","edit_type":"Edit {{type}}: {{title}}","add_a_post":"Add a post","add_to_survey":"Add to this survey","edit_post":"Edit {{title}}","change_type":"Change type","incomplete_step":"To publish a post all required tasks must be marked as complete. The required task {{stage}} has not yet been marked complete","save_post":"Save Post","publish":"Publish to...","publish_to":"Publish to {{role}}","published_to":"Published to {{role}}","unpublish":"Revert to Draft","everyone":"Everyone","back":"Back","contact_info":"Enter your contact info (optional)","author_realname":"Name","author_email":"Email","form":{"categories":"Categories","description":"Description","location":"Location","title":"Title","link":{"name":"Link Name","url":"Link url","add_link":"Add Link"}}},"preview":{"private":"private","public":"public","read_more":"&nbsp;... Read&nbsp;More","tags":"Categories","post_actions":{"post_actions":"Post Actions","select":"select","edit":"edit","set":"set","publish":"publish","unpublish":"unpublish","delete":"delete"}},"valid":{"invalid_state":"This post is currently in an invalid state. You'll need to complete all required tasks before you can re-publish this post. You can either complete the necessary tasks or give your post a different status, like \"under review.\"","validation_fail":"Required fields are missing, these fields are marked with an * below.","title":{"required":"A title is required","minlength":"Title is too short","maxlength":"Title is too long"},"content":{"required":"Description cannot be empty"},"tags":{"required":"Categories are required"},"values":{"required":"\"{{label}}\" is required","parse":"\"{{label}}\" could not be parsed","date":"\"{{label}}\" must be a date","number":"\"{{label}}\" must be a number"},"author_name":{"maxlength":"Name is too long"},"author_email":{"email":"Invalid email"}},"media":{"enter_a":"Enter a","youtube":" Youtube","current_url":"Current image","add_caption":"Add caption","upload":"Upload","add_photo":"Add photo","delete_photo":"Delete photo","replace_image":"Replace image"},"video":{"enter_a":"Enter a","or":" or ","vimeo":" Vimeo","video_url":" video URL"},"unstructured":{"add_survey":{"info":"<strong>This post hasn't yet been assigned to a survey within your deployment.</strong> That's because it was submitted via {{source}}, which doesn't provide a way for the author to add their post to a specific survey.","choose":"Which survey would you like to add this post to?","title":"Add this post to a survey","save_and_edit":"Add to survey &amp; edit"},"survey_title":"Unknown Survey"}},"role":{"add_role":"Add Role","edit_role":"Edit Role","name":"Name","description":"Description","save":"Save Role","save_add_another":"Save & Add Another","permissions":"Permissions","delete":"Delete","delete_role":"Delete this role","delete_role_desc":"<strong>If you delete this role</strong>, all of the users assigned to it will be assigned default permissions. Proceed with caution.","everyone":"Everyone","just_you":"Just you"},"webhook":{"add_webhook":"Add Role","edit_webhook":"Edit Role","name":"Name","shared_secret":"Shared Secret","url":"API URL","entity_type":"Entity Type","event_type":"Event Type","save":"Save Role","save_add_another":"Save & Add Another","delete":"Delete","delete_webhook":"Delete this webhook","delete_webhook_desc":"<strong>If you delete this webhook</strong>, all associated webhook events will be lost. Proceed with caution."},"saved_search":{"visible_to_public":"This Saved Search is visible to the public","visible_to_you":"This Saved Search is visible to just you and admins","visible_to_roles":"This Saved Search is visible to {{roles}}","featured":"Featured","featured_tooltip":"Featured searches appear to all users in <br>the \"Saved Searches\" menu"},"collection":{"visible_to_public":"This Collection is visible to the public","visible_to_you":"This Collection is visible to just you and admins","visible_to_roles":"This Collection is visible to {{roles}}"},"set":{"by":"by","clear_search":"Clear Search","create_collection":"Create Collection","create_new":" Create New","create_savedsearch":"Create Saved Search","description":"Description","delete_collection":"Delete this collection","delete_savedsearch":"Delete this Saved Search","default_viewing_mode":"Default viewing mode","edit_collection_settings":"Edit Collection","edit_search_settings":"Edit Saved Search","featured":"Featured","featured_collection":"This collection is featured","featured_collection_tooltip":"Featured Collections appear to all users in <br>the \"Collections\" menu","find_a_collection":"Find a collection...","find_a_saved_search":"Find a saved search...","add_to_collection":"Add to Collection","empty_list_collections":"No collections","empty_list_savedsearches":"No saved searches","collection_name":"Collection name","name_your_collection":"Name your collection...","name_savedsearch":"Saved Search name","visible_to_collection":"Who can see this Collection","visible_to_savedsearch":"Who can see this Saved Search","reset_savedsearch":"Reset Search","save_set":"Save Collection","save_savedsearch":"Save Search","update_savedsearch":"Update Search","set_settings":"Collection Settings","add_notification":"Add Notification","remove":"remove"},"category":{"add_tag":"Add Category","save_add_another":"Save & Add Another","delete_category":"Delete category","delete_this_category":"Delete this category","delete_category_desc":"<strong>If you delete this category</strong>, it will no longer be associated with any posts. Proceed with caution.","child_permissions":"Permissions for this category are managed by the parent category.","select_all":"Select All","choose_roles":"Choose Roles","create_tag":"Create Category","saved_tag":"Category saved.","deleted_tags":"Categories deleted.","manage_tags":"Manage Categories","edit_tag":"Edit Category","editor":{"name":"Category Name","slug":"Category Link","slug_help":"If left blank, will be automatically generated from category name.","description":"Description","type":"Type","color":"Icon Color","icon":"Icon Name","roles_help":"Only selected roles will be able to view this category."},"types":{"category":"Category","status":"Status"},"delete":"Delete"},"tool":{"manage_forms":"Manage Forms","manage_tags":"Manage Categories","manage_users":"Manage Users","manage_roles":"Manage Roles","manage_webhooks":"Manage Webhooks","manage_views":"Manage Views","manage_map_settings":"Manage Map Settings","manage_appearance_settings":"Manage Appearance Settings","manage_plugins":"Manage Plugins","appearance_settings":"Appearance Settings","map_settings":"Map Settings","site_settings":"Site Settings","settings":"Settings","tools":"Tools"},"map_settings":{"admin_map_settings":"Map Settings","saved_map_settings":"Map Settings saved."},"settings":{"appearance":"Appearance Settings","continue":"Continue","current_header":"Current background image","customize_your_new_deployment":"Customize your new deployment","embed":"Embed","embed_info":"To embed your map on another site use the code snippet below.","embed_code":"&lt;iframe width=\"500\" height=\"400\" src=\"{{url}}\"&gt;&lt;/iframe&gt;","settings_list":{"general":"General","general_desc":"Change your deployment's name, description, logo, and other details.","surveys":"Surveys","surveys_desc":"Create and configure the surveys your deployment collects.","data_sources":"Data Sources","data_sources_desc":"Configure email, SMS, and social media channels that help your deployment collect survey data.","import":"Import","import_desc":"Upload survey data to your deployment from a CSV file.","users":"Users","users_desc":"Create and manage the people that contribute to your deployment.","roles":"Roles","roles_desc":"Create and manage the type of permissions your users have on your deployment.","categories":"Categories","categories_desc":"Create and manage the categories people can put posts into for improved organization.","webhooks":"Webhooks","webhooks_desc":"Create webhooks that send Ushahidi Platform data to external applications when specific events are triggered.","plans":"Plans","plan_desc":"Your deployment's current plan is <strong>{{current_plan}}</strong>."},"data_sources":{"data_sources":"Data Sources","enable_provider_message":"Accept survey submissions from this source","hint_turn_on_off":"You can configure options for data sources, and then turn sources on and off.","hint_plugin_needs_configuring":"You need to configure this data source before you can enable it.","provider_options":"Options","configure":"Configure","options":"Options","saving_changes":"Saving","unavailable":"The datasource {{value}} is unavailable. <a href=\"/settings/plan\">Upgrade your plan</a> to get it!"},"deployment_delete_this":"Delete this deployment","deployment_delete":"Delete deployment","deployment_delete_info":"<strong>If you delete this deployment</strong>, all of its data will also be deleted. Proceed with caution.","deployment_name":"Deployment name","deployment_logo":"Deployment logo","map_default_baselayer":"Default base layer","map_clustering":"Combine nearby posts","map_default_latitude":"Default latitude","map_default_longitude":"Default longitude","map_default_zoom_level":"Default zoom level","map_default_location":"Default location","site":"Site Settings","site_email":"Contact email address","site_email_note":"Use caution, as this will be visible to anyone on your site.","site_description":"Describe your site","site_description_placeholder":"An optional one sentence description","site_timezone":"Site timezone","site_language":"Site language","site_private":"Make this deployment private","select_image":"Select image","saved_settings":"Deployment settings saved!","saved_map_settings":"Map settings saved!","features":{"features":"Features","please_select_features":"Please select the features you would like to enable."},"generic_field_error":"Invalid entry, please try again.","skip":"Skip this task","add_first_post":"Add Your First Post","add_first_post_subtitle":"A deployment is nothing until it has some content in it.","invite_people":"Or invite people to help you create posts.","add_new_users":"Add New Users","valid":{"name":{"required":"Site name is required"}}},"data_import":{"survey_field":"Survey field","csv_column":"CSV column","choose_which_column":"Choose which CSV column should be assigned to each survey field","each_survey_field":"Each of the survey's fields are listed below. Choose the column from your CSV file that you'd like to use to populate each of those fields.","status_explanation":"Ushahidi recognizes one of three post statuses: Published, Under review, and Archived. So be sure that each entry in the column you select has one of those three values.","defined_column":"Defined by a column in your CSV file...","imported_posts_status":"Imported posts should have their status...","marked_as":"Marked as...","see_imported_posts":"See imported posts","import_another_csv":"Import another CSV file","import_complete":"Your import is complete","complete_info":"The data from your CSV spreadsheet, <em>{{filename}}</em>, was successfully imported into your <a href=\"/settings/survey/{{form_id}}\">{{form_name}}</a> survey.","import_another":"Import another CSV file","nearly_complete":"Your import is nearly complete","finish_info":"The data from your CSV spreadsheet is still being processed. You're welcome to leave this page or wait until the process is complete. Either way, we'll notify you when your data is ready.","next":"Next","configure_imported_posts":"Configure imported posts","configure_explanation":"Through this interface you can set values for the survey fields that were not mapped to entries in the CSV. These values will be the same for all imported posts.","import":"Import","import_explanation_csv":"Import the data from a CSV spreadsheet into your deployment as posts belonging to a specific survey","import_explanation_file_size":"The size for a single file is limited to 10 MB","import_explanation_format_location_1":"Geographic locations should be included as separate latitude and longitude columns in your CSV","import_explanation_required_fields":"All required survey fields must have an associated value set in the CSV. For example, if the field title is required then the field must be mapped to a CSV column where all rows of that column have a value set","configure_posts":"Configure Posts","configure_all_imported_posts":"Configure all imported posts","csv":"CSV","file_csv":"CSV file","import_csv":"Import CSV","import_to":"Import to ","choose_csv_file":"Choose CSV file","organize_data":"Organize data","organize_your_imported_data":"Assign CSV columns to post fields","assign_csv_message":"Assign CSV columns to post fields","csv_instructions":"Each of the column names from your CSV file are listed below. Choose the <strong>{{form_name}}</strong> field that you'd like each column to be imported to.","csv_instructions_required_fields":"Fields marked with a [*] are required and must be assigned a value.","csv_column_name":"CSV column name","post_type_title":"{{form_name}} field name","leave_empty":"Leave empty","cancel_import":"Cancel import","finish_import":"Finish import","which_survey":"which survey?"},"user":{"add_user":"Add User","edit_user":"Edit User","update_password":"Update Password","change_role":"Change Role","save":"Save User","save_add_another":"Save & Add Another","show_all_roles":"Show All Roles","cannot_delete_yourself":"You cannot delete your own user","cannot_change_your_own_role":"You cannot change your own role","confirm_password":"Confirm Password","delete_user":"Delete user","delete_this_user":"Delete this user","delete_user_desc":"<strong>If you delete this user</strong>, posts created by this user will no longer have author information. This cannot be undone. Proceed with caution.","edit_profile":"Edit Profile","save_profile":"Save Profile","cancel":"Cancel","email":"Email Address","failed_attempts":"Failed attempts: ","full_name":"Display Name","never":"Never","no_full_name":"No display name","number_of_users_shown":"Number of users shown","per_page":"{{count}} users","password":"Password","new_password":"New Password","register":"Register","role":"Role: ","roles":"Roles","saved_user":"User saved","deleted_user":"User deleted","search_and_filter":"Search & Filter Users","passwordreset_instructions":"Enter your email to request a password reset","passwordreset_confirm_instructions":"If your email exists in our database, you will receive a password recovery email soon.","token":"Password reset token","valid":{"full_name":{"required":"Display name is required","maxlength":"Display name is too long"},"email":{"required":"Email address is required","email":"This email address is invalid","maxlength":"This email address is too long"},"password":{"required":"Password is required","minlength":"This password is too short","maxlength":"This password is too long"}}},"user_profile":{"title":"account settings","update_password":"Update password","update_success":"Your profile was updated successfully. You may need to sign out and back in before all your changes are reflected.","button":{"save":"Save &amp; close","cancel":"Cancel"},"nav":{"general":"General","notifications":"Notifications"}},"user_create":{"full_name":"Display Name","email":"Email Address","role":"Role"},"notify":{"contact":{"save_success":"Contact saved","delete_confirm":"Do you want to remove your account?","error_message":"An error occurred while trying to remove your account","destroy_success":"Account removed successfully"},"default":{"proceed_warning":"This action cannot be undone. Please proceed with caution.","save_success":"Saved resource","save_error":"Unable to save resource, please try again","destroy_confirm":"Are you sure you want to delete this resource?","destroy_success":"Deleted resource","destroy_error":"Unable to delete resource, please try again","destroy_cancelled":"Delete cancelled","bulk_destroy_confirm":"Are you sure you want to delete {{count}} resources?","bulk_destroy_success":"Deleted resource","bulk_destroy_error":"Unable to delete resource, please try again","bulk_destroy_cancelled":"Delete cancelled"},"data_import":{"see_imported_posts":"See imported posts","file_missing":"Please choose a CSV file to upload.","form_missing":"Please select a Survey.","csv_upload":"File {{name}} successfully uploaded","csv_import_processed_errors":"<strong>Your CSV import</strong> is complete. {{processed}} records imported, {{errors}} records failed.","csv_import_success_info":"The data from your CSV spreadsheet, <em>{{filename}}</em>, was successfully imported into your <a href=\"/views/list\">{{form_name}}</a> survey.","duplicate_fields":"Columns must be mapped to unique survey fields. The following columns have more than 1 mapping: {{duplicates}}","required_fields":"Required fields must be set to a value. The following fields have not been set: {{required}}","no_mappings":"No fields have been assigned mappings - at least one field must be mapped to continue","csv_import_cancel":"CSV import cancelled","csv_import_cancel_confirm":"Are you sure you want to cancel importing?"},"general_settings":{"save_success":"General settings saved"},"map_settings":{"save_success":"Map settings saved"},"generic":{"okay":"Ok","alerts":"Alerts","confirm":"Confirmation"},"login":{"failed":"Login failed, check your email and password."},"register":{"failed":"There were errors during registration. Check your input and try again.","success":"Registration complete! You can now log in.."},"post":{"delete_image_confirm":"Are you sure you want to remove this image?","save_success":"Post {{name}} saved","save_success_review":"Post {{name}} saved. Your post will be reviewed by a moderator before publishing.","save_error":"Unable to save post, please try again","publish_success":"Post has been published for {{role}}","set_draft":"Post is now visible to just you","publish_error":"Unable to publish post, please try again","unpublish_success":"Post has been unpublished","unpublish_error":"Unable to unpublish post, please try again","yes_confirm_delete":"Yes, delete this post","confirm_delete":"Confirm Delete","destroy_title":"Delete Post","delete_question":"Are you sure you want to delete your post {{post}}?","destroy_success":"Post deleted","destroy_success_bulk":"Posts deleted","destroy_confirm":"Are you sure you want to delete this post?","destroy_error":"Unable to delete post, please try again","bulk_destroy_confirm":"Are you sure you want to delete {{count}} posts?","stage_save_success":"Updated {{stage}}","export":"This will export filtered posts. Are you sure you want to continue?","update_status_success_bulk":"Status updated for {{count}} posts"},"category":{"save_success":"Saved category {{name}}","destroy_confirm":"Are you sure you want to delete this category?","destroy_confirm_desc":"Deleting this category will remove it from all existing posts. This action cannot be undone.","destroy_success":"Category deleted","destroy_error":"Unable to delete category, please try again","bulk_destroy_confirm":"Are you sure you want to delete {{count}} categories?","bulk_destroy_confirm_desc":"Deleting these categories will remove them from all existing posts. This action cannot be undone.","bulk_destroy_success":"{{count}} categories deleted"},"role":{"delete_question":"Are you sure you want to delete the role {{role}}?","destroy_success":"Role {{role}} deleted.","save_success":"Role {{role}} saved.","last_admin":"You can not delete the only admin role"},"webhook":{"delete_question":"Are you sure you want to delete the webhook {{webhook}}?","destroy_success":"Webhook {{webhook}} deleted.","save_success":"Webhook {{webhook}} saved."},"datasource":{"save_success":"Saved Data Source {{name}}"},"user":{"save_success":"User {{name}} saved","edit_success":"User {{name}} updated","destroy_confirm":"Are you sure you want to delete this user?","destroy_success":"User deleted","destroy_error":"Unable to delete user, please try again","bulk_destroy_confirm":"Are you sure you want to delete {{count}} users?","bulk_destroy_success":"Users deleted","bulk_role_change_confirm":"Are you sure you want to change the role of {{count}} users to {{role}}?","bulk_role_change_success":"User roles changed to {{role_name}}"},"video":{"incorrect_url":"The URL, {{url}}, you entered did not match either a Youtube or Vimeo URL format."},"form":{"add_to_survey":"Add to survey","save_success":"Survey {{name}} saved","save_stage_success":"Survey task {{name}} saved","save_attribute_success":"Field {{name}} added","edit_form_success":"Survey {{name}} updated","edit_stage_success":"Survey task {{name}} updated","delete_form_confirm":"Are you sure you want to delete this survey?","delete_form_confirm_desc":"This action cannot be undone. Deleting this survey will remove all of its data, including posts.","destroy_form_success":"Survey {{name}} deleted","delete_stage_confirm":"Are you sure you want to delete this task?","delete_stage_confirm_desc":"This action cannot be undone. Deleting this task will remove all of its fields, and any data in them.","destroy_stage_success":"Survey task {{name}} deleted","delete_attribute_confirm":"Are you sure you want to delete this field?","delete_attribute_confirm_desc":"This action cannot be undone. Deleting this field will remove its data from all existing posts.","destroy_attribute_success":"Field {{name}} deleted"},"collection":{"delete_collection_confirm":"Are you sure you want to delete this collection?","created_collection":"Collection {{collection}} created successfully","updated_collection":"Collection {{collection}} saved","add_to_collection":"Post has been added to {{collection}}","removed_from_collection":"Post has been removed from {{collection}}","bulk_add_to_collection":"{{count}} posts have been added to {{collection}}"},"savedsearch":{"delete_savedsearch_confirm":"Are you sure you want to delete this saved search?"},"passwordreset":{"failed":"Password reset failed","success":"Your password has been reset"},"notification":{"add":"You will now be notified when new posts are added to {{set}}","delete_confirm":"Are you sure you want to remove this notification?","destroy_success":"<strong>You will no longer receive notifications about</strong> {{name}}."},"message":{"sent_to":"Message sent to {{contact}}"}},"empty":{"default":"No records found.","post":"No posts found.","user":"No users found.","category":"No categories found.","role":"No roles found.","webhook":"No webhooks found.","permission":"No permissions found.","form":"No forms found."},"location":{"search":"Search","use_current_location":"Use your current location","click_map":"<em>You can search or click the area of map where you want to place the marker.</em>","placeholder":"Find a location..","search_results":"Search results","error":"Sorry we could not find a location matching your search"},"notification":{"title":"Notifications","contacts_heading":"How you get notifications","notifications_heading":"What you get notified about","error_message":"The notification could not be deleted at this time","send_to_address":"Send notifications to this address","button":{"delete":"Delete notification"}},"contact":{"edit":"Edit","save_changes":"Save changes","saving_changes":"Saving changes","cancel_edit":"Cancel","add_phone_number":"Add a phone number","add_email_address":"Add an email address","edit_phone_number":"Edit your phone number","edit_email_address":"Edit your email address","error_message":"The contact could not be saved at this time","type":{"phone":"Phone","email":"Email"},"button":{"add":"Add account","delete":"Remove account"},"valid":{"email":{"required":"An email address is required to receive notifications","email":"This email address is invalid","maxlength":"This email address is too long"},"phone":{"required":"A phone number is required to receive notifications","pattern":"A valid phone number is required","minlength":"This number is too short","maxlength":"This number is too long"}}},"terms_of_service":{"title":"Ushahidi Terms of Service","terms_of_service":"We have updated our <a href=\"https://www.ushahidi.com/terms-of-service\" target=\"_blank\">Terms and Conditions</a> and <a href=\"https://www.ushahidi.com/privacy-policy\" target=\"_blank\">Privacy Policy</a>. Please review these documents carefully and accept the terms in order to continue to use Ushahidi's services.","agree":"I agree to Ushahidi's Terms of Service.","accept_and_continue":"Accept and Continue"},"languages":{"ach":"Acoli","ady":"Adyghe","af":"Afrikaans","af-ZA":"Afrikaans (South Africa)","ak":"Akan","sq":"Albanian","sq-AL":"Albanian (Albania)","aln":"Albanian Gheg","am":"Amharic","am-ET":"Amharic (Ethiopia)","ar":"Arabic","ar-EG":"Arabic (Egypt)","ar-SA":"Arabic (Saudi Arabia)","ar-SD":"Arabic (Sudan)","ar-SY":"Arabic (Syria)","ar-AA":"Arabic (Unitag)","an":"Aragonese","hy":"Armenian","hy-AM":"Armenian (Armenia)","as":"Assamese","as-IN":"Assamese (India)","ast":"Asturian","ast-ES":"Asturian (Spain)","az":"Azerbaijani","az@Arab":"Azerbaijani (Arabic)","az-AZ":"Azerbaijani (Azerbaijan)","az-IR":"Azerbaijani (Iran)","az@latin":"Azerbaijani (Latin)","bal":"Balochi","ba":"Bashkir","eu":"Basque","eu-ES":"Basque (Spain)","bar":"Bavarian","be":"Belarusian","be-BY":"Belarusian (Belarus)","be@tarask":"Belarusian (Tarask)","bn":"Bengali","bn-BD":"Bengali (Bangladesh)","bn-IN":"Bengali (India)","brx":"Bodo","bs":"Bosnian","bs-BA":"Bosnian (Bosnia and Herzegovina)","br":"Breton","bg":"Bulgarian","bg-BG":"Bulgarian (Bulgaria)","my":"Burmese","my-MM":"Burmese (Myanmar)","ca":"Catalan","ca-ES":"Catalan (Spain)","ca@valencia":"Catalan (Valencian)","ceb":"Cebuano","tzm":"Central Atlas Tamazight","hne":"Chhattisgarhi","cgg":"Chiga","zh":"Chinese","zh-CN":"Chinese (China)","zh-CN.GB2312":"Chinese (China) (GB2312)","gan":"Chinese (Gan)","hak":"Chinese (Hakka)","zh-HK":"Chinese (Hong Kong)","czh":"Chinese (Huizhou)","cjy":"Chinese (Jinyu)","lzh":"Chinese (Literary)","cmn":"Chinese (Mandarin)","mnp":"Chinese (Min Bei)","cdo":"Chinese (Min Dong)","nan":"Chinese (Min Nan)","czo":"Chinese (Min Zhong)","cpx":"Chinese (Pu-Xian)","zh-Hans":"Chinese Simplified","zh-TW":"Chinese (Taiwan)","zh-TW.Big5":"Chinese (Taiwan) (Big5) ","zh-Hant":"Chinese Traditional","wuu":"Chinese (Wu)","hsn":"Chinese (Xiang)","yue":"Chinese (Yue)","cv":"Chuvash","ksh":"Colognian","kw":"Cornish","co":"Corsican","crh":"Crimean Turkish","hr":"Croatian","hr-HR":"Croatian (Croatia)","cs":"Czech","cs-CZ":"Czech (Czech Republic)","da":"Danish","da-DK":"Danish (Denmark)","dv":"Divehi","doi":"Dogri","nl":"Dutch","nl-BE":"Dutch (Belgium)","nl-NL":"Dutch (Netherlands)","dz":"Dzongkha","dz-BT":"Dzongkha (Bhutan)","en":"English","en-AU":"English (Australia)","en-AT":"English (Austria)","en-BD":"English (Bangladesh)","en-BE":"English (Belgium)","en-CA":"English (Canada)","en-CL":"English (Chile)","en-CZ":"English (Czech Republic)","en-ee":"English (Estonia)","en-FI":"English (Finland)","en-DE":"English (Germany)","en-GH":"English (Ghana)","en-HK":"English (Hong Kong)","en-HU":"English (Hungary)","en-IN":"English (India)","en-IE":"English (Ireland)","en-lv":"English (Latvia)","en-lt":"English (Lithuania)","en-NL":"English (Netherlands)","en-NZ":"English (New Zealand)","en-NG":"English (Nigeria)","en-PK":"English (Pakistan)","en-PL":"English (Poland)","en-RO":"English (Romania)","en-SK":"English (Slovakia)","en-ZA":"English (South Africa)","en-LK":"English (Sri Lanka)","en-SE":"English (Sweden)","en-CH":"English (Switzerland)","en-GB":"English (United Kingdom)","en-US":"English (United States)","myv":"Erzya","eo":"Esperanto","et":"Estonian","et-EE":"Estonian (Estonia)","fo":"Faroese","fo-FO":"Faroese (Faroe Islands)","fil":"Filipino","fi":"Finnish","fi-FI":"Finnish (Finland)","frp":"Franco-Provençal (Arpitan)","fr":"French","fr-BE":"French (Belgium)","fr-CA":"French (Canada)","fr-FR":"French (France)","fr-CH":"French (Switzerland)","fur":"Friulian","ff":"Fulah","ff-SN":"Fulah (Senegal)","gd":"Gaelic, Scottish","gl":"Galician","gl-ES":"Galician (Spain)","lg":"Ganda","ka":"Georgian","ka-GE":"Georgian (Georgia)","de":"German","de-AT":"German (Austria)","de-DE":"German (Germany)","de-CH":"German (Switzerland)","el":"Greek","el-GR":"Greek (Greece)","kl":"Greenlandic","gu":"Gujarati","gu-IN":"Gujarati (India)","gun":"Gun","ht":"Haitian (Haitian Creole)","ht-HT":"Haitian (Haitian Creole) (Haiti)","ha":"Hausa","haw":"Hawaiian","he":"Hebrew","he-IL":"Hebrew (Israel)","hi":"Hindi","hi-IN":"Hindi (India)","hu":"Hungarian","hu-HU":"Hungarian (Hungary)","is":"Icelandic","is-IS":"Icelandic (Iceland)","io":"Ido","ig":"Igbo","ilo":"Iloko","id":"Indonesian","id-ID":"Indonesian (Indonesia)","ia":"Interlingua","iu":"Inuktitut","ga":"Irish","ga-IE":"Irish (Ireland)","it":"Italian","it-IT":"Italian (Italy)","it-CH":"Italian (Switzerland)","ja":"Japanese","ja-JP":"Japanese (Japan)","jv":"Javanese","kab":"Kabyle","kn":"Kannada","kn-IN":"Kannada (India)","pam":"Kapampangan","ks":"Kashmiri","ks-IN":"Kashmiri (India)","csb":"Kashubian","kk":"Kazakh","kk@Arab":"Kazakh (Arabic)","kk@Cyrl":"Kazakh (Cyrillic)","kk-KZ":"Kazakh (Kazakhstan)","kk@latin":"Kazakh (Latin)","km":"Khmer","km-KH":"Khmer (Cambodia)","rw":"Kinyarwanda","ky":"Kirgyz","tlh":"Klingon","kok":"Konkani","ko":"Korean","ko-KR":"Korean (Korea)","ku":"Kurdish","ku-IQ":"Kurdish (Iraq)","lad":"Ladino","lo":"Lao","lo-LA":"Lao (Laos)","ltg":"Latgalian","la":"Latin","lv":"Latvian","lv-LV":"Latvian (Latvia)","lez":"Lezghian","lij":"Ligurian","li":"Limburgian","ln":"Lingala","lt":"Lithuanian","lt-LT":"Lithuanian (Lithuania)","jbo":"Lojban","en@lolcat":"LOLCAT English","lmo":"Lombard","dsb":"Lower Sorbian","nds":"Low German","lb":"Luxembourgish","mk":"Macedonian","mk-MK":"Macedonian (Macedonia)","mai":"Maithili","mg":"Malagasy","ms":"Malay","ml":"Malayalam","ml-IN":"Malayalam (India)","ms-MY":"Malay (Malaysia)","mt":"Maltese","mt-MT":"Maltese (Malta)","mni":"Manipuri","mi":"Maori","arn":"Mapudungun","mr":"Marathi","mr-IN":"Marathi (India)","mh":"Marshallese","mw1":"Mirandese","mn":"Mongolian","mn-MN":"Mongolian (Mongolia)","nah":"Nahuatl","nv":"Navajo","nr":"Ndebele, South","nap":"Neapolitan","ne":"Nepali","ne-NP":"Nepali (Nepal)","nia":"Nias","nqo":"N'ko","se":"Northern Sami","nso":"Northern Sotho","no":"Norwegian","nb":"Norwegian Bokmål","nb-NO":"Norwegian Bokmål (Norway)","no-NO":"Norwegian (Norway)","nn":"Norwegian Nynorsk","nn-NO":"Norwegian Nynorsk (Norway)","ny":"Nyanja","oc":"Occitan (post 1500)","or":"Oriya","or-IN":"Oriya (India)","om":"Oromo","os":"Ossetic","pfl":"Palatinate German","pa":"Panjabi (Punjabi)","pa-IN":"Panjabi (Punjabi) (India)","pap":"Papiamento","fa":"Persian","fa-AF":"Persian (Afghanistan)","fa-IR":"Persian (Iran)","pms":"Piemontese","en@pirate":"Pirate English","pl":"Polish","pl-PL":"Polish (Poland)","pt":"Portuguese","pt-BR":"Portuguese (Brazil)","pt-PT":"Portuguese (Portugal)","ps":"Pushto","ro":"Romanian","ro-RO":"Romanian (Romania)","rm":"Romansh","ru":"Russian","ru-ee":"Russian (Estonia)","ru-lv":"Russian (Latvia)","ru-lt":"Russian (Lithuania)","ru@petr1708":"Russian Petrine orthography","ru-RU":"Russian (Russia)","sah":"Sakha (Yakut)","sm":"Samoan","sa":"Sanskrit","sat":"Santali","sc":"Sardinian","sco":"Scots","sr":"Serbian","sr@Ijekavian":"Serbian (Ijekavian)","sr@ijekavianlatin":"Serbian (Ijekavian Latin)","sr@latin":"Serbian (Latin)","sr-RS@latin":"Serbian (Latin) (Serbia)","sr-RS":"Serbian (Serbia)","sn":"Shona","scn":"Sicilian","szl":"Silesian","sd":"Sindhi","si":"Sinhala","si-LK":"Sinhala (Sri Lanka)","sk":"Slovak","sk-SK":"Slovak (Slovakia)","sl":"Slovenian","sl-SI":"Slovenian (Slovenia)","so":"Somali","son":"Songhay","st":"Sotho, Southern","st-ZA":"Sotho, Southern (South Africa)","sma":"Southern Sami","es":"Spanish","es-AR":"Spanish (Argentina)","es-BO":"Spanish (Bolivia)","es-CL":"Spanish (Chile)","es-CO":"Spanish (Colombia)","es-CR":"Spanish (Costa Rica)","es-DO":"Spanish (Dominican Republic)","es-EC":"Spanish (Ecuador)","es-SV":"Spanish (El Salvador)","es-GT":"Spanish (Guatemala)","es-419":"Spanish (Latin America)","es-MX":"Spanish (Mexico)","es-NI":"Spanish (Nicaragua)","es-PA":"Spanish (Panama)","es-PY":"Spanish (Paraguay)","es-PE":"Spanish (Peru)","es-PR":"Spanish (Puerto Rico)","es-ES":"Spanish (Spain)","es-US":"Spanish (United States)","es-UY":"Spanish (Uruguay)","es-VE":"Spanish (Venezuela)","su":"Sundanese","sw":"Swahili","sw-KE":"Swahili (Kenya)","ss":"Swati","sv":"Swedish","sv-FI":"Swedish (Finland)","sv-SE":"Swedish (Sweden)","tl":"Tagalog","tl-PH":"Tagalog (Philippines)","tg":"Tajik","tg-TJ":"Tajik (Tajikistan)","tzl":"Talossan","ta":"Tamil","ta-IN":"Tamil (India)","ta-LK":"Tamil (Sri-Lanka)","tt":"Tatar","te":"Telugu","te-IN":"Telugu (India)","tet":"Tetum (Tetun)","th":"Thai","th-TH":"Thai (Thailand)","bo":"Tibetan","bo-CN":"Tibetan (China)","ti":"Tigrinya","to":"Tongan","ts":"Tsonga","tn":"Tswana","tr":"Turkish","tr-TR":"Turkish (Turkey)","tk":"Turkmen","tk-TM":"Turkmen (Turkmenistan)","udm":"Udmurt","ug":"Uighur","ug@Arab":"Uighur (Arabic)","ug@Cyrl":"Uighur (Cyrillic)","ug@Latin":"Uighur (Latin)","uk":"Ukrainian","uk-UA":"Ukrainian (Ukraine)","vmf":"Upper Franconian","hsb":"Upper Sorbian","ur":"Urdu","ur-PK":"Urdu (Pakistan)","uz":"Uzbek","uz@Arab":"Uzbek (Arabic)","uz@Cyrl":"Uzbek (Cyrillic)","uz@Latn":"Uzbek (Latin)","uz-UZ":"Uzbek (Uzbekistan)","ve":"Venda","vec":"Venetian","vi":"Vietnamese","vi-VN":"Vietnamese (Viet Nam)","vls":"Vlaams","wa":"Walloon","war":"Wáray-Wáray","cy":"Welsh","cy-GB":"Welsh (United Kingdom)","fy":"Western Frisian","fy-NL":"Western Frisian (Netherlands)","wo":"Wolof","wo-SN":"Wolof (Senegal)","xh":"Xhosa","yi":"Yiddish","yo":"Yoruba","zu":"Zulu","zu-ZA":"Zulu (South Africa)"}}

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = ['$templateCache', function ($templateCache) {
	    $templateCache.put('uib/template/pagination/pagination.html', __webpack_require__(536));
	}];

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<nav class=pagination ng-show=\"pages.length > 1\"> <ul> <li ng-if=::boundaryLinks ng-class=\"{disabled: noPrevious()||ngDisabled}\" ng-click=\"selectPage(1, $event)\"> <a ng-click=\"selectPage(1, $event)\">{{::getText('first')}}</a> </li> <li ng-if=::directionLinks ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=prev> <a ng-click=\"selectPage(page - 1, $event)\"> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#chevron-left></use> </svg> <span class=hidden>Previous</span> </a> </li> <li> <ul class=page-numbers> <li class=pg-number ng-repeat=\"page in pages track by $index\" ng-class=\"{active: page.active}\"> <a ng-if=!page.active ng-click=\"selectPage(page.number, $event)\"> {{page.text}} </a> <span ng-if=page.active> {{page.text}} </span> </li> </ul> </li> <li ng-if=::directionLinks ng-class=\"{disabled: noNext()||ngDisabled}\" class=next> <a ng-click=\"selectPage(page + 1, $event)\"> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#chevron-right></use> </svg> <span class=hidden>Next</span> </a> </li> <li ng-if=::boundaryLinks ng-class=\"{disabled: noNext()||ngDisabled}\"> <a ng-click=\"selectPage(totalPages, $event)\">{{::getText('last')}}</a> </li> </ul> </nav> ";

/***/ }),
/* 537 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['CacheFactoryProvider', function (CacheFactoryProvider) {
	    angular.extend(CacheFactoryProvider.defaults, {
	        maxAge: 15 * 60 * 1000, // 15 mins
	        cacheFlushInterval: 60 * 60 * 1000, // This cache will clear itself every hour.
	        storageMode: 'localStorage',
	        storagePrefix: 'ush-caches.',
	        deleteOnExpire: 'aggressive'
	    });
	}];

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = ['$routeProvider', '$locationProvider', function ($routeProvider, $locationProvider) {
	
	    $locationProvider.html5Mode(true);
	
	    $routeProvider.when('/login', {
	        controller: __webpack_require__(539),
	        template: ''
	    }).when('/forbidden', {
	        controller: __webpack_require__(540),
	        template: __webpack_require__(541)
	    }).when('/register', {
	        controller: __webpack_require__(542),
	        template: ''
	    }).when('/forgotpassword', {
	        controller: __webpack_require__(543),
	        template: ''
	    }).when('/forgotpassword/confirm', {
	        controller: __webpack_require__(544),
	        template: ''
	    }).when('/forgotpassword/confirm/:token*', {
	        controller: __webpack_require__(544),
	        template: ''
	    }).otherwise('/');
	}];

/***/ }),
/* 539 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = LoginController;
	
	LoginController.$inject = ['Authentication', '$location'];
	function LoginController(Authentication, $location) {
	    Authentication.openLogin();
	    $location.url('/');
	}

/***/ }),
/* 540 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$scope', function ($scope) {}];

/***/ }),
/* 541 */
/***/ (function(module, exports) {

	module.exports = "<main role=main> <div class=main-col> <h1 class=panel-title translate>nav.forbidden</h1> <p translate> app.forbidden </p> </div> </main> ";

/***/ }),
/* 542 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = RegisterController;
	
	RegisterController.$inject = ['Registration', '$location'];
	function RegisterController(Registration, $location) {
	    Registration.openRegister();
	    $location.url('/');
	}

/***/ }),
/* 543 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['PasswordReset', '$location', function (PasswordReset, $location) {
	    PasswordReset.openReset();
	    $location.url('/');
	}];

/***/ }),
/* 544 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = PasswordResetConfirmController;
	
	PasswordResetConfirmController.$inject = ['$rootScope', 'PasswordReset', '$location', '$routeParams'];
	function PasswordResetConfirmController($rootScope, PasswordReset, $location, $routeParams) {
	    var $scope = $rootScope.$new();
	    $scope.token = $routeParams.token;
	
	    PasswordReset.openResetConfirm($scope);
	    $location.url('/');
	}

/***/ }),
/* 545 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$rootScope', '$location', function ($rootScope, $location) {
	    // Setup PL layout and switching function
	    $rootScope.globalLayout = 'layout-a';
	    $rootScope.setLayout = function (layout) {
	        $rootScope.globalLayout = layout;
	    };
	    // Setup PL modal visible and switching function
	    $rootScope.modalVisible = false;
	    $rootScope.toggleModalVisible = function (state) {
	        $rootScope.modalVisible = typeof state !== 'undefined' ? state : !$rootScope.modalVisible;
	    };
	}];

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = [
	// '$scope',
	'$rootScope', '$translate', 'TranslationService', 'Languages', 'moment', function (
	// $scope,
	$rootScope, $translate, TranslationService, ConfigEndpoint, Languages, moment) {
	
	    $rootScope.rtlEnabled = false;
	
	    $rootScope.switchRtl = function () {
	        $rootScope.rtlEnabled = !$rootScope.rtlEnabled;
	    };
	    TranslationService.getLanguage().then(function (language) {
	        translate(language);
	    });
	
	    function translate(language) {
	        TranslationService.translate(language);
	        if (language !== 'en') {
	            __webpack_require__.e/* require */(1, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(547)("./" + language + '.js')]; (function () {
	                moment.locale(language);
	            }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));});
	        }
	    }
	}];

/***/ }),
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */
/***/ (function(module, exports) {

	module.exports = "<svg class=ushahidi-logo xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink viewBox=\"0 0 273.5 266.5\" xml:space=preserve> <g> <circle cx=248.8 cy=207.1 r=21.6 /> <path d=\"M239.8,81.7c7.9-6.6,12.9-16.5,12.9-27.6c0-19.8-16.1-35.9-35.9-35.9c-7,0-13.6,2.1-19.1,5.5\n            c-2.1-6.2-8-10.7-15-10.7c-5.1,0-9.6,2.4-12.5,6.1c-9.9-3-20.4-4.6-31.3-4.6c-40.6,0-75.9,22.1-94.8,54.9\n            c-23.2,3-41.3,22.8-41.3,46.9c0,21.3,14.1,39.3,33.6,45.2c7.7,20.9,21.6,38.8,39.4,51.5c10.6,28.7,38.2,49.2,70.5,49.2\n            c38.4,0,70.1-28.9,74.6-66.1c17-19.3,27.3-44.5,27.3-72.2C248.2,108.9,245.2,94.7,239.8,81.7 M139,209.4\n            c-47.3,0-85.6-38.3-85.6-85.6S91.7,38.2,139,38.2s85.6,38.3,85.6,85.6C224.5,171.1,186.2,209.4,139,209.4\"/> <circle cx=25.1 cy=57.9 r=12.3 /> <g> <path d=M137,198.5c0.5,0,1.1,0.1,1.6,0.1c-0.4,0-0.8,0-1.3-0.1C137.2,198.5,137.1,198.5,137,198.5z /> <path d=M70,94.5L70,94.5l-0.1,0.2l0,0C69.9,94.6,70,94.6,70,94.5z /> <path d=M177.5,57.6c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1,0-0.1-0.1-0.2-0.1C177.2,57.5,177.3,57.5,177.5,57.6z /> <path d=\"M153.9,190.5c-8.7-0.5-18.3-2.3-28.1-5.3c-2.9,5.8-5.2,9.3-6.8,10c5.8,1.7,11.4,2.8,16.6,3.1\n                c0.2,0,0.4,0,0.6,0C142.2,198.4,148.3,195.7,153.9,190.5z\"/> <path d=M136.3,198.4c-0.1,0-0.1,0-0.2,0c0.3,0,0.6,0,0.9,0c0.1,0,0.2,0,0.3,0C136.9,198.5,136.6,198.4,136.3,198.4z /> <path d=M77.2,81c0.1-0.2,0.3-0.4,0.4-0.6C77.4,80.7,77.3,80.8,77.2,81z /> <path d=\"M176,189.2c1.1-0.6,2.2-1.3,3.2-2c-5.3,2.4-12.5,3.6-20.9,3.4c-6,5.2-12.6,7.9-19.3,7.9c0.3,0,0.6,0,0.9,0\n                c11.3,0,21.9-2.5,31.5-6.9l0.3-0.2C173,190.8,174.5,190,176,189.2z\"/> <path d=M118.2,195.4c2.7,0.8,5.4,1.4,8.1,1.9c-2.6-0.5-5.2-1.1-7.8-1.9H118.2z /> <path d=M116.8,194.9c0.4,0.1,0.9,0.3,1.3,0.4L117,195L116.8,194.9z /> <path d=M129,197.8c-0.7-0.1-1.3-0.2-2-0.3C127.7,197.5,128.4,197.7,129,197.8z /> <path d=M74.8,84.9l1.4-2.3C75.7,83.3,75.2,84.1,74.8,84.9z /> <path d=M97.7,185.7c-0.1-0.1-0.2-0.1-0.3-0.2C97.6,185.6,97.7,185.6,97.7,185.7z /> <path d=\"M106.9,190.9c-2.1-1-4.2-2.1-6-3.2l-0.6-0.4c4.8,3,10,5.4,15.4,7.2h0.1C112.8,193.5,109.8,192.3,106.9,190.9z\n                \"/> <path d=M132.4,198.2c-0.2,0-0.4,0-0.6-0.1C132,198.1,132.2,198.1,132.4,198.2z /> <path d=\"M94.8,183.6c-0.1-0.1-0.2-0.2-0.4-0.3c0.6,0.4,1.1,0.8,1.7,1.2c-0.3-0.2-0.7-0.5-1.1-0.8\n                C95,183.7,94.9,183.7,94.8,183.6z\"/> <path d=\"M135.7,198.4c-0.5,0-1-0.1-1.5-0.1c0.9,0.1,1.9,0.1,2.8,0.2c-0.3,0-0.6,0-0.9,0\n                C135.9,198.4,135.8,198.4,135.7,198.4z\"/> <path d=\"M93.3,136.7c-9-6-15.8-12.4-20.2-18.5c-3.7,10.9-4.3,21.3-2.4,30.7c3.8,5.4,9.9,10.9,17.7,16.2\n                C88.1,157.2,89.6,147.5,93.3,136.7z\"/> <path d=\"M92.7,170.6c0.4,7.3,2.6,12.7,6.4,15.8c2.2,1.3,4.6,2.6,7.1,3.8c3.2,1.5,6.6,2.9,9.9,4\n                c0.8-1,2.4-4.7,4.8-10.7c-5.5-1.9-11-4.1-16.3-6.6C100.2,174.9,96.3,172.8,92.7,170.6z\"/> <path d=\"M94.8,132.7c4.2-10.9,10-21.6,16.8-31.3c-7.7-5.2-13.7-10.7-17.5-16c-8.4,8.3-15.2,18.1-19.5,28.8\n                C79,120.3,85.9,126.6,94.8,132.7z\"/> <path d=\"M95.6,79.7c9-7.6,19.5-13.6,30.6-17.3c-1.7-3-2.2-5.8-1.3-8.1c-11.5,1.5-22.3,5.5-31.5,11.7\n                C91.9,69.9,92.7,74.6,95.6,79.7z\"/> <path d=\"M204.1,120.9c-5.4,2.5-12.8,3.6-21.3,3.5c-0.2,11.9-2.1,23.9-5.6,34.9c9.8,0.2,18.4-1.2,24.6-4\n                C205.2,144.3,205.8,132.5,204.1,120.9z\"/> <path d=\"M170.6,163.3c-10.3-0.6-21.6-2.7-33.2-6.2c-3.8,10.7-7.4,19.5-10.4,25.9c10.1,3,20.1,4.9,29.1,5.4\n                C161.6,182.5,166.6,174,170.6,163.3z\"/> <path d=\"M97.3,82.3c3.7,5.1,9.4,10.4,16.8,15.4c7-9.5,14.9-18,23-24.7c-4.4-3-7.8-6.1-9.9-9.1\n                C116.4,68,106.1,74.4,97.3,82.3z\"/> <path d=\"M160.6,188.6c8.6,0.1,16.1-1,21.6-3.6c7.8-6.2,14.2-14.8,18.2-25.6c-6.3,2.9-14.8,4.2-24.7,4\n                C171.8,174.2,166.5,182.6,160.6,188.6z\"/> <path d=\"M150.8,114.6c9.6,2.9,19.1,4.6,27.7,5.2c0.3-11.8-0.9-23.4-3.3-33.8c-5-0.3-10.6-1.4-16.3-3.1\n                C156.7,92.5,154,103.3,150.8,114.6z\"/> <path d=M69.8,94.9c-0.4,1.1-0.9,2.2-1.3,3.3l0.2-0.5L69.8,94.9z /> <path d=\"M203.3,116.6c-2.3-11.5-7-22.6-13.6-32.5c-3.1,1.4-7.3,2.1-12.1,2c3.2,10.4,5,22,5.1,33.9\n                C191,120.1,198.1,119,203.3,116.6z\"/> <path d=\"M207.9,113.8c3.3-2.7,4.7-6.1,4.5-9.9c-3.3-10.2-9.2-19.5-17.3-27.3c0.1,2.2-0.7,4.3-2.7,5.9\n                c-0.4,0.3-0.8,0.6-1.2,0.9c7,9.6,12,20.6,14.6,31.9C206.6,114.8,207.3,114.3,207.9,113.8z\"/> <path d=\"M98.1,139.8c-3.7,10.8-5.5,20.3-5.5,28c3.7,2.3,7.8,4.5,12.2,6.6c5.6,2.6,11.3,5,16.9,6.9\n                c2.5-6.5,5.8-15.4,9.6-26.1c-6.5-2.2-13-4.8-19.3-7.9C107,144.9,102.4,142.4,98.1,139.8z\"/> <path d=\"M127.7,110.4c-4.3-2.1-8.3-4.2-12-6.5c-6.4,10-12,20.9-16.1,31.8c4.3,2.6,8.9,5.1,13.9,7.5\n                c6.3,3,12.8,5.6,19.3,7.8c3.9-11,7.9-22.6,11.6-33.8C138.8,115.3,133.2,113.1,127.7,110.4z\"/> <path d=\"M178.3,124.3c-8.9-0.6-18.7-2.4-28.7-5.4c-3.3,11.4-7,23.1-10.8,34.1c11.6,3.5,23,5.6,33.2,6.2\n                C175.6,148.1,177.7,136.1,178.3,124.3z\"/> <path d=\"M118.1,100.2c3.5,2.2,7.4,4.3,11.6,6.3c5.3,2.5,10.7,4.7,16.1,6.5c3.7-11.1,7.1-21.8,10-31\n                c-3.2-1.1-6.4-2.4-9.5-3.9c-2.5-1.2-4.7-2.4-6.8-3.7C132.1,81.6,124.7,90.5,118.1,100.2z\"/> <path d=\"M210.4,149.8c-0.9,2.3-2.4,4.4-4.6,6.2c-0.8,0.6-1.6,1.2-2.5,1.8c-4.1,10.7-10.6,19.4-18.6,25.8\n                c0.5-0.3,0.9-0.6,1.4-1c12.2-9.5,21.4-22.6,25.9-37.7l-1.1,3.4L210.4,149.8z\"/> <path d=\"M91.2,66.2c0.7-1.1,1.6-2.1,2.8-3.1c0.3-0.2,0.6-0.5,0.9-0.7l3-2.1c0.4-0.3,0.8-0.6,1.2-0.8\n                c-8,5.1-14.9,11.7-20.5,19.3C82.3,74,86.5,69.8,91.2,66.2z\"/> <path d=\"M72.6,111c4.3-10.7,11.2-20.4,19.8-28.4c-3-5.2-3.9-10.1-2.2-14.3C82.9,73.8,77,80.8,72.6,89\n                c-1,1.9-1.9,3.9-2.7,5.6C68.1,99.4,69.1,105.1,72.6,111z\"/> <path d=M142.4,47.6c0.6,0,1.2,0,1.8,0.1C143.6,47.7,143,47.7,142.4,47.6z /> <path d=M131.4,62.4c1.9,2.7,5,5.5,8.9,8.1c7.6-5.8,15.3-10,22.6-12C152.4,57.6,141.7,59,131.4,62.4z /> <path d=\"M131.3,51.2c-0.6,0.5-1,1-1.4,1.6c10.7-0.4,21.9,1.4,32.9,5.9c-8.3-6-17-9.2-25.4-10.1\n                C134.9,49,132.8,49.9,131.3,51.2z\"/> <path d=M69.9,94.7L69.9,94.7v-0.2C70,94.6,69.9,94.6,69.9,94.7z /> <path d=\"M71.1,115.1c-3.3-5.7-4.4-11-2.9-15.7c-2.4,7.4-3.8,15.4-3.8,23.6c0,5.9,0.7,11.6,2,17.1c0.5,2,1.4,4,2.6,6.1\n                C66.9,136.6,67.4,126,71.1,115.1z\"/> <path d=M129.4,53.8c-0.9,2.1-0.4,4.6,1.1,7.3c10.5-3,21.6-3.9,32.3-2.5C151.6,54.5,140.2,53,129.4,53.8z /> <path d=\"M155.5,49.2c-0.3,0-0.5-0.1-0.7-0.1c3.2,0.7,6,3.7,8,9.5c3.3-3.9,5.6-5.4,7-4.8c0.8,0.3,1.8,0.8,2.6,1.2\n                c-2.2-1-5.4,0.1-9.6,3.6c8.9-0.7,16.5,1,22.6,4.6c-2.1-1.8-4.7-3.7-7.6-5.4c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1-0.1-0.3-0.2-0.4-0.2\n                c-0.4-0.2-0.8-0.5-1.2-0.7l0,0c-0.3-0.2-0.6-0.3-0.9-0.5c-6.3-3.3-13.2-5.8-20.5-7.2l0.3,0.1L155.5,49.2z\"/> <path d=\"M175.8,56.7c0.2,0.1,0.5,0.3,0.7,0.4c-0.4-0.3-0.9-0.5-1.4-0.7C175.4,56.4,175.6,56.6,175.8,56.7L175.8,56.7z\n                \"/> <path d=\"M77.2,165c-0.8-1.2-1.6-2.5-2.3-3.6l-0.2-0.3c-2.1-3.6-3.7-7.4-4.9-11.4c-1-1.8-1.8-3.5-2.3-5.1\n                c2.4,8,6,15.4,10.8,22.1c-0.3-0.4-0.6-0.9-0.9-1.3C77.3,165.2,77.2,165.1,77.2,165z\"/> <path d=\"M142.1,47.6c-0.8,0-1.5-0.1-2.3-0.1c-3.4,0-6.8,0.3-10.2,0.7c2.1-0.3,4.2-0.4,6.3-0.3\n                C137.9,47.7,140,47.6,142.1,47.6z\"/> <path d=\"M97.2,60.9c-1.1,0.9-2,1.9-2.7,2.9c9.1-6,19.7-9.7,31.1-10.8c0.4-0.6,0.9-1.2,1.6-1.7c1.7-1.4,4-2.4,6.8-3\n                c-3.4-0.1-6.8,0.3-10,1c1.6-0.3,3.7-0.7,5.4-1c-11,1.5-21.2,5.4-30.1,11.2l-1.2,0.9C97.7,60.5,97.4,60.7,97.2,60.9z\"/> <path d=M152.3,48.6c-4.8-0.8-9.3-0.9-13-0.4c7.9,0.9,16,4.3,23.6,10.4C159.9,52.7,156.2,49.4,152.3,48.6z /> <path d=M151.9,48.5h0.3c-1.8-0.3-3.5-0.5-5.3-0.7h0.1C148.4,48.1,150.4,48.3,151.9,48.5z /> <path d=\"M189.4,66.3c3.1,3,5,6.1,5.6,8.9c8,7.3,13.9,16.4,17.2,26.3c-0.1-0.6-0.3-1.2-0.5-1.8l0,0\n                c-3.8-11.8-10.5-22.3-19.2-30.8l0.7,0.6C192,68.4,190.7,67.3,189.4,66.3z\"/> <path d=\"M148.4,75.2c2.8,1.3,5.6,2.5,8.5,3.4c2.6-8.3,4.6-15.2,5.9-20c-6.5,2.4-13.5,7.1-20.4,13.3\n                C144.2,73,146.3,74.1,148.4,75.2z\"/> <path d=M179.6,58.9c-0.7-0.4-1.4-0.8-2.1-1.2c0.1,0,0.1,0.1,0.2,0.1C178.2,58.1,178.8,58.4,179.6,58.9z /> <path d=\"M213.5,107.7c0.2,3.9-1.3,7.5-4.7,10.3c-0.7,0.5-1.4,1-2.1,1.5c2,11.4,1.5,23.2-1.9,34.2\n                c0.9-0.6,1.7-1.1,2.5-1.8c2.4-2,4-4.4,4.8-7c2.1-6.9,3.2-14.3,3.2-21.9c0-1.7-0.1-3.3-0.2-5c-0.1-1.1-0.2-2-0.2-2.8\n                C214.6,112.7,214.2,110.2,213.5,107.7z\"/> <path d=M215,116c-0.1-0.6-0.1-1.1-0.2-1.6c0,0.3,0.1,0.6,0.1,0.9C214.9,115.5,215,115.8,215,116z /> <path d=\"M95,183.8c0.5,0.4,1,0.7,1.6,1.1c-4.4-3.5-7.1-9.3-8-16.8c-7.6-5.1-13.4-10.5-17.1-15.6\n                c1.3,4.5,3.2,8.8,5.6,12.6c0.1,0.1,0.1,0.2,0.2,0.3c0.3,0.5,0.6,0.9,0.9,1.3c4.4,6.2,9.7,11.7,15.7,16.3c0.3,0.2,0.6,0.4,0.8,0.6\n                C94.9,183.7,95,183.7,95,183.8z\"/> <path d=M186.8,64.6c-6.5-4-14.6-6.2-24-6c11.3,2.7,21.1,7.5,29.1,14C191.3,70.1,189.6,67.3,186.8,64.6z /> <path d=M174.1,82.2c-2.6-9.3-6.4-17.5-11.3-23.6c-0.3,5.1-1.5,12.4-3.2,20.9C164.6,81,169.6,81.9,174.1,82.2z /> <path d=M187.2,80.5c-6.6-8.8-14.8-16.4-24.4-21.9c5.7,6.2,10.3,14.3,13.6,23.7C180.7,82.3,184.5,81.8,187.2,80.5z /> <path d=M181.4,60.1c0.5,0.3,1,0.7,1.5,1C182.4,60.7,181.9,60.4,181.4,60.1z /> <path d=M190.2,66.8l0.7,0.7C190.7,67.3,190.5,67.1,190.2,66.8z /> <path d=\"M188.6,79.8c0.4-0.2,0.7-0.5,1.1-0.8c1.7-1.5,2.5-3.2,2.4-5.2c-8-6.8-17.9-12.1-29.2-15.2\n                C172.9,63.8,181.6,71.2,188.6,79.8z\"/> <line class=st4 x1=70 y1=94.5 x2=69.9 y2=94.8 /> <path d=M77.2,165c0.1,0.1,0.1,0.2,0.2,0.3C77.3,165.2,77.2,165.1,77.2,165z /> <path d=M78.3,166.7L78.3,166.7L78.3,166.7c-0.3-0.4-0.6-0.9-0.9-1.3C77.7,165.8,78,166.3,78.3,166.7z /> <path d=M175.8,56.7L175.8,56.7L175.8,56.7z /> </g> </g> </svg> ";

/***/ }),
/* 666 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Ushahidi adaptive input directive
	 * The adaptive-form attribute should be added to the parent div that
	 * will receive the class updates.
	 * The adaptive-input attribute should be added to a child input of the above
	 * div
	 */
	
	angular.module('ushahidi.common.adaptive-input', []).directive('adaptiveForm', function () {
	    return {
	        restrict: 'A',
	        controller: ['$scope', '$element', '$attrs', function ($scope, $element, $attrs) {
	
	            this.classAdd = function (className) {
	                $element.addClass(className);
	            };
	            this.classRemove = function (className) {
	                $element.removeClass(className);
	            };
	        }]
	    };
	}).directive('adaptiveInput', function () {
	    return {
	        require: '?^adaptiveForm',
	        restrict: 'A',
	        link: function link($scope, $element, $attrs, adaptiveController) {
	
	            activate();
	
	            function activate() {
	                $element.bind('focus', focusOn);
	                $element.bind('blur', focusOff);
	            }
	
	            // Check on initial load if field has value
	            // If so set focus
	            $scope.$watch($attrs.ngModel, function (value) {
	                value ? adaptiveController.classAdd('value') : '';
	            });
	
	            function focusOn($event) {
	                $event.preventDefault();
	                adaptiveController.classAdd('focus');
	            }
	
	            function focusOff($event) {
	                $event.preventDefault();
	                adaptiveController.classRemove('focus');
	                !$element.val() ? adaptiveController.classRemove('value') : '';
	            }
	        }
	    };
	});

/***/ }),
/* 667 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Ushahidi dropdown directive
	 * Based on angular-ui-bootstrap dropdown
	 */
	
	angular.module('ushahidi.common.dropdown', ['ui.bootstrap.position']).constant('dropdownConfig', {
	    openClass: 'active',
	    toggleOpenClass: 'active',
	    menuOpenClass: 'active'
	}).service('dropdownService', ['$document', '$rootScope', function ($document, $rootScope) {
	    var openScope = null;
	
	    this.open = function (dropdownScope) {
	        if (!openScope) {
	            $document.bind('click', closeDropdown);
	            $document.bind('keydown', keybindFilter);
	        }
	
	        if (openScope && openScope !== dropdownScope) {
	            openScope.isOpen = false;
	        }
	
	        openScope = dropdownScope;
	    };
	
	    this.close = function (dropdownScope) {
	        if (openScope === dropdownScope) {
	            openScope = null;
	            $document.unbind('click', closeDropdown);
	            $document.unbind('keydown', keybindFilter);
	        }
	    };
	
	    var closeDropdown = function closeDropdown(evt) {
	        // This method may still be called during the same mouse event that
	        // unbound this event handler. So check openScope before proceeding.
	        if (!openScope) {
	            return;
	        }
	
	        if (evt && openScope.getAutoClose() === 'disabled') {
	            return;
	        }
	
	        var toggleElement = openScope.getToggleElement();
	        if (evt && toggleElement && toggleElement[0].contains(evt.target)) {
	            return;
	        }
	
	        var dropdownElement = openScope.getDropdownElement();
	        if (evt && openScope.getAutoClose() === 'outsideClick' && dropdownElement && dropdownElement[0].contains(evt.target)) {
	            return;
	        }
	
	        openScope.isOpen = false;
	
	        if (!$rootScope.$$phase) {
	            openScope.$apply();
	        }
	    };
	
	    var keybindFilter = function keybindFilter(evt) {
	        if (evt.which === 27) {
	            openScope.focusToggleElement();
	            closeDropdown();
	        } else if (openScope.isKeynavEnabled() && /(38|40)/.test(evt.which) && openScope.isOpen) {
	            evt.preventDefault();
	            evt.stopPropagation();
	            openScope.focusDropdownEntry(evt.which);
	        }
	    };
	}]).controller('DropdownController', ['$scope', '$attrs', '$parse', 'dropdownConfig', 'dropdownService', '$animate', '$uibPosition', '$document', '$compile', '$templateRequest', function ($scope, $attrs, $parse, dropdownConfig, dropdownService, $animate, $position, $document, $compile, $templateRequest) {
	    var self = this,
	        scope = $scope.$new(),
	        // create a child scope so we are not polluting original one
	    templateScope,
	        openClass = dropdownConfig.openClass,
	        toggleOpenClass = dropdownConfig.toggleOpenClass,
	        menuOpenClass = dropdownConfig.menuOpenClass,
	        getIsOpen,
	        setIsOpen = angular.noop,
	        toggleInvoker = $attrs.onToggle ? $parse($attrs.onToggle) : angular.noop,
	        appendToBody = false,
	        keynavEnabled = false;
	
	    this.init = function (element) {
	        self.$element = element;
	
	        if ($attrs.isOpen) {
	            getIsOpen = $parse($attrs.isOpen);
	            setIsOpen = getIsOpen.assign;
	
	            $scope.$watch(getIsOpen, function (value) {
	                scope.isOpen = !!value;
	            });
	        }
	
	        appendToBody = angular.isDefined($attrs.dropdownAppendToBody);
	        keynavEnabled = angular.isDefined($attrs.keyboardNav);
	
	        if (appendToBody && self.dropdownMenu) {
	            $document.find('body').append(self.dropdownMenu);
	            element.on('$destroy', function handleDestroyEvent() {
	                self.dropdownMenu.remove();
	            });
	        }
	    };
	
	    this.toggle = function (open) {
	        return scope.isOpen = arguments.length ? !!open : !scope.isOpen;
	    };
	
	    // Allow other directives to watch status
	    this.isOpen = function () {
	        return scope.isOpen;
	    };
	
	    scope.getToggleElement = function () {
	        return self.toggleElement;
	    };
	
	    scope.getAutoClose = function () {
	        return $attrs.autoClose || 'always'; //or 'outsideClick' or 'disabled'
	    };
	
	    scope.getElement = function () {
	        return self.$element;
	    };
	
	    scope.isKeynavEnabled = function () {
	        return keynavEnabled;
	    };
	
	    scope.focusDropdownEntry = function (keyCode) {
	        var elems = self.dropdownMenu ? //If append to body is used.
	        angular.element(self.dropdownMenu).find('a') : angular.element(self.$element).find('ul').eq(0).find('a');
	
	        switch (keyCode) {
	            case 40:
	                {
	                    if (!angular.isNumber(self.selectedOption)) {
	                        self.selectedOption = 0;
	                    } else {
	                        self.selectedOption = self.selectedOption === elems.length - 1 ? self.selectedOption : self.selectedOption + 1;
	                    }
	                    break;
	                }
	            case 38:
	                {
	                    if (!angular.isNumber(self.selectedOption)) {
	                        return;
	                    } else {
	                        self.selectedOption = self.selectedOption === 0 ? 0 : self.selectedOption - 1;
	                    }
	                    break;
	                }
	        }
	        elems[self.selectedOption].focus();
	    };
	
	    scope.getDropdownElement = function () {
	        return self.dropdownMenu;
	    };
	
	    scope.focusToggleElement = function () {
	        if (self.toggleElement) {
	            self.toggleElement[0].focus();
	        }
	    };
	
	    scope.$watch('isOpen', function (isOpen, wasOpen) {
	        if (appendToBody && self.dropdownMenu) {
	            var pos = $position.positionElements(self.$element, self.dropdownMenu, 'bottom-left', true);
	            var css = {
	                top: pos.top + 'px',
	                display: isOpen ? 'block' : 'none'
	            };
	
	            var rightalign = self.dropdownMenu.hasClass('dropdown-menu-right');
	            if (!rightalign) {
	                css.left = pos.left + 'px';
	                css.right = 'auto';
	            } else {
	                css.left = 'auto';
	                css.right = window.innerWidth - (pos.left + self.$element.prop('offsetWidth')) + 'px';
	            }
	
	            self.dropdownMenu.css(css);
	        }
	
	        $animate[isOpen ? 'addClass' : 'removeClass'](self.$element, openClass).then(function () {
	            if (angular.isDefined(isOpen) && isOpen !== wasOpen) {
	                toggleInvoker($scope, { open: !!isOpen });
	            }
	        });
	        // Add extra classes to the toggle and menu elements
	        if (self.toggleElement && toggleOpenClass) {
	            $animate[isOpen ? 'addClass' : 'removeClass'](self.toggleElement, toggleOpenClass);
	        }
	        if (self.dropdownMenu && menuOpenClass) {
	            $animate[isOpen ? 'addClass' : 'removeClass'](self.dropdownMenu, menuOpenClass);
	        }
	
	        if (isOpen) {
	            if (self.dropdownMenuTemplateUrl) {
	                $templateRequest(self.dropdownMenuTemplateUrl).then(function (tplContent) {
	                    templateScope = scope.$new();
	                    $compile(tplContent.trim())(templateScope, function (dropdownElement) {
	                        var newEl = dropdownElement;
	                        self.dropdownMenu.replaceWith(newEl);
	                        self.dropdownMenu = newEl;
	                    });
	                });
	            }
	
	            scope.focusToggleElement();
	            dropdownService.open(scope);
	        } else {
	            if (self.dropdownMenuTemplateUrl) {
	                if (templateScope) {
	                    templateScope.$destroy();
	                }
	                var newEl = angular.element('<ul class="dropdown-menu"></ul>');
	                self.dropdownMenu.replaceWith(newEl);
	                self.dropdownMenu = newEl;
	            }
	
	            dropdownService.close(scope);
	            self.selectedOption = null;
	        }
	
	        setIsOpen($scope, isOpen);
	    });
	
	    $scope.$on('$locationChangeSuccess', function () {
	        if (scope.getAutoClose() !== 'disabled') {
	            scope.isOpen = false;
	        }
	    });
	
	    $scope.$on('$destroy', function () {
	        scope.$destroy();
	    });
	}]).directive('dropdown', function () {
	    return {
	        controller: 'DropdownController',
	        link: function link(scope, element, attrs, dropdownCtrl) {
	            dropdownCtrl.init(element);
	            element.addClass('dropdown');
	        }
	    };
	}).directive('dropdownMenu', function () {
	    return {
	        restrict: 'A',
	        require: '?^dropdown',
	        link: function link(scope, element, attrs, dropdownCtrl) {
	            if (!dropdownCtrl) {
	                return;
	            }
	            var tplUrl = attrs.templateUrl;
	            if (tplUrl) {
	                dropdownCtrl.dropdownMenuTemplateUrl = tplUrl;
	            }
	            if (!dropdownCtrl.dropdownMenu) {
	                dropdownCtrl.dropdownMenu = element;
	            }
	
	            if (attrs.unpositioned) {
	                scope.$watch(function () {
	                    // Get the first positioned element that contains dropdown
	                    return element[0].offsetParent !== null;
	                }, function (value) {
	                    if (value) {
	                        // Offset is offset of positioned element + dropdown offset
	                        var offset = element[0].offsetParent.offsetLeft + element[0].parentElement.offsetLeft;
	
	                        var css = {
	                            left: offset + 'px'
	                        };
	
	                        element.css(css);
	                    }
	                });
	            }
	        }
	    };
	}).directive('keyboardNav', function () {
	    return {
	        restrict: 'A',
	        require: '?^dropdown',
	        link: function link(scope, element, attrs, dropdownCtrl) {
	
	            element.bind('keydown', function (e) {
	
	                if ([38, 40].indexOf(e.which) !== -1) {
	
	                    e.preventDefault();
	                    e.stopPropagation();
	
	                    var elems = angular.element(element).find('a');
	
	                    switch (e.keyCode) {
	                        case 40:
	                            // Down
	                            if (!angular.isNumber(dropdownCtrl.selectedOption)) {
	                                dropdownCtrl.selectedOption = 0;
	                            } else {
	                                dropdownCtrl.selectedOption = dropdownCtrl.selectedOption === elems.length - 1 ? dropdownCtrl.selectedOption : dropdownCtrl.selectedOption + 1;
	                            }
	                            break;
	                        case 38:
	                            // Up
	                            dropdownCtrl.selectedOption = dropdownCtrl.selectedOption === 0 ? 0 : dropdownCtrl.selectedOption - 1;
	                            break;
	                    }
	                    elems[dropdownCtrl.selectedOption].focus();
	                }
	            });
	        }
	
	    };
	}).directive('dropdownToggle', function () {
	    return {
	        require: '?^dropdown',
	        link: function link(scope, element, attrs, dropdownCtrl) {
	            if (!dropdownCtrl) {
	                return;
	            }
	
	            element.addClass('dropdown-toggle');
	
	            dropdownCtrl.toggleElement = element;
	
	            var toggleDropdown = function toggleDropdown(event) {
	                event.preventDefault();
	
	                if (!element.hasClass('disabled') && !attrs.disabled) {
	                    scope.$apply(function () {
	                        dropdownCtrl.toggle();
	                    });
	                }
	            };
	
	            element.bind('click', toggleDropdown);
	
	            // WAI-ARIA
	            element.attr({ 'aria-haspopup': true, 'aria-expanded': false });
	            scope.$watch(dropdownCtrl.isOpen, function (isOpen) {
	                element.attr('aria-expanded', !!isOpen);
	            });
	
	            scope.$on('$destroy', function () {
	                element.unbind('click', toggleDropdown);
	            });
	        }
	    };
	});

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Ushahidi Angular Modal directive
	 * Based on the Angular Bootstrap Modal directive
	 */
	angular.module('ushahidi.common.modal', []).directive('modal', ['$translate', '$rootScope', function ($translate, $rootScope) {
	    return {
	        restrict: 'E',
	        transclude: true,
	        template: __webpack_require__(669),
	
	        scope: {
	            title: '@?',
	            icon: '=?',
	            visible: '=?',
	            closeOnOverlayClick: '=?',
	            showCloseButton: '=?'
	        },
	
	        controller: ['$scope', '$attrs', '$parse', '$timeout', function ($scope, $attrs, $parse, $timeout) {
	            $scope.iconPath = $scope.icon ? '/img/iconic-sprite.svg#' + $scope.icon : '';
	
	            var classChangePromise = null;
	            $scope.iconPath = __webpack_require__(412) + '#' + $scope.icon;
	            $scope.classVisible = false;
	            $scope.modalOffset = 0;
	            $scope.title = $translate.instant($scope.title);
	
	            // If closeOnOverlayClick isn't passed, default to true
	            if (typeof $scope.closeOnOverlayClick === 'undefined') {
	                $scope.closeOnOverlayClick = true;
	            }
	
	            // If showCloseButton isn't passed, default to true
	            if (typeof $scope.showCloseButton === 'undefined') {
	                $scope.showCloseButton = true;
	            }
	
	            $scope.$watch('visible', function (state, previousState) {
	                if (state === true) {
	                    if (!$scope.classVisible) {
	                        // Animate in.
	                        $scope.classVisible = true;
	                        $rootScope.toggleModalVisible();
	
	                        // Set offset based on window position
	                        // @todo move offset to a config param
	                        var windowYpos = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
	                        $scope.modalOffset = windowYpos + 40 + 'px';
	                        // @todo set max height
	                        // $('.modal-body').css('max-height', $(window).height() * 0.66);
	
	                        if (classChangePromise) {
	                            $timeout.cancel(classChangePromise);
	                        }
	                    }
	                } else if (state === false) {
	                    if ($scope.classVisible) {
	                        // Animate out.
	                        $scope.classVisible = false;
	                        $rootScope.toggleModalVisible();
	
	                        if (classChangePromise) {
	                            $timeout.cancel(classChangePromise);
	                        }
	
	                        classChangePromise = $timeout(function () {
	                            $scope.classDetached = true;
	                        }, 400);
	                    }
	                }
	            });
	
	            $scope.closeModal = function (context) {
	                if (context === 'overlay' && $scope.closeOnOverlayClick !== true) {
	                    return;
	                }
	
	                $scope.visible = false;
	            };
	
	            $scope.$on('$destroy', function (event) {
	                if (classChangePromise) {
	                    $timeout.cancel(classChangePromise);
	                }
	            });
	        }]
	    };
	}]);

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div ng-show=classVisible class=modal style=display:block> <div class=modal-window ng-style=\"{ top : modalOffset }\"> <button class=\"button-beta button-flat modal-trigger modal-trigger-close\" ng-show=showCloseButton ng-click=closeModal()> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#x></use> </svg> <span class=hidden translate>modal.button.close</span> </button> <h3 class=modal-title ng-if=title> <svg class=iconic ng-if=icon> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href={{iconPath}}></use> </svg> <span class=label> {{ title }} </span> </h3> <ng-transclude></ng-transclude> </div> <div class=modal-overlay></div> </div> ";

/***/ }),
/* 670 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('ushahidi.common.custom-on-change', []).directive('customOnChange', function () {
	    return {
	        restricet: 'A',
	        link: function link($scope, $element, $attrs) {
	            var onChangeFunc = $scope.$eval($attrs.customOnChange);
	            $element.bind('change', onChangeFunc);
	        }
	    };
	});

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('ushahidi.user-profile', []).directive('accountSettings', __webpack_require__(672)).directive('userProfile', __webpack_require__(674)).directive('notifications', __webpack_require__(676));

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = ['$rootScope', 'UserEndpoint', 'ModalService', function ($rootScope, UserEndpoint, ModalService) {
	    return {
	        restrict: 'E',
	        replace: true,
	        scope: {},
	        template: __webpack_require__(673),
	        link: function link(scope) {
	            scope.user = UserEndpoint.getFresh({ id: 'me' });
	
	            scope.general = true;
	            scope.notifications = false;
	
	            scope.showGeneral = function () {
	                scope.general = true;
	                scope.notifications = false;
	            };
	
	            scope.showNotifications = function () {
	                scope.general = false;
	                scope.notifications = true;
	            };
	
	            scope.$on('event:close', function () {
	                ModalService.close();
	            });
	        }
	    };
	}];

/***/ }),
/* 673 */
/***/ (function(module, exports) {

	module.exports = "<div> <h3 class=modal-title> {{user.realname || user.email}} <em translate>user_profile.title</em> </h3> <nav class=\"tabs-menu init\"> <ul> <li ng-class=\"{'active': general}\"> <a ng-click=showGeneral() translate> user_profile.nav.general </a> </li> <li ng-class=\"{'active': notifications}\"> <a ng-click=showNotifications() translate> user_profile.nav.notifications </a> </li> </ul> </nav> <div class=modal-body> <user-profile ng-show=general></user-profile> <notifications ng-show=notifications></notifications> </div> </div> ";

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = ['UserEndpoint', 'Notify', '_', '$translate', function (UserEndpoint, Notify, _, $translate) {
	    return {
	        restrict: 'E',
	        replace: true,
	        scope: {},
	        template: __webpack_require__(675),
	        link: function link($scope) {
	            $scope.state = {
	                success: false,
	                processing: false,
	                changingPassword: false,
	                password: ''
	            };
	
	            $scope.saveUser = function (user) {
	                $scope.state.success = false;
	                $scope.state.processing = true;
	
	                var userPayload = angular.copy(user);
	
	                // If we're not changing the password, drop that property from payload (just in case.)
	                if ($scope.state.changingPassword) {
	                    userPayload.password = $scope.state.password;
	                }
	
	                var update = UserEndpoint.update({ id: 'me' }, userPayload);
	
	                update.$promise.then(function (user) {
	                    Notify.notify('user_profile.update_success');
	
	                    $scope.state.success = true;
	                    $scope.state.processing = false;
	
	                    // Collapse password change form field.
	                    $scope.state.changingPassword = false;
	                    $scope.state.password = '';
	
	                    $scope.user = user;
	
	                    $scope.$emit('event:close');
	                }, function (errorResponse) {
	                    // error
	                    Notify.apiErrors(errorResponse);
	                    $scope.state.processing = false;
	                });
	            };
	
	            $scope.cancel = function () {
	                $scope.$emit('event:close');
	            };
	
	            $scope.user = UserEndpoint.getFresh({ id: 'me' });
	        }
	    };
	}];

/***/ }),
/* 675 */
/***/ (function(module, exports) {

	module.exports = "<div> <p class=\"alert confirmation\" ng-show=state.success translate>user_profile.update_success</p> <form name=form> <div class=form-field> <label class=input-label ng-class=\"{ 'error': form.full_name.$invalid && form.full_name.$dirty, 'success': form.full_name.$valid }\" for=full_name translate>user.full_name</label> <input id=full_name name=full_name type=text ng-class=\"{ 'error': form.full_name.$invalid && form.full_name.$dirty }\" ng-disabled=state.processing placeholder=\"{{ 'user_create.full_name'|translate }}\" ng-maxlength=150 ng-model=user.realname required> <p ng-repeat=\"(error, value) in form.full_name.$error\" ng-show=form.full_name.$dirty class=\"alert error\" translate=\"{{'user.valid.full_name.' + error}}\"></p> </div> <div class=form-field> <label class=input-label ng-class=\"{ 'error': form.email.$invalid && form.email.$dirty, 'success': form.email.$valid }\" for=email translate>user.email</label> <input id=email name=email type=email ng-class=\"{ 'error': form.email.$invalid && form.email.$dirty }\" ng-disabled=state.processing placeholder=\"{{ 'user_create.email'|translate }}\" ng-maxlength=150 ng-model=user.email required> <p ng-repeat=\"(error, value) in form.email.$error\" ng-show=form.email.$dirty class=\"alert error\" translate=\"{{'user.valid.email.' + error}}\"></p> </div> <p ng-hide=state.changingPassword><a href class=\"cta change-password\" ng-click=\"state.changingPassword = !state.changePachangingPasswordssword\" translate>user_profile.update_password</a></p> <div ng-if=state.changingPassword> <label class=input-label ng-class=\"{ 'error': form.password.$invalid && form.password.$dirty, 'success': form.password.$valid }\" for=password translate>user.password</label> <input id=password name=password type=password ng-class=\"{ 'error': form.password.$invalid && form.password.$dirty }\" ng-disabled=state.processing ng-minlength=7 ng-maxlength=72 ng-model=state.password required> <p ng-repeat=\"(error, value) in form.password.$error\" ng-show=form.password.$dirty class=\"alert error\" translate=\"{{'user.valid.password.' + error}}\"></p> </div> <div class=modal-actions> <div class=form-field> <button type=button class=button-link ng-click=cancel() translate> user_profile.button.cancel </button> <button type=submit class=\"button button-alpha\" ng-click=saveUser(user) ng-disabled=\"form.$invalid || state.processing\"> <div class=loading ng-show=saving><div class=line></div><div class=line></div><div class=line></div></div> <span translate>user_profile.button.save</span> </button> </div> </div> </form> </div> ";

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = ['UserEndpoint', 'ContactEndpoint', 'CollectionEndpoint', 'SavedSearchEndpoint', 'NotificationEndpoint', 'Notify', '_', '$translate', '$q', function (UserEndpoint, ContactEndpoint, CollectionEndpoint, SavedSearchEndpoint, NotificationEndpoint, Notify, _, $translate, $q) {
	    return {
	        restrict: 'E',
	        replace: true,
	        scope: {},
	        template: __webpack_require__(677),
	        link: function link($scope, elem) {
	
	            var loadNotifications = function loadNotifications() {
	                NotificationEndpoint.query({ user: 'me' }).$promise.then(function (notifications) {
	                    _.forEach(notifications, function (notification) {
	                        // Add name of the subscribed collection
	                        CollectionEndpoint.get({ collectionId: notification.set.id }, function (collection) {
	                            notification.name = collection.name;
	                        }, function () {
	                            // Try to get the SavedSearch name instead
	                            SavedSearchEndpoint.get({ id: notification.set.id }, function (savedSearch) {
	                                notification.name = savedSearch.name;
	                            });
	                        });
	                    });
	
	                    $scope.notifications = notifications;
	                });
	            };
	
	            var loadContacts = function loadContacts() {
	                ContactEndpoint.query({ user: 'me' }).$promise.then(function (contacts) {
	                    _.forEach(contacts, function (contact) {
	                        // Save the original contact values
	                        // and use them to track changes
	                        contact.original = {
	                            contact: contact.contact,
	                            can_notify: contact.can_notify
	                        };
	
	                        // make inactive by default
	                        contact.active = false;
	                    });
	
	                    // Grab the user registration email if there are no contacts
	                    if (contacts.length === 0) {
	                        UserEndpoint.get({ id: 'me' }, function (user) {
	                            contacts.push({
	                                type: 'email',
	                                contact: user.email,
	                                original: user.email,
	                                active: false,
	                                isLoginEmail: true
	                            });
	                        });
	                    }
	
	                    $scope.contacts = contacts;
	                });
	            };
	
	            var saveContact = function saveContact(contact) {
	                if (contact.id) {
	                    return ContactEndpoint.update(contact).$promise;
	                } else {
	                    // Enable notifications for new contacts by default
	                    contact.can_notify = true;
	                    return ContactEndpoint.save(contact).$promise;
	                }
	            };
	
	            var contactHasChanged = function contactHasChanged(contact) {
	                return contact.original.contact !== contact.contact || contact.original.can_notify !== contact.can_notify;
	            };
	
	            loadContacts();
	            loadNotifications();
	
	            $scope.deleteNotification = function (notification) {
	                Notify.confirmDelete('notify.notification.delete_confirm').then(function () {
	                    NotificationEndpoint.delete({ id: notification.id }).$promise.then(function () {
	                        Notify.notify('notify.notification.destroy_success', { name: notification.name });
	
	                        // Reload notifications
	                        loadNotifications();
	                    }, function () {
	                        Notify.error('notification.error_message');
	                    });
	                });
	            };
	
	            $scope.deleteContact = function (contact) {
	                Notify.confirmDelete('notify.contact.delete_confirm').then(function () {
	                    ContactEndpoint.delete({ id: contact.id }).$promise.then(function () {
	                        Notify.notify('notify.contact.destroy_success');
	
	                        // Reload Contacts
	                        loadContacts();
	                    }, function () {
	                        Notify.error('contact.error_message');
	                    });
	                });
	            };
	
	            // Default contact type for new contacts
	            $scope.contact = {
	                type: 'email',
	                active: false
	            };
	
	            // New contact listing is inactive by default
	            $scope.active = false;
	
	            $scope.toggleActive = function (contact) {
	                contact.active = !contact.active;
	            };
	
	            // Only enable Save if active contacts are valid
	            $scope.canUpdate = function () {
	                // Get contacts that are currently being edited
	                var activeContacts = _.filter($scope.contacts, function (contact) {
	                    return contact.active === true;
	                });
	
	                return !_.isEmpty(activeContacts) && _.every(activeContacts, function (contact) {
	                    return contactHasChanged(contact) && !_.isUndefined(contact.contact);
	                });
	            };
	
	            $scope.canAdd = function () {
	                if ($scope.contact.active) {
	                    return !_.isUndefined($scope.contact.contact);
	                }
	
	                // Check if you can add the login email address as a contact
	                return _.find($scope.contacts, function (contact) {
	                    return !_.isUndefined(contact.contact) && contact.isLoginEmail;
	                });
	            };
	
	            $scope.saveContacts = function () {
	                var validContacts,
	                    promises = [];
	
	                $scope.saving = true;
	
	                // Get Valid contacts
	                validContacts = _.filter($scope.contacts, function (contact) {
	                    return !_.isUndefined(contact.contact);
	                });
	
	                // Add new contact if valid
	                if (!_.isUndefined($scope.contact.contact)) {
	                    validContacts.push($scope.contact);
	                }
	
	                _.forEach(validContacts, function (contact) {
	                    promises.push(saveContact(contact));
	                });
	
	                $q.all(promises).then(function () {
	                    Notify.notify('notify.contact.save_success');
	
	                    $scope.$emit('event:close');
	                }, function () {
	                    Notify.error('contact.error_message');
	                });
	
	                $scope.saving = false;
	            };
	
	            $scope.cancel = function () {
	                $scope.$emit('event:close');
	            };
	        }
	    };
	}];

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=account-tab> <div class=listing> <h3 class=listing-heading ng-if=\"contacts.length !== 0\" translate>notification.contacts_heading</h3> <div class=listing-item ng-repeat=\"contact in contacts\" ng-class=\"{'active': contact.active}\"> <div class=listing-item-secondary> <button type=button class=button-link ng-click=toggleActive(contact)> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> <span class=button-label translate>contact.configure</span> </button> </div> <div class=listing-item-primary> <h2 class=listing-item-title> {{contact.contact}} <span class=status-indicator ng-class=\"{green: contact.can_notify}\"></span> </h2> </div> <div class=listing-item-body> <div class=\"form-field switch\"> <label translate>notification.send_to_address</label> <div class=toggle-switch> <input class=tgl id=\"{{contact.id || false}}\" type=checkbox ng-model=contact.can_notify> <label class=tgl-btn for=\"{{contact.id || false}}\"></label> </div> </div> <form name=editContactForm> <div class=form-field> <label ng-if=\"contact.type === 'email'\" class=input-label ng-class=\"{ 'error': editContactForm.contact.$invalid && editContactForm.contact.$dirty, 'success': editContactForm.contact.$valid }\" for=contact translate>contact.edit_email_address</label> <label ng-if=\"contact.type === 'phone'\" class=input-label for=contact translate>contact.edit_phone_number</label> <p ng-repeat=\"(error, value) in editContactForm.contact.$error\" ng-if=\"contact.type === 'email'\" ng-show=editContactForm.contact.$dirty class=\"alert error\" translate=\"{{'contact.valid.email.' + error}}\"></p> <p ng-repeat=\"(error, value) in editContactForm.contact.$error\" ng-if=\"contact.type === 'phone'\" ng-show=editContactForm.contact.$dirty class=\"alert error\" translate=\"{{'contact.valid.phone.' + error}}\"></p> <input name=contact id=contact ng-if=\"contact.type === 'email'\" type=email ng-class=\"{ 'error': editContactForm.contact.$invalid && editContactForm.contact.$dirty }\" ng-maxlength=150 ng-model=contact.contact required> <input name=contact id=contact ng-if=\"contact.type === 'phone'\" type=text ng-class=\"{ 'error': editContactForm.contact.$invalid && editContactForm.contact.$dirty }\" ng-maxlength=25 ng-model=contact.contact ng-pattern=/^\\d+$/ required> </div> </form> <div class=form-field ng-if=!contact.isLoginEmail> <button class=button-destructive ng-click=deleteContact(contact) translate>contact.button.delete</button> </div> </div> </div> <div class=listing-item ng-class=\"{'active': contact.active}\"> <div class=listing-item-primary> <h2 class=listing-item-title> <a class=\"button button-flat\" ng-click=toggleActive(contact) translate> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#plus></use> </svg> contact.button.add </a> </h2> </div> <div class=listing-item-body> <form name=addContactForm> <div class=form-field> <label class=radio-label> <input ng-model=contact.type name=email value=email id=email type=radio checked=checked> {{'contact.type.email' | translate}} </label> </div> <div class=form-field> <label class=radio-label> <input ng-model=contact.type name=phone value=phone id=phone type=radio> {{'contact.type.phone' | translate}} </label> </div> <div class=form-field> <label ng-if=\"contact.type === 'email'\" class=input-label ng-class=\"{ 'error': addContactForm.contact.$invalid && addContactForm.contact.$dirty, 'success': addContactForm.contact.$valid }\" for=contact translate>contact.add_email_address</label> <label ng-if=\"contact.type === 'phone'\" class=input-label for=contact translate>contact.add_phone_number</label> <p ng-repeat=\"(error, value) in addContactForm.contact.$error\" ng-if=\"contact.type === 'email'\" ng-show=addContactForm.contact.$dirty class=\"alert error\" translate=\"{{'contact.valid.email.' + error}}\"></p> <p ng-repeat=\"(error, value) in addContactForm.contact.$error\" ng-if=\"contact.type === 'phone'\" ng-show=addContactForm.contact.$dirty class=\"alert error\" translate=\"{{'contact.valid.phone.' + error}}\"></p> <input name=contact id=contact ng-if=\"contact.type === 'email'\" type=email placeholder=\"{{'contact.add_email_address' | translate}}\" ng-class=\"{ 'error': addContactForm.contact.$invalid && addContactForm.contact.$dirty }\" ng-maxlength=150 ng-model=contact.contact required> <input name=contact id=contact ng-if=\"contact.type === 'phone'\" type=text placeholder=\"{{'contact.add_phone_number' | translate}}\" ng-class=\"{ 'error': addContactForm.contact.$invalid && addContactForm.contact.$dirty }\" ng-maxlength=25 ng-model=contact.contact ng-pattern=/^\\d+$/ required> </div> </form> </div> </div> </div> <div class=listing ng-if=\"notifications.length !== 0\"> <h3 class=listing-heading translate>notification.notifications_heading</h3> <div ng-repeat=\"notification in notifications\" class=listing-item> <div class=listing-item-secondary> <button type=button class=button-link ng-click=deleteNotification(notification)> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#circle-x></use> </svg> <span class=button-label translate>notification.button.delete</span> </button> </div> <div class=listing-item-primary> <div class=listing-item-image> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#star></use> </svg> </div> <h2 class=listing-item-title>{{notification.name}}</h2> </div> </div> </div> <div class=modal-actions> <div class=form-field> <button type=button class=button-link ng-click=cancel() translate>user_profile.button.cancel</button> <button type=button class=button-alpha ng-disabled=\"!canAdd() && !canUpdate()\" ng-click=saveContacts()> <div class=loading ng-show=saving><div class=line></div><div class=line></div><div class=line></div></div> <span translate>user_profile.button.save</span> </button> </div> </div> </div> ";

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('ushahidi.main', ['ushahidi.posts', 'ushahidi.activity']);
	
	__webpack_require__(679);
	__webpack_require__(818);

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('ushahidi.posts', [])
	
	// Shared directives + services
	.directive('postActions', __webpack_require__(680)).directive('postMetadata', __webpack_require__(682)).service('PostMetadataService', __webpack_require__(684)).service('PostSurveyService', __webpack_require__(685))
	
	// Detail Screen
	.directive('postMessages', __webpack_require__(686)).directive('postAddForm', __webpack_require__(689)).directive('postValue', __webpack_require__(691)).directive('postMediaValue', __webpack_require__(693)).directive('postVideoView', __webpack_require__(695)).directive('postDetailMap', __webpack_require__(697)).service('PostActionsService', __webpack_require__(699))
	
	// Create / Edit Screens
	.service('PostEntity', __webpack_require__(700)).service('PostEditService', __webpack_require__(701)).service('MediaEditService', __webpack_require__(702)).directive('postMedia', __webpack_require__(703)).directive('postVideoInput', __webpack_require__(705)).directive('postDatetime', __webpack_require__(709)).directive('postLocation', __webpack_require__(711)).directive('postRelation', __webpack_require__(713))
	
	// Post editing workflows
	.directive('postEditor', __webpack_require__(715)).directive('postValueEdit', __webpack_require__(717)).directive('postTabs', __webpack_require__(719)).directive('postToolbox', __webpack_require__(721)).directive('postTimelineToolbox', __webpack_require__(723))
	
	// Timeline and Map screen
	.service('PostViewService', __webpack_require__(725)).directive('postView', __webpack_require__(726)).directive('postViewList', __webpack_require__(728)).directive('postViewMap', __webpack_require__(730)).directive('postViewCreate', __webpack_require__(732)).directive('postCard', __webpack_require__(733)).directive('postPreviewMedia', __webpack_require__(735)).directive('addPostButton', __webpack_require__(737)).directive('addPostSurveyList', __webpack_require__(740)).directive('addPostTextButton', __webpack_require__(742)).directive('modeContextFormFilter', __webpack_require__(744)).directive('filterBySurvey', __webpack_require__(746)).directive('filterBySurveyDropdown', __webpack_require__(748)).directive('postToolbar', __webpack_require__(749))
	// Filters
	.directive('filterPosts', __webpack_require__(751)).directive('filterCategory', __webpack_require__(754)).directive('filterDate', __webpack_require__(756)).directive('filterForm', __webpack_require__(758)).directive('filterVisibleTo', __webpack_require__(760)).directive('filterStatus', __webpack_require__(762)).directive('filterLocation', __webpack_require__(764)).directive('filterHasLocation', __webpack_require__(766)).directive('postActiveFilters', __webpack_require__(768)).service('PostFilters', __webpack_require__(770)).directive('filterModal', __webpack_require__(771))
	// Share
	.directive('postShare', __webpack_require__(773)).directive('shareMenu', __webpack_require__(775)).directive('shareMenuModal', __webpack_require__(779)).directive('postExport', __webpack_require__(781))
	// @todo move elsewhere? Used in post-view and activity
	.directive('postViewUnavailable', __webpack_require__(783)).directive('savedSearchEditor', __webpack_require__(785)).directive('savedSearchCreate', __webpack_require__(787)).directive('savedSearchUpdate', __webpack_require__(789)).directive('savedSearchModal', __webpack_require__(791)).directive('savedSearchModeContext', __webpack_require__(793)).service('CollectionsService', __webpack_require__(795)).directive('collectionModeContext', __webpack_require__(796)).directive('collectionEditor', __webpack_require__(798)).directive('collectionListing', __webpack_require__(800)).directive('collectionToggleButton', __webpack_require__(802)).directive('collectionToggleLink', __webpack_require__(804)).config(__webpack_require__(806)).run(['Leaflet', function (L) {
	    L.Icon.Default.imagePath = '/img';
	}]);

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = PostActionsDirective;
	
	PostActionsDirective.$inject = ['PostEndpoint', 'Notify', '$location', '$route', 'PostActionsService'];
	function PostActionsDirective(PostEndpoint, Notify, $location, $route, PostActionsService) {
	    return {
	        restrict: 'E',
	        replace: true,
	        scope: {
	            post: '='
	        },
	        template: __webpack_require__(681),
	        link: PostActionsLink
	    };
	
	    function PostActionsLink($scope) {
	        $scope.deletePost = deletePost;
	        $scope.updateStatus = updateStatus;
	
	        activate();
	
	        function activate() {
	            $scope.statuses = PostActionsService.getStatuses();
	        }
	
	        function deletePost() {
	            PostActionsService.delete($scope.post).then(function () {
	                // If we're not already on some top level view
	                if ($location.path().indexOf('views') === -1 && $location.path().indexOf('collections') === -1 && $location.path().indexOf('savedsearches') === -1) {
	                    // Redirect to list
	                    $location.path('/views/list');
	                } else {
	                    $route.reload();
	                }
	            });
	        }
	
	        function updateStatus(status) {
	            $scope.post.status = status;
	
	            PostEndpoint.update($scope.post).$promise.then(function () {
	                Notify.notify('notify.post.save_success', { name: $scope.post.title });
	            }, function (errorResponse) {
	                Notify.apiErrors(errorResponse);
	            });
	        }
	    }
	}

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=postcard-actions dropdown> <a ng-show=\"post.allowed_privileges.indexOf('update') !== -1\" ng-href=/posts/{{post.id}}/edit class=\"button-gamma button-flat hide-until-small\"> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#pencil></use> </svg> </a> <button class=\"button-gamma button-flat init\" data-toggle=dropdown-menu dropdown-toggle> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#ellipses></use> </svg> <span class=hidden>More</span> </button> <div class=\"dropdown-menu init\" dropdown-menu> <ul> <li ng-show=\"post.allowed_privileges.indexOf('update') !== -1\" class=hide-when-small> <a ng-href=/posts/{{post.id}}/edit> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#pencil></use> </svg> <span class=label translate=nav.edit>Edit</span> </a> </li> <li> <collection-toggle-link post=post></collection-toggle-link> </li> <li> <post-share post-id=post.id></post-share> </li> </ul> <div class=divider ng-show=\"post.allowed_privileges.indexOf('change_status') !== -1 || post.allowed_privileges.indexOf('update') !== -1 \"></div> <ul> <li ng-repeat=\"status in statuses\" ng-show=\"post.allowed_privileges.indexOf('change_status') !== -1\"> <a ng-click=updateStatus(status)> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#globe ng-if=\"status=='published'\"></use> <use xlink:href=" + __webpack_require__(412) + "#box ng-if=\"status=='archived'\"></use> <use xlink:href=" + __webpack_require__(412) + "#lock-locked ng-if=\"status=='draft'\"></use> </svg> <span class=label ng-if=\"status=='published'\" translate=post.post_actions.publish>Publish</span> <span class=label ng-if=\"status=='draft'\" translate=post.post_actions.put_under_review>Put under </span> <span class=label ng-if=\"status=='archived'\" translate=post.post_actions.archive>Archive</span> </a> </li> <li ng-show=\"post.allowed_privileges.indexOf('update') !== -1\"> <a ng-click=deletePost()> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#trash></use> </svg> <span class=label translate=nav.delete>Delete</span> </a> </li> </ul> </div> </div> ";

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = PostMetadataDirective;
	
	PostMetadataDirective.$inject = ['$translate', '_', 'moment', 'PostMetadataService'];
	function PostMetadataDirective($translate, _, moment, PostMetadataService) {
	    return {
	        restrict: 'E',
	        scope: {
	            post: '=',
	            // Should we hide the date for posts this week?
	            hideDateThisWeek: '@?'
	        },
	        template: __webpack_require__(683),
	        link: function link($scope) {
	            //console.log($scope.post);
	            $scope.visibleTo = '';
	            $scope.displayTime = '';
	            $scope.displayTimeFull = '';
	            $scope.timeago = '';
	            $scope.hideDateThisWeek = $scope.hideDateThisWeek || false;
	
	            activate();
	
	            function activate() {
	                $scope.visibleTo = visibleTo($scope.post);
	                $scope.source = PostMetadataService.formatSource($scope.post.source);
	                $scope.post.user = PostMetadataService.loadUser($scope.post);
	                $scope.post.contact = PostMetadataService.loadContact($scope.post);
	
	                formatDates();
	            }
	
	            function formatDates() {
	                var postDate = moment($scope.post.post_date),
	                    now = moment();
	
	                if (now.isSame(postDate, 'day')) {
	                    $scope.displayTime = postDate.fromNow();
	                } else if (now.isSame(postDate, 'week') && $scope.hideDateThisWeek) {
	                    $scope.displayTime = postDate.format('LT');
	                } else {
	                    $scope.displayTime = postDate.format('LL');
	                }
	                $scope.displayTimeFull = postDate.format('LLL');
	
	                $scope.timeago = postDate.from(now);
	            }
	
	            function visibleTo(post) {
	                if (post.status === 'draft') {
	                    return 'draft';
	                }
	
	                if (!_.isEmpty(post.published_to)) {
	                    return post.published_to.join(', ');
	                }
	
	                return 'everyone';
	            }
	        }
	    };
	}

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<ul class=metadata> <li> <a class=status-indicator> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#globe ng-if=\"post.status=='published'\"></use> <use xlink:href=" + __webpack_require__(412) + "#lock-locked ng-if=\"post.status=='draft'\"></use> <use xlink:href=" + __webpack_require__(412) + "#box ng-if=\"post.status=='archived'\"></use> </svg> <span class=label translate=post.status_published ng-if=\"post.status=='published'\"></span> <span class=label translate=post.status_review ng-if=\"post.status=='draft'\"></span> <span class=label translate=post.status_archived ng-if=\"post.status=='archived'\"></span> </a> </li> <li> <img src=\"http://www.gravatar.com/avatar/{{ post.user.gravatar || '00000000000000000000000000000000' }}?d=retro&s=40\" class=avatar> <strong class=label ng-show=\"post.user && !post.author_realname\">{{ post.user.realname }}</strong> <strong class=label ng-show=\"post.contact && !post.author_realname\">{{ post.contact.contact}}</strong> <strong class=label ng-show=post.author_realname>{{ post.author_realname}}</strong> </li> <li class=tooltip> <span class=label>{{timeago}}</span> <span class=bug title=\"{{ displayTimeFull }}\">{{ displayTime }}</span> </li> <li> <span class=label translate-values=\"{ source : source }\" translate=post.source></span> </li> </ul> ";

/***/ }),
/* 684 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = PostMetadataService;
	
	PostMetadataService.$inject = ['Util', 'UserEndpoint', 'ContactEndpoint'];
	
	function PostMetadataService(Util, UserEndpoint, ContactEndpoint) {
	    var PostMetadataService = {
	        // Format source (fixme!)
	        formatSource: function formatSource(source) {
	            if (source === 'sms') {
	                return 'SMS';
	            } else if (source) {
	                // Uppercase first character
	                return source.charAt(0).toUpperCase() + source.slice(1);
	            } else {
	                return 'Web';
	            }
	        },
	        loadUser: function loadUser(post) {
	            if (post.user && post.user.id) {
	                return UserEndpoint.getFresh({ id: post.user.id });
	            }
	        },
	        loadContact: function loadContact(post) {
	            if (!post.user && post.contact && post.contact.id) {
	                return ContactEndpoint.get({ id: post.contact.id, ignore403: true }, angular.noop, angular.noop);
	            }
	        }
	    };
	
	    return Util.bindAllFunctionsToSelf(PostMetadataService);
	}

/***/ }),
/* 685 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = PostSurveyService;
	
	PostSurveyService.$inject = ['Util', 'FormEndpoint', '$rootScope', '$q', '_'];
	
	function PostSurveyService(Util, FormEndpoint, $rootScope, $q, _) {
	    var PostSurveyService = {
	        allowedSurveys: allowedSurveys,
	        canCreatePostInSurvey: canCreatePostInSurvey
	    };
	
	    function canCreatePostInSurvey(form) {
	        // If the form isn't loaded yet, we definitely can't add to it
	        if (!form) {
	            return false;
	        }
	
	        if ($rootScope.hasPermission('Manage Posts')) {
	            return true;
	        }
	
	        // if everyone_can_create, include the form
	        if (form.everyone_can_create) {
	            return true;
	        }
	        // Otherwise, continue to check if the user has access
	
	        // If we're not logged in, we have no role so we definitely don't have access
	        if ($rootScope.currentUser === null) {
	            return false;
	        }
	
	        // Finally, if we are logged in, check if our role is in the list
	        if (_.contains(form.can_create, $rootScope.currentUser.role)) {
	            return true;
	        }
	
	        return false;
	    }
	
	    function allowedSurveys() {
	        var allowed_forms = $q.defer();
	
	        FormEndpoint.queryFresh().$promise.then(function (forms) {
	            if ($rootScope.hasPermission('Manage Posts')) {
	                allowed_forms.resolve(forms);
	            } else {
	                allowed_forms.resolve(_.filter(forms, canCreatePostInSurvey));
	            }
	        });
	
	        return allowed_forms.promise;
	    }
	
	    return Util.bindAllFunctionsToSelf(PostSurveyService);
	}

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = ['$rootScope', '$translate', 'ContactEndpoint', 'MessageEndpoint', 'Notify', 'UserEndpoint', '_', 'moment', 'ModalService', function ($rootScope, $translate, ContactEndpoint, MessageEndpoint, Notify, UserEndpoint, _, moment, ModalService) {
	    return {
	        restrict: 'E',
	        replace: true,
	        scope: {
	            post: '='
	        },
	        template: __webpack_require__(687),
	        link: function link($scope) {
	
	            // Pagination
	            $scope.currentPage = 1;
	            $scope.itemsPerPage = 5;
	            $scope.totalItems = $scope.itemsPerPage;
	            $scope.pageChanged = getMessagesForPagination;
	
	            // Initialize
	            ContactEndpoint.get({ id: $scope.post.contact.id }).$promise.then(function (contact) {
	                $scope.contact = contact;
	            });
	
	            getMessagesForPagination();
	
	            function getMessagesForPagination() {
	                if ($scope.post.contact.id) {
	                    MessageEndpoint.allInThread({
	                        contact: $scope.post.contact.id,
	                        offset: ($scope.currentPage - 1) * $scope.itemsPerPage,
	                        limit: $scope.itemsPerPage
	                    }).$promise.then(function (response) {
	                        var created,
	                            messages = response.results;
	
	                        $scope.messages = messages;
	                        _.each(messages, function (message, index) {
	                            if (message.user) {
	                                message.user = UserEndpoint.getFresh({ id: message.user.id });
	                            }
	
	                            // Format update time for display
	                            created = message.updated || message.created;
	                            message.displayTime = formatDate(created);
	
	                            $scope.totalItems = response.total_count;
	                        });
	                    });
	                }
	            }
	
	            $scope.sendMessage = function () {
	                ModalService.close();
	
	                var reply = {
	                    message: $scope.message.reply_text,
	                    direction: 'outgoing',
	                    contact_id: $scope.post.contact.id,
	                    parent_id: $scope.messages[$scope.messages.length - 1].id
	                };
	
	                var request = MessageEndpoint.save(reply);
	
	                request.$promise.then(function (response) {
	                    // Update listing with new messages
	                    getMessagesForPagination();
	
	                    Notify.notify('notify.message.sent_to', { contact: $scope.contact.contact });
	                }, function (errorResponse) {
	                    Notify.apiErrors(errorResponse);
	                });
	            };
	
	            $scope.reply = function () {
	                $scope.message = {};
	                ModalService.openTemplate(__webpack_require__(688), 'post.messages.send', false, $scope, true, true);
	            };
	
	            function formatDate(date) {
	                var now = moment();
	                date = moment(date);
	
	                if (now.isSame(date, 'day')) {
	                    return date.fromNow();
	                }
	
	                return date.format('LLL');
	            }
	        }
	    };
	}];

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"listing card\"> <h3 class=listing-heading translate>post.messages.title</h3> <div ng-repeat=\"message in messages track by message.id\" class=listing-item> <div class=listing-item-primary> <div class=listing-item-image ng-if=\"message.direction == 'outgoing'\"> <img src=\"http://www.gravatar.com/avatar/{{ message.user.gravatar || '00000000000000000000000000000000' }}?d=retro&s=40\" class=avatar> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#arrow-thick-left></use> </svg> </div> <h2 class=listing-item-title> <span ng-if=\"message.direction == 'incoming'\">{{ ::contact.contact }}</span> <span ng-if=\"message.direction == 'outgoing' && message.user.realname\">{{ ::message.user.realname }}</span> </h2> <p class=listing-item-secondary>{{message.displayTime}}</p> <p>{{ message.message }}</p> </div> </div> <div class=listing-item ng-show=\"totalItems > itemsPerPage\"> <div class=listing-item-primary> <uib-pagination ng-model=currentPage items-per-page=itemsPerPage total-items=totalItems ng-change=pageChanged() max-size=5 rotate=false></uib-pagination> </div> </div> <div class=listing-item> <div class=listing-item-primary> <h2 class=listing-item-title> <a href=\"\" class=\"button button-flat\" ng-click=reply()> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#plus></use> </svg> {{ 'post.messages.send' | translate }} </a> </h2> </div> </div> </div> ";

/***/ }),
/* 688 */
/***/ (function(module, exports) {

	module.exports = "<div> <form name=form ng-submit=sendMessage()> <div class=form-field ng-class=\"{ 'error': form.reply.$invalid && form.reply.$dirty }\"> <textarea id=reply name=reply placeholder=\"Send message to {{ contact.contact }}\" ng-model=message.reply_text ng-minlength=2 ng-maxlength=140 required></textarea> </div> <div class=form-field> <button type=submit class=\"button-alpha modal-trigger\" ng-submit=sendMessage() ng-disabled=form.reply.$invalid translate>post.messages.save</button> </div> </form> </div> ";

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = ['FormEndpoint', 'PostEndpoint', '$translate', 'Notify', '$location', function (FormEndpoint, PostEndpoint, $translate, Notify, $location) {
	    return {
	        restrict: 'E',
	        replace: true,
	        scope: {
	            post: '='
	        },
	        template: __webpack_require__(690),
	        link: function link($scope) {
	            $translate('post.unstructured.add_survey.info', { source: $scope.post.source }).then(function (message) {
	                $scope.surveyInfo = message;
	            });
	
	            $scope.addForm = function () {
	                $scope.post.form = { id: $scope.selectedSurvey };
	
	                PostEndpoint.update($scope.post).$promise.then(function (response) {
	                    Notify.notify('notify.post.save_success', { name: $scope.post.title });
	                    $location.path('/posts/' + $scope.post.id + '/edit');
	                }, function (errorResponse) {
	                    Notify.apiErrors(errorResponse);
	                });
	            };
	
	            FormEndpoint.queryFresh().$promise.then(function (surveys) {
	                $scope.surveys = surveys;
	
	                if (surveys.length > 0) {
	                    $scope.selectedSurvey = surveys[0].id;
	                }
	            });
	        }
	    };
	}];

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=form-sheet ng-show=\"surveys.length > 0\"> <div class=form-sheet-summary> <h3 class=form-sheet-title translate>post.unstructured.add_survey.title</h3> </div> <div class=form-field> <p ng-bind-html=surveyInfo></p> </div> <form name=form ng-submit=addForm()> <fieldset> <legend translate> post.unstructured.add_survey.choose </legend> <div class=\"form-field radio\" ng-repeat=\"survey in surveys\"> <input id={{survey.id}} type=radio ng-model=$parent.selectedSurvey ng-value=survey.id /> <label for={{survey.id}}>{{survey.name}}</label> </div> </fieldset> <div class=form-field> <button class=button-alpha type=submit> <span class=button-label translate>post.unstructured.add_survey.save_and_edit</span> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#arrow-right></use> </svg> </button> </div> </form> </div> ";

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = ['PostEndpoint', 'moment', '_', function (PostEndpoint, moment, _) {
	    return {
	        restrict: 'E',
	        replace: true,
	        scope: {
	            key: '=',
	            value: '=',
	            attribute: '=',
	            type: '=',
	            tags: '='
	        },
	        template: __webpack_require__(692),
	        link: function link($scope) {
	            // This whole directive is wrong and it should feel wrong
	            // Depending on whether we are dealing with a post task or a standard task
	            // the css class is swapped. This Boolean manages that distinction.
	            $scope.standardTask = $scope.type === 'standard';
	            // TODO Move to Service
	            $scope.formatTags = function (tagIds) {
	                // getting tag-names and formatting them for displaying
	                var formatedTags = ' ';
	                _.each(tagIds, function (tag, index) {
	                    var tagObj = _.where($scope.tags, { id: parseInt(tag) });
	                    if (tagObj[0]) {
	                        tag = tagObj[0].tag;
	                        if (index < tagIds.length - 1) {
	                            formatedTags += tag + ', ';
	                        } else {
	                            formatedTags += tag;
	                        }
	                    }
	                });
	                return formatedTags;
	            };
	            if ($scope.attribute.type === 'relation') {
	                $scope.value = $scope.value.map(function (entry) {
	                    return PostEndpoint.get({ id: entry });
	                });
	            }
	            if ($scope.attribute.input === 'tags') {
	                $scope.value = $scope.formatTags($scope.value);
	            }
	            if ($scope.attribute.type === 'datetime') {
	                if ($scope.attribute.input === 'date') {
	                    $scope.value = $scope.value.map(function (entry) {
	                        return moment(entry).format('LL');
	                    });
	                }
	                if ($scope.attribute.input === 'datetime') {
	                    $scope.value = $scope.value.map(function (entry) {
	                        return moment(entry).format('LLL');
	                    });
	                }
	                if ($scope.attribute.input === 'time') {
	                    $scope.value = $scope.value.map(function (entry) {
	                        return moment(entry).format('LT');
	                    });
	                }
	            }
	        }
	    };
	}];

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div ng-class=\"{'postcard-field': !standardTask, 'listing-item-primary': standardTask}\"> <div ng-if=\"attribute.input !== 'video'\"> <h2 class=form-label> {{attribute.label}} </h2> <div ng-if=\"attribute.input === 'tags'\"> <p> <svg class=iconic style=margin-right:4px> <use xlink:href=" + __webpack_require__(412) + "#tag></use> </svg> {{value}} </p> </div> <div ng-repeat=\"entry in value\" ng-if=\"attribute.type === 'relation'\"> <a ng-href=/posts/{{entry.id}}>{{entry.title}}</a> </div> <div ng-repeat=\"entry in value\" ng-if=\"attribute.type !== 'relation' && attribute.input !== 'tags'\"> <p ng-if=\"attribute.type !== 'markdown'\">{{entry}}</p> <p ng-if=\"attribute.type === 'markdown'\" markdown-to-html=entry></p> </div> </div> <post-video-view ng-if=\"attribute.input === 'video'\" label={{attribute.label}} video-url=value></post-video-view> </div> ";

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = ['MediaEndpoint', '_', function (MediaEndpoint, _) {
	    return {
	        restrict: 'E',
	        replace: true,
	        scope: {
	            mediaId: '=',
	            label: '@'
	        },
	        template: __webpack_require__(694),
	        link: function link($scope) {
	            if (!_.isNull($scope.mediaId)) {
	                MediaEndpoint.get({ id: $scope.mediaId }).$promise.then(function (media) {
	                    $scope.media = media;
	                });
	            }
	        }
	    };
	}];

/***/ }),
/* 694 */
/***/ (function(module, exports) {

	module.exports = "<div class=postcard-field> <h2 class=form-label> {{label}} </h2> <img ng-src=\"{{ media.original_file_url }}\" class=postcard-image> <p class=small><em>{{ media.caption }}</em></p> </div> ";

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = PostVideoValue;
	
	PostVideoValue.$inject = [];
	
	function PostVideoValue() {
	    return {
	        restrict: 'E',
	        scope: {
	            videoUrl: '=',
	            label: '@'
	        },
	        template: __webpack_require__(696),
	        controller: PostVideoValueController
	    };
	}
	
	PostVideoValueController.$inject = ['$scope', '$sce'];
	
	function PostVideoValueController($scope, $sce) {
	    activate();
	
	    function activate() {
	        $scope.videoUrl = $sce.trustAsResourceUrl($scope.videoUrl[0]);
	    }
	}

/***/ }),
/* 696 */
/***/ (function(module, exports) {

	module.exports = "<div class=postcard-field> <h2 class=form-label> {{label}} </h2> <div class=video_embed-fluid> <iframe src={{videoUrl}} frameborder=0 allowfullscreen></iframe> </div> </div> ";

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = PostDetailMap;
	
	PostDetailMap.$inject = ['PostEndpoint', 'Maps', '_', 'PostFilters', 'Leaflet', '$q', '$rootScope', '$compile'];
	function PostDetailMap(PostEndpoint, Maps, _, PostFilters, L, $q, $rootScope, $compile) {
	    return {
	        restrict: 'E',
	        scope: {
	            postId: '='
	        },
	        link: DetailMapLink,
	        template: __webpack_require__(698)
	    };
	
	    function DetailMapLink($scope, element, attrs) {
	        var map;
	        $scope.hideMap = false;
	
	        activate();
	
	        function activate() {
	            // Start loading data
	            var geojson = PostEndpoint.geojson({ id: $scope.postId }).$promise;
	            var createMap = Maps.createMap(element[0].querySelector('#post-map')).then(function (data) {
	                map = data;
	            });
	
	            // When data is loaded
	            $q.all({
	                map: createMap,
	                geojson: geojson
	            })
	            // Create the map
	            .then(addGeoJSONToMap);
	
	            // Cleanup leaflet map
	            $scope.$on('$destroy', function () {
	                if (map) {
	                    map.remove();
	                }
	            });
	        }
	
	        function addGeoJSONToMap(data) {
	            var geojsonData = data.geojson;
	            // If theres no location data, drop out now
	            if (geojsonData.features && geojsonData.features.length === 0) {
	                $scope.hideMap = true;
	                return;
	            }
	
	            var geojson = L.geoJson(geojsonData, {
	                pointToLayer: Maps.pointToLayer
	            });
	            geojson.addTo(map);
	
	            // Focus map on data points but..
	            // Avoid zooming further than 15 (particularly when we just have a single point)
	            map.fitBounds(geojson.getBounds());
	            if (map.getZoom() > 15) {
	                map.setZoom(15);
	            }
	        }
	    }
	}

/***/ }),
/* 698 */
/***/ (function(module, exports) {

	module.exports = "<div class=postcard-field ng-hide=hideMap> <h2 class=form-label translate>post.location</h2> <div id=post-map class=map></div> </div> ";

/***/ }),
/* 699 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['_', 'Util', '$translate', 'PostEndpoint', 'Notify', '$q', function (_, Util, $translate, PostEndpoint, Notify, $q) {
	    var PostActionsService = {
	        delete: function _delete(post) {
	            var deferred = $q.defer();
	
	            Notify.confirmDelete('notify.post.destroy_confirm').then(function () {
	                PostEndpoint.delete({ id: post.id }).$promise.then(function () {
	                    Notify.notify('notify.post.destroy_success', { name: post.title });
	                    deferred.resolve();
	                }, function (errorResponse) {
	                    Notify.apiErrors(errorResponse);
	                    deferred.reject(errorResponse);
	                });
	            });
	
	            return deferred.promise;
	        },
	        getStatuses: function getStatuses() {
	            return ['published', 'draft', 'archived'];
	        }
	    };
	
	    return Util.bindAllFunctionsToSelf(PostActionsService);
	}];

/***/ }),
/* 700 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['CONST', function (CONST) {
	    return function (data) {
	        return angular.extend({}, {
	            // id: 0,
	            title: '',
	            content: '',
	            locale: CONST.DEFAULT_LOCALE,
	            values: {},
	            completed_stages: [],
	            published_to: [],
	            post_date: new Date()
	        }, data);
	    };
	}];

/***/ }),
/* 701 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['_', 'Util', '$translate', 'Notify', function (_, Util, $translate, Notify) {
	    var PostEditService = {
	        cleanPostValues: function cleanPostValues(post) {
	            _.each(post.values, function (value, key) {
	                // Strip out empty values
	                post.values[key] = _.filter(value);
	                // Remove entirely if no values are left
	                if (!post.values[key].length) {
	                    delete post.values[key];
	                }
	            });
	            return post;
	        },
	        validatePost: function validatePost(post, form, tasks) {
	            // First get tasks to be validated
	            // The post task is always validated
	            // Other tasks are only validated if marked completed
	
	            var isPostValid = true;
	            var tasks_to_validate = [];
	
	            _.each(tasks, function (task) {
	                if (task.type === 'post' || _.contains(post.completed_stages, task.id)) {
	                    tasks_to_validate.push(task);
	                }
	            });
	
	            // Validate Post default fields
	            if (!form) {
	                return false;
	            }
	
	            if (form.title.$invalid) {
	                return false;
	            }
	
	            if (!form.content || form.content.$invalid) {
	                return false;
	            }
	
	            // Validate required fields for each task that needs to be validated
	            _.each(tasks_to_validate, function (task) {
	                var required_attributes = _.where(task.attributes, { required: true });
	
	                _.each(required_attributes, function (attribute) {
	                    if (attribute.input === 'checkbox') {
	                        var checkboxValidity = false;
	                        _.each(attribute.options, function (option) {
	                            if (!_.isUndefined(form['values_' + attribute.id + '_' + option]) && !form['values_' + attribute.id + '_' + option].$invalid) {
	                                checkboxValidity = isPostValid;
	                            }
	                        });
	                        isPostValid = checkboxValidity;
	                    } else {
	
	                        if (_.isUndefined(form['values_' + attribute.id]) || form['values_' + attribute.id].$invalid) {
	                            if (!_.isUndefined(form['values_' + attribute.id])) {
	                                form['values_' + attribute.id].$dirty = true;
	                            }
	
	                            isPostValid = false;
	                        }
	                    }
	                });
	            });
	            return isPostValid;
	        }
	    };
	
	    return Util.bindAllFunctionsToSelf(PostEditService);
	}];

/***/ }),
/* 702 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$q', '$http', '_', 'Util', '$translate', 'MediaEndpoint', 'Notify', function ($q, $http, _, Util, $translate, MediaEndpoint, Notify) {
	    var MediaEditService = {
	        saveMedia: function saveMedia(medias, post) {
	            var deferred = $q.defer();
	            var calls = [];
	            // Loop over medias and check for changes
	            _.each(medias, function (media, key) {
	                // Check if media needs to be updated
	                if (media.changed) {
	                    // Check if new media or if the media file has changed
	                    // otherwise just update the caption
	                    if (!media.id && media.deleted) {
	                        post.values[key][0] = null;
	                        // Check if a new file was uploaded
	                    } else if (media.file) {
	                        calls.push(MediaEditService.uploadFile(media).then(function (media) {
	                            post.values[key][0] = media ? media.id : null;
	                        }));
	                        // Otherwise update the media as it has changed
	                    } else {
	                        // Remove irrelevant fields
	                        delete media.changed;
	                        calls.push(MediaEditService.update(media).then(function (media) {
	                            post.values[key][0] = media ? media.id : null;
	                        }));
	                    }
	                }
	            });
	            // Wait for all media updates to complete
	            // then resolve the promise and continue
	            // saving the post
	            $q.all(calls).then(function () {
	                deferred.resolve(post);
	            });
	            return deferred.promise;
	        },
	        deleteMedia: function deleteMedia(mediaId) {
	            if (mediaId) {
	                return MediaEndpoint.delete({ id: mediaId }).$promise;
	            }
	            // Return a promise anyway if there is no media to delete
	            return $q.when();
	        },
	        update: function update(media) {
	            var deferred = $q.defer();
	
	            MediaEndpoint.update(media).$promise.then(function (media) {
	                deferred.resolve(media);
	            }, function (error) {
	                Notify.apiErrors(error);
	                // We warn the user about image errors but
	                // we continue to save the post
	                deferred.resolve({});
	            });
	            return deferred.promise;
	        },
	        uploadFile: function uploadFile(media) {
	            var deferred = $q.defer();
	            // Delete current file
	            this.deleteMedia(media.id).then(function () {
	                var formData = new FormData();
	
	                formData.append('file', media.file);
	
	                if (media.caption) {
	                    formData.append('caption', media.caption);
	                }
	
	                $http.post(Util.apiUrl('/media'), formData, {
	                    headers: {
	                        'Content-Type': undefined
	                    }
	                }).then(function (response) {
	                    media.id = response.data.id;
	                    deferred.resolve(media);
	                }, function (error) {
	                    Notify.apiErrors(error);
	                    // We warn the user about image errors but
	                    // we continue to save the post
	                    deferred.resolve({});
	                });
	            }, function (error) {
	                Notify.apiErrors(error);
	                // We warn the user about image errors but
	                // we continue to save the post
	                deferred.resolve({});
	            });
	
	            return deferred.promise;
	        }
	    };
	
	    return Util.bindAllFunctionsToSelf(MediaEditService);
	}];

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = ['$http', 'MediaEndpoint', 'MediaEditService', 'Util', 'Notify', '$q', function ($http, MediaEndpoint, MediaEditService, Util, Notify, $q) {
	    return {
	        restrict: 'E',
	        replace: true,
	        require: '^^form',
	        scope: {
	            mediaId: '=',
	            media: '=',
	            name: '@'
	        },
	        template: __webpack_require__(704),
	        link: function link($scope, element, attr, formCtrl) {
	
	            if ($scope.mediaId) {
	                MediaEndpoint.get({ id: $scope.mediaId }).$promise.then(function (media) {
	                    $scope.media = media;
	                    // Set initial media state
	                    $scope.media.changed = false;
	                });
	            } else {
	                // Initialize media object
	                $scope.media = { file: null, caption: null, dataURI: null, changed: false };
	            }
	
	            $scope.showAdd = function () {
	                return !$scope.media.id && !$scope.media.changed || $scope.media.deleted;
	            };
	
	            $scope.showReplace = function () {
	                return $scope.media.dataURI || $scope.media.id;
	            };
	
	            $scope.showDelete = function () {
	                return $scope.media.id;
	            };
	
	            $scope.deleteMedia = function (mediaId) {
	                // Mark for deletion
	                Notify.confirmDelete('notify.post.delete_image_confirm').then(function () {
	                    MediaEditService.deleteMedia(mediaId).then(function () {
	                        $scope.media = {};
	                        $scope.media.changed = true;
	                        $scope.media.deleted = true;
	                        $scope.mediaId = null;
	                    });
	                });
	            };
	        }
	    };
	}];

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = " <form> <div class=\"form-field file\"> <file-upload id={{name}} container=media model=mediaId> </file-upload> <label for={{name}} class=\"button button-gamma\" ng-show=showAdd()> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#plus></use> </svg> <span class=button-label translate=post.media.add_photo></span> </label> <figure ng-show=showReplace()> <img ng-src={{media.original_file_url}} ng-show=\"media.id && !media.dataURI\"> <img ng-src={{media.dataURI}} ng-show=media.dataURI> <div class=form-field> <button class=button-destructive ng-click=deleteMedia(media.id) ng-show=showDelete()> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#trash></use> </svg> <span class=hidden translate=post.media.delete_photo></span> </button> <file-upload id={{name}} container=media model=mediaId></file-upload> <label for={{name}} class=\"button button-gamma\"> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#image></use> </svg> <span class=button-label translate=post.media.replace_image></span> </label> </div> </figure> <div> <figure> <p class=small translate>post.media.add_caption</p> <input type=text placeholder=\"{{ 'post.media.add_caption' | translate }}\" ng-model=media.caption> </figure> </div> </div> </form> ";

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = PostVideo;
	
	PostVideo.$inject = [];
	
	function PostVideo() {
	    return {
	        restrict: 'E',
	        scope: {
	            videoUrl: '='
	        },
	        template: __webpack_require__(706),
	        controller: PostVideoController
	    };
	}
	
	PostVideoController.$inject = ['$scope', '$sce', 'Util', 'Notify'];
	
	function PostVideoController($scope, $sce, Util, Notify) {
	    $scope.constructIframe = constructIframe;
	    // $scope.getVideoThumbnail = getVideoThumbnail;
	    activate();
	    function activate() {
	        // Here we make a statement of trust of the URL based on having previously constructed it
	        $scope.video = $sce.trustAsResourceUrl($scope.videoUrl);
	        $scope.previewId = $scope.videoId ? $scope.videoId : Util.simpluUUID();
	    }
	
	    function constructIframe(videoUrl) {
	        parseVideo(videoUrl);
	
	        var preview = angular.element(document.getElementById($scope.previewId));
	
	        if ($scope.videoUrl === undefined) {
	            preview.empty();
	        } else {
	            preview.empty();
	            preview.html(createVideo()).wrap('<div class="video_embed-fluid" />');
	        }
	    }
	
	    // Originates from PL
	    function parseVideo(url) {
	        // - Supported YouTube URL formats:
	        //   - http://www.youtube.com/watch?v=My2FRPA3Gf8
	        //   - http://youtu.be/My2FRPA3Gf8
	        //   - https://youtube.googleapis.com/v/My2FRPA3Gf8
	        // - Supported Vimeo URL formats:
	        //   - http://vimeo.com/25451551
	        //   - http://player.vimeo.com/video/25451551
	        // - Also supports relative URLs:
	        //   - //player.vimeo.com/video/25451551
	        if (url) {
	            // NOTE: It is very important to pay special attention to the santization needs of this regex if it is changed.
	            // It is important that it does not allow subdomains other than player or www in order to ensure that a malicious user
	            // can not exploit this field to insert malicious content in an iframe
	            var match = url.match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/);
	            $scope.videoUrl = undefined;
	            if (match) {
	                if (match[3].indexOf('youtu') > -1) {
	                    // Here we make a statement of trust of the URL based on having pulled out just the id
	                    $scope.videoUrl = 'https://www.youtube.com/embed/' + match[6];
	                    $scope.video = $sce.trustAsResourceUrl($scope.videoUrl);
	                } else if (match[3].indexOf('vimeo') > -1) {
	                    // Here we make a statement of trust of the URL based on having pulled out just the id
	                    $scope.videoUrl = 'https://player.vimeo.com/video/' + match[6];
	                    $scope.video = $sce.trustAsResourceUrl($scope.videoUrl);
	                } else {
	                    urlError(url);
	                }
	            } else {
	                urlError(url);
	            }
	        }
	    }
	
	    function urlError(url) {
	        Notify.error('notify.video.incorrect_url', { url: url });
	    }
	
	    // Originates from PL
	    function createVideo() {
	        return '<iframe src="' + $scope.video + '" frameborder="0" allowfullscreen>';
	    }
	
	    // // Originates from PL
	    // function getVideoThumbnail(url, cb) {
	    //     // Obtains the video's thumbnail and passed it back to a callback function.
	    //     var videoObj = parseVideo(url);
	    //     if (videoObj.type === 'youtube') {
	    //         cb('//img.youtube.com/vi/' + videoObj.id + '/maxresdefault.jpg');
	    //     } else if (videoObj.type === 'vimeo') {
	    //         // Requires jQuery
	    //         $.get('http://vimeo.com/api/v2/video/' + videoObj.id + '.json', function(data) {
	    //             cb(data[0].thumbnail_large);
	    //         });
	    //     }
	    // }
	}

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = " <form> <div class=\"form-field video_embed\"> <label>{{label}}</label> <p> <span translate=post.video.enter_a>Enter a</span> <img src=" + __webpack_require__(707) + " class=wordmark-replace> <span translate=post.video.or> or </span> <img src=" + __webpack_require__(708) + " class=wordmark-replace> <span translate=post.video.video_url> video URL</span> </p> <input type=text ng-model=videoUrl ng-change=constructIframe(videoUrl) placeholder=https://youtu.be/123456> <div id={{previewId}} class=form-field-preview ng-show=videoUrl> <div class=video_embed-fluid> <iframe frameborder=0 ng-src={{video}} allowfullscreen></iframe> </div> </div> </div> </form> ";

/***/ }),
/* 707 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAARCAYAAABegLWFAAAAAXNSR0IArs4c6QAABWFJREFUSA2tll1sVEUUx/8zd+92u7ItkBUqLYWSUqgUEkM0RlEDqBhRg5oYosYPjPrg14OB8EJCeDIkJuoDiSZAiPLAxwMSjImJaNTEFFEhLWClRWhLaVgQ2t12d+/dmfF/7u5CDURC8CS/nbkzc2f+c86cuavwP5gD1PmOpoXKojHUqk5bJK1CLdtrFJxvgRmwNqmUsqy7GPQAFAoOLlBAgRLGNXTW90zGmKB72rFMTmSx79ZsqG1G2np6e0yrFZzM15xSJlUTZqZICOUfQF+nz3FAiQPYdazg3Gstxwc7ZVgtCUmJiGniEWm7oZ1pb95cp9Xa0ZKprl1+R9RNVCitjn4TU7LEVZugFUkqH7fucE6n7pf2N8jbZDXpJd+Sn8k68p92srW1Rpns75OXLm9Pvb+eQQoi76iaOEY+347srp1QiUQ0hwuKmPLuWsQa7kBmwzooT/Z/rUVCHYyzZrFs4SeykDxI2sgS0kNuaKEfTqV3GoJ8HuHQEPzWNsTb70R47hxKly/DGMOjxpWKAWxYKvd3LIqeTbEY9bEbhn2mUCiXfPaU8ix0i4gTIV1kGVlOuH18ReaQVaSViDWSh4m44h7SkYKZZH0/mTt8CAOvrEah6yiKvScxuOZ5FP/qgz+vHY6ei9+1GJiUokCKLOThz29HYslDsAy7obe9mbOQfPRxls0UKMtzQ3DpGGuGfEleJyLoB1JfKdMsL5EHyN1kB5lNPiU9TYnEpp6xwGeM4OLULGeJC1ovjobNH9ObZ3Fhyydo3nsAZ1Y/DTs+jvicVjRu3Qm/sQn9Lz4HcyGDmV/shpeqgxkZwcCaF2B7jvPkeynOFtkB/k4j3CJ2kSeIJMp9RI7Bs6RIZCOSeJI8JQTGZ1i0YYt1vDTYKCahkrrkXpR/Upd+7aGUyWDgrTfhGNZ4+wKknnpGOtG78hHIWU09uQphMUTAa6kq7ijfl/BKhn5DbidZ0kVGiHjyGpPBkn9VZICIquTkv+pRm9Ywo6PIn/wTluLgx6Hr6+GY6fG5PO582ZuaRokbsc7VS1jF5CLsJreRfiKpJB7zK6WseV0Tr0mn3FPRIP5caWO7eFFMxEVjorCXM9WxQRIllk6jYf0GBMPnUOg/TQ9r8fRoVZy8L6GSsImJMLHK1Feeq23SrnwVC6wzsq6+GsqKIBlBbNRdbqtOJhksFnnT9xEMDuDEyhVIMtNLPHcq5kvf2WpYZWxVkNRFqAiXLUopz9Ivs0q21kX1kpenl0JZK1qvsnokVDzEj5WaPIVDK+KkX7zCxVUsFnnSBiFUPB6dx5YtnyH98qsIea0wtNmJ4mr4apKIiINEMvV70lQpx1mKUEmYeYTbszm6Oi8ekFCqmpro0jUUZXI5TF66DM0bN7GXuxJRFJxc0IG5O3ZCJ5MoDg/j0ncHEZ/RiPl798GfPh2jnZ0wMlarC+XgR69H2fgbq7+SXsJ8jjL2Q5b7yHkie99Dvia/bGxo6O4Pgpc8qLQItLyzckeOINfVxfMzjFI2i+FtW5E/dSpaVC7m7KFOjHV3Y+zECWT27sFYzx8o9PUxRppjt+Hi/v0wXoxOV5snhpLT37z9OLv5ozql38vxu2kLctvwbuHFa8MQjoddxXgHlkrQNQk4w9Mh/0tkFJNBi6fpJXnPyRHgdzVZW4u8s0dDePdOTIjopZv94bIfZI1tZ8SW+4kE9182xWvCCnyslk7HozMj/1zkn8mVsHEzEhIZW7Suj5V3lg6cLtyy50TKbq4zfdasRbzFZnP/U7h0koslePZauECbcq6ZX46ZWutaxusS+4ZIL8d1QbmLHDOmnct6Wp/PGnPkscHBv2XefwAFN2BLMaJizQAAAABJRU5ErkJggg=="

/***/ }),
/* 708 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAARCAYAAABegLWFAAAAAXNSR0IArs4c6QAAA75JREFUSA3tVW1olWUYvs57zvu+59058wz3oWdzzg1ryVaRwn5ouMSCLDBo+Kd+lCPJHxEGSlEhKPYz/OEPEQSNwq+gDymIiCCkDKoJ0y1DN+e2Nre2znY+3/Oe98Prfs4cGoSHBH+ED4O9z/Pc9/1c93Vdz3OAB+O/MRAKOCpNLXoBdC0E/t2XoVV6ylcTNracS+HAYKbSlHuOqwicUHt6zMa1nI8ao6KUewYmBe4qqwATFWeLHlKlAKvjEcm7L2PxpAupEg4P5fFik4lnk1H8NOPg0NU8dCLb2xHDd1MlDGVdHOisxkDaxdHhPHa3xxDm/hcTReTcAK+1WsqTZ8jydNHHyyujaFto5krGxVnGDeU81LBoL2Ol0WnbwynG/zxbgs+Wn24w8Mqqch0F7ptJG+8P5DBpB2BNdDPg2EgBv6Q8xdrrv2Ywzj0B2lKVw8kxB2MFn7FZDGY8TBQCyLWaYfIwD++b8+D6AVwu7uuoxmfjBewfzENUqIqEcJ0xvFvY2WZhZ18af2R8dNfr+JM19zEuwYO2NVtQBmquCmPXQxZiYTDAA+tif0ccdUYIUa69sdpCYzSEWs67lurYUKtDrPfjrIseMv1YIqwO/XrSUftP1EQUg0siGvpSDt67lINFij9fn8ALSYMgQ2gwQwScpQo+drRF8VFXAr2rooq982RRhgLXkdDRs8JCc5WGCTI0Zfs4R1mlk54mA4/W6LjBddnvqjVZnAx7ZQl2t8exhJ0WSMVzPPjdNXHVufi0k6CPj9igotjaaOA3WueT0SLlN7Gx3sD5v10k2fSrLZYCk6Y1RIEY2ZWx6DnpbC07/nTcwd6BLC5TLin+1sMxekUOCFDNpGH67gJl09nW1kYT8yVKmfXJegjb6ZU5zq9mPcWkyQdxaOH72ymH/org4ONxrFsawYnrtrJQkjXroxrmHB9f0pMmleom8DvAyeTJOkOB+2HGRYul4UMWShDF5XTZe9//5WIwnUaOLElvTVYYNr8FuPhEDD6Sd3mzAyXPnv4shASPPpkuAvOM+3jUZvMu6kyNVtGUd9/uz2CEPrw475LFKDbR8zIWmZPJ5mUGnk/qSrI9j8TQXl3eforBl5jYQlMKO3nP5221+UsRoN6M4E16sm+uBI9yNxLwpoYIUk6ALcsNbKjTcWS4gN/ZoNzgVtZ4h7Wf4Z7UPHQlT1+6qCXYDzpjeGmlxRegLOtd3zkBLcOnGbSFpPIKCKX8Bv7b/Na6/HfInjw7tw6+fS9P9i1a4B/lbw958P3/YeAme9qUxi4/HgMAAAAASUVORK5CYII="

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = ['moment', '_', function (moment, _) {
	    return {
	        restrict: 'E',
	        replace: true,
	        scope: {},
	        require: 'ngModel',
	        template: __webpack_require__(710),
	        link: function link($scope, element, attrs, ngModel) {
	            // Split date time in time and date fields
	            $scope.timeOptions = { format: 'HH:i', interval: 15, onClose: save };
	            $scope.dateOptions = { format: 'yyyy-mm-dd', onClose: save };
	            $scope.model = null;
	
	            // If no ngModel, skip the rest
	            if (!ngModel) {
	                return;
	            }
	
	            // Update models on render
	            ngModel.$render = render;
	
	            // Render ngModel viewValue into scope
	            function render() {
	                $scope.model = moment(ngModel.$viewValue).toDate();
	            }
	
	            // Save model value
	            // Only runs when modal closes, this avoids overwriting the time
	            // and rounding it to 15mins, even when the user never changed it
	            function save() {
	                ngModel.$setViewValue($scope.model);
	            }
	        }
	    };
	}];

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div> <div class=\"form-field date\"> <div class=input-with-icon> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#calendar></use> </svg> <input type=text pick-a-date=model pick-a-date-options=dateOptions /> </div> </div> <div class=\"form-field date\"> <div class=input-with-icon> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#clock></use> </svg> <input type=text pick-a-time=model pick-a-time-options=timeOptions /> </div> </div> </div> ";

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = PostLocationDirective;
	
	PostLocationDirective.$inject = ['$document', '$http', 'Leaflet', 'Geocoding', 'Maps', '_', 'Notify', '$window'];
	function PostLocationDirective($document, $http, L, Geocoding, Maps, _, Notify, $window) {
	    return {
	        restrict: 'E',
	        replace: true,
	        scope: {
	            id: '@',
	            name: '@',
	            model: '=',
	            required: '='
	        },
	        template: __webpack_require__(712),
	        link: PostLocationLink
	    };
	
	    function PostLocationLink($scope, element, attrs) {
	        var currentPositionControl,
	            map,
	            marker,
	            zoom = 8;
	
	        $scope.processing = false;
	        $scope.searchLocationTerm = '';
	        $scope.searchLocation = searchLocation;
	        $scope.searchTimeout;
	        $scope.handleActiveSearch = handleActiveSearch;
	        $scope.clear = clear;
	
	        // for dropdown
	        $scope.showSearchResults = showSearchResults;
	        $scope.hideSearchResults = hideSearchResults;
	        $scope.chooseLocation = chooseLocation;
	        $scope.chooseCurrentLocation = chooseCurrentLocation;
	        $scope.searchResults = [];
	        $scope.showCurrentPositionControl = false;
	        activate();
	
	        function activate() {
	
	            Maps.createMap(element[0].querySelector('.map')).then(function (data) {
	                map = data;
	
	                // init marker with current model value
	                if ($scope.model && typeof $scope.model.lat !== 'undefined' && typeof $scope.model.lon !== 'undefined') {
	                    updateMarkerPosition($scope.model.lat, $scope.model.lon);
	                    centerMapTo($scope.model.lat, $scope.model.lon);
	                }
	                map.on('click', onMapClick);
	                // treat locationfound same as map click
	                map.on('locationfound', onMapClick);
	                // Add locate control, but only on https
	                if (window.location.protocol === 'https:' || window.location.hostname === 'localhost') {
	                    $scope.showCurrentPositionControl = true;
	                    currentPositionControl = L.control.locate({
	                        follow: true
	                    }).addTo(map);
	                }
	                // @todo: Should we watch the model and update map?
	            });
	
	            $document.on('click', onDocumentClick);
	        }
	
	        function onDocumentClick(event) {
	            if (!element[0].querySelector('.searchbar').contains(event.target)) {
	                $scope.hideSearchResults();
	            }
	        }
	
	        function onMapClick(e) {
	            var wrappedLatLng = e.latlng.wrap(),
	                lat = wrappedLatLng.lat,
	                lon = wrappedLatLng.lng;
	
	            updateMarkerPosition(lat, lon);
	            updateModelLatLon(lat, lon);
	        }
	
	        function updateModelLatLon(lat, lon) {
	            $scope.model = {
	                lat: lat,
	                lon: lon
	            };
	        }
	
	        function updateMarkerPosition(lat, lon) {
	            if (marker) {
	                marker.setLatLng([lat, lon]);
	            } else {
	                marker = L.marker([lat, lon], {
	                    draggable: true,
	                    icon: Maps.pointIcon()
	                });
	                marker.addTo(map);
	
	                marker.on('dragend', function (ev) {
	                    var latLng = ev.target.getLatLng();
	                    updateModelLatLon(latLng.lat, latLng.lng);
	                });
	            }
	        }
	
	        function centerMapTo(lat, lon) {
	            map.setView([lat, lon], zoom);
	        }
	
	        function clear() {
	            $scope.model = null;
	            if (marker) {
	                map.removeLayer(marker);
	                marker = null;
	            }
	        }
	
	        // for dropdown
	        function showSearchResults() {
	            element[0].querySelector('#searchbar-results').classList.add('active');
	        }
	
	        function hideSearchResults() {
	            element[0].querySelector('#searchbar-results').classList.remove('active');
	        }
	
	        function handleActiveSearch(event) {
	            var del = event.keyCode === 8 || event.keyCode === 46;
	            var letter = event.keyCode > 47 && event.keyCode < 58;
	            var number = event.keyCode > 64 && event.keyCode < 91;
	            if (del || letter || number) {
	                $scope.processing = true;
	                if ($scope.searchTimeout) {
	                    clearTimeout($scope.searchTimeout);
	                }
	                $scope.searchTimeout = setTimeout($scope.searchLocation, 250);
	            }
	            if (event.keyCode === 13) {
	                event.preventDefault();
	                return false;
	            }
	        }
	
	        function searchLocation() {
	            $scope.processing = true;
	            Geocoding.searchAllInfo($scope.searchLocationTerm).then(function (results) {
	                $scope.processing = false;
	                $scope.searchResults = results;
	            });
	        }
	
	        function chooseLocation(location) {
	            $scope.searchLocationTerm = '';
	            updateModelLatLon(location.lat, location.lon);
	            updateMarkerPosition(location.lat, location.lon);
	            centerMapTo(location.lat, location.lon);
	            $scope.hideSearchResults();
	        }
	
	        function chooseCurrentLocation() {
	            currentPositionControl.start();
	            $scope.hideSearchResults();
	        }
	    }
	}

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = " <div class=location-wrapper> <div id={{id}}-map class=map style=height:265px;width:100%></div> <form class=searchbar> <div class=\"searchbar-input init\" role=search> <div class=form-field> <input name={{name}} type=search maxlength=250 placeholder=\"{{'location.placeholder' | translate}}\" ng-model=searchLocationTerm ng-focus=showSearchResults() ng-keydown=handleActiveSearch($event) /> </div> <div id=searchbar-results class=\"searchbar-results dropdown-menu init\"> <div class=form-field> <button class=\"button-beta button-plain\" ng-click=chooseCurrentLocation() ng-if=showCurrentPositionControl> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#location> </use> </svg> <span class=button-label translate>location.use_current_location</span> </button> </div> <div class=tool> <h6 class=tool-heading translate>location.search_results</h6> <dl ng-repeat=\"result in searchResults\" ng-if=\"!processing && searchResults.length > 0\"> <dt class=list-item ng-click=chooseLocation(result)> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#map-marker> </use> </svg> <em>{{result.display_name}}</em> </dt> </dl> <dl class=dropdown-menu-body ng-if=processing> <dt class=list-item> <div class=loading style=width:auto> <div class=line></div> <div class=line></div> <div class=line></div> </div> </dt> </dl> <dl class=dropdown-menu-body ng-if=\"!processing && !searchResults\"> <dt class=list-item> No matching locations. </dt> </dl> </div> </div> </div> </form> <p translate>location.click_map</p> </div>";

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = ['PostEndpoint', '_', function (PostEndpoint, _) {
	
	    return {
	        restrict: 'E',
	        replace: true,
	        scope: {
	            id: '@',
	            name: '@',
	            model: '=',
	            required: '=',
	            attribute: '='
	        },
	        template: __webpack_require__(714),
	        link: function link($scope) {
	
	            $scope.noResults = false;
	            $scope.searching = false;
	
	            $scope.$watch(function () {
	                return $scope.model;
	            }, function (newValue, oldValue) {
	                if (!$scope.selectedPost || $scope.selectedPost.id !== newValue) {
	                    $scope.selectedPost = PostEndpoint.get({ id: $scope.model });
	                }
	            });
	
	            $scope.search = function (event) {
	                event.preventDefault();
	                var query = { q: $scope.searchTerm };
	
	                if ($scope.attribute.config.input && $scope.attribute.config.input.form) {
	                    query.form = $scope.attribute.config.input.form.join(',');
	                }
	
	                $scope.noResults = false;
	                $scope.searching = true;
	
	                PostEndpoint.query(query).$promise.then(function (response) {
	                    $scope.searching = false;
	                    $scope.results = response.results;
	                    if (!response.results.length) {
	                        $scope.noResults = true;
	                    }
	                });
	            };
	
	            $scope.selectPost = function (post) {
	                $scope.model = post.id;
	                $scope.selectedPost = post;
	                $scope.results = null;
	            };
	
	            $scope.clearPost = function () {
	                $scope.model = null;
	                $scope.selectedPost = null;
	            };
	        }
	    };
	}];

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<form class=input-relation> <p ng-if=model>{{ selectedPost.title }} ({{ model }}) <button class=\"button-secondary icon-only alt trash\" type=button ng-click=clearPost() translate></button></p> <div class=input-inline> <input class=form-control type=text placeholder=Search.. ng-model=searchTerm> <button type=button ng-click=search($event)> <div class=loading ng-if=searching> <div class=line></div> <div class=line></div> <div class=line></div> </div> <span class=button-label translate=nav.search ng-if=!searching>Search</span> <span class=button-label translate=app.searching ng-if=searching>Searching</span> </button> </div> <div class=\"alert error\" ng-if=noResults> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#warning></use> </svg> <span translate=post.no_search_results>Your search didn't match any posts</span> </div> <ul> <li ng-repeat=\"post in results\"> <button type=button class=\"button-secondary icon-only check\" ng-click=selectPost(post) translate></button> {{ post.id }} : {{ post.title }} </li> </ul> </form> ";

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = PostEditor;
	
	PostEditor.$inject = [];
	
	function PostEditor() {
	    return {
	        restrict: 'E',
	        scope: {
	            post: '=',
	            attributesToIgnore: '=',
	            form: '=',
	            postMode: '='
	        },
	        template: __webpack_require__(716),
	        controller: PostEditorController
	    };
	}
	
	PostEditorController.$inject = ['$scope', '$q', '$filter', '$location', '$translate', '$timeout', 'moment', 'PostEntity', 'PostEndpoint', 'PostEditService', 'FormEndpoint', 'FormStageEndpoint', 'FormAttributeEndpoint', 'UserEndpoint', 'TagEndpoint', 'Notify', '_', 'PostActionsService', 'MediaEditService'];
	
	function PostEditorController($scope, $q, $filter, $location, $translate, $timeout, moment, postEntity, PostEndpoint, PostEditService, FormEndpoint, FormStageEndpoint, FormAttributeEndpoint, UserEndpoint, TagEndpoint, Notify, _, PostActionsService, MediaEditService) {
	
	    // Setup initial stages container
	    $scope.everyone = $filter('translate')('post.modify.everyone');
	    $scope.isEdit = !!$scope.post.id;
	    $scope.validationErrors = [];
	    $scope.visibleStage = 1;
	    $scope.enableTitle = true;
	
	    $scope.setVisibleStage = setVisibleStage;
	    $scope.fetchAttributesAndTasks = fetchAttributesAndTasks;
	
	    $scope.allowedChangeStatus = allowedChangeStatus;
	    $scope.getTag = getTag;
	    $scope.deletePost = deletePost;
	    $scope.canSavePost = canSavePost;
	    $scope.savePost = savePost;
	    $scope.cancel = cancel;
	    $scope.postTitleLabel = 'Title';
	    $scope.postDescriptionLabel = 'Description';
	    $scope.tagKeys = [];
	    $scope.save = $translate.instant('app.save');
	    $scope.saving = $translate.instant('app.saving');
	    $scope.submit = $translate.instant('app.submit');
	    $scope.submitting = $translate.instant('app.submitting');
	    activate();
	
	    function activate() {
	        $scope.post.form = $scope.form;
	        $scope.fetchAttributesAndTasks($scope.post.form.id).then(function () {
	            // Use $timeout to delay this check till after form fields are rendered.
	            $timeout(function () {
	                // If the post in marked as 'Published' but it is not in
	                // a valid state to be saved as 'Published' warn the user
	                if ($scope.post.status === 'published' && !canSavePost()) {
	                    Notify.error('post.valid.invalid_state');
	                }
	            });
	        });
	
	        $scope.medias = {};
	        $scope.savingText = $translate.instant('app.saving');
	        $scope.submittingText = $translate.instant('app.submitting');
	    }
	
	    function setVisibleStage(stageId) {
	        $scope.visibleStage = stageId;
	    }
	
	    function fetchAttributesAndTasks(formId) {
	        return $q.all([FormStageEndpoint.queryFresh({ formId: formId }).$promise, FormAttributeEndpoint.queryFresh({ formId: formId }).$promise, TagEndpoint.queryFresh().$promise]).then(function (results) {
	            var post = $scope.post;
	            var tasks = _.sortBy(results[0], 'priority');
	            var attrs = _.chain(results[1]).sortBy('priority').value();
	            var categories = results[2];
	            // If attributesToIgnore is set, remove those attributes from set of fields to display
	            var attributes = [];
	            _.each(attrs, function (attr) {
	                if (attr.type === 'title' || attr.type === 'description') {
	                    if (attr.type === 'title') {
	                        $scope.postTitleLabel = attr.label;
	                        $scope.postTitleInstructions = attr.instructions;
	                    }
	                    if (attr.type === 'description') {
	                        $scope.postDescriptionLabel = attr.label;
	                        $scope.postDescriptionInstructions = attr.instructions;
	                    }
	                } else {
	                    attributes.push(attr);
	                }
	            });
	
	            // Initialize values on post (helps avoid madness in the template)
	            attributes.map(function (attr) {
	                // Create associated media entity
	                if (attr.input === 'upload') {
	                    var media = {};
	                    if ($scope.post.values[attr.key]) {
	                        media = $scope.post.values[attr.key][0];
	                    }
	                    $scope.medias[attr.key] = {};
	                }
	                if (attr.input === 'tags') {
	                    // adding category-objects attribute-options
	                    attr.options = _.chain(attr.options).map(function (category) {
	                        return _.findWhere(categories, { id: category });
	                    }).filter().value();
	
	                    // adding category-objects to children
	                    _.each(attr.options, function (category) {
	                        if (category.children.length > 0) {
	                            category.children = _.chain(category.children).map(function (child) {
	                                return _.findWhere(attr.options, { id: child.id });
	                            }).filter().value();
	                        }
	                    });
	                }
	                // @todo don't assign default when editing? or do something more sane
	                if (!$scope.post.values[attr.key]) {
	                    if (attr.input === 'location') {
	                        // Prepopulate location fields from message location
	                        if ($scope.post.values.message_location) {
	                            $scope.post.values[attr.key] = angular.copy($scope.post.values.message_location);
	                        } else {
	                            $scope.post.values[attr.key] = [null];
	                        }
	                    } else if (attr.input === 'number') {
	                        $scope.post.values[attr.key] = [parseInt(attr.default)];
	                    } else if (attr.input === 'date' || attr.input === 'datetime') {
	                        $scope.post.values[attr.key] = attr.default ? [new Date(attr.default)] : [new Date()];
	                    } else {
	                        $scope.post.values[attr.key] = [attr.default];
	                    }
	                } else if (attr.input === 'date' || attr.input === 'datetime') {
	                    // Date picker requires date object
	                    // ensure that dates are preserved in UTC
	                    if ($scope.post.values[attr.key][0]) {
	                        $scope.post.values[attr.key][0] = moment($scope.post.values[attr.key][0]).toDate();
	                    }
	                } else if (attr.input === 'number') {
	                    // Number input requires a number
	                    if ($scope.post.values[attr.key][0]) {
	                        $scope.post.values[attr.key][0] = parseFloat($scope.post.values[attr.key][0]);
	                    }
	                } else if (attr.input === 'tags') {
	                    // tag.id needs to be a number
	                    if ($scope.post.values[attr.key]) {
	                        $scope.post.values[attr.key] = $scope.post.values[attr.key].map(function (id) {
	                            return parseInt(id);
	                        });
	                    }
	                }
	            });
	
	            _.each(tasks, function (task) {
	                task.attributes = _.filter(attributes, function (attribute) {
	                    return attribute.form_stage_id === task.id;
	                });
	            });
	
	            // If number of completed stages matches number of tasks - not including Post,
	            // assume they're all complete, and just show the first task
	            if (post.completed_stages.length === tasks.length - 1 && tasks.length > 1) {
	                $scope.setVisibleStage(tasks[1].id);
	            } else {
	                // Get incomplete stages
	                var incompleteStages = _.filter(tasks, function (task) {
	                    return !_.contains(post.completed_stages, task.id);
	                });
	
	                // Return lowest priority incomplete task - not including post
	                incompleteStages.length > 1 ? $scope.setVisibleStage(incompleteStages[1].id) : '';
	            }
	            $scope.tasks = tasks;
	        });
	    }
	    function getTag(tagId) {
	        var tag;
	        _.each($scope.categories, function (category) {
	            if (category.id === tagId) {
	                tag = category;
	            }
	        });
	        return tag;
	    }
	    function canSavePost() {
	        return PostEditService.validatePost($scope.post, $scope.postForm, $scope.tasks);
	    }
	
	    function cancel() {
	
	        var path = $scope.post.id ? '/posts/' + $scope.post.id : '/';
	        $location.path(path);
	    }
	
	    function deletePost(post) {
	        PostActionsService.delete(post).then(function () {
	            $location.path('/');
	        });
	    }
	
	    function allowedChangeStatus() {
	        return $scope.post.allowed_privileges && $scope.post.allowed_privileges.indexOf('change_status') !== -1;
	    }
	
	    function resolveMedia() {
	        return MediaEditService.saveMedia($scope.medias, $scope.post);
	    }
	
	    function savePost() {
	        $scope.saving_post = true;
	        if (!$scope.canSavePost()) {
	            Notify.error('post.valid.validation_fail');
	            $scope.saving_post = false;
	            return;
	        }
	        // Create/update any associated media objects
	        // Media creation must be completed before we can progress with saving
	        resolveMedia().then(function () {
	
	            // Avoid messing with original object
	            // Clean up post values object
	            if ('message_location' in $scope.post.values) {
	                $scope.post.values.message_location = [];
	            }
	            var post = PostEditService.cleanPostValues(angular.copy($scope.post));
	            // adding neccessary tags to post.tags, needed for filtering
	            if ($scope.tagKeys.length > 0) {
	                post.tags = _.chain(post.values).pick($scope.tagKeys) // Grab just the 'tag' fields        { key1: [0,1], key2: [1,2], key3: undefined }
	                .values() // then take their values            [ [0,1], [1,2], undefined ]
	                .flatten() // flatten them into a single array  [0,1,1,2,undefined]
	                .filter() // Remove nulls                      [0,1,1,2]
	                .uniq() // Remove duplicates                 [0,1,2]
	                .value(); // and output
	            }
	            var request;
	            if (post.id) {
	                request = PostEndpoint.update(post);
	            } else {
	                request = PostEndpoint.save(post);
	            }
	            request.$promise.then(function (response) {
	                var success_message = response.status && response.status === 'published' ? 'notify.post.save_success' : 'notify.post.save_success_review';
	
	                if (response.id && response.allowed_privileges.indexOf('read') !== -1) {
	                    $scope.saving_post = false;
	                    $scope.post.id = response.id;
	                    Notify.notify(success_message, { name: $scope.post.title });
	                    $location.path('/posts/' + response.id);
	                } else {
	                    Notify.notify(success_message, { name: $scope.post.title });
	                    $location.path('/');
	                }
	            }, function (errorResponse) {
	                // errors
	                var validationErrors = [];
	                // @todo refactor limit handling
	                _.each(errorResponse.data.errors, function (value, key) {
	                    // Ultimately this should check individual status codes
	                    // for the moment just check for the message we expect
	                    if (value.title === 'limit::posts') {
	                        Notify.limit('limit.post_limit_reached');
	                    } else {
	                        validationErrors.push(value);
	                    }
	                });
	                Notify.errors(_.pluck(validationErrors, 'message'));
	                $scope.saving_post = false;
	            });
	        });
	    }
	}

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<form name=postForm ng-submit=savePost() novalidate> <div class=\"mode-context init\" dropdown> <layout-class layout=a></layout-class> <header class=mode-context-header> <ol class=breadcrumbs> <li><a href=/ ng-controller=\"navigation as nav\">{{nav.site.name}}</a></li> </ol> <h1 class=mode-context-title>{{post.form.name}}</h1> </header> <span class=mode-context-trigger dropdown-toggle> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> <span class=\"label hidden\" translate=app.show_more_less>Show more/less</span> </span> <div class=mode-context-body> <p>{{post.form.description}}</p> </div> </div> <main role=main> <div class=toolbar> <div class=button-group ng-show=post.id> <button type=button class=button-flat ng-click=cancel() translate=app.cancel>Cancel</button> <button type=submit class=button-alpha ng-if=!saving_post>{{save}}</button> <button type=submit class=button-alpha disabled=disabled ng-if=saving_post>{{saving}} <div class=loading> <div class=line></div> <div class=line></div> <div class=line></div> </div> </button> </div> <div class=button-group ng-show=!post.id> <post-share button=true ng-show=!post.id></post-share> <button type=submit class=button-alpha ng-if=!saving_post>{{submit}}</button> <button type=submit class=button-alpha disabled=disabled ng-if=saving_post>{{submitting}} <div class=loading> <div class=line></div> <div class=line></div> <div class=line></div> </div> </button> </div> </div> <div class=main-col> <div class=form-sheet> <div class=post-band ng-style=\"{backgroundColor: form.color}\"></div> <div class=\"form-field init required\" adaptive-form ng-class=\"{\n                'error': postForm.title.$invalid && postForm.title.$dirty,\n                'success': !postForm.title.$invalid && postForm.title.$dirty\n              }\"> <label> {{postTitleLabel}} </label> <p> {{postTitleInstructions}} </p> <input id=title name=title type=text ng-model=post.title ng-required=true ng-minlength=2 ng-maxlength=150 adaptive-input> <div class=\"alert error\" ng-show=postForm.title.$dirty ng-repeat=\"(error, value) in postForm.title.$error\"> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#warning></use> </svg> <span translate=\"{{'post.valid.title.' + error}}\"></span> </div> </div> <div class=\"form-field init required\" ng-class=\"{\n                    'error': postForm.content.$invalid && postForm.content.$dirty,\n                    'success': !postForm.content.$invalid && postForm.content.$dirty\n                  }\" adaptive-form> <label> {{postDescriptionLabel}} </label> <p> {{postDescriptionInstructions}} </p> <textarea id=content name=content data-min-rows=1 rows=1 ng-model=post.content ng-required=true adaptive-input msd-elastic>\n                    </textarea> <div class=\"alert error\" ng-show=postForm.content.$dirty ng-repeat=\"(error, value) in postForm.content.$error\"> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#warning></use> </svg> <span translate=\"{{'post.valid.content.' + error}}\"></span> </div> </div> <post-value-edit ng-repeat=\"attribute in tasks[0].attributes | orderBy: 'priority' as filtered_result track by attribute.id\" post=post post-field=true form=postForm medias=medias attribute=attribute></post-value-edit> <post-toolbox post=post></post-toolbox> </div> <post-tabs ng-show=\"tasks.length > 1\" form=postForm post=post stages=tasks attributes=attributes visible-stage=visibleStage> </post-tabs> <div class=form-sheet ng-if=post.id> <div class=form-sheet-summary> <h3 class=form-sheet-title translate=post.delete_post>Delete this post</h3> </div> <div class=form-field> <p translate=post.delete_post_desc><strong>If you delete this post</strong>, all of its comments and messages will also be deleted. Proceed with caution.</p> <button class=button-destructive ng-click=deletePost(post)> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#trash></use> </svg> <span class=button-label translate=post.delete_post>Delete post</span> </button> </div> </div> <ush-logo></ush-logo> </div> </main> </form> ";

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = PostValueEdit;
	
	PostValueEdit.$inject = [];
	
	function PostValueEdit() {
	    return {
	        restrict: 'E',
	        scope: {
	            form: '=',
	            post: '=',
	            attribute: '=',
	            postField: '=',
	            medias: '=',
	            categories: '='
	        },
	        controller: PostValueEditController,
	        template: __webpack_require__(718)
	    };
	}
	
	PostValueEditController.$inject = ['$scope', '_'];
	
	function PostValueEditController($scope, _) {
	    var fieldSetAttributes = ['checkbox', 'radio', 'tags'];
	    $scope.isDate = isDate;
	    $scope.isDateTime = isDateTime;
	    $scope.isText = isText;
	    $scope.isTextarea = isTextarea;
	    $scope.isCheckbox = isCheckbox;
	
	    $scope.dateFormat = { format: 'yyyy-mm-dd' };
	
	    $scope.canAddValue = canAddValue;
	    $scope.canRemoveValue = canRemoveValue;
	    $scope.addValue = addValue;
	    $scope.removeValue = removeValue;
	
	    $scope.selectParent = selectParent;
	    $scope.selectChild = selectChild;
	    $scope.taskIsMarkedCompleted = taskIsMarkedCompleted;
	
	    $scope.isFieldSetStructure = isFieldSetStructure;
	    activate();
	
	    function activate() {}
	
	    function taskIsMarkedCompleted() {
	        // If we are dealing with a Post Field we want to always show errors for required post fields
	        // Otherwise we only want to show errors for required fields of Tasks marked as completed
	        return !_.isUndefined($scope.postField) ? true : _.contains($scope.post.completed_stages, $scope.attribute.form_stage_id);
	    }
	
	    function isFieldSetStructure(attr) {
	        if (_.contains(fieldSetAttributes, attr.input)) {
	            return true;
	        }
	        return false;
	    }
	    function isDate(attr) {
	        return attr.input === 'date';
	    }
	    function isDateTime(attr) {
	        return attr.input === 'datetime';
	    }
	    function isText(attr) {
	        return attr.input === 'text';
	    }
	    function isTextarea(attr) {
	        return attr.input === 'textarea';
	    }
	    function isCheckbox(attr) {
	        return attr.input === 'checkbox';
	    }
	
	    // Can more values be added for this attribute?
	    function canAddValue(attr) {
	        return (
	            // Attribute allows unlimited values
	            attr.cardinality === 0 ||
	            // Less values than cardinality allows
	            $scope.post.values[attr.key].length < attr.cardinality
	        );
	    }
	    // Can this values be removed?
	    function canRemoveValue(attr, key) {
	        return $scope.post.values[attr.key].length > 1;
	    }
	    // Add a new value
	    function addValue(attr) {
	        $scope.post.values[attr.key].push(null);
	    }
	    // Remove a value
	    function removeValue(attr, key) {
	        $scope.post.values[attr.key].splice(key, 1);
	    }
	
	    function selectParent(parent, attrKey) {
	        if (_.contains($scope.post.values[attrKey], parent.id)) {
	            _.each(parent.children, function (child) {
	                $scope.post.values[attrKey].push(child.id);
	            });
	        } else {
	            _.each(parent.children, function (child) {
	                $scope.post.values[attrKey] = _.filter($scope.post.values[attrKey], function (id) {
	                    return id !== child.id;
	                });
	            });
	        }
	    }
	
	    function selectChild(child, attrKey) {
	        if (!_.contains($scope.post.values[attrKey], child.parent.id) && _.contains($scope.post.values[attrKey], child.id)) {
	            $scope.post.values[attrKey].push(child.parent.id);
	        }
	    }
	}

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div> <div ng-if=!isFieldSetStructure(attribute) class=\"form-field init\" adaptive-form ng-class=\"{\n        'error': form['values_' + attribute.key].$invalid && form['values_' + attribute.key].$dirty,\n        'success': ! form['values_' + attribute.key].$invalid && form['values_' + attribute.key].$dirty,\n        'required': attribute.required,\n        'date' : isDate(attribute) || isDateTime(attribute),\n        'location' : attribute.input === 'location'\n      }\"> <label for=values[{{attribute.key}}][0]> <svg ng-show=attribute.response_private class=iconic> <use xlink:href=" + __webpack_require__(412) + "#lock-locked></use> </svg> {{attribute.label}} </label> <p>{{attribute.instructions}}</p> <div ng-repeat=\"(key, value) in post.values[attribute.key] track by key\"> <div ng-switch=attribute.input> <div ng-switch-when=date> <div class=input-with-icon> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#calendar></use> </svg> <input type=date pick-a-date=date pick-a-date-options=dateFormat name=values_{{attribute.id}} ng-model=post.values[attribute.key][key] ng-required=attribute.required /> </div> </div> <div ng-switch-when=datetime class=input-with-icon> <post-datetime id=values[{{attribute.key}}][{{key}}] name=values_{{attribute.id}} ng-model=post.values[attribute.key][key] ng-required=attribute.required></post-datetime> </div> <select ng-switch-when=select id=values[{{attribute.key}}][{{key}}] name=values_{{attribute.id}} ng-model=post.values[attribute.key][key] ng-required=attribute.required> <option ng-repeat=\"opt in attribute.options\" value={{opt}}>{{opt}}</option> </select> <input ng-switch-when=number id=values[{{attribute.key}}][{{key}}] name=values_{{attribute.id}} type=number ng-model=post.values[attribute.key][key] ng-required=attribute.required> <input ng-switch-when=text id=values[{{attribute.key}}][{{key}}] name=values_{{attribute.id}} type=text ng-model=post.values[attribute.key][key] ng-required=attribute.required adaptive-input> <textarea ng-switch-when=textarea data-min-rows=1 rows=1 class=adapt-field style=overflow-x:hidden;word-wrap:break-word;height:55px id=values[{{attribute.key}}][{{key}}] name=values_{{attribute.id}} ng-model=post.values[attribute.key][key] ng-required=attribute.required adaptive-input msd-elastic>\n              </textarea> <textarea ng-switch-when=markdown data-min-rows=1 rows=1 class=adapt-field style=overflow-x:hidden;word-wrap:break-word;height:55px id=values[{{attribute.key}}][{{key}}] name=values_{{attribute.id}} ng-model=post.values[attribute.key][key] ng-required=attribute.required adaptive-input msd-elastic>\n              </textarea> <post-relation attribute=attribute key=key id=values[{{attribute.key}}][{{key}}] name=values_{{attribute.id}} model=post.values[attribute.key][key] ng-required=attribute.required ng-switch-when=relation></post-relation> <post-location attribute=attribute key=key id=values[{{attribute.key}}][{{key}}] name=values_{{attribute.id}} model=post.values[attribute.key][key] ng-model=post.values[attribute.key][key] ng-required=attribute.required ng-switch-when=location></post-location> <post-media ng-switch-when=upload name=values_{{attribute.id}} media-id=post.values[attribute.key][key] media=medias[attribute.key] ng-model=post.values[attribute.key][key] ng-required=attribute.required></post-media> <post-video-input ng-switch-when=video name=values_{{attribute.id}} video-url=post.values[attribute.key][key] ng-model=post.values[attribute.key][key] ng-required=attribute.required></post-video-input> </div> </div> <div class=\"alert error\" ng-show=\"form['values_' + attribute.id].$dirty && taskIsMarkedCompleted()\" ng-repeat=\"(error, value) in form['values_' + attribute.id].$error\"> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#warning></use> </svg> <span translate=\"{{'post.valid.values.' + error}}\" translate-values=\"{ label : attribute.label }\"></span> </div> </div> <fieldset ng-if=isFieldSetStructure(attribute)> <label>{{attribute.label}}</label> <p>{{attribute.instructions}}</p> <div ng-switch=attribute.input> <div ng-switch-when=radio> <div ng-repeat=\"(key, value) in post.values[attribute.key] track by key\"> <div class=\"form-field radio\" ng-repeat=\"option in attribute.options\"> <label> <input name=values_{{attribute.id}} type=radio ng-model=post.values[attribute.key][key] ng-required=attribute.required value={{option}}> {{option}} </label> </div> </div> </div> <div ng-switch-when=checkbox> <div class=\"form-field checkbox\" ng-repeat=\"option in attribute.options\"> <label> <input type=checkbox checklist-model=post.values[attribute.key] ng-required=attribute.required name=values_{{attribute.id}}_{{option}} checklist-value=option value=option> {{option}} </label> </div> </div> <div ng-switch-when=tags> <div class=\"form-field checkbox\" ng-repeat=\"option in attribute.options\" ng-if=\"option.parent_id === null\"> <label> <input type=checkbox checklist-model=post.values[attribute.key] name=values_{{attribute.id}}_{{option.id}} checklist-value=option.id value=option.id ng-click=\"selectParent(option, attribute.key)\"> {{option.tag}} </label> <div class=\"form-field checkbox\" ng-if=option.children ng-repeat=\"child in option.children\"> <label> <input type=checkbox checklist-model=post.values[attribute.key] name=values_{{attribute.id}}_{{child.id}} checklist-value=child.id value=child.id ng-click=\"selectChild(child, attribute.key)\"> {{child.tag}} </label> </div> </div> <add-category form-id=post.form.id attribute=attribute post-value=post.values[attribute.key]></add-category> </div> <div class=\"alert error\" ng-show=\"form['values_' + attribute.id].$dirty && taskIsMarkedCompleted()\" ng-repeat=\"(error, value) in form['values_' + attribute.id].$error\"> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#warning></use> </svg> <span translate=\"{{'post.valid.values.' + error}}\" translate-values=\"{ label : attribute.label }\"></span> </div> </div></fieldset> </div> ";

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = PostVerticalTabs;
	
	PostVerticalTabs.$inject = [];
	function PostVerticalTabs() {
	    return {
	        restrict: 'E',
	        scope: {
	            form: '=',
	            post: '=',
	            stages: '=',
	            attributes: '=',
	            visibleStage: '='
	        },
	        template: __webpack_require__(720),
	        controller: PostVerticalTabsController
	    };
	}
	
	PostVerticalTabsController.$inject = ['$scope', 'FormEndpoint', 'FormStageEndpoint', 'FormAttributeEndpoint', 'PostEditService', '_'];
	function PostVerticalTabsController($scope, FormEndpoint, FormStageEndpoint, FormAttributeEndpoint, PostEditService, _) {
	    $scope.setVisibleStage = setVisibleStage;
	    $scope.stageIsComplete = stageIsComplete;
	    $scope.toggleStageCompletion = toggleStageCompletion;
	
	    activate();
	
	    function activate() {
	        $scope.setVisibleStage($scope.visibleStage);
	    }
	
	    function setVisibleStage(stageId) {
	        $scope.visibleStage = stageId;
	    }
	
	    function stageIsComplete(stageId) {
	        return $scope.post.completed_stages.indexOf(stageId) > -1;
	    }
	
	    function toggleStageCompletion(stageId) {
	        stageId = parseInt(stageId);
	        if (_.includes($scope.post.completed_stages, stageId)) {
	            $scope.post.completed_stages = _.without($scope.post.completed_stages, stageId);
	        } else {
	            $scope.post.completed_stages.push(stageId);
	        }
	    }
	}

/***/ }),
/* 720 */
/***/ (function(module, exports) {

	module.exports = "<div class=form-sheet ng-repeat=\"stage in stages | limitTo: 1 - stages.length\"> <header class=form-sheet-summary> <h1 class=\"form-sheet-title section-title\">{{stage.label}}</h1> </header> <div ng-show=stage.show_when_published class=alert> <p translate=survey.task_visible_when_published>This task will be visible when post is published</p> </div> <div class=\"form-field switch\"> <label translate=post.task_completed>Task completed</label> <div class=toggle-switch> <input class=tgl ng-attr-id=\"{{ 'toggle-complete-' + stage.id }}\" type=checkbox ng-checked=stageIsComplete(stage.id) ng-click=toggleStageCompletion(stage.id)> <label class=tgl-btn for=toggle-complete-{{stage.id}} ng-attr-id=\"{{ 'toggle-complete-label-' + stage.id }}\"></label> </div> </div> <post-value-edit ng-repeat=\"attribute in stage.attributes | orderBy: 'priority' as filtered_result track by attribute.id\" post=post form=form attribute=attribute></post-value-edit> </div> ";

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = PostToolboxDirective;
	
	PostToolboxDirective.$inject = ['PostActionsService', 'PostMetadataService', 'moment', '$rootScope'];
	function PostToolboxDirective(PostActionsService, PostMetadataService, moment, $rootScope) {
	    return {
	        restrict: 'E',
	        scope: {
	            post: '='
	        },
	        template: __webpack_require__(722),
	        link: PostToolboxLink
	    };
	
	    function PostToolboxLink($scope) {
	        $scope.changeStatus = changeStatus;
	        $scope.allowedChangeStatus = allowedChangeStatus;
	        $scope.allowedChangeOwner = allowedChangeOwner;
	        $scope.editAuthor = editAuthor;
	        $scope.showUserRealname = showUserRealname;
	        $scope.showAuthorRealname = showAuthorRealname;
	        $scope.loadAuthorFormDefaults = loadAuthorFormDefaults;
	
	        activate();
	
	        function activate() {
	            $scope.source = PostMetadataService.formatSource($scope.post.source);
	            $scope.post.user = PostMetadataService.loadUser($scope.post);
	            $scope.statuses = PostActionsService.getStatuses();
	            formatDates();
	        }
	
	        function changeStatus(status) {
	            $scope.post.status = status;
	        }
	
	        // TODO: this function should be moved to a general service handling permissions
	        function allowedChangeStatus() {
	            return $scope.post.allowed_privileges && $scope.post.allowed_privileges.indexOf('change_status') !== -1;
	        }
	
	        // FIXME: Enable after allowing change of author in API
	        function allowedChangeOwner() {
	            return false;
	        }
	
	        function editAuthor() {
	            $scope.showEditAuthorButton = false;
	            $scope.showEditAuthorForm = true;
	        }
	
	        function showUserRealname() {
	            return !$scope.showEditAuthorForm && !$scope.post.author_realname && $scope.post.user;
	        }
	
	        function showAuthorRealname() {
	            return !$scope.showEditAuthorForm && $scope.post.author_realname;
	        }
	
	        function loadAuthorFormDefaults() {
	            if ($scope.post.author_realname || $scope.post.user) {
	                $scope.showEditAuthorButton = true;
	                $scope.showEditAuthorForm = false;
	            } else {
	                $scope.showEditAuthorButton = false;
	                $scope.showEditAuthorForm = true;
	            }
	        }
	
	        function formatDates() {
	            $scope.displayCreated = moment($scope.post.created).format('LLL');
	
	            if ($scope.post.updated) {
	                $scope.displayUpdated = moment($scope.post.updated).format('LLL');
	            }
	        }
	    }
	}

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=toolbox ng-if=post.id> <div class=tool ng-if=allowedChangeStatus() dropdown> <fieldset class=\"custom-fieldset init\"> <legend class=\"dropdown-trigger init\" data-toggle=dropdown-menu dropdown-toggle> <span class=legend-label> <span class=custom-fieldset-value> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#globe ng-if=\"post.status=='published'\"></use> <use xlink:href=" + __webpack_require__(412) + "#lock-locked ng-if=\"post.status=='draft'\"></use> <use xlink:href=" + __webpack_require__(412) + "#box ng-if=\"post.status=='archived'\"></use> </svg> <span translate=post.published ng-if=\"post.status == 'published'\">Published</span> <span translate=post.draft ng-if=\"post.status == 'draft'\">Under review</span> <span translate=post.archived ng-if=\"post.status == 'archived'\">Archived</span> </span> </span> <svg class=\"iconic chevron\"> <use xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> </legend> <div class=\"dropdown-menu init\" dropdown-menu> <div class=\"form-field radio icon-input\" ng-repeat=\"status in statuses\" ng-class=\"{'checked' : status == post.status}\" ng-click=changeStatus(status)> <label for={{status}}> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#globe ng-if=\"status=='published'\"></use> <use xlink:href=" + __webpack_require__(412) + "#lock-locked ng-if=\"status=='draft'\"></use> <use xlink:href=" + __webpack_require__(412) + "#box ng-if=\"status=='archived'\"></use> </svg> <input type=radio name=status id={{status}} /> <span translate=post.published ng-if=\"status == 'published'\">Published</span> <span translate=post.draft ng-if=\"status == 'draft'\">Under review</span> <span translate=post.archived ng-if=\"status == 'archived'\">Archived</span> </label> </div> </div> </fieldset> </div> <div class=tool dropdown auto-close=disabled ng-if=allowedChangeOwner()> <h6 class=tool-heading translate=post.author>Author</h6> <span class=\"tool-trigger init\" data-toggle=dropdown-menu dropdown-toggle ng-click=loadAuthorFormDefaults()> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> <span class=\"label hidden\">Show/hide</span> </span> <div class=\"toggle-content init\" dropdown-menu> <div class=listing-item> <div class=listing-item-primary ng-if=showUserRealname()> <div class=listing-item-image> <img src=\"http://www.gravatar.com/avatar/{{ post.user.gravatar || '00000000000000000000000000000000' }}?d=retro&s=40\" class=avatar> </div> <h2 class=listing-item-title>{{ post.user.realname }}</h2> <p class=listing-item-secondary></p> </div> <div class=listing-item-primary ng-if=showAuthorRealname()> <h2 class=listing-item-title>{{ post.author_realname }}</h2> <p class=listing-item-secondary></p> </div> <div class=listing-item-primary ng-if=showEditAuthorForm> <div class=\"form-field init\"> <input type=text class=adapt-field ng-model=post.author_realname focus=showEditAuthorForm> </div> </div> </div> <button type=button class=\"button-gamma button-flat\" data-modal=edit-author ng-click=editAuthor() ng-if=showEditAuthorButton translate=post.change_author>Change author</button> </div> </div> <div class=tool dropdown auto-close=disabled> <h6 class=tool-heading translate=post.post_date>Post date</h6> <span class=\"tool-trigger init\" data-toggle=dropdown-menu dropdown-toggle> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> <span class=\"label hidden\">Show/hide</span> </span> <div class=\"toggle-content init\" dropdown-menu> <fieldset> <post-datetime ng-model=post.post_date></post-datetime> <ul class=metadata> <li><span translate=post.created_at></span> {{displayCreated}} <span translate-values=\"{ source : source }\" translate=post.source></span></li> <li ng-if=post.updated><span translate=post.updated_at></span> {{displayUpdated}}</li> </ul> </fieldset> </div> </div> </div> ";

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = PostTimelineToolboxDirective;
	
	PostTimelineToolboxDirective.$inject = ['moment', '$rootScope'];
	function PostTimelineToolboxDirective(moment, $rootScope) {
	    return {
	        restrict: 'E',
	        scope: {
	            orderBy: '<',
	            order: '<',
	            onChange: '&'
	        },
	        template: __webpack_require__(724),
	        link: PostTimelineToolboxLink
	    };
	
	    function PostTimelineToolboxLink($scope) {
	        $scope.change = change;
	
	        activate();
	
	        function activate() {}
	
	        function change() {
	            $scope.onChange({ order: $scope.order, orderBy: $scope.orderBy });
	        }
	    }
	}

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"toolbox hide-until-small\"> <div class=tool dropdown auto-close=disabled> <h6 class=tool-heading translate=app.sort_by>Sort By</h6> <span class=\"tool-trigger init\" data-toggle=dropdown-menu dropdown-toggle> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> <span class=\"label hidden\">Show/hide</span> </span> <div class=\"toggle-content init\" dropdown-menu> <fieldset> <div class=custom-select> <select ng-model=orderBy ng-change=change()> <option value=post_date translate=post.post_date>Post Date</option> <option value=created translate=app.date_created>Date created</option> <option value=updated translate=app.date_updated>Date updated</option> </select> </div> </fieldset> <fieldset> <div class=\"form-field radio\"> <label> <input type=radio id=asc value=asc name=order ng-model=order ng-change=change()> <span translate=app.oldest_first>Oldest first</span> </label> </div> <div class=\"form-field radio\"> <label> <input type=radio id=desc value=desc name=order ng-model=order ng-change=change()> <span translate=app.newest_first>Newest first</span> </label> </div> </fieldset> </div> </div> </div> ";

/***/ }),
/* 725 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['_', 'Util', '$translate', '$rootScope', 'SliderService', function (_, Util, $translate, $rootScope, SliderService) {
	    var scope;
	
	    var PostViewService = {
	        showNoPostsSlider: function showNoPostsSlider() {
	            var scope = getScope();
	            // TODO review translation sanitization
	            $translate(['post.there_are_no_posts', 'post.in_this_deployment']).then(function (noPostText) {
	                scope.noPostText = noPostText;
	                SliderService.openTemplate('<p><strong>{{noPostText["post.there_are_no_posts"]}}</strong>{{noPostText["post.in_this_deployment"]}}</p>' + '<add-post-text-button></add-post-text-button>' + '<button class="button-flat message-trigger" ng-click="close()">Dismiss</button>', 'file', false, scope, false, false, true);
	            });
	        }
	    };
	
	    function getScope() {
	        if (scope) {
	            scope.$destroy();
	        }
	        scope = $rootScope.$new();
	        return scope;
	    }
	
	    return Util.bindAllFunctionsToSelf(PostViewService);
	}];

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = [function () {
	    var controller = ['$scope', '_', function ($scope, _) {
	        // Initial scope
	        $scope.isLoading = {
	            state: false
	        };
	
	        // Set default view
	        if (!$scope.currentView) {
	            $scope.currentView = 'map';
	        }
	
	        // Change mode
	        $scope.$emit('event:mode:change', $scope.currentView);
	    }];
	
	    return {
	        restrict: 'E',
	        replace: true,
	        transclude: true,
	        scope: {
	            filters: '=',
	            currentView: '='
	        },
	        controller: controller,
	        template: __webpack_require__(727)
	    };
	}];

/***/ }),
/* 727 */
/***/ (function(module, exports) {

	module.exports = "<div> <post-toolbar is-loading=isLoading current-view=currentView filters=filters></post-toolbar> <ng-transclude></ng-transclude> <div ng-switch=currentView> <post-view-map ng-switch-when=map is-loading=isLoading filters=filters></post-view-map> <post-view-list ng-switch-when=list is-loading=isLoading filters=filters></post-view-list> <post-view-create ng-switch-when=create></post-view-create> <post-view-unavailable ng-switch-when=unavailable view=unavailableView></post-view-unavailable> <post-view-map ng-switch-default is-loading=isLoading filters=filters></post-view-map> </div> </div> ";

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = PostListDirective;
	
	PostListDirective.$inject = [];
	function PostListDirective() {
	    return {
	        restrict: 'E',
	        replace: true,
	        scope: {
	            filters: '=',
	            isLoading: '='
	        },
	        controller: PostListController,
	        template: __webpack_require__(729)
	    };
	}
	
	PostListController.$inject = ['$scope', '$q', '$translate', 'PostEndpoint', 'Notify', 'PostViewService', '_', 'ConfigEndpoint', 'moment', 'PostFilters', 'PostActionsService'];
	function PostListController($scope, $q, $translate, PostEndpoint, Notify, PostViewService, _, ConfigEndpoint, moment, PostFilters, PostActionsService) {
	    $scope.currentPage = 1;
	    $scope.selectedPosts = [];
	    $scope.itemsPerPageOptions = [10, 20, 50];
	    $scope.itemsPerPage = $scope.itemsPerPageOptions[1];
	    // until we have the correct total_count value from backend request:
	    $scope.totalItems = $scope.itemsPerPage;
	    $scope.posts = [];
	    $scope.groupedPosts = {};
	    $scope.order = 'desc';
	    $scope.orderBy = 'post_date';
	
	    $scope.deletePosts = deletePosts;
	    $scope.hasFilters = hasFilters;
	    $scope.userHasBulkActionPermissions = userHasBulkActionPermissions;
	    $scope.statuses = PostActionsService.getStatuses();
	    $scope.changeStatus = changeStatus;
	    $scope.loadMore = loadMore;
	    $scope.getPosts = getPosts;
	    $scope.resetPosts = resetPosts;
	    $scope.clearPosts = false;
	    $scope.clearSelectedPosts = clearSelectedPosts;
	    $scope.changeOrder = changeOrder;
	    activate();
	
	    // whenever the filters changes, update the current list of posts
	    $scope.$watch(function () {
	        return $scope.filters;
	    }, function (newValue, oldValue) {
	        if (newValue !== oldValue) {
	            $scope.clearPosts = true;
	            getPosts();
	        }
	    }, true);
	
	    function activate() {
	        // Initial load
	        getPosts();
	        $scope.$watch('selectedPosts.length', function () {
	            $scope.$emit('post:list:selected', $scope.selectedPosts);
	        });
	    }
	
	    function resetPosts() {
	        $scope.posts = [];
	        $scope.groupedPosts = {};
	        $scope.totalItems = $scope.itemsPerPage;
	        $scope.currentPage = 1;
	        $scope.selectedPosts = [];
	    }
	
	    function changeOrder(order, orderBy) {
	        $scope.order = order;
	        $scope.orderBy = orderBy;
	        $scope.clearPosts = true;
	        getPosts();
	    }
	
	    function getPosts(query) {
	        query = query || PostFilters.getQueryParams($scope.filters);
	        var postQuery = _.extend({}, query, {
	            offset: ($scope.currentPage - 1) * $scope.itemsPerPage,
	            limit: $scope.itemsPerPage,
	            order: $scope.order,
	            orderby: $scope.orderBy
	        });
	        $scope.isLoading.state = true;
	        PostEndpoint.query(postQuery).$promise.then(function (postsResponse) {
	            // Clear posts
	            $scope.clearPosts ? resetPosts() : null;
	            // Add posts to full set of posts
	            // @todo figure out if we can store these more efficiently
	            Array.prototype.push.apply($scope.posts, postsResponse.results);
	
	            // Merge grouped posts into existing groups
	            angular.forEach(groupPosts(postsResponse.results), function (posts, group) {
	                if (angular.isArray($scope.groupedPosts[group])) {
	                    Array.prototype.push.apply($scope.groupedPosts[group], posts);
	                } else {
	                    $scope.groupedPosts[group] = posts;
	                }
	            });
	
	            $scope.totalItems = postsResponse.total_count;
	            $scope.isLoading.state = false;
	
	            if ($scope.posts.count === 0 && !PostFilters.hasFilters($scope.filters)) {
	                PostViewService.showNoPostsSlider();
	            }
	        });
	    }
	
	    function groupPosts(posts) {
	        var now = moment(),
	            yesterday = moment().subtract(1, 'days');
	
	        return _.groupBy(posts, function (post) {
	            var postDate = moment(post.post_date);
	            if (now.isSame(postDate, 'd')) {
	                return $translate.instant('nav.today');
	            } else if (yesterday.isSame(postDate, 'd')) {
	                return $translate.instant('nav.yesterday');
	            } else {
	                return postDate.fromNow();
	            }
	        });
	    }
	
	    function deletePosts() {
	        Notify.confirmDelete('notify.post.bulk_destroy_confirm', { count: $scope.selectedPosts.length }).then(function () {
	            // ask server to delete selected posts
	            // and refetch posts from server
	            $scope.isLoading.state = true;
	            var deletePostsPromises = _.map($scope.selectedPosts, function (postId) {
	                $scope.selectedPosts = _.without($scope.selectedPosts, postId);
	                return PostEndpoint.delete({ id: postId }).$promise;
	            });
	            $q.all(deletePostsPromises).then(handleDeleteSuccess, handleDeleteErrors);
	
	            function handleDeleteErrors(errorResponse) {
	                $scope.isLoading.state = false;
	                Notify.apiErrors(errorResponse);
	            }
	            function handleDeleteSuccess(deleted) {
	                $scope.isLoading.state = false;
	                Notify.notify('notify.post.destroy_success_bulk');
	                // Remove deleted posts from state
	                var deletedIds = _.pluck(deleted, 'id');
	                angular.forEach($scope.groupedPosts, function (posts, group) {
	                    $scope.groupedPosts[group] = _.reject(posts, function (post) {
	                        return _.contains(deletedIds, post.id);
	                    });
	                });
	                $scope.posts = _.reject($scope.posts, function (post) {
	                    return _.contains(deletedIds, post.id);
	                });
	                clearSelectedPosts();
	
	                if (!$scope.posts.length) {
	                    $scope.clearPosts = true;
	                    getPosts();
	                }
	            }
	        });
	    }
	
	    function changeStatus(status) {
	        var selectedPosts = _.filter($scope.posts, function (post) {
	            return _.contains($scope.selectedPosts, post.id);
	        });
	
	        var count = $scope.selectedPosts.length;
	
	        var updateStatusPromises = _.map(selectedPosts, function (post) {
	            post.status = status;
	            // $scope.selectedPosts = _.without($scope.selectedPosts, post.id);
	            return PostEndpoint.update(post).$promise;
	        });
	
	        $q.all(updateStatusPromises).then(function () {
	            Notify.notify('notify.post.update_status_success_bulk', { count: count });
	            clearSelectedPosts();
	        }, function (errorResponse) {
	            Notify.apiErrors(errorResponse);
	        });
	    }
	
	    // @todo reconsider: show this for ALL logged in users??
	    function userHasBulkActionPermissions() {
	        return _.any($scope.posts, function (post) {
	            return _.intersection(post.allowed_privileges, ['update', 'delete', 'change_status']).length > 0;
	        });
	    }
	
	    function hasFilters() {
	        return PostFilters.hasFilters($scope.filters);
	    }
	
	    function loadMore() {
	        // Increment page
	        $scope.currentPage++;
	        $scope.clearPosts = false;
	        getPosts();
	    }
	
	    function clearSelectedPosts() {
	        // Clear selected posts
	        $scope.selectedPosts.splice(0);
	    }
	}

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=main-col> <div class=\"listing timeline\" ng-class=\"{ 'toolbar-active' : selectedPosts.length > 0 }\"> <h2 class=listing-heading-section ng-repeat-start=\"(timeAgo, posts) in groupedPosts\"> {{ timeAgo }} </h2> <post-card ng-repeat-end ng-repeat=\"post in posts\" can-select=userHasBulkActionPermissions() post=post selected-posts=selectedPosts> </post-card> <listing-toolbar entities=posts selected-set=selectedPosts> <span dropdown ng-if=userHasBulkActionPermissions()> <button class=\"button-beta init\" data-toggle=toggle-content dropdown-toggle> <span class=button-label translate=app.mark_as>Mark as</span> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> </button> <ul class=\"dropdown-menu toggle-content init\" dropdown-menu unpositioned=true> <li ng-repeat=\"status in statuses\"> <a ng-click=changeStatus(status)> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#globe ng-if=\"status=='published'\"></use> <use xlink:href=" + __webpack_require__(412) + "#lock-locked ng-if=\"status=='draft'\"></use> <use xlink:href=" + __webpack_require__(412) + "#box ng-if=\"status=='archived'\"></use> </svg> <span class=label translate=post.published ng-if=\"status == 'published'\">Published</span> <span class=label translate=post.draft ng-if=\"status == 'draft'\">Under review</span> <span class=label translate=post.archived ng-if=\"status == 'archived'\">Archive</span> </a> </li> </ul> </span> <collection-toggle-button selected-posts=selectedPosts posts=posts on-done=clearSelectedPosts()></collection-toggle-button> <button type=button class=button-destructive ng-click=deletePosts()> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#trash></use> </svg> <span class=\"button-label hidden\">nav.delete</span> </button> </listing-toolbar> <post-timeline-toolbox order=order order-by=orderBy on-change=\"changeOrder(order, orderBy)\"></post-timeline-toolbox> <div class=listing-item ng-if=\"posts.length == 0 && hasFilters() && !isLoading.state\"> <h4 translate>post.no_search_results </h4></div> <div class=listing-item ng-if=\"posts.length == 0 && !hasFilters() && !isLoading.state\"> <h4 translate>post.no_posts_yet </h4></div> <div class=listing-item ng-if=\"posts.length > 0 || isLoading.state\"> <div class=listing-item-primary> <button ng-disabled=isLoading.state ng-hide=isLoading.state class=\"button-gamma button-flat\" ng-click=loadMore() translate=app.load_more>Load more </button> <button type=button class=\"button-gamma button-flat\" ng-show=isLoading.state> <div class=loading> <div class=line></div> <div class=line></div> <div class=line></div> </div> <span class=button-label translate=app.loading>Loading</span> </button> </div> </div> </div> </div> ";

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = PostViewMap;
	
	PostViewMap.$inject = ['PostEndpoint', 'Maps', '_', 'PostFilters', 'Leaflet', '$q', '$rootScope', '$compile'];
	function PostViewMap(PostEndpoint, Maps, _, PostFilters, L, $q, $rootScope, $compile) {
	    return {
	        restrict: 'E',
	        replace: true,
	        scope: {
	            filters: '=',
	            isLoading: '='
	        },
	        link: PostViewMapLink,
	        template: __webpack_require__(731)
	    };
	
	    function PostViewMapLink($scope, element, attrs) {
	        var map, markers;
	        var currentGeoJsonRequests = [];
	        var limit = 200;
	        var requestBlockSize = 5;
	        var numberOfChunks = 0;
	
	        activate();
	
	        function activate() {
	            // Start loading data
	            var posts = loadPosts();
	            var createMap = Maps.createMap(element[0].querySelector('#map')).then(function (data) {
	                map = data;
	            });
	
	            // When data is loaded
	            $q.all({
	                map: createMap,
	                posts: posts
	            }).then(function (data) {
	                addPostsToMap(data.posts);
	                return data;
	            }).then(watchFilters);
	
	            // Cleanup leaflet map
	            $scope.$on('$destroy', function () {
	                if (map) {
	                    map.remove();
	                }
	            });
	        }
	
	        function clearData() {
	            if (markers) {
	                map.removeLayer(markers);
	                markers = undefined;
	            }
	        }
	
	        function addPostsToMap(posts) {
	
	            var geojson = L.geoJson(posts, {
	                pointToLayer: Maps.pointToLayer,
	                onEachFeature: onEachFeature
	            });
	
	            if (map.options.clustering) {
	
	                markers = markers ? markers : L.markerClusterGroup();
	                // This has to be done individually.
	                // Using clusterLayer.addLayers() breaks the clustering.
	                // Need to investigate as this should have been fixing in v1.0.0
	                angular.forEach(geojson.getLayers(), function (layer) {
	                    markers.addLayer(layer);
	                });
	            } else {
	                markers = geojson;
	            }
	            markers.addTo(map);
	
	            if (posts.features.length > 0) {
	                map.fitBounds(geojson.getBounds());
	            }
	            // Focus map on data points but..
	            // Avoid zooming further than 15 (particularly when we just have a single point)
	            if (map.getZoom() > 15) {
	                map.setZoom(15);
	            }
	        }
	
	        function watchFilters() {
	            // whenever filters change, reload the posts on the map
	            $scope.$watch(function () {
	                return $scope.filters;
	            }, function (newValue, oldValue) {
	                if (newValue !== oldValue) {
	                    cancelCurrentRequests();
	                    clearData();
	                    reloadMapPosts();
	                }
	            }, true);
	        }
	
	        function cancelCurrentRequests() {
	            _.each(currentGeoJsonRequests, function (request) {
	                request.$cancelRequest();
	            });
	            currentGeoJsonRequests = [];
	        }
	
	        function reloadMapPosts() {
	            var test = loadPosts();
	            test.then(addPostsToMap);
	        }
	
	        function loadPosts(query, offset, currentBlock) {
	            offset = offset || 0;
	            currentBlock = currentBlock || 1;
	
	            query = query || PostFilters.getQueryParams($scope.filters);
	
	            var conditions = _.extend(query, {
	                limit: limit,
	                offset: offset,
	                has_location: 'mapped'
	            });
	            $scope.isLoading.state = true;
	
	            var request = PostEndpoint.geojson(conditions);
	            currentGeoJsonRequests.push(request);
	
	            return request.$promise.then(function (posts) {
	
	                // Set number of chunks
	                if (offset === 0 && posts.total > limit) {
	                    numberOfChunks = Math.floor((posts.total - limit) / limit);
	                    numberOfChunks += (posts.total - limit) % limit > 0 ? 1 : 0;
	                }
	
	                // Retrieve blocks of chunks
	                // At the end of a block request the next block of chunks
	                if (numberOfChunks > 0 && currentBlock === 1) {
	                    var block = numberOfChunks > requestBlockSize ? requestBlockSize : numberOfChunks;
	                    numberOfChunks -= requestBlockSize;
	                    while (block > 0) {
	                        block -= 1;
	                        offset += limit;
	                        loadPosts(query, offset, block).then(addPostsToMap);
	                    }
	                }
	
	                if (numberOfChunks <= 0) {
	                    $scope.isLoading.state = false;
	                }
	                return posts;
	            });
	        }
	
	        function onEachFeature(feature, layer) {
	            layer.on('click', function (e) {
	                // Grab the layer that was actually clicked on
	                var layer = e.layer;
	                // If we somehow got the feature group: grab the first child
	                // because the FeatureGroup doesn't get added to the map when clustering
	                if (layer instanceof L.FeatureGroup) {
	                    layer = layer.getLayers()[0];
	                }
	
	                if (layer.getPopup()) {
	                    layer.openPopup();
	                } else {
	                    getPostDetails(feature).then(function (details) {
	                        var scope = $rootScope.$new();
	                        scope.post = details;
	
	                        var el = $compile('<post-card post="post" short-content="true"></post-card>')(scope);
	
	                        layer.bindPopup(el[0], {
	                            'minWidth': '300',
	                            'maxWidth': '300',
	                            'className': 'pl-popup'
	                        });
	                        layer.openPopup();
	                    });
	                }
	            });
	        }
	
	        function getPostDetails(feature) {
	            return PostEndpoint.get({ id: feature.properties.id }).$promise;
	        }
	    }
	}

/***/ }),
/* 731 */
/***/ (function(module, exports) {

	module.exports = "<div class=map-view> <div id=map class=\"map full-size\"></div> </div> ";

/***/ }),
/* 732 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = PostViewCreate;
	
	PostViewCreate.$inject = [];
	
	function PostViewCreate() {
	    return {
	        restrict: 'E',
	        replace: true,
	        scope: {},
	        controller: PostViewCreateController
	    };
	}
	PostViewCreateController.$inject = ['$rootScope', '$scope', 'PostSurveyService', 'MainsheetService', '$location', 'Notify'];
	
	function PostViewCreateController($rootScope, $scope, PostSurveyService, MainsheetService, $location, Notify) {
	    // resetting path to map-view when mainsheet-modal is closed
	    $rootScope.$on('mainsheet:statechange', function () {
	        if (MainsheetService.getState() && $location.path() === '/views/create') {
	            $location.path('/views/map');
	        }
	    });
	
	    activate();
	    function activate() {
	        PostSurveyService.allowedSurveys().then(function (forms) {
	            $scope.forms = forms;
	            if (forms.length > 0) {
	                $scope.disabled = false;
	            }
	            if ($scope.forms.length === 1) {
	                $location.path('/posts/create/' + $scope.forms[0].id);
	            } else {
	                MainsheetService.openTemplate('<add-post-survey-list></add-post-survey-list>', 'app.submit_response', $scope);
	            }
	        }, function (errorResponse) {
	            Notify.apiErrors(errorResponse);
	        });
	    }
	}

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = PostCardDirective;
	
	PostCardDirective.$inject = ['FormEndpoint'];
	function PostCardDirective(FormEndpoint) {
	    return {
	        restrict: 'E',
	        replace: true,
	        scope: {
	            post: '=',
	            canSelect: '=',
	            selectedPosts: '=',
	            shortContent: '@'
	        },
	        template: __webpack_require__(734),
	        link: function link($scope) {
	            activate();
	
	            function activate() {
	                loadForm($scope.post.form);
	            }
	
	            function loadForm(form) {
	                // Replace form with full object
	                if (form) {
	                    FormEndpoint.get({ id: form.id }, function (form) {
	                        $scope.post.form = form;
	                    });
	                }
	            }
	        }
	    };
	}

/***/ }),
/* 734 */
/***/ (function(module, exports) {

	module.exports = "<article class=postcard> <div class=post-band ng-style=\"{backgroundColor: post.form.color}\"></div> <div class=listing-item-select> <input ng-show=canSelect type=checkbox checklist-value=post.id checklist-model=selectedPosts> </div> <div class=postcard-body> <header class=postcard-header> <post-metadata post=post hide-date-this-week=true></post-metadata> <post-actions post=post></post-actions> </header> <div class=postcard-overflow> <div class=postcard-title> <a ng-href=/posts/{{post.id}}> <div class=postcard-field> {{ post.title || post.content | limitTo:150 }}{{ !post.title && post.content.length > 150 ? ' ...' : ''}} </div> </a> </div> <post-preview-media post=post></post-preview-media> <div ng-if=!shortContent class=postcard-field> {{ post.content }} </div> <div ng-if=shortContent class=postcard-field> {{ post.content | limitTo:150 }}{{ post.content.length > 150 ? ' ...' : ''}} </div> </div> </div></article> ";

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = ['FormAttributeEndpoint', 'MediaEndpoint', '_', function (FormAttributeEndpoint, MediaEndpoint, _) {
	    return {
	        restrict: 'E',
	        replace: true,
	        scope: {
	            post: '='
	        },
	        template: __webpack_require__(736),
	        link: function link($scope) {
	
	            if (!$scope.post.form) {
	                return;
	            }
	
	            FormAttributeEndpoint.queryFresh({ formId: $scope.post.form.id }).$promise.then(function (attributes) {
	
	                // Use image from the first media attribute
	                var mediaAttribute = _.find(attributes, function (attribute) {
	                    return attribute.type === 'media';
	                });
	
	                // Get the media url and caption
	                if (mediaAttribute && !_.isUndefined($scope.post.values[mediaAttribute.key])) {
	                    MediaEndpoint.get({ id: $scope.post.values[mediaAttribute.key] }).$promise.then(function (media) {
	                        $scope.media = media;
	                    });
	                }
	            });
	        }
	    };
	}];

/***/ }),
/* 736 */
/***/ (function(module, exports) {

	module.exports = "<div class=postcard-field ng-show=media> <img ng-src=\"{{ media.original_file_url }}\" alt=\"{{ media.caption }}\" class=postcard-image> </div> ";

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = AddPostButtonDirective;
	
	AddPostButtonDirective.$inject = [];
	function AddPostButtonDirective() {
	    return {
	        restrict: 'E',
	        scope: true,
	        replace: true,
	        controller: AddPostButtonController,
	        template: __webpack_require__(738)
	    };
	}
	
	AddPostButtonController.$inject = ['$scope', 'Notify', 'MainsheetService', 'PostSurveyService', '$location'];
	function AddPostButtonController($scope, Notify, MainsheetService, PostSurveyService, $location) {
	    $scope.forms = [];
	    $scope.disabled = true;
	    $scope.handleClick = handleClick;
	
	    activate();
	
	    function activate() {
	        getAvailableSurveys();
	    }
	
	    function getAvailableSurveys() {
	        PostSurveyService.allowedSurveys().then(function (forms) {
	            $scope.forms = forms;
	            if (forms.length > 0) {
	                $scope.disabled = false;
	            }
	        }, function (errorResponse) {
	            Notify.apiErrors(errorResponse);
	        });
	    }
	
	    function handleClick() {
	        if ($scope.forms.length === 1) {
	            $location.path('/posts/create/' + $scope.forms[0].id);
	        } else {
	            MainsheetService.openTemplate('<add-post-survey-list></add-post-survey-list>', 'app.submit_response', $scope);
	        }
	    }
	}

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=fab data-message=add-post> <button type=button class=\"button-alpha button-fab\" ng-click=handleClick() ng-disabled=disabled> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#plus></use> <foreignObject> <img class=icon src=" + __webpack_require__(739) + "> </foreignObject> </svg> <span class=hidden>Add</span> </button> </div> ";

/***/ }),
/* 739 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEwAACxMBAJqcGAAAAC1JREFUOI1jZMAN/qPxGbEpYsJjAFFg1ABIyKKHNn1dMPAGYE1dUDCaEullAAAi0gMdELO4MAAAAABJRU5ErkJggg=="

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = AddPostSurveyListDirective;
	
	AddPostSurveyListDirective.$inject = [];
	
	function AddPostSurveyListDirective() {
	    return {
	        restrict: 'E',
	        scope: true,
	        controller: AddPostSurveyListController,
	        template: __webpack_require__(741)
	    };
	}
	
	AddPostSurveyListController.$inject = ['$scope', '$location'];
	
	function AddPostSurveyListController($scope, $location) {
	
	    $scope.handleClick = handleClick;
	
	    function handleClick(form) {
	        $scope.closeMainsheet();
	        $location.path('posts/create/' + form.id);
	    }
	}

/***/ }),
/* 741 */
/***/ (function(module, exports) {

	module.exports = "<ul> <li ng-repeat=\"form in forms\"> <a ng-click=handleClick(form)> <span class=post-band ng-style=\"{backgroundColor: form.color}\"></span> {{form.name}} </a> </li> </ul>";

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = AddPostButtonDirective;
	
	AddPostButtonDirective.$inject = [];
	function AddPostButtonDirective() {
	    return {
	        restrict: 'E',
	        scope: true,
	        controller: AddPostButtonController,
	        template: __webpack_require__(743)
	    };
	}
	
	AddPostButtonController.$inject = ['$scope', 'PostSurveyService', 'SliderService', '$location'];
	function AddPostButtonController($scope, PostSurveyService, SliderService, $location) {
	    $scope.forms = [];
	    $scope.buttonToggle = false;
	    $scope.buttonOptionsStyle = { opacity: 0, display: 'none' };
	    $scope.toggleButton = toggleButton;
	    $scope.createPost = createPost;
	    $scope.disabled = false;
	
	    activate();
	
	    function activate() {
	        // Load forms
	        PostSurveyService.allowedSurveys().then(function (forms) {
	            $scope.forms = forms;
	            if (forms.length > 0) {
	                $scope.disabled = false;
	            }
	        });
	    }
	
	    function createPost(path) {
	        SliderService.close();
	        $location.path('/posts/create/' + path);
	    }
	
	    function toggleButton() {
	        if ($scope.forms.length === 1) {
	            createPost($scope.forms[0].id);
	        } else {
	            $scope.buttonToggle = !$scope.buttonToggle;
	            if ($scope.buttonToggle) {
	                $scope.buttonOptionsStyle = { opacity: 1, display: 'flex' };
	            } else {
	                $scope.buttonOptionsStyle = { opacity: 0, display: 'none' };
	            }
	        }
	    }
	}

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<button type=button class=\"button-alpha button-dropdown init\" ng-click=toggleButton() ng-class=\"{ 'active': buttonToggle }\"> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#plus></use> <foreignObject> <img class=icon src=" + __webpack_require__(739) + "> </foreignObject> </svg> <span class=button-label translate=nav.add_post>Add post</span> </button> <ul class=\"dropdown-menu init\" ng-show=buttonToggle ng-class=\"{ 'active': buttonToggle }\"> <li ng-repeat=\"form in forms\"> <a ng-click=createPost(form.id)> <span class=post-band> </span> {{form.name}} </a> </li> </ul> ";

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = ModeContextFormFilterDirective;
	
	ModeContextFormFilterDirective.$inject = [];
	function ModeContextFormFilterDirective() {
	    return {
	        restrict: 'E',
	        scope: true,
	        controller: ModeContextFormFilter,
	        template: __webpack_require__(745)
	    };
	}
	ModeContextFormFilter.$inject = ['$scope', 'FormEndpoint', 'PostEndpoint', 'TagEndpoint', '$q', '_', '$rootScope', 'PostSurveyService', 'PostFilters', '$timeout', '$location'];
	function ModeContextFormFilter($scope, FormEndpoint, PostEndpoint, TagEndpoint, $q, _, $rootScope, PostSurveyService, PostFilters, $timeout, $location) {
	    $scope.forms = [];
	    $scope.showOnly = showOnly;
	    $scope.selectParent = selectParent;
	    $scope.hide = hide;
	    $scope.unknown_post_count = 0;
	    $scope.hasManageSettingsPermission = $rootScope.hasManageSettingsPermission;
	    $scope.canAddToSurvey = PostSurveyService.canCreatePostInSurvey;
	    $scope.showLanguage = false;
	    $scope.languageToggle = languageToggle;
	    $scope.unmapped = 0;
	    $scope.location = $location;
	    $scope.goToUnmapped = goToUnmapped;
	    $scope.getUnmapped = getUnmapped;
	    $scope.changeForms = changeForms;
	    activate();
	
	    $scope.$watch('filters', function () {
	        getPostStats(PostFilters.getFilters()).$promise.then(updateCounts);
	    }, true);
	
	    function activate() {
	        // Load forms
	        $scope.forms = FormEndpoint.queryFresh();
	        $scope.tags = TagEndpoint.queryFresh();
	        var postCountRequest = getPostStats($scope.filters);
	        $q.all([$scope.forms.$promise, postCountRequest.$promise, $scope.tags.$promise]).then(function (responses) {
	            if (!responses[1] || !responses[1].totals || !responses[1].totals[0]) {
	                return;
	            }
	            var tags = responses[2];
	
	            // adding children to tags
	            _.each(_.where(tags, { parent_id: null }), function (tag) {
	                if (tag && tag.children) {
	                    tag.children = _.filter(_.map(tag.children, function (child) {
	                        return _.findWhere(tags, { id: parseInt(child.id) });
	                    }));
	                }
	            });
	
	            angular.forEach($scope.forms, function (form, index) {
	                var formTagIds = _.pluck(form.tags, 'id');
	                // assigning whole tag-object to forms
	                $scope.forms[index].tags = _.filter(_.map(tags, function (tag) {
	                    // Remove children
	                    if (tag.parent_id === null) {
	                        tag = _.clone(tag);
	                        tag.children = _.clone(tag.children);
	
	                        // Grab the tags selected for this form
	                        if (_.contains(formTagIds, tag.id)) {
	                            // Filter the children based on form.tags
	                            tag.children = _.filter(tag.children, function (child) {
	                                return _.contains(formTagIds, child.id);
	                            });
	
	                            return tag;
	                        }
	                    }
	
	                    return false;
	                }));
	            });
	
	            updateCounts(responses[1]);
	        });
	    }
	
	    function getPostStats(filters) {
	        var query = PostFilters.getQueryParams(filters);
	        var queryParams = _.extend({}, query, {
	            'group_by': 'form',
	            include_unmapped: true
	        });
	        // we want stats for all forms, not just the ones visible right now
	        if (queryParams.form) {
	            delete queryParams.form;
	        }
	        // deleting categories since they are selected in the sidebar and not in the filter-modal = might get confusing
	        if (queryParams.tags) {
	            delete queryParams.tags;
	        }
	        return PostEndpoint.stats(queryParams);
	    }
	
	    function updateCounts(stats) {
	        // assigning count of unknown-values
	        var unknown = _.findWhere(stats.totals[0].values, { id: null });
	        $scope.unknown_post_count = unknown && unknown.total ? unknown.total : 0;
	
	        // Setting nb of unmapped posts
	        $scope.unmapped = stats.unmapped ? stats.unmapped : 0;
	
	        // assigning count for all forms
	        _.each($scope.forms, function (form) {
	            var posts = _.findWhere(stats.totals[0].values, { id: form.id });
	            form.post_count = posts && posts.total ? posts.total : 0;
	        });
	    }
	
	    function selectParent(parent, formId) {
	        // If we've just selected the tag
	        if (_.contains($scope.filters.tags, parent.id)) {
	            // ... then select its children too
	            _.each(parent.children, function (child) {
	                $scope.filters.tags.push(child.id);
	            });
	
	            // Also filter to just this form
	            $scope.filters.form.splice(0, $scope.filters.form.length, formId);
	            // Or if we're deselecting the parent
	        } else {
	            // Deselect the children too
	            _.each(parent.children, function (child) {
	                // Remove each child without replacing the tags array
	                var index = $scope.filters.tags.indexOf(child.id);
	                if (index !== -1) {
	                    $scope.filters.tags.splice(index, 1);
	                }
	            });
	        }
	    }
	
	    function languageToggle() {
	        $scope.showLanguage = !$scope.showLanguage;
	    }
	
	    function showOnly(formId) {
	        $scope.filters.form.splice(0, $scope.filters.form.length, formId);
	        // Remove tags filter
	        $scope.filters.tags.splice(0, $scope.filters.tags.length);
	    }
	
	    function changeForms() {
	        if ($scope.forms.length > 1) {
	            // Remove tags filter
	            $scope.filters.tags.splice(0, $scope.filters.tags.length);
	        }
	    }
	
	    function getUnmapped() {
	        if ($scope.unmapped === 1) {
	            return $scope.unmapped + ' post';
	        }
	        return $scope.unmapped + ' posts';
	    }
	
	    function goToUnmapped() {
	        var filters = PostFilters.getDefaults();
	        filters.form.push('none');
	        filters.has_location = 'unmapped';
	        PostFilters.setFilters(filters);
	        $location.path('/views/list');
	    }
	    function hide(formId) {
	        var index = $scope.filters.form.indexOf(formId);
	        if (index !== -1) {
	            $scope.filters.form.splice(index, 1);
	        }
	    }
	}

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<form class=survey-filter> <div class=\"survey-filter-checkbox init\" ng-class=\"{ checked : (filters.form.indexOf(form.id) !== -1) }\" ng-repeat=\"form in forms\" dropdown> <div class=survey-filter-parent> <div class=survey-filter-label> <span class=post-band ng-style=\"{backgroundColor: form.color}\"></span> <label class=checked> <input type=checkbox checklist-value=form.id checklist-model=filters.form ng-change=changeForms()> {{ ::form.name }} </label> </div> <span class=\"survey-filter-total init\" data-toggle=dropdown-menu dropdown-toggle> {{ form.post_count }} <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> </span> <ul class=\"dropdown-menu init\" dropdown-menu> <li ng-show=canAddToSurvey(form)> <a ng-href=\"posts/create/{{ ::form.id }}\"> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#plus></use> </svg> <span class=label translate=post.add_to_form translate-values=\"{ form: form.name }\">Add to</span> </a> </li> <div class=divider></div> <li><a translate=post.show_only_form translate-values=\"{ form: form.name }\" ng-click=showOnly(form.id)>Show only </a></li> <li><a translate=post.hide_form translate-values=\"{ form: form.name }\" ng-click=hide(form.id)>Hide</a></li> <div class=divider></div> <li ng-show=hasManageSettingsPermission()> <a ng-href=\"/settings/surveys/edit/{{ form.id }}\"> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#cog></use> </svg> <span class=label translate=nav.survey_settings>Survey settings</span> </a> </li> </ul> </div> <fieldset class=survey-filter-children dropdown auto-close=outsideClick ng-show=\"form.tags.length > 0 && form.post_count > 0\"> <legend class=init data-toggle=form-fieldgroup dropdown-toggle ng-class=\"{ selected : filters.tags.length }\" translate=app.categories_count translate-values=\"{ count: form.tags.length }\"> </legend> <div class=\"form-fieldgroup init\" dropdown-menu> <div class=\"form-field checkbox\" ng-repeat=\"tag in form.tags\" ng-class=\"{'checked': filters.tags.indexOf(tag.id) > -1}\"> <label ng-click=\"selectParent(tag, form.id)\"> <input type=checkbox checklist-value=tag.id checklist-model=filters.tags /> {{tag.tag}} </label> <div class=form-fieldgroup ng-class=\"{'active': filters.tags.indexOf(tag.id) > -1}\"> <div class=\"form-field checkbox\" ng-repeat=\"child in tag.children\" ng-class=\"{'checked': filters.tags.indexOf(child.id) !== -1}\" ng-show=\"filters.tags.indexOf(tag.id) > -1\"> <label> <input type=checkbox checklist-value=child.id checklist-model=filters.tags /> {{child.tag}} </label> </div> </div> </div> </div> </fieldset> </div> <div class=\"survey-filter-checkbox init\" ng-class=\"{ checked : (filters.form.indexOf('none') !== -1) }\" dropdown> <div class=survey-filter-label> <span class=post-band ng-style=\"{backgroundColor: form.color}\"></span> <label class=checked> <input type=checkbox checklist-value=\"'none'\" checklist-model=filters.form> <span translate=nav.unknown>Unknown</span> </label> </div> <span class=\"survey-filter-total init\" data-toggle=dropdown-menu dropdown-toggle> {{ unknown_post_count }} <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> </span> <ul class=\"dropdown-menu init\" dropdown-menu> <div class=divider></div> <li><a translate=post.show_only_unknown_form ng-click=\"showOnly('none')\">Show only Unknown</a></li> <li><a translate=post.hide_unknown_form ng-click=\"hide('none')\">Hide Unknown</a></li> </ul> </div> </form> <div class=tool ng-show=\"unmapped > 0 && currentView === 'map'\"> <p>There are <a ng-click=goToUnmapped()><strong>{{getUnmapped()}}</strong></a> not shown here because they don't include location information.</p> </div> <div class=form-field ng-show=hasManageSettingsPermission()> <a ng-href=/settings/surveys/create class=\"button button-link\"> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#plus></use> </svg> <span class=button-label translate=app.create_new_survey>Create new survey</span> </a> </div>  <div class=tool> <h6 class=tool-heading>Language</h6> <span class=\"tool-trigger init\" ng-class=\"{'active': showLanguage}\" ng-click=languageToggle()> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> <span class=\"label hidden\">Show/hide</span> </span> <div class=toggle-content ng-class=\"{'active': showLanguage}\"> <language-switch></language-switch> </div> </div> ";

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = FilterBySurveryDirective;
	
	FilterBySurveryDirective.$inject = [];
	function FilterBySurveryDirective() {
	    return {
	        restrict: 'E',
	        scope: {
	            filters: '='
	        },
	        replace: true,
	        controller: FilterBySurveryController,
	        template: __webpack_require__(747)
	    };
	}
	
	FilterBySurveryController.$inject = ['$scope', '$rootScope'];
	function FilterBySurveryController($scope, $rootScope) {
	
	    $scope.openFilters = openFilters;
	
	    activate();
	
	    function activate() {}
	
	    function openFilters() {
	        $rootScope.$emit('filters:open:dropdown');
	    }
	}

/***/ }),
/* 747 */
/***/ (function(module, exports) {

	module.exports = "<div embed-only=true class=\"toolbox hide-when-medium\"> <button ng-click=openFilters() class=\"button-beta button-plain mode-context-trigger\" translate=app.filter_by_survey>Filter by survey</button> </div> ";

/***/ }),
/* 748 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = FilterBySurveryDropdownDirective;
	
	FilterBySurveryDropdownDirective.$inject = [];
	function FilterBySurveryDropdownDirective() {
	    return {
	        restrict: 'A',
	        replace: true,
	        controller: FilterBySurveryDropdownController
	    };
	}
	
	FilterBySurveryDropdownController.$inject = ['$scope', '$rootScope'];
	function FilterBySurveryDropdownController($scope, $rootScope) {
	
	    $scope.filtersMenuOpen = false;
	
	    activate();
	
	    function activate() {
	        $rootScope.$on('filters:open:dropdown', function () {
	            externalOpenDropDown();
	        });
	    }
	
	    function externalOpenDropDown() {
	        $scope.filtersMenuOpen = true;
	    }
	}

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = PostToolbarDirective;
	
	PostToolbarDirective.$inject = [];
	function PostToolbarDirective() {
	    return {
	        restrict: 'E',
	        scope: {
	            isLoading: '=',
	            filters: '=',
	            currentView: '='
	        },
	        controller: PostToolbarController,
	        template: __webpack_require__(750)
	    };
	}
	
	PostToolbarController.$inject = [];
	function PostToolbarController() {}

/***/ }),
/* 750 */
/***/ (function(module, exports) {

	module.exports = "<div class=toolbar> <add-post-button></add-post-button> <filter-posts current-view=currentView filters=filters embed-only=false></filter-posts> <filter-by-survey></filter-by-survey> <div class=\"button-group hide-until-medium\" embed-only=true> <post-share filters=filters button=true></post-share> </div> <div class=button-group embed-only=false> <post-share filters=filters button=true></post-share> </div> <div class=progress-bar ng-show=isLoading.state> <span> Loading... </span> </div> </div> ";

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = FilterPostsDirective;
	
	FilterPostsDirective.$inject = [];
	function FilterPostsDirective() {
	    return {
	        restrict: 'E',
	        scope: {
	            filters: '=',
	            currentView: '='
	        },
	        replace: true,
	        controller: FilterPostsController,
	        template: __webpack_require__(752)
	    };
	}
	
	FilterPostsController.$inject = ['$scope', '$timeout', 'ModalService', 'PostFilters'];
	function FilterPostsController($scope, $timeout, ModalService, PostFilters) {
	    $scope.searchSavedToggle = false;
	    $scope.cancel = cancel;
	    $scope.applyFilters = applyFilters;
	    $scope.openFilterModal = openFilterModal;
	    $scope.openSavedModal = openSavedModal;
	    activate();
	
	    function activate() {
	        // @todo define initial filter values
	        // $scope.$watch('filters', handleFilterChange, true);
	    }
	
	    function cancel() {
	        // Reset filters
	        rollbackForm();
	        // .. and close the dropdown
	        ModalService.close();
	    }
	
	    function openFilterModal() {
	        // Set active task so we know who this attribute will belong to
	        ModalService.openTemplate('<filter-modal></filter-modal>', 'app.filter_by', '/img/material/svg-sprite-content-symbol.svg#ic_filter_list_24px', $scope, true, true);
	    }
	    function applyFilters(event) {
	        // ngFormController automatically commits changes to the model ($scope.filters)
	        // Just close the dropdown
	        ModalService.close();
	    }
	
	    function openSavedModal() {
	        ModalService.openTemplate('<saved-search-modal></saved-search-modal>', 'nav.saved_searches', '/img/iconic-sprite.svg#star', $scope, true, true);
	    }
	
	    function rollbackForm() {
	        PostFilters.clearFilters();
	    }
	}

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<form name=postFiltersForm role=search class=searchbar dropdown auto-close=outsideClick ng-submit=applyFilters() ng-model-options=\"{ updateOn : 'submit' }\"> <filter-searchbar model=filters.q></filter-searchbar> <div class=searchbar-options> <a class=button ng-click=openSavedModal()> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#star></use> </svg> <span class=\"button-label hidden\" translate>app.saved</span> </a> <a id=togglePostSearchFilters class=\"button searchbar-options-filter\" ng-click=openFilterModal()> <svg class=iconic> <use xlink:href=" + __webpack_require__(753) + "#ic_filter_list_24px> </use> </svg> <span class=button-label translate>app.filters</span> </a> </div> </form> ";

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "55353a0616332fe4d0f92e129a27425c.svg";

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = CategorySelectDirective;
	
	CategorySelectDirective.$inject = ['TagEndpoint', '_'];
	function CategorySelectDirective(TagEndpoint, _) {
	    return {
	        restrict: 'E',
	        replace: true,
	        scope: {},
	        require: 'ngModel',
	        link: CategorySelectLink,
	        template: __webpack_require__(755)
	    };
	
	    function CategorySelectLink(scope, element, attrs, ngModel) {
	        if (!ngModel) {
	            return;
	        }
	        scope.categories = [];
	        scope.parents = [];
	        scope.selectedCategories = [];
	        activate();
	
	        function activate() {
	            // Load categories
	            TagEndpoint.queryFresh().$promise.then(function (result) {
	                scope.categories = result;
	                // adding children to tags
	                _.each(scope.categories, function (category) {
	                    if (category.children) {
	                        var children = [];
	                        _.each(category.children, function (child) {
	                            _.each(scope.categories, function (childObj) {
	                                if (childObj.id === parseInt(child.id)) {
	                                    children.push(childObj);
	                                }
	                            });
	                            category.children = children;
	                        });
	                    }
	                });
	                // separating parents from children
	                scope.parents = _.filter(scope.categories, function (category) {
	                    if (category.parent_id === null) {
	                        return category;
	                    }
	                });
	            });
	
	            scope.$watch('selectedCategories', saveValueToView, true);
	            ngModel.$render = renderModelValue;
	        }
	        function renderModelValue() {
	            // Update selectCategories w/o breaking references used by checklist-model
	            Array.prototype.splice.apply(scope.selectedCategories, [0, scope.selectedCategories.length].concat(ngModel.$viewValue));
	        }
	
	        function saveValueToView(selectedCategories) {
	            var selected = [];
	            // removing children that has no parent selected
	            _.each(scope.categories, function (category) {
	                if (category.parent && _.contains(selectedCategories, category.id) && _.contains(selectedCategories, category.parent.id)) {
	                    selected.push(category.id);
	                } else if (category.parent_id === null && _.contains(selectedCategories, category.id)) {
	                    selected.push(category.id);
	                }
	            });
	            ngModel.$setViewValue(angular.copy(selected));
	        }
	    }
	}

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<fieldset ng-show=categories.length overflow-toggle has-overflow=\"parents.length > 2\" ng-model-options=\"{ updateOn: 'default' }\"> <legend translate=nav.categories>Categories</legend> <div class=\"form-field checkbox\" ng-repeat=\"(index, category) in categories\" ng-class=\"{ overflow : ($index > 1) }\" ng-if=\"category.parent_id === null\"> <label> <input type=checkbox checklist-value=category.id value=category.id checklist-model=selectedCategories> {{ ::category.tag }} </label> <div class=\"form-field checkbox\" ng-if=\"category.children && selectedCategories.indexOf(category.id) > -1\" ng-repeat=\"child in category.children\"> <label> <input type=checkbox checklist-model=selectedCategories checklist-value=child.id value=child.id ng-selected=\"selectedCategories.indexOf(category.id) >-1\"> {{ ::child.tag }} </label> </div> </div> <span class=form-field-toggle> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> <span translate=nav.more>More</span> </span> </fieldset> ";

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = DateSelectDirective;
	
	DateSelectDirective.$inject = [];
	function DateSelectDirective() {
	    return {
	        restrict: 'E',
	        scope: {
	            dateBeforeModel: '=',
	            dateAfterModel: '='
	        },
	        controller: DateSelectController,
	        template: __webpack_require__(757)
	    };
	}
	
	DateSelectController.$inject = ['$scope'];
	function DateSelectController($scope) {
	    $scope.options = { format: 'yyyy-mm-dd' };
	}

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<fieldset> <legend translate>global_filter.date_range</legend> <div class=\"form-field date\"> <label class=hidden translate=global_filter.filter_tabs.created_after>Start date</label> <div class=input-with-icon> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#calendar></use> </svg> <input type=date pick-a-date=dateAfter pick-a-date-options=options placeholder=\"{{ 'global_filter.filter_tabs.created_after' | translate }}\" ng-model=dateAfterModel /> </div> </div> <span class=date-joiner>to</span> <div class=\"form-field date\"> <label class=hidden translate=global_filter.filter_tabs.created_before>End date</label> <div class=input-with-icon> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#calendar></use> </svg> <input type=date pick-a-date=dateBefore pick-a-date-options=options placeholder=\"{{ 'global_filter.filter_tabs.created_before' | translate }}\" ng-model=dateBeforeModel> </div> </div> </fieldset> ";

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = FormSelectDirective;
	
	FormSelectDirective.$inject = ['FormEndpoint'];
	function FormSelectDirective(FormEndpoint) {
	    return {
	        restrict: 'E',
	        replace: true,
	        scope: {},
	        require: 'ngModel',
	        link: FormSelectLink,
	        template: __webpack_require__(759)
	    };
	
	    function FormSelectLink(scope, element, attrs, ngModel) {
	        if (!ngModel) {
	            return;
	        }
	
	        scope.forms = [];
	        scope.selectedForms = [];
	
	        activate();
	
	        function activate() {
	            // Load forms
	            scope.forms = FormEndpoint.queryFresh();
	
	            scope.$watch('selectedForms', saveValueToView, true);
	            ngModel.$render = renderModelValue;
	        }
	        function renderModelValue() {
	            // Update selectedForms w/o breaking references used by checklist-model
	            Array.prototype.splice.apply(scope.selectedForms, [0, scope.selectedForms.length].concat(ngModel.$viewValue));
	        }
	
	        function saveValueToView(selectedForms) {
	            ngModel.$setViewValue(angular.copy(selectedForms));
	        }
	    }
	}

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<fieldset overflow-toggle has-overflow=\"forms.length > 1\" ng-model-options=\"{ updateOn: 'default' }\"> <legend translate=app.surveys>Survey</legend> <div class=\"form-field checkbox\" ng-repeat=\"(index, form) in forms\" ng-class=\"{ overflow : ($index > 1) }\"> <label> <input checklist-value=form.id checklist-model=selectedForms type=checkbox name=selectedForms> {{ ::form.name }} </label> </div> <div class=\"form-field checkbox\" ng-class=\"{ overflow : (forms.length > 1) }\"> <label> <input checklist-value=\"'none'\" checklist-model=selectedForms type=checkbox name=selectedForms> <span translate=nav.unknown>Unknown</span> </label> </div> <span class=form-field-toggle> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> <span translate=nav.more>More</span> </span> </fieldset> ";

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = VisibleToSelectDirective;
	
	VisibleToSelectDirective.$inject = [];
	function VisibleToSelectDirective() {
	    return {
	        restrict: 'E',
	        replace: true,
	        scope: {
	            statusModel: '=',
	            publishedToModel: '='
	        },
	        controller: VisibleToSelectController,
	        template: __webpack_require__(761)
	    };
	}
	
	VisibleToSelectController.$inject = ['$scope', 'RoleEndpoint', '$rootScope'];
	function VisibleToSelectController($scope, RoleEndpoint, $rootScope) {
	    $scope.roles = [];
	    $scope.visible_to = '';
	    $scope.hasPermission = $rootScope.hasPermission;
	
	    activate();
	
	    $scope.$watch('statusModel', updateStateFromModels);
	    $scope.$watch('publishedToModel', updateStateFromModels);
	    $scope.$watch('visible_to', updateModelsFromState);
	
	    function activate() {
	        $scope.roles = RoleEndpoint.query();
	    }
	
	    function updateStateFromModels() {
	        if ($scope.statusModel === 'draft') {
	            $scope.visible_to = 'draft';
	        } else if ($scope.statusModel === 'all') {
	            $scope.visible_to = 'everyone';
	        } else if ($scope.statusModel === 'published' && !$scope.publishedToModel) {
	            $scope.visible_to = 'everyone';
	        } else {
	            $scope.visible_to = $scope.publishedToModel;
	        }
	    }
	
	    function updateModelsFromState() {
	        if ($scope.visible_to === 'everyone') {
	            $scope.statusModel = 'all';
	            $scope.publishedToModel = '';
	        } else if ($scope.visible_to === 'draft') {
	            $scope.statusModel = 'draft';
	            $scope.publishedToModel = '';
	        } else {
	            $scope.statusModel = 'published';
	            $scope.publishedToModel = $scope.visible_to;
	        }
	    }
	}

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<fieldset overflow-toggle has-overflow=roles.length> <legend translate=global_filter.who_its_visible_to>Who it's visible to</legend> <div class=\"form-field radio\"> <label> <input type=radio name=visible_to ng-model=visible_to value=everyone> <span translate=nav.everyone>Everyone</span> </label> </div> <div class=\"form-field radio\" ng-repeat=\"role in roles\" ng-class=\"{ overflow : ($index > 0) }\"> <label> <input type=radio name=visible_to ng-model=$parent.visible_to value=\"{{ role.name }}\"> {{ ::role.display_name }} </label> </div> <div class=\"form-field radio\" ng-class=\"{ overflow : (roles.length > 0) }\"> <label> <input type=radio name=visible_to ng-model=visible_to value=draft> <span translate=nav.only_you ng-hide=\"hasPermission('Manage Posts')\">Only you</span> <span translate=nav.only_author ng-show=\"hasPermission('Manage Posts')\">Only the author (draft)</span> </label> </div> <span class=form-field-toggle> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> <span translate=nav.more>More</span> </span> </fieldset> ";

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = StatusSelectDirective;
	
	StatusSelectDirective.$inject = ['PostActionsService', '$rootScope'];
	function StatusSelectDirective(PostActionsService, $rootScope) {
	    return {
	        restrict: 'E',
	        replace: true,
	        scope: {},
	        require: 'ngModel',
	        link: StatusSelectLink,
	        template: __webpack_require__(763)
	    };
	
	    function StatusSelectLink(scope, element, attrs, ngModel) {
	        scope.statuses = PostActionsService.getStatuses();
	        scope.selectedStatuses = [];
	        scope.hasPermission = $rootScope.hasPermission;
	
	        activate();
	
	        function activate() {
	            scope.$watch('selectedStatuses', saveValueToView, true);
	            ngModel.$render = renderModelValue;
	        }
	
	        function renderModelValue() {
	            // Update selectedStatuses w/o breaking references used by checklist-model
	            Array.prototype.splice.apply(scope.selectedStatuses, [0, scope.selectedStatuses.length].concat(ngModel.$viewValue));
	        }
	
	        function saveValueToView(selectedStatuses) {
	            ngModel.$setViewValue(angular.copy(selectedStatuses));
	        }
	    }
	}

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<fieldset overflow-toggle has-overflow=\"statuses.length > 2\" ng-model-options=\"{ updateOn: 'default' }\" ng-show=\"hasPermission('Manage Posts')\"> <legend translate=global_filter.status>Status</legend> <div class=\"form-field checkbox icon-input\" ng-repeat=\"(index, status) in statuses\" ng-class=\"{ overflow: ($index > 1) }\"> <label> <svg class=iconic ng-if=\"status == 'published'\"> <use xlink:href=" + __webpack_require__(412) + "#globe></use> </svg> <svg class=iconic ng-if=\"status == 'draft'\"> <use xlink:href=" + __webpack_require__(412) + "#lock-locked></use> </svg> <svg class=iconic ng-if=\"status == 'archived'\"> <use xlink:href=" + __webpack_require__(412) + "#box></use> </svg> <input type=checkbox ng-model=status checklist-model=selectedStatuses checklist-value=status name=selectedStatuses> <span translate=post.published ng-if=\"status == 'published'\">Published</span> <span translate=post.draft ng-if=\"status == 'draft'\">Under review</span> <span translate=post.archived ng-if=\"status == 'archived'\">Archive</span> </label> </div> <span class=form-field-toggle> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> <span translate=nav.more>More</span> </span> </fieldset> ";

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = LocationFilterDirective;
	
	LocationFilterDirective.$inject = ['Geocoding', '$q'];
	function LocationFilterDirective(Geocoding, $q) {
	    return {
	        restrict: 'E',
	        replace: true,
	        scope: {
	            centerPointModel: '=',
	            withinKmModel: '='
	        },
	        link: LocationFilterLink,
	        template: __webpack_require__(765)
	    };
	
	    //LocationFilterLink.$inject = ['Geocoding'];
	    function LocationFilterLink($scope, element, attrs) {
	        $scope.geocoding = false;
	        $scope.locationSearchText = '';
	        $scope.$watch('centerPointModel', updateStateFromModels);
	        $scope.$watch('locationSearchText', updateModelsFromState);
	
	        function updateStateFromModels(newValue, oldValue) {
	            if (!$scope.locationSearchText) {
	                $scope.locationSearchText = $scope.centerPointModel;
	            }
	        }
	
	        function updateModelsFromState() {
	            if ($scope.locationSearchText) {
	                geocode($scope.locationSearchText).then(function (coords) {
	                    $scope.centerPointModel = coords;
	                });
	            } else {
	                $scope.centerPointModel = '';
	            }
	        }
	
	        function geocode(location) {
	            var defer = $q.defer(),
	                valid_coords = /\-?[0-9]+(\.[0-9]+)?\s*,\s*\-?[0-9]+(\.[0-9]+)?/;
	
	            if (!location) {
	                return;
	            }
	
	            if (valid_coords.test(location)) {
	                defer.resolve(location);
	            } else {
	                // perform a geocoding lookup on the location
	                $scope.geocoding = true;
	
	                Geocoding.searchCoordinates(location).then(function (coordinates) {
	                    if (!coordinates) {
	                        defer.reject();
	                        return;
	                    } // @todo - handle bad lookup
	
	                    $scope.geocoding = false;
	                    defer.resolve(coordinates[0] + ',' + coordinates[1]);
	                });
	            }
	
	            return defer.promise;
	        }
	    }
	}

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<fieldset> <legend translate=global_filter.location>Location</legend> <div class=form-field> <div class=input-with-icon> <input type=text style=padding-left:24px placeholder=\"{{ 'global_filter.location_placeholder' | translate }}\" ng-model=locationSearchText> <svg class=iconic style=left:8px> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#location></use> </svg> </div> </div> <div class=form-field> <select ng-model=withinKmModel convert-to-number> <option value=1 translate>global_filter.option_1</option> <option value=10 translate>global_filter.option_2</option> <option value=50 translate>global_filter.option_3</option> <option value=100 translate>global_filter.option_4</option> <option value=500 translate>global_filter.option_5</option> </select> </div> </fieldset> ";

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = FilterHasLocationDirective;
	
	FilterHasLocationDirective.$inject = [];
	
	function FilterHasLocationDirective() {
	    return {
	        restrict: 'E',
	        replace: true,
	        scope: {
	            hasLocation: '='
	        },
	        require: 'ngModel',
	        link: FilterHasLocationLink,
	        template: __webpack_require__(767)
	    };
	}
	
	function FilterHasLocationLink($scope, $element, $attrs, ngModel) {
	    activate();
	    function activate() {
	        $scope.$watch('hasLocation', saveToView, true);
	    }
	
	    function saveToView(hasLocation) {
	        ngModel.$setViewValue(angular.copy(hasLocation));
	    }
	}

/***/ }),
/* 767 */
/***/ (function(module, exports) {

	module.exports = "<fieldset> <legend translate=global_filter.filter_tabs.has_location></legend> <div class=\"form-field radio\"> <label translate=global_filter.filter_tabs.all_posts> </label> <input ng-value=all ng-checked=\"hasLocation === 'all'\" ng-model=hasLocation type=radio name=hasLocation> </div> <div class=\"form-field radio\"> <label translate=global_filter.filter_tabs.unmapped></label> <input value=unmapped ng-model=hasLocation type=radio name=hasLocation ng-checked=\"hasLocation === 'unmapped'\"> </div> <div class=\"form-field radio\"> <label translate=global_filter.filter_tabs.mapped></label> <input value=mapped ng-model=hasLocation ng-checked=\"hasLocation === 'mapped'\" type=radio name=hasLocation> </div> </fieldset> ";

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = ActiveFilters;
	
	ActiveFilters.$inject = ['$translate', '$filter', 'PostFilters', '_', 'TagEndpoint', 'RoleEndpoint', 'UserEndpoint'];
	function ActiveFilters($translate, $filter, PostFilters, _, TagEndpoint, RoleEndpoint, UserEndpoint) {
	    return {
	        restrict: 'E',
	        scope: true,
	        template: __webpack_require__(769),
	        link: ActiveFiltersLink
	    };
	
	    function ActiveFiltersLink($scope) {
	        $scope.activeFilters = {};
	        $scope.removeFilter = removeFilter;
	        $scope.transformFilterValue = transformFilterValue;
	
	        var rawFilters = {};
	        var _tags = [];
	        var roles = [];
	        var users = [];
	
	        activate();
	
	        function activate() {
	            $scope.$watch(function () {
	                return PostFilters.getActiveFilters(PostFilters.getFilters());
	            }, handleFiltersUpdate, true);
	
	            RoleEndpoint.query().$promise.then(function (results) {
	                roles = _.indexBy(results, 'name');
	            });
	            UserEndpoint.query().$promise.then(function (results) {
	                users = _.indexBy(results.results, 'id');
	            });
	            TagEndpoint.query().$promise.then(function (results) {
	                _tags = _.indexBy(results, 'id');
	            });
	        }
	
	        function makeArray(value) {
	            if (!angular.isArray(value)) {
	                return [value];
	            }
	            return value;
	        }
	
	        function handleFiltersUpdate(filters) {
	            var activeFilters = angular.copy(filters);
	            rawFilters = angular.copy(filters);
	            // Remove set filter as it is only relevant to collections and should be immutable in that view
	            delete activeFilters.set;
	            // Remove form filter as its shown by the mode-context-form-filter already
	            delete activeFilters.form;
	            // Remove categories since its shown by the mode-context-form-filter already
	            if (filters.form && filters.form.length <= 1) {
	                delete activeFilters.tags;
	            }
	            // Remove within_km as its shown with the center_point value
	            delete activeFilters.within_km;
	
	            $scope.activeFilters = _.mapObject(activeFilters, makeArray);
	        }
	
	        function transformFilterValue(value, key) {
	            if (transformers[key]) {
	                return transformers[key](value);
	            }
	
	            return value;
	        }
	
	        function removeFilter(filterKey, value) {
	            PostFilters.clearFilter(filterKey, value);
	        }
	
	        var transformers = {
	            tags: function tags(value) {
	                return _tags[value] ? _tags[value].tag : value;
	            },
	            user: function user(value) {
	                return users[value] ? users[value].realname : value;
	            },
	            // form : function (value) {
	            //     return options.forms[value] ? options.forms[value].name : value;
	            // },
	            // current_stage : function (value) {
	            //     var stages = _.flatten(_.values(options.postStages), true),
	            //         stage = _.findWhere(stages, {id : value});
	            //     return stage ? stage.label : value;
	            // },
	            // set : function (value) {
	            //     return options.collections[value] ? options.collections[value].name : value;
	            // },
	            center_point: function center_point(value) {
	                return $translate.instant('global_filter.filter_tabs.location_value', {
	                    value: rawFilters.location_text ? rawFilters.location_text : value,
	                    km: rawFilters.within_km
	                });
	            },
	            created_before: function created_before(value) {
	                return $filter('date', 'longdate')(value);
	            },
	            created_after: function created_after(value) {
	                return $filter('date', 'longdate')(value);
	            },
	            date_before: function date_before(value) {
	                return $filter('date', 'longdate')(value);
	            },
	            date_after: function date_after(value) {
	                return $filter('date', 'longdate')(value);
	            },
	            status: function status(value) {
	                return $translate.instant('post.' + value);
	            }
	        };
	    }
	}

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div ng-repeat=\"(key, values) in activeFilters\"> <span class=bug ng-repeat=\"value in values track by $index\"> <svg class=iconic ng-click=\"removeFilter(key, value)\"> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#circle-x></use> </svg> <span><em><translate translate=global_filter.filter_tabs.{{key}}></translate>:</em> {{ transformFilterValue(value, key) }}</span> </span> </div> ";

/***/ }),
/* 770 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = PostFiltersService;
	
	PostFiltersService.$inject = ['_', 'FormEndpoint', 'TagEndpoint', '$q'];
	function PostFiltersService(_, FormEndpoint, TagEndpoint, $q) {
	    // Create initial filter state
	    var filterState = window.filterState = getDefaults();
	    var forms = [];
	    var filterMode = 'all';
	    var entityId = null;
	
	    // @todo take this out of the service
	    // but ensure it happens at the right times
	    activate();
	
	    return {
	        getDefaults: getDefaults,
	        getQueryParams: getQueryParams,
	        getFilters: getFilters,
	        setFilters: setFilters,
	        clearFilters: clearFilters,
	        clearFilter: clearFilter,
	        hasFilters: hasFilters,
	        getActiveFilters: getActiveFilters,
	        setMode: setMode,
	        getMode: getMode,
	        getModeId: getModeId
	    };
	
	    function activate() {
	        FormEndpoint.queryFresh().$promise.then(function (result) {
	            forms = result;
	            filterState.form = filterState.form || [];
	            if (filterState.form.length === 0) {
	                // just in case of race conditions
	                Array.prototype.splice.apply(filterState.form, [0, 0].concat(_.pluck(forms, 'id')));
	            }
	        });
	    }
	
	    // Get filterState
	    function getFilters() {
	        return filterState;
	    }
	
	    function setFilters(newState) {
	        // Replace 'all' with full list of statuses
	        // Gives less confusing active display, and works around API bug
	        if (newState.status === 'all') {
	            newState.status = ['published', 'draft', 'archived'];
	        }
	
	        // Replace filterState with defaults + newState
	        // Including defaults ensures all values are always defined
	        return angular.extend(filterState, getDefaults(), newState);
	    }
	
	    function clearFilters() {
	        return angular.copy(getDefaults(), filterState);
	    }
	
	    function clearFilter(filterKey, value) {
	        if (angular.isArray(filterState[filterKey])) {
	            filterState[filterKey] = _.without(filterState[filterKey], value);
	        } else {
	            filterState[filterKey] = getDefaults()[filterKey];
	        }
	    }
	
	    function getDefaults() {
	        return {
	            q: '',
	            date_after: '',
	            date_before: '',
	            status: filterMode === 'collection' ? ['published', 'draft', 'archived'] : ['published', 'draft'],
	            published_to: '',
	            center_point: '',
	            has_location: 'all',
	            within_km: '1',
	            current_stage: [],
	            tags: [],
	            form: _.pluck(forms, 'id'),
	            set: [],
	            user: false
	        };
	    }
	
	    function getQueryParams(filters) {
	        var query = _.omit(filters, function (value, key, object) {
	            // Is value empty?
	            // Is it a date?
	            if (_.isDate(value)) {
	                return false;
	            }
	            // Is it an empty object or array?
	            if (_.isObject(value) || _.isArray(value)) {
	                return _.isEmpty(value);
	            }
	            // Or is it just falsy?
	            return !value;
	        });
	
	        if (filters.center_point) {
	            query.center_point = filters.center_point;
	            query.within_km = filters.within_km || 10;
	        } else {
	            delete query.within_km;
	        }
	
	        if (filterMode === 'collection') {
	            query.set = [entityId].concat(query.set);
	        }
	        return query;
	    }
	
	    function getActiveFilters(filters) {
	        var defaults = getDefaults();
	        return _.omit(filters, function (value, key, object) {
	            // Ignore difference in within_km
	            if (key === 'within_km') {
	                return true;
	            }
	            // Is the same as the default?
	            if (_.isEqual(defaults[key], value)) {
	                return true;
	            }
	            // Is an array with all the same elements? (order doesn't matter)
	            if (_.isArray(defaults[key]) && _.difference(value, defaults[key]).length === 0 && _.difference(defaults[key], value).length === 0) {
	                return true;
	            }
	            // Is value empty? ..and not a date object
	            // _.empty only works on arrays, object and strings.
	            return _.isEmpty(value) && !_.isDate(value);
	        });
	    }
	
	    function hasFilters(filters) {
	        return !_.isEmpty(getActiveFilters(filters));
	    }
	
	    function setMode(newMode, id) {
	        // If mode changes, reset filters
	        if (newMode !== filterMode) {
	            filterMode = newMode;
	            clearFilters();
	        }
	        entityId = id;
	    }
	
	    function getMode() {
	        return filterMode;
	    }
	
	    function getModeId() {
	        return entityId;
	    }
	}
	
	// clearSelected: function () {
	//     var localDefaults = angular.copy(filterDefaults);
	//     _.each(localDefaults, _.bind(function (value, key) {
	//         this[key] = value;
	//     }, this));
	// },
	// setSelected: function (newFilters) {
	//     var localDefaults = angular.copy(filterDefaults);
	//     newFilters = angular.copy(newFilters);
	
	//     _.each(localDefaults, _.bind(function (defaultValue, key) {
	//         if (_.has(newFilters, key)) {
	//             this[key] = newFilters[key];
	//         } else {
	//             this[key] = defaultValue;
	//         }
	//     }, this));
	// },

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = FilterModal;
	
	FilterModal.$inject = ['ModalService'];
	function FilterModal(ModalService) {
	    return {
	        restrict: 'E',
	        link: FilterModalLink,
	        template: __webpack_require__(772)
	    };
	}
	
	function FilterModalLink($scope, $element, $attrs) {}

/***/ }),
/* 772 */
/***/ (function(module, exports) {

	module.exports = "<div class=modal-body> <div class=hide-when-medium> <filter-form ng-model=filters.form></filter-form> <filter-category ng-model=filters.tags></filter-category> </div> <filter-status ng-model=filters.status></filter-status> <filter-date date-after-model=filters.date_after date-before-model=filters.date_before></filter-date> <filter-location center-point-model=filters.center_point within-km-model=filters.within_km></filter-location> <div class=modal-actions> <div class=form-field> <button type=button class=button-link ng-click=cancel() translate>global_filter.clear_filters</button> <button type=submit class=button-alpha translate ng-click=applyFilters()>app.apply_filters</button> </div> </div> </div> ";

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = PostShareDirective;
	
	PostShareDirective.$inject = [];
	function PostShareDirective() {
	    return {
	        restrict: 'E',
	        replace: true,
	        scope: {
	            filters: '=',
	            button: '=?',
	            postId: '=?'
	        },
	        controller: PostShareController,
	        template: __webpack_require__(774)
	    };
	}
	
	PostShareController.$inject = ['$scope', '$window', 'ModalService'];
	function PostShareController($scope, $window, ModalService) {
	    $scope.loading = false;
	    $scope.openShareMenu = openShareMenu;
	    $scope.isButton = isButton;
	    $scope.isAdd = isAdd;
	
	    activate();
	
	    function activate() {}
	
	    function isButton() {
	        return $scope.button;
	    }
	
	    function isAdd() {
	        if ($window.location.href.indexOf('post') > 0) {
	            return true;
	        }
	        return false;
	    }
	
	    function openShareMenu() {
	        var template = '<share-menu-modal post-id="' + $scope.postId + '"></share-menu-modal>';
	        ModalService.openTemplate(template, 'app.share', 'share', $scope, true, true);
	    }
	}

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<a ng-class=\"{ 'button' : isButton(), 'button-flat': isAdd()}\" ng-click=openShareMenu()> <div class=loading ng-if=loading> <div class=line></div> <div class=line></div> <div class=line></div> </div> <svg class=iconic ng-hide=loading> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#share></use> </svg> <span ng-class=\"{'button-label': isButton(), 'label': !isButton()}\" translate=app.share> Share {{isButton()}} </span> </a> ";

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = ShareMenuDirective;
	
	ShareMenuDirective.$inject = [];
	function ShareMenuDirective() {
	    return {
	        restrict: 'E',
	        scope: {
	            surveyId: '=',
	            postId: '='
	        },
	        replace: true,
	        controller: ShareMenuController,
	        template: __webpack_require__(776)
	    };
	}
	
	ShareMenuController.$inject = ['$scope', '$routeParams', 'Util', '$window'];
	function ShareMenuController($scope, $routeParams, Util, $window) {
	    $scope.loading = false;
	    $scope.shareUrl = Util.currentUrl();
	    $scope.isExportable = isExportable;
	
	    activate();
	
	    function activate() {
	        // If we are in a post action menu
	        // Then we have to change the url to ensure that when
	        // selected from either the map or timeline view for
	        // an individual post that the URL is correct
	        if ($scope.postId) {
	            $scope.shareUrl = $window.location.origin + '/posts/' + $scope.postId;
	        }
	
	        if ($scope.surveyId) {
	            $scope.shareUrl = $window.location.origin + '/posts/create/' + $scope.surveyId;
	        }
	        $scope.shareUrlEncoded = encodeURIComponent($scope.shareUrl);
	    }
	    // Check if current view is exportable based on URI
	    function isExportable() {
	        if ($window.location.href.indexOf('post') > 0) {
	            return false;
	        }
	        return true;
	    }
	}

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<form class=panel-body name=form ng-submit=submit()> <div class=form-field ng-show=surveyId> <label translate=app.survey_web_address>Your survey's web address</label> <input type=url value={{shareUrl}} readonly=\"\"> </div> <div class=\"listing init\"> <div class=listing-item> <div class=listing-item-primary> <div class=listing-item-image> <img class=icon src=" + __webpack_require__(777) + " alt=\"\"> </div> <h2 class=listing-item-title> <div class=fb-share-button data-href={{shareUrl}} data-layout=button_count data-size=large data-mobile-iframe=true> <a class=fb-xfbml-parse-ignore target=_blank ng-href=\"https://www.facebook.com/sharer/sharer.php?u={{shareUrlEncoded}}&amp;src=sdkpreparse\"> Facebook </a> </div> </h2> </div> </div> <div class=listing-item> <div class=listing-item-primary> <div class=listing-item-image> <img class=icon src=" + __webpack_require__(778) + " alt=\"\"> </div> <h2 class=listing-item-title><a ng-href=\"https://twitter.com/home?status={{shareUrlEncoded}}\">Twitter</a></h2> </div> </div> <div class=listing-item dropdown auto-close=disabled> <div dropdown-toggle> <div class=listing-item-secondary> <button type=button class=\"button-link listing-item-toggle\"> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> <span class=button-label>Configure</span> </button> </div> <div class=listing-item-primary> <div class=listing-item-image> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#code></use> </svg> </div> <h2 class=\"listing-item-title listing-item-toggle\">Embed</h2> </div> </div> <div class=listing-item-body dropdown-menu> <div class=form-field> <label>HTML</label> <textarea>&lt;iframe width=\"560\" height=\"315\" src=\"{{shareUrl}}\" frameborder=\"0\" allowfullscreen&gt;&lt;/iframe&gt;</textarea> </div> </div> </div> <div class=listing-item ng-show=isExportable()> <div class=listing-item-primary> <div class=listing-item-image> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#external-link></use> </svg> </div> <h2 class=listing-item-title> <post-export filters=filters></post-export> </h2> </div> </div> </div> </form> ";

/***/ }),
/* 777 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDowNTgwMTE3NDA3MjA2ODExODA4M0NDMTM4MEMyQTVFQiIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpCOUMxMDdGMkE2MTYxMUUyOEJFQUJDRTMzOERDQjM5MCIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpCOUMxMDdGMUE2MTYxMUUyOEJFQUJDRTMzOERDQjM5MCIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M2IChNYWNpbnRvc2gpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6QUM3QUJGQTkzODIwNjgxMThDMTQ5OEFGOTgxQUJBQ0UiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MDU4MDExNzQwNzIwNjgxMTgwODNDQzEzODBDMkE1RUIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4rzsvUAAADP0lEQVR42uycvU9TURiHX9ryESiiFoEIAQQDVkUGRaMghkAgGhMSNcpAiDoxkKiJRhmdhD/BQQcndVcUN4MmLiRGEye0lIIJiECQUuiHnlOLG4OX1ntanyf5Le29afs+vfc995ybm9V86YEkqFQZVDmjUq7iFEglEZUZlecq91T8+kVH4s0ulY8q/QkxyEg9rkStdc0/qHRuCKlWeaJSSI1sY5vKU5UqLeS2ShE1sR3t4I4j0TPADE47Eg0czKDCQQM3CqeDGpgFQhACCEEIIAQhkApclOA32S6HNHrLpKGuVOr2eGR3iVuKd+ZLbrZL8nJdEg5HJbQeiW+7GorIcnBdlld01mT++6p8W1iR2fmgzC8G5d37AEKssrfaIxe69supo5VSWJC7ubBsZzwavV2Jp2DTbVt6HiLkb6koLZKBviZpOVzJKctOsrJEznUekIHeI3/+8Qix68c6HTLY3ypdJ2to6iY07bvX2qS1qYphrwlcv3zceBn/jZCO5lrp7qjnwtAE9BD1xpVjXKmbQm/3ISly5yHEBNz5OXK+y5tW3zmjhZxtq49PeyDEENpP1KTdd85YIcU7CmRfjQchptDoLY1Pk6TdbEKmCvHW7trS/tFoTF6OfZa341PyaWJOlpZDElqLIMQqVeXW7479OvdDbg2/El9ggSMkWZQVuy3tpxeibg6NyuT0Ij0kmXi251vab+T1hG0yMlpITra1n/Zm3M8oKxVYvSD0BRYRYhJ6NIUQgwiGwggxiVjsJ0IAIQgBhCAEEIIQQAhCwD6MXw8Ze3w1bT4vEo1Je9+j+GojR4gB+GeWtiQDIUlmUgmhh5gkZBohRuFLwtIvQpLIlwBCjEGvo0zNIMQY9L1c6+EoQjKpfyAkmUICCOEIgdRegyAkqaesBYSYwuz8StLu5zJ+ttfqk3Wsztpu5Uk+HCEZCEIQAghBCCAEIYAQhABCEAIIAYQgBBCCEEAIQgAhCAGEAEIQAghBCCAEIYAQhABCACEIAQtCopTBGKJayAx1MIaAFvKMOhjDiBYyrLJELWxHOxjSQnwqPSrL1MQ2dO0vqkxujLJeqDSo3Ffx0+j/TQNP1FrX/KDKqH7xlwADADHHxixr3zsSAAAAAElFTkSuQmCC"

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bb663f3714c694d4f8d32711debbed28.png";

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = ShareMenuDirective;
	
	ShareMenuDirective.$inject = [];
	function ShareMenuDirective() {
	    return {
	        restrict: 'E',
	        scope: {
	            surveyId: '=',
	            postId: '='
	        },
	        replace: true,
	        controller: ShareMenuController,
	        template: __webpack_require__(780)
	    };
	}
	
	ShareMenuController.$inject = ['$scope', '$routeParams', 'Util', '$window'];
	function ShareMenuController($scope, $routeParams, Util, $window) {}

/***/ }),
/* 780 */
/***/ (function(module, exports) {

	module.exports = "<div class=modal-body> <share-menu post-id=postId></share-menu> </div> ";

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = PostExportDirective;
	
	PostExportDirective.$inject = [];
	function PostExportDirective() {
	    return {
	        restrict: 'E',
	        scope: {
	            filters: '='
	        },
	        controller: PostExportController,
	        template: __webpack_require__(782)
	    };
	}
	
	PostExportController.$inject = ['$scope', '$translate', 'PostEndpoint', 'ConfigEndpoint', 'Notify', '$q', 'PostFilters'];
	function PostExportController($scope, $translate, PostEndpoint, ConfigEndpoint, Notify, $q, PostFilters) {
	    $scope.loading = false;
	    $scope.exportPosts = exportPosts;
	
	    function exportPosts() {
	        Notify.confirm('notify.post.export').then(function (message) {
	            $scope.loading = true;
	
	            if (!$scope.filters) {
	                $scope.filters = [];
	            }
	
	            var format = 'csv',
	                //@todo handle more formats
	            // Prepare filters for export
	            query = angular.extend({}, PostFilters.getQueryParams($scope.filters), {
	                format: format
	            }),
	                site = ConfigEndpoint.get({ id: 'site' }).$promise,
	                postExport = PostEndpoint.export(query);
	
	            // Save export data to file
	            $q.all([site, postExport]).then(function (response) {
	
	                var filename = response[0].name + '-' + new Date().toISOString().substring(0, 10) + '.' + format,
	                    data = response[1].data;
	
	                // Create anchor link
	                var anchor = angular.element('<a/>');
	
	                // ...and attach it.
	                angular.element(document.body).append(anchor);
	
	                // Set attributes
	                anchor.attr({
	                    href: 'data:attachment/' + format + ';charset=utf-8,' + encodeURIComponent(data),
	                    download: filename
	                });
	
	                // Show file download dialog
	                anchor[0].click();
	
	                // ... and finally remove the link
	                anchor.remove();
	                $scope.loading = false;
	            });
	        });
	    }
	}

/***/ }),
/* 782 */
/***/ (function(module, exports) {

	module.exports = "<a ng-click=exportPosts() translate=app.export_to_csv>Export to CSV</a> ";

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = [function () {
	
	    return {
	        restrict: 'E',
	        replace: true,
	        scope: {
	            view: '='
	        },
	        template: __webpack_require__(784)
	    };
	}];

/***/ }),
/* 784 */
/***/ (function(module, exports) {

	module.exports = "<div class=main-col> <span translate translate-values=\"{value: '{{view}}'}\"> feature_limits.view_unavailable </span> <p><a class=button href=/settings/plan translate>limit.upgrade</a></p> </div> ";

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = ['$q', '$location', '$rootScope', '$translate', 'SavedSearchEndpoint', '_', 'Notify', 'ViewHelper', 'RoleEndpoint', function ($q, $location, $rootScope, $translate, SavedSearchEndpoint, _, Notify, ViewHelper, RoleEndpoint) {
	    return {
	        restrict: 'E',
	        replace: true,
	        template: __webpack_require__(786),
	        scope: {
	            savedSearch: '='
	        },
	        link: function link($scope, $element, $attrs) {
	            if (!$scope.savedSearch) {
	                throw {
	                    message: 'savedsearchEditor must be passed a saved-search parameter'
	                };
	            }
	
	            $scope.featuredEnabled = function () {
	                return $rootScope.hasPermission('Manage Posts');
	            };
	
	            $scope.isAdmin = $rootScope.isAdmin;
	
	            $scope.views = ViewHelper.views();
	
	            $scope.cpySavedSearch = _.clone($scope.savedSearch);
	
	            $scope.save = function (savedSearch) {
	                var persist = savedSearch.id ? SavedSearchEndpoint.update : SavedSearchEndpoint.save;
	                persist(savedSearch).$promise.then(function (savedSearch) {
	                    $location.url('/savedsearches/' + savedSearch.id);
	                    $scope.savedSearch = _.clone(savedSearch);
	                    $scope.$parent.closeModal();
	                    $rootScope.$broadcast('event:savedSearch:update');
	                }, function (errorResponse) {
	                    Notify.apiErrors(errorResponse);
	                });
	            };
	
	            $scope.cancel = $scope.$parent.closeModal;
	        }
	    };
	}];

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"modal-body savedsearch-editor\"> <div class=\"form-field title\"> <label translate>set.name_savedsearch</label> <input type=text placeholder=\"Name your Saved Search...\" ng-model=cpySavedSearch.name /> </div> <div class=form-field> <label class=input-label translate>set.description</label> <textarea ng-model=cpySavedSearch.description />\n    </div>\n\n    <div class=\"form-field switch\" ng-if=featuredEnabled()>\n        <label for=saved-search-featured>\n            <translate translate=saved_search.featured>Featured</translate>\n            <span class=tooltip>\n                <svg class=iconic>\n                    <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#question-mark></use>\n                </svg>\n                <span class=bug translate=saved_search.featured_tooltip>Featured searches appear to all users in <br>the \"Saved Searches\" menu</span>\n            </span>\n        </label>\n        <div class=toggle-switch>\n            <input class=tgl id=saved-search-featured type=checkbox ng-model=cpySavedSearch.featured>\n            <label class=tgl-btn for=saved-search-featured value=1></label>\n        </div>\n    </div>\n\n    <div class=form-field>\n        <label class=input-label translate=set.default_viewing_mode>Default viewing mode</label>\n        <div class=custom-select>\n            <select ng-options=\"view.name as view.display_name for view in views\" ng-model=cpySavedSearch.view>\n            </select>\n        </div>\n    </div>\n    \n    <role-selector model=savedSearch title=\"'app.who_can_see_this'\"></role-selector>\n    <div class=modal-actions>\n        <div class=form-field>\n            <button type=button class=\"button-link modal-trigger\" ng-click=cancel() translate>app.cancel</button>\n            <button type=button class=\"button-alpha modal-trigger\" ng-click=save(cpySavedSearch) translate>app.save_and_close</button>\n        </div>\n    </div>\n</div> ";

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = ['$rootScope', 'ModalService', 'PostFilters', function ($rootScope, ModalService, PostFilters) {
	    return {
	        restrict: 'E',
	        template: __webpack_require__(788),
	        link: function link($scope, $element, $attrs) {
	
	            // Init an empty saved search
	            $scope.savedSearch = {
	                view: 'map',
	                role: []
	            };
	
	            // Compare current filters to default filters
	            $scope.hasFilters = function () {
	                return PostFilters.hasFilters($scope.filters);
	            };
	
	            $scope.saveSearch = function () {
	                // Copy the current filters into our search..
	                $scope.savedSearch.filter = $scope.filters;
	                ModalService.openTemplate('<saved-search-editor saved-search="savedSearch"></saved-search-editor>', 'set.create_savedsearch', 'star', $scope, false, false);
	            };
	
	            $scope.clearFilters = function () {
	                PostFilters.clearFilters();
	            };
	        }
	    };
	}];

/***/ }),
/* 788 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"savedsearch-create form-field\" ng-show=hasFilters()> <button ng-click=saveSearch() ng-show=$root.loggedin class=button-alpha type=button translate> set.save_savedsearch </button> <button ng-click=clearFilters() class=button-link type=button translate> set.clear_search </button> </div> ";

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = ['$q', '$rootScope', 'SavedSearchEndpoint', '_', 'Notify', 'PostFilters', function ($q, $rootScope, SavedSearchEndpoint, _, Notify, PostFilters) {
	    return {
	        restrict: 'E',
	        template: __webpack_require__(790),
	        link: function link($scope, $element, $attrs) {
	            if (!$scope.savedSearch) {
	                throw {
	                    message: 'savedsearchEditor must be passed a saved-search parameter'
	                };
	            }
	
	            // Compare current filters to saved filters
	            $scope.filtersChanged = function () {
	                return !angular.equals($scope.filters, $scope.savedSearch.filter);
	            };
	
	            $scope.saveSearch = function () {
	                // Copy the current filters into our search..
	                $scope.savedSearch.filter = PostFilters.getQueryParams($scope.filters);
	
	                SavedSearchEndpoint.update($scope.savedSearch).$promise.then(function (savedSearch) {
	                    $rootScope.$broadcast('event:savedSearch:update');
	                }, function (errorResponse) {
	                    Notify.apiErrors(errorResponse);
	                });
	            };
	
	            $scope.resetSearch = function () {
	                PostFilters.setFilters($scope.savedSearch.filter);
	                // Slight hack: to avoid incorrectly detecting a changed search
	                // we push the real query we're using back into the saved search.
	                // This will now include any default params we excluded before
	                $scope.savedSearch.filter = angular.copy(PostFilters.getFilters());
	            };
	        }
	    };
	}];

/***/ }),
/* 790 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"savedsearch-update form-field\" ng-show=filtersChanged()> <button ng-click=saveSearch() ng-show=canEdit class=button-alpha type=button translate> set.update_savedsearch </button> <button ng-click=resetSearch() class=button-link type=button translate> set.reset_savedsearch </button> </div> ";

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = SavedSearchModal;
	
	SavedSearchModal.$inject = [];
	function SavedSearchModal() {
	    return {
	        restrict: 'E',
	        scope: true,
	        controller: SavedSearchModalController,
	        template: __webpack_require__(792)
	    };
	}
	
	SavedSearchModalController.$inject = ['$scope', '$element', '$attrs', '$rootScope', '$location', 'UserEndpoint', 'SavedSearchEndpoint', '_', 'ModalService'];
	function SavedSearchModalController($scope, $element, $attrs, $rootScope, $location, UserEndpoint, SavedSearchEndpoint, _, ModalService) {
	    var users = [];
	
	    $scope.searchSearches = searchSearches;
	    $scope.createNewSearch = createNewSearch;
	    $scope.goToSearch = goToSearch;
	    activate();
	
	    // Reload searches on login / logout events
	    $scope.$on('event:authentication:logout:succeeded', loadSavedSearches);
	    $scope.$on('event:authentication:login:succeeded', loadSavedSearches);
	    $scope.$on('savedSearch:update', loadSavedSearches);
	
	    function activate() {
	        loadSavedSearches();
	    }
	
	    // Load searches + users
	    function loadSavedSearches(query) {
	        $scope.searches = [];
	        query = query || {};
	        SavedSearchEndpoint.query(query).$promise.then(function (searches) {
	            $scope.searches = searches;
	
	            angular.forEach($scope.searches, function (search) {
	                // if this search has a user, and its not the currentUser
	                if (_.isObject(search.user) && search.user.id !== _.result($rootScope.currentUser, 'userId')) {
	                    // Load the user (if we haven't already)
	                    if (!users[search.user.id]) {
	                        users[search.user.id] = UserEndpoint.getFresh({ id: search.user.id });
	                    }
	                    // Save user info onto the search itself
	                    search.user = users[search.user.id];
	                }
	            });
	        });
	    }
	
	    function createNewSearch() {
	        // Copy the current filters into our search..
	        ModalService.openTemplate('<saved-search-editor saved-search="savedSearch"></saved-search-editor>', 'set.create_savedsearch', 'star', $scope, false, false);
	    }
	    function searchSearches(query) {
	        loadSavedSearches({
	            q: query
	        });
	    }
	
	    /**
	     * @param searchId: the saved search id, used to identify it in the url path.
	     * We are just closing the modal before we go to the new saved search the user selected in the frontend.
	     * See: https://waffle.io/ushahidi/platform/cards/598289fa17b93500a65be936
	     */
	    function goToSearch(searchId) {
	        ModalService.close();
	        $location.url('/savedsearches/' + searchId);
	    }
	}

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=form-field> <label class=hidden translate=set.find_a_saved_search>Find a saved search</label> <div class=input-with-icon> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#magnifying-glass></use> </svg> <input type=search ng-model=savedSearchQuery placeholder=\"{{ 'set.find_a_saved_search' | translate }}\" ng-keydown=searchSearches(savedSearchQuery)> </div> </div> <div class=modal-body> <div class=listing> <div class=listing-item ng-repeat=\"search in searches\"> <div class=listing-item-primary> <h2 class=listing-item-title><a href=# ng-click=goToSearch(search.id)>{{search.name}}</a></h2> </div> </div> </div> </div> ";

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = SavedSearchModeContext;
	
	SavedSearchModeContext.$inject = [];
	
	function SavedSearchModeContext() {
	    return {
	        restrict: 'E',
	        controller: SavedSearchModeContextController,
	        template: __webpack_require__(794)
	    };
	}
	
	SavedSearchModeContextController.$inject = ['$scope', '$translate', '$location', '$rootScope', 'NotificationEndpoint', 'SavedSearchEndpoint', 'Notify', '_', 'ModalService'];
	function SavedSearchModeContextController($scope, $translate, $location, $rootScope, NotificationEndpoint, SavedSearchEndpoint, Notify, _, ModalService) {
	    // Show Add Notification link
	    $scope.showNotificationLink = true;
	    $scope.canEdit = false;
	    $scope.notification = false;
	
	    $scope.saveNotification = saveNotification;
	    $scope.removeNotification = removeNotification;
	    $scope.editSavedSearch = editSavedSearch;
	    $scope.deleteSavedSearch = deleteSavedSearch;
	
	    activate();
	
	    function activate() {
	        $scope.canEdit = canEdit($scope.savedSearch);
	
	        NotificationEndpoint.query({ set: $scope.savedSearch.id, ignore403: true, user: 'me' }, function (notifications) {
	            // show link if subscription does not exist
	            $scope.showNotificationLink = notifications.length === 0;
	            if (notifications.length) {
	                $scope.notification = notifications[0];
	            }
	        }, angular.noop);
	    }
	
	    // Check if we can edit
	    function canEdit(savedSearch) {
	        return _.contains(savedSearch.allowed_privileges, 'update');
	    }
	
	    function editSavedSearch() {
	        ModalService.openTemplate('<saved-search-editor saved-search="savedSearch"></saved-search-editor>', 'set.edit_search_settings', 'star', $scope, false, false);
	        //$rootScope.$emit('savedSearchEditor:show', $scope.collection);
	    }
	
	    function deleteSavedSearch() {
	        Notify.confirm('notify.savedsearch.delete_savedsearch_confirm').then(function () {
	            SavedSearchEndpoint.delete({
	                id: $scope.savedSearch.id
	            }).$promise.then(function () {
	                $location.url('/');
	                $rootScope.$broadcast('savedSearch:update');
	            }, function (errorResponse) {
	                Notify.apiErrors(errorResponse);
	            });
	        });
	    }
	
	    function saveNotification(savedSearch) {
	        var notification = { set: savedSearch.id };
	
	        NotificationEndpoint.save(notification).$promise.then(function (notification) {
	            // No need to show the link after subscription
	            $scope.showNotificationLink = false;
	            $scope.notification = notification;
	            Notify.notify('notify.notification.add', { set: savedSearch.name });
	        });
	    }
	
	    function removeNotification() {
	        Notify.confirm('notify.notification.delete_confirm').then(function () {
	            NotificationEndpoint.delete($scope.notification).$promise.then(function (notification) {
	                $scope.showNotificationLink = true;
	                Notify.notify('notify.notification.destroy_notification_success', { name: notification.name });
	            });
	        });
	    }
	}

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"mode-context init\" dropdown> <header class=mode-context-header> <ol class=breadcrumbs ng-controller=\"navigation as nav\"> <li><a href=/ >{{nav.site.name}}</a></li> </ol> <h1 class=mode-context-title> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#star></use> </svg> {{savedSearch.name}} </h1> </header> <span class=mode-context-trigger dropdown-toggle> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> <span class=\"label hidden\" translate>app.show_more_less</span> </span> <div class=mode-context-body> <p ng-if=savedSearch.description>{{savedSearch.description}}</p> <ul class=metadata> <li> <span class=\"status-indicator public tooltip\" ng-if=!savedSearch.role> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#globe></use> </svg> <span class=bug translate=saved_search.visible_to_public>This saved search is visible to the public</span> </span> <span class=\"status-indicator yellow tooltip\" ng-if=savedSearch.role> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#globe></use> </svg> <span class=bug translate=saved_search.visible_to_roles translate-values=\"{ roles: savedSearch.role.join(', ') }\">This saved search is visible to ...</span> </span> </li> <li> <span ng-if=savedSearch.user> <span translate=app.created_by translate-values=\"{ author : savedSearch.user.realname }\">Created by</span> </span> </li> </ul> <div class=form-field ng-if=canEdit dropdown> <button type=button data-modal=edit-savedSearch ng-click=editSavedSearch()> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#pencil></use> </svg> <span class=button-label translate>app.edit</span> </button> <button type=button data-toggle=dropdown-menu class=init dropdown-toggle> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#ellipses></use> </svg> <span class=\"button-label hidden\" translate>app.more</span> </button> <ul class=\"dropdown-menu init\" dropdown-menu> <li ng-if=showNotificationLink> <a ng-click=saveNotification(savedSearch)> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#bell></use> </svg> <span class=label ng-click=saveNotification(savedSearch) translate=app.get_notifications>Get notifications</span> </a> </li> <li ng-if=!showNotificationLink> <a ng-click=removeNotification(savedSearch)> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#bell></use> </svg> <span class=label translate=app.turn_off_notifications>Turn off notifications</span> </a> </li> <li> <a ng-click=deleteSavedSearch()> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#trash></use> </svg> <span class=label translate=app.delete></span> </a> </li> </ul> </div> <div class=form-field ng-if=\"!canEdit && $root.loggedin\"> <button type=button ng-if=showNotificationLink ng-click=saveNotification(savedSearch)> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#bell></use> </svg> <span class=button-label translate=app.get_notifications>Get notifications</span> </button> <button type=button ng-if=!showNotificationLink class=button-flat> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#bell></use> </svg> <span class=button-label translate=app.turn_off_notifications>Turn off notifications</span> </button> </div> <div class=form-field> <a ng-href=/views/{{collection.view}} type=button class=button-link> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#arrow-left></use> </svg> <span class=button-label translate=app.return_to_all_posts>Return to all posts</span> </a> </div> <mode-context-form-filter></mode-context-form-filter> <post-active-filters></post-active-filters> <saved-search-update></saved-search-update> </div> </div> ";

/***/ }),
/* 795 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = CollectionsService;
	
	CollectionsService.$inject = ['ModalService', 'Notify', '$location', 'CollectionEndpoint'];
	function CollectionsService(ModalService, Notify, $location, CollectionEndpoint) {
	    return {
	        showCollectionList: showCollectionList,
	        showAddToCollection: showAddToCollection,
	        editCollection: editCollection,
	        createCollection: createCollection,
	        deleteCollection: deleteCollection
	    };
	
	    function showCollectionList() {
	        ModalService.openTemplate('<collection-listing toggle-mode="false"></collection-listing>', 'app.collections', 'grid-three-up', false, true, true);
	    }
	
	    function showAddToCollection(posts) {
	        var scope = {
	            posts: posts
	        };
	
	        ModalService.openTemplate('<collection-listing toggle-mode="true" posts="posts"></collection-listing>', 'app.edit_collection', 'grid-three-up', scope, true, true);
	    }
	
	    function editCollection(collection) {
	        var scope = {
	            collection: collection
	        };
	
	        ModalService.openTemplate('<collection-editor collection="collection"></collection-editor>', 'app.edit_collection', 'grid-three-up', scope, false, false);
	    }
	
	    function createCollection(posts) {
	        var scope = {
	            posts: posts
	        };
	
	        ModalService.openTemplate('<collection-editor posts="posts"></collection-editor>', 'app.create_collection', 'grid-three-up', scope, false, false);
	    }
	
	    function deleteCollection(collection) {
	        Notify.confirm('notify.collection.delete_collection_confirm').then(function () {
	            CollectionEndpoint.delete({
	                collectionId: collection.id
	            }).$promise.then(function () {
	                $location.url('/');
	            }, function (errorResponse) {
	                Notify.apiErrors(errorResponse);
	            });
	        });
	    }
	}

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = CollectionModeContext;
	
	CollectionModeContext.$inject = [];
	
	function CollectionModeContext() {
	    return {
	        restrict: 'E',
	        controller: CollectionModeContextController,
	        template: __webpack_require__(797)
	    };
	}
	
	CollectionModeContextController.$inject = ['$scope', '$rootScope', '$translate', '$location', 'NotificationEndpoint', 'CollectionEndpoint', 'Notify', '_', 'CollectionsService'];
	function CollectionModeContextController($scope, $rootScope, $translate, $location, NotificationEndpoint, CollectionEndpoint, Notify, _, CollectionsService) {
	    $scope.editCollection = editCollection;
	    $scope.deleteCollection = deleteCollection;
	    $scope.saveNotification = saveNotification;
	    $scope.removeNotification = removeNotification;
	
	    // Show Add Notification link
	    $scope.showNotificationLink = true;
	    $scope.canEdit = false;
	    $scope.notification = false;
	
	    activate();
	
	    function activate() {
	        $scope.canEdit = canEdit($scope.collection);
	
	        NotificationEndpoint.query({ set: $scope.collection.id, ignore403: true, user: 'me' }, function (notifications) {
	            // show link if subscription does not exist
	            $scope.showNotificationLink = notifications.length === 0;
	            if (notifications.length) {
	                $scope.notification = notifications[0];
	            }
	        }, angular.noop);
	    }
	
	    function canEdit(collection) {
	        return _.contains(collection.allowed_privileges, 'update');
	    }
	
	    function editCollection() {
	        CollectionsService.editCollection($scope.collection);
	    }
	
	    function deleteCollection() {
	        CollectionsService.deleteCollection($scope.collection);
	    }
	
	    function saveNotification(collection) {
	        var notification = { set: collection.id };
	        NotificationEndpoint.save(notification).$promise.then(function (notification) {
	            // No need to show the link after subscription
	            $scope.showNotificationLink = false;
	            $scope.notification = notification;
	            Notify.notify('notify.notification.add', { set: collection.name });
	        });
	    }
	
	    function removeNotification() {
	        Notify.confirm('notify.notification.delete_confirm').then(function () {
	            NotificationEndpoint.delete($scope.notification).$promise.then(function (notification) {
	                $scope.showNotificationLink = true;
	                Notify.notify('notify.notification.destroy_notification_success', { name: notification.name });
	            });
	        });
	    }
	}

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"mode-context init\" dropdown> <header class=mode-context-header> <ol class=breadcrumbs ng-controller=\"navigation as nav\"> <li><a href=/ >{{ nav.site.name }}</a></li> </ol> <h1 class=mode-context-title> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#grid-three-up></use> </svg> {{collection.name}} </h1> </header> <span class=mode-context-trigger dropdown-toggle> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> <span class=\"label hidden\" translate>app.show_more_less</span> </span> <div class=mode-context-body> <p ng-if=collection.description>{{collection.description}}</p> <ul class=metadata> <li> <span class=\"status-indicator public tooltip\" ng-if=\"!collection.role || collection.role.length == 0\"> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#globe></use> </svg> <span class=bug translate=collection.visible_to_public>This Collection is visible to the public</span> </span> <span class=\"status-indicator yellow tooltip\" ng-if=\"collection.role.length > 0\"> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#globe></use> </svg> <span class=bug translate=collection.visible_to_roles translate-values=\"{ roles: collection.role.join(', ') }\">This Collection is visible to ...</span> </span> </li> <li> <span ng-if=collection.user> <span translate=app.created_by translate-values=\"{ author : collection.user.realname }\">Created by</span> </span> </li> </ul> <div class=form-field ng-if=canEdit dropdown> <button type=button data-modal=edit-collection ng-click=editCollection()> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#pencil></use> </svg> <span class=button-label translate>app.edit</span> </button> <button type=button data-toggle=dropdown-menu class=init dropdown-toggle> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#ellipses></use> </svg> <span class=\"button-label hidden\" translate>app.more</span> </button> <ul class=\"dropdown-menu init\" dropdown-menu> <li ng-if=showNotificationLink> <a ng-click=saveNotification(collection)> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#bell></use> </svg> <span class=label ng-click=saveNotification(collection) translate=app.get_notifications>Get notifications</span> </a> </li> <li ng-if=!showNotificationLink> <a ng-click=removeNotification(collection)> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#bell></use> </svg> <span class=label translate=app.turn_off_notifications>Turn off notifications</span> </a> </li> <li> <a ng-click=deleteCollection()> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#trash></use> </svg> <span class=label translate=app.delete></span> </a> </li> </ul> </div> <div class=form-field ng-if=\"!canEdit && $root.loggedin\"> <button type=button ng-if=showNotificationLink ng-click=saveNotification(collection)> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#bell></use> </svg> <span class=button-label translate=app.get_notifications>Get notifications</span> </button> <button type=button ng-if=!showNotificationLink class=button-flat> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#bell></use> </svg> <span class=button-label translate=app.turn_off_notifications>Turn off notifications</span> </button> </div> <div class=form-field> <a ng-href=/views/{{collection.view}} type=button class=button-link> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#arrow-left></use> </svg> <span class=button-label translate=app.return_to_all_posts>Return to all posts</span> </a> </div> <mode-context-form-filter></mode-context-form-filter> <post-active-filters></post-active-filters> </div> </div> ";

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = CollectionEditor;
	
	CollectionEditor.$inject = [];
	function CollectionEditor() {
	    return {
	        restrict: 'E',
	        scope: {
	            collection: '<',
	            posts: '='
	        },
	        controller: CollectionEditorController,
	        template: __webpack_require__(799)
	    };
	}
	
	CollectionEditorController.$inject = ['$scope', '$q', '$location', '$translate', '$rootScope', 'CollectionEndpoint', '_', 'Notify', 'ViewHelper', 'RoleEndpoint', 'CollectionsService'];
	function CollectionEditorController($scope, $q, $location, $translate, $rootScope, CollectionEndpoint, _, Notify, ViewHelper, RoleEndpoint, CollectionsService) {
	    $scope.isAdmin = $rootScope.isAdmin;
	    $scope.views = ViewHelper.views();
	
	    $scope.featuredEnabled = featuredEnabled;
	    $scope.cancel = cancel;
	    $scope.saveCollection = saveCollection;
	
	    activate();
	
	    function activate() {
	        if (!$scope.collection) {
	            setBasicCollection();
	        } else {
	            $scope.cpyCollection = angular.copy($scope.collection);
	        }
	
	        RoleEndpoint.query().$promise.then(function (roles) {
	            $scope.roles = roles;
	        });
	    }
	
	    // Set default view for Collection to be Map
	    function setBasicCollection() {
	        $scope.cpyCollection = {};
	        $scope.cpyCollection.view = 'map';
	        $scope.cpyCollection.role = [];
	    }
	
	    function featuredEnabled() {
	        return $rootScope.hasPermission('Manage Posts');
	    }
	
	    function cancel() {
	        $scope.$parent.closeModal();
	    }
	
	    function saveCollection(collection) {
	        // Are we creating or updating?
	        var persist = collection.id ? CollectionEndpoint.update : CollectionEndpoint.save;
	
	        // Collection endpoint uses collectionId so make sure thats set
	        collection.collectionId = collection.id;
	
	        // Save the collection
	        persist(collection).$promise.then(function (savedCollection) {
	            $scope.collection = angular.copy(savedCollection);
	            // and close the modal
	            $scope.$parent.closeModal();
	            // If we were adding posts, show the add to collection dialog again
	            if ($scope.posts) {
	                CollectionsService.showAddToCollection($scope.posts);
	            } else {
	                // Broadcast the updated collection
	                $rootScope.$broadcast('collection:update', savedCollection);
	            }
	            Notify.notify(collection.id ? 'notify.collection.updated_collection' : 'notify.collection.created_collection', { collection: savedCollection.name });
	        }, function (errorResponse) {
	            Notify.apiErrors(errorResponse);
	        });
	    }
	}

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=modal-body> <div class=\"form-field title\"> <label translate>set.collection_name</label> <input type=text ng-model=cpyCollection.name placeholder=\"{{'set.name_your_collection'|translate}}\"> </div> <div class=form-field> <label translate> set.description </label> <textarea ng-model=cpyCollection.description></textarea> </div> <div class=\"form-field switch\" ng-if=featuredEnabled()> <label> <span translate> set.featured </span> <span class=tooltip> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#question-mark></use> </svg> <span class=bug translate>set.featured_collection_tooltip</span> </span> </label> <div class=toggle-switch> <input class=tgl id=switch1 type=checkbox ng-model=cpyCollection.featured> <label class=tgl-btn for=switch1></label> </div> </div> <div class=form-field> <label translate>set.default_viewing_mode</label> <div class=custom-select> <select ng-options=\"view.name as view.display_name for view in views\" ng-model=cpyCollection.view> </select> </div> </div> <role-selector model=cpyCollection title=\"'app.who_can_see_this'\"></role-selector> <div class=modal-actions> <div class=form-field> <button type=button class=\"button-link modal-trigger\" ng-click=cancel() translate>app.cancel</button> <button type=button class=\"button-alpha modal-trigger\" ng-click=saveCollection(cpyCollection) translate>app.save_and_close</button> </div> </div> </div> ";

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = CollectionListing;
	
	CollectionListing.$inject = [];
	
	function CollectionListing() {
	    return {
	        restrict: 'E',
	        replace: true,
	        scope: {
	            'isToggleMode': '<toggleMode',
	            'posts': '='
	        },
	        controller: CollectionListingController,
	        template: __webpack_require__(801)
	    };
	}
	
	CollectionListingController.$inject = ['$rootScope', '$scope', '$translate', '$location', '$q', 'Notify', 'CollectionEndpoint', '_', 'CollectionsService'];
	function CollectionListingController($rootScope, $scope, $translate, $location, $q, Notify, CollectionEndpoint, _, CollectionsService) {
	    var collectionsPath = '/collections/';
	
	    $scope.postInCollection = postInCollection;
	    $scope.toggleCollection = toggleCollection;
	    $scope.addToPostsSet = addToPostsSet;
	    $scope.collectionClickHandler = collectionClickHandler;
	    $scope.createNewCollection = createNewCollection;
	    $scope.searchCollections = loadCollections;
	    $scope.currentUser = $rootScope.currentUser;
	
	    activate();
	
	    function activate() {
	        loadCollections();
	    }
	
	    function loadCollections(collectionQuery) {
	        if ($scope.isToggleMode) {
	            $scope.collections = CollectionEndpoint.editableByMe({ q: collectionQuery });
	        } else {
	            $scope.collections = CollectionEndpoint.query({ q: collectionQuery });
	        }
	    }
	
	    function postInCollection(collection) {
	        // If we are dealing with a single model we want to mark
	        // all collections it exists in as checked
	        // If we are dealing with multiple posts the user
	        // does not have the option to remove posts from collections only to add
	
	        // TODO figure out to set newly created checkbox checked once it's been addToCollection
	        return $scope.posts.length === 1 ? _.contains($scope.posts[0].sets, String(collection.id)) : false;
	    }
	
	    // Update post set with collection(s) it has been added to
	    function addToPostsSet(collectionId) {
	        _.each($scope.posts, function (post) {
	            post.sets.push(collectionId);
	        });
	    }
	
	    // Add the post(s) to a given collection
	    function addToCollection(selectedCollection) {
	        var collectionId = selectedCollection.id,
	            collection = selectedCollection.name;
	        var calls = [];
	        // Create collection update calls for all posts
	        // TODO: allow many to one update for posts to collection
	        // on api
	        _.each($scope.posts, function (post) {
	            calls.push(CollectionEndpoint.addPost({ 'collectionId': collectionId, 'id': post.id }));
	        });
	        $q.all(calls).then(function () {
	            // Update the posts sets
	            $scope.addToPostsSet(String(collectionId));
	            Notify.notify('notify.collection.add_to_collection', { collection: collection });
	        }, function (errorResponse) {
	            Notify.apiErrors(errorResponse);
	        });
	    }
	
	    // Remove post(s) from a given collection
	    function removeFromCollection(selectedCollection) {
	        var collectionId = selectedCollection.id,
	            collection = selectedCollection.name;
	        var calls = [];
	        _.each($scope.posts, function (post) {
	            calls.push(CollectionEndpoint.removePost({ 'collectionId': collectionId, 'id': post.id }));
	        });
	        $q.all(calls).then(function () {
	            _.each($scope.posts, function (post) {
	                post.sets = _.without(post.sets, String(collectionId));
	            });
	            Notify.notify('notify.collection.removed_from_collection', { collection: collection });
	        }, function (errorResponse) {
	            Notify.apiErrors(errorResponse);
	        });
	    }
	
	    // Handle behaviour of the collection listing item click
	    // In Listing mode: a click will take the user to the collections page
	    // In Toggle mode: a click will select a given collection
	    function collectionClickHandler(collection) {
	        $scope.isToggleMode ? toggleCollection(collection) : goToCollection(collection);
	    }
	
	    // This feature is only available in Lisiting mode
	    // When a user clicks on a collection lisiting item
	    // they will be directed to the collection page
	    function goToCollection(collection) {
	        $scope.$parent.closeModal();
	        $location.path(collectionsPath + collection.id + '/' + collection.view);
	    }
	
	    // Toggle a post as selected or not
	    // This behaviour is specific to the Toggle mode of collection listing
	    // It allows a user to select a collection by clicking on the whole row
	    function toggleCollection(selectedCollection) {
	        // If we are dealing with a single post the user can add and remove from collection
	        // For mass updates of many post the user is only permitted to add to collection
	        if ($scope.posts.length === 1) {
	            if (_.contains($scope.posts[0].sets, String(selectedCollection.id))) {
	                removeFromCollection(selectedCollection);
	            } else {
	                addToCollection(selectedCollection);
	            }
	        } else {
	            addToCollection(selectedCollection);
	        }
	    }
	
	    // This function passes flow control to the Collection Creation modal
	    // In Toggle mode: we expect the creation editor to return control to the Listing directive
	    // In the toggleMode we attach the post(s) to the event, collectionEditor will return this post(s)
	    // after the creation, along with the newly created collection
	    function createNewCollection() {
	        $scope.$parent.closeModal();
	        CollectionsService.createCollection($scope.posts);
	    }
	}

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div> <div class=modal-body style=max-height:337.26px> <div class=\"form-field search\"> <label class=hidden translate>set.find_a_collection</label> <div class=input-with-icon> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#magnifying-glass></use> </svg> <form ng-submit=searchCollections(collectionQuery)> <input name=collectionQuery ng-model=collectionQuery type=search placeholder=\"{{ 'set.find_a_collection' | translate}}\"> </form> </div> </div> <div class=\"listing init\"> <div class=listing-item ng-repeat=\"collection in collections\"> <div class=listing-item-select ng-if=isToggleMode> <input type=checkbox ng-checked=postInCollection(collection) ng-click=toggleCollection(collection)> </div> <div class=listing-item-primary> <h2 class=listing-item-title> <a ng-click=collectionClickHandler(collection)> {{collection.name}} </a> </h2> <p class=listing-item-secondary ng-if=collection.user_id> <span translate> app.by </span> <a ng-href=/users/{{collection.user_id}}> {{collection.user_id}} </a> </p> </div> </div> </div> </div> <div class=modal-actions ng-if=currentUser> <div class=form-field> <button type=button class=button-beta ng-click=createNewCollection()> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#plus></use> </svg> <span class=button-label translate>app.create_new</span> </button> </div> </div> </div> ";

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = ['$rootScope', '_', 'CollectionsService', function ($rootScope, _, CollectionsService) {
	    return {
	        restrict: 'E',
	        replace: true,
	        scope: {
	            posts: '=',
	            selectedPosts: '=',
	            onDone: '&'
	        },
	        link: function link($scope, $element, $attrs, ngModel) {
	            $scope.toggleCollection = function () {
	                // Reduce set of post of objects to only those currently selected
	                var selectedPostObjects = _.filter($scope.posts, function (post) {
	                    return _.contains($scope.selectedPosts, post.id);
	                });
	
	                CollectionsService.showAddToCollection(selectedPostObjects);
	                // Trigger done handler (clear selected posts)
	                $scope.onDone();
	            };
	        },
	        template: __webpack_require__(803)
	    };
	}];

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<button type=button class=button-beta data-modal=add-to-collection ng-click=toggleCollection()> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#grid-three-up></use> </svg> <span class=button-label translate=set.add_to_collection>Add to collection</span> </button> ";

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = ['$rootScope', 'CollectionsService', function ($rootScope, CollectionsService) {
	    return {
	        restrict: 'E',
	        replace: true,
	        scope: {
	            post: '='
	        },
	        link: function link($scope, $element, $attrs, ngModel) {
	            $scope.toggleCollection = function () {
	                // Collection toggle expects an array of posts
	                CollectionsService.showAddToCollection([$scope.post]);
	            };
	        },
	        template: __webpack_require__(805)
	    };
	}];

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<a data-modal=add-to-collection ng-click=toggleCollection()> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#grid-three-up></use> </svg> <span class=label translate=set.add_to_collection>Add to collection</span> </a> ";

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = ['$routeProvider', function ($routeProvider) {
	
	    $routeProvider.when('/', {
	        resolveRedirectTo: ['PostFilters', function (PostFilters) {
	            var mode = PostFilters.getMode();
	            var entityId = PostFilters.getModeId();
	
	            if (mode === 'collection') {
	                return '/collections/' + entityId;
	            } else if (mode === 'savedsearch') {
	                return '/savedsearches/' + entityId;
	            } else {
	                return '/views/map';
	            }
	        }]
	    }).when('/views/:view?', {
	        controller: __webpack_require__(807),
	        template: __webpack_require__(808)
	    }).when('/collections/:id/:view?', {
	        controller: __webpack_require__(809),
	        template: __webpack_require__(810),
	        resolve: {
	            collection: ['$route', 'CollectionEndpoint', function ($route, CollectionEndpoint) {
	
	                return CollectionEndpoint.get({ collectionId: $route.current.params.id }).$promise;
	            }]
	        }
	    }).when('/savedsearches/:id/:view?', {
	        controller: __webpack_require__(811),
	        template: __webpack_require__(812),
	        resolve: {
	            savedSearch: ['$route', 'SavedSearchEndpoint', function ($route, SavedSearchEndpoint) {
	                return SavedSearchEndpoint.get({ id: $route.current.params.id }).$promise;
	            }]
	        }
	    }).when('/posts/create/:id', {
	        controller: __webpack_require__(813),
	        template: __webpack_require__(814)
	    }).when('/posts/:id', {
	        controller: __webpack_require__(815),
	        template: __webpack_require__(816),
	        resolve: {
	            post: ['$route', 'PostEndpoint', function ($route, PostEndpoint) {
	                return PostEndpoint.get({ id: $route.current.params.id }).$promise;
	            }]
	        }
	    }).when('/posts/:id/edit', {
	        controller: __webpack_require__(817),
	        template: __webpack_require__(814)
	    });
	}];

/***/ }),
/* 807 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = PostViewsController;
	
	PostViewsController.$inject = ['$scope', '$translate', '$routeParams', 'PostFilters'];
	function PostViewsController($scope, $translate, $routeParams, PostFilters) {
	    // Set view based out route
	    $scope.currentView = $routeParams.view;
	
	    // Set the page title
	    $translate('post.posts').then(function (title) {
	        $scope.title = title;
	        $scope.$emit('setPageTitle', title);
	    });
	
	    PostFilters.setMode('all');
	    $scope.filters = PostFilters.getFilters();
	
	    $scope.$emit('event:allposts:show');
	    $scope.$on('$destroy', function () {
	        $scope.$emit('event:allposts:close');
	    });
	}

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div> <layout-class layout=a></layout-class> <div class=\"mode-context init\" ng-controller=\"navigation as nav\" dropdown auto-close=disabled filter-by-survey-dropdown is-open=filtersMenuOpen> <header class=mode-context-header ng-class=\"{ 'has-logo' : nav.site.image_header }\"> <h1 class=mode-context-title><a href=/ ng-bind=nav.site.name></a></h1> <img ng-if=nav.site.image_header ng-src=\"{{ nav.site.image_header }}\" class=deployment-logo /> </header> <span class=mode-context-trigger dropdown-toggle> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> <span class=\"label hidden\" translate>app.show_more_less</span> </span> <div class=mode-context-body> <p markdown-to-html=nav.site.description></p> <post-active-filters></post-active-filters> <saved-search-create></saved-search-create> <mode-context-form-filter></mode-context-form-filter> </div> </div> <main role=main> <post-view current-view=currentView filters=filters base-url=/views/ > </post-view> <ush-logo></ush-logo> </main> </div> ";

/***/ }),
/* 809 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$scope', '$translate', '$routeParams', 'PostFilters', 'collection', 'UserEndpoint', '_', function ($scope, $translate, $routeParams, PostFilters, collection, UserEndpoint, _) {
	    // Add set to the scope
	    $scope.collection = collection;
	    $scope.currentView = currentView;
	
	    activate();
	
	    function activate() {
	        setCollection(collection);
	
	        // Set the page title
	        $translate('post.posts').then(function (title) {
	            $scope.title = title;
	            $scope.$emit('setPageTitle', title);
	        });
	
	        $scope.$emit('event:collection:show', collection);
	        $scope.$on('$destroy', function () {
	            $scope.$emit('event:collection:close');
	        });
	
	        // If collection is reloaded
	        $scope.$on('collection:update', function (ev, collection) {
	            // Check it was *this* collection
	            if (collection.id === $scope.collection.id) {
	                setCollection(collection);
	            }
	        });
	
	        // Reset GlobalFilter + add set filter
	        // Ensure that ALL posts are visible under collections
	        // Set default collection status filters
	        PostFilters.setMode('collection', collection.id);
	        $scope.filters = PostFilters.getFilters();
	    }
	
	    // Set view based on route or set view
	    function currentView() {
	        return $routeParams.view || collection.view;
	    }
	
	    function setCollection(collection) {
	        $scope.collection = collection;
	        $scope.collection.user = getCollectionUser();
	    }
	
	    function getCollectionUser() {
	        return $scope.collection.user ? UserEndpoint.get({ id: $scope.collection.user.id }) : undefined;
	    }
	}];

/***/ }),
/* 810 */
/***/ (function(module, exports) {

	module.exports = "<div> <layout-class layout=a></layout-class> <collection-mode-context></collection-mode-context> <main role=main> <post-view current-view=currentView() filters=filters> </post-view> </main> </div> ";

/***/ }),
/* 811 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$scope', '$translate', '$routeParams', '_', 'PostFilters', 'savedSearch', 'UserEndpoint', 'Notify', function ($scope, $translate, $routeParams, _, PostFilters, savedSearch, UserEndpoint, Notify) {
	    // Set view based on route or set view
	    $scope.currentView = function () {
	        return $routeParams.view || savedSearch.view;
	    };
	
	    $scope.$emit('event:savedsearch:show', savedSearch);
	    $scope.$on('$destroy', function () {
	        $scope.$emit('event:savedsearch:close');
	    });
	
	    // Add set to the scope
	    $scope.savedSearch = savedSearch;
	    $scope.getSavedSearchUser = function () {
	        return $scope.savedSearch.user ? UserEndpoint.get({ id: $scope.savedSearch.user.id }) : undefined;
	    };
	    $scope.savedSearch.user = $scope.getSavedSearchUser();
	
	    $translate('post.posts').then(function (title) {
	        $scope.title = title;
	        $scope.$emit('setPageTitle', title);
	    });
	
	    // Set initial filter state
	    PostFilters.setMode('savedsearch', savedSearch.id);
	    PostFilters.setFilters(savedSearch.filter);
	    $scope.filters = PostFilters.getFilters();
	    // Slight hack: to avoid incorrectly detecting a changed search
	    // we push the real query we're using back into the saved search.
	    // This will now include any default params we excluded before
	    savedSearch.filter = angular.copy(PostFilters.getFilters());
	}];

/***/ }),
/* 812 */
/***/ (function(module, exports) {

	module.exports = "<div> <layout-class layout=a></layout-class> <saved-search-mode-context></saved-search-mode-context> <main role=main> <post-view current-view=currentView() filters=filters> </post-view> </main> </div> ";

/***/ }),
/* 813 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$scope', '$translate', '$location', '$controller', '$routeParams', 'PostEntity', 'PostEndpoint', 'FormEndpoint', function ($scope, $translate, $location, $controller, $routeParams, postEntity, PostEndpoint, FormEndpoint) {
	    $translate('post.create_post').then(function (title) {
	        $scope.title = title;
	        $scope.$emit('setPageTitle', title);
	    });
	
	    $scope.post = postEntity();
	
	    PostEndpoint.options().$promise.then(function (options) {
	        $scope.post.allowed_privileges = options.allowed_privileges;
	    });
	
	    FormEndpoint.getFresh({ id: $routeParams.id }).$promise.then(function (form) {
	        $scope.form = form;
	    });
	}];

/***/ }),
/* 814 */
/***/ (function(module, exports) {

	module.exports = "<post-editor post=post form=form ng-if=form.id></post-editor> ";

/***/ }),
/* 815 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$scope', '$rootScope', 'post', '$translate', '$q', '$filter', '$location', 'PostEndpoint', 'CollectionEndpoint', 'UserEndpoint', 'TagEndpoint', 'FormAttributeEndpoint', 'FormStageEndpoint', 'FormEndpoint', 'Maps', '_', 'Notify', 'moment', 'PostSurveyService', function ($scope, $rootScope, post, $translate, $q, $filter, $location, PostEndpoint, CollectionEndpoint, UserEndpoint, TagEndpoint, FormAttributeEndpoint, FormStageEndpoint, FormEndpoint, Maps, _, Notify, moment, PostSurveyService) {
	    $rootScope.setLayout('layout-c');
	    $scope.post = post;
	    $scope.post_task = {};
	    $scope.hasPermission = $rootScope.hasPermission;
	    $scope.canCreatePostInSurvey = PostSurveyService.canCreatePostInSurvey;
	    $scope.mapDataLoaded = false;
	    $scope.form_attributes = [];
	    $scope.publishedFor = function () {
	        if ($scope.post.status === 'draft') {
	            return 'post.publish_for_you';
	        }
	        if (!_.isEmpty($scope.post.published_to)) {
	            return $scope.post.published_to.join(', ');
	        }
	
	        return 'post.publish_for_everyone';
	    };
	
	    $scope.stageIsComplete = function (stageId) {
	        return _.includes($scope.post.completed_stages, stageId);
	    };
	
	    // Set page title to post title, if there is one available.
	    if (post.title && post.title.length) {
	        $scope.$emit('setPageTitle', post.title);
	    } else {
	        $translate('post.post_details').then(function (title) {
	            $scope.title = title;
	            $scope.$emit('setPageTitle', title);
	        });
	    }
	
	    // Load the post form
	    if ($scope.post.form && $scope.post.form.id) {
	        $q.all([FormEndpoint.getFresh({ id: $scope.post.form.id }), FormStageEndpoint.queryFresh({ formId: $scope.post.form.id }).$promise, FormAttributeEndpoint.queryFresh({ formId: $scope.post.form.id }).$promise, TagEndpoint.queryFresh().$promise]).then(function (results) {
	            $scope.form = results[0];
	            $scope.form_name = results[0].name;
	            $scope.form_description = results[0].description;
	            $scope.form_color = results[0].color;
	            $scope.tags = results[3];
	            // Set page title to '{form.name} Details' if a post title isn't provided.
	            if (!$scope.post.title) {
	                $translate('post.type_details', { type: results[0].name }).then(function (title) {
	                    $scope.$emit('setPageTitle', title);
	                });
	            }
	            var tasks = _.sortBy(results[1], 'priority');
	            var attrs = _.chain(results[2]).sortBy('priority').value();
	
	            var attributes = [];
	            _.each(attrs, function (attr) {
	                if (!_.contains($scope.attributesToIgnore, attr.key)) {
	                    attributes.push(attr);
	                }
	            });
	            attributes = attributes.length ? attributes : attrs;
	
	            angular.forEach(attributes, function (attr) {
	                this[attr.key] = attr;
	            }, $scope.form_attributes);
	
	            // Make the first task visible
	            if (!_.isEmpty(tasks) && tasks.length > 1) {
	                $scope.visibleTask = tasks[1].id;
	                tasks[1].hasFileIcon = true;
	            }
	
	            _.each(tasks, function (task) {
	                // Set post task id
	                // NOTE: This assumes that there is only one Post Task per Post
	                if (task.type === 'post') {
	                    $scope.post_task = task;
	                } else {
	                    // Mark completed tasks
	                    if (_.indexOf($scope.post.completed_stages, task.id) !== -1) {
	                        task.completed = true;
	                    }
	                }
	            });
	
	            // Remove post task from tasks
	            tasks = _.filter(tasks, function (task) {
	                return task.type !== 'post';
	            });
	
	            $scope.tasks = tasks;
	
	            // Figure out which tasks have values
	            $scope.tasks_with_attributes = [];
	            _.each($scope.post.values, function (value, key) {
	
	                if ($scope.form_attributes[key]) {
	                    $scope.tasks_with_attributes.push($scope.form_attributes[key].form_stage_id);
	                }
	            });
	            $scope.tasks_with_attributes = _.uniq($scope.tasks_with_attributes);
	        });
	    }
	
	    $scope.taskHasValues = function (task) {
	        return _.contains($scope.tasks_with_attributes, task.id);
	    };
	
	    $scope.showTasks = function () {
	        return $scope.tasks.length > 1;
	    };
	
	    $scope.isPostValue = function (key) {
	        return $scope.form_attributes[key] && $scope.post_task && $scope.form_attributes[key].form_stage_id === $scope.post_task.id;
	    };
	
	    $scope.showType = function (type) {
	        if (type === 'point') {
	            return false;
	        }
	        if (type === 'geometry') {
	            return false;
	        }
	
	        return true;
	    };
	
	    $scope.activateTaskTab = function (selectedTaskId) {
	        $scope.visibleTask = selectedTaskId;
	    };
	
	    $scope.publishPostTo = function (updatedPost) {
	        // first check if tasks required have been marked complete
	        var requiredTasks = _.where($scope.tasks, { required: true }),
	            errors = [];
	
	        _.each(requiredTasks, function (task) {
	            // if this stage isn't complete, add to errors
	            if (_.indexOf($scope.post.completed_stages, task.id) === -1) {
	                errors.push($filter('translate')('post.modify.incomplete_step', { stage: task.label }));
	            }
	        });
	
	        if (errors.length) {
	            Notify.errorsPretranslated(errors); // todo WTF
	            return;
	        }
	
	        $scope.post = updatedPost;
	
	        PostEndpoint.update($scope.post).$promise.then(function () {
	            var message = post.status === 'draft' ? 'notify.post.set_draft' : 'notify.post.publish_success';
	            var role = message === 'draft' ? 'draft' : _.isEmpty(post.published_to) ? 'everyone' : post.published_to.join(', ');
	
	            Notify.notify(message, { role: role });
	        }, function (errorResponse) {
	            Notify.apiErrors(errorResponse);
	        });
	    };
	}];

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"mode-context init\" dropdown> <header class=mode-context-header> <ol class=breadcrumbs ng-controller=\"navigation as nav\"> <li><a href=/ ng-bind=nav.site.name></a></li> </ol> <h1 class=mode-context-title>{{form.name || 'post.unstructured.survey_title' | translate}}</h1> </header> <span class=mode-context-trigger dropdown-toggle> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> <span class=\"label hidden\" translate>app.show_more_less</span> </span> <div class=mode-context-body ng-if=post.form> <p>{{ form.description }}</p> <a class=\"button button-flat\" ng-href=/posts/create/{{post.form.id}} ng-show=canCreatePostInSurvey(form)> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#plus></use> </svg> <span class=button-label translate>post.modify.add_to_survey</span> </a> </div> </div> <main role=main> <div class=full-col> <article class=postcard role=article> <div class=post-band ng-style=\"{backgroundColor: form.color}\"></div> <div class=postcard-body> <h1 class=\"form-sheet-title survey-title\"> {{post.title}} </h1> <p> {{form.description}} </p> <div class=postcard-header> <post-metadata post=post></post-metadata> <post-actions post=post></post-actions> </div> <div ng-repeat=\"(key,value) in post.values\" ng-if=\"isPostValue(key) && form_attributes[key] && showType(form_attributes[key].type)\" class=postcard-field> <post-media-value ng-if=\"form_attributes[key].type === 'media'\" label={{form_attributes[key].label}} media-id=value></post-media-value> </div> <div ng-if=post.content class=postcard-field> <p markdown-to-html=post.content></p> </div> <post-value ng-repeat=\"(key,value) in post.values\" ng-if=\"form_attributes[key].type !== 'media' && isPostValue(key) && showType(form_attributes[key].type)\" key=key value=value attribute=form_attributes[key] tags=tags type=\"'post'\"> </post-value> <post-detail-map post-id=post.id></post-detail-map> </div></article> <div class=\"listing card init\" ng-show=tasks.length> <h3 class=listing-heading translate=app.tasks>Tasks</h3> <nav class=tabs-menu data-tabs=tasks-tabs data-tabs-hash> <ul> <li ng-repeat=\"task in tasks\" ng-class=\"{'active': visibleTask == task.id}\"> <a ng-click=activateTaskTab(task.id)> {{task.label}} </a> <span class=status ng-class=\"{'completed': taskIsComplete(visibleTask)}\"> </span> </li> </ul> </nav> <div class=\"listing-item tasks-tabs tabs-target active\"> <div class=alert ng-repeat=\"task in tasks\" ng-if=!taskHasValues(task) ng-show=\"task.id === visibleTask\"> <p translate=post.modify.no_task_values>There are currently no saved values for this task.</p> </div> <div ng-repeat=\"(key,value) in post.values\" ng-if=\"form_attributes[key].type === 'media' && !isPostValue(key) && form_attributes[key] && showType(form_attributes[key].type)\" ng-show=\"form_attributes[key].form_stage_id === visibleTask\" class=listing-item-primary> <post-media-value label={{form_attributes[key].label}} media-id=value></post-media-value> </div> <div ng-repeat=\"(key,value) in post.values\" ng-if=\"form_attributes[key].type !== 'media' && !isPostValue(key) && form_attributes[key] && showType(form_attributes[key].type)\" ng-show=\"form_attributes[key].form_stage_id === visibleTask\"> <post-value tags=tags key=key value=value attribute=form_attributes[key] type=\"'standard'\"> </post-value> </div> </div> </div> <post-add-form post=post ng-if=\"!post.form && post.allowed_privileges.indexOf('update') !== -1\"></post-add-form> <post-messages post=post ng-if=post.contact.id></post-messages> <ush-logo></ush-logo> </div> </main> ";

/***/ }),
/* 817 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$scope', '$translate', '$location', '$controller', '$routeParams', 'FormEndpoint', 'PostEndpoint', function ($scope, $translate, $location, $controller, $routeParams, FormEndpoint, PostEndpoint) {
	
	    $translate('post.edit_post').then(function (title) {
	        $scope.title = title;
	        $scope.$emit('setPageTitle', title);
	    });
	
	    PostEndpoint.get({ id: $routeParams.id }).$promise.then(function (post) {
	        // Redirect to view if no edit permissions
	        if (post.allowed_privileges.indexOf('update') === -1) {
	            $location.url('/posts/' + post.id);
	        }
	
	        // Make post tags numeric
	        post.tags = post.tags.map(function (tag) {
	            return parseInt(tag.id);
	        });
	        // Ensure completes stages array is numeric
	        post.completed_stages = post.completed_stages.map(function (stageId) {
	            return parseInt(stageId);
	        });
	
	        if (post.form) {
	            $scope.form = FormEndpoint.get({ id: post.form.id }, function (form) {
	                // Set page title to post title, if there is one available.
	                if (post.title && post.title.length) {
	                    $translate('post.modify.edit_type', { type: form.name, title: post.title }).then(function (title) {
	                        $scope.$emit('setPageTitle', title);
	                    });
	                }
	            });
	        } else {
	            $location.url('/posts/' + post.id);
	        }
	        $scope.post = post;
	    });
	}];

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('ushahidi.activity', []).config(__webpack_require__(819)).directive('activityTimeline', __webpack_require__(822)).directive('activityBarChart', __webpack_require__(824)).directive('activityTimeChart', __webpack_require__(826));

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = ['$routeProvider', function ($routeProvider) {
	
	    $routeProvider.when('/activity', {
	        controller: __webpack_require__(820),
	        template: __webpack_require__(821)
	    });
	}];

/***/ }),
/* 820 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ActivityController;
	
	ActivityController.$inject = ['$scope', '$translate', 'moment', 'Features'];
	
	function ActivityController($scope, $translate, moment, Features) {
	    // Initial values
	    $scope.isActivityAvailable = false;
	    $scope.currentInterval = 'all';
	    $scope.editableInterval = 'all';
	    $scope.filters = {
	        created_after: null,
	        created_before: null
	    };
	    $scope.filtersMenuOpen = false;
	    $scope.dateOptions = { format: 'yyyy-mm-dd' };
	
	    $scope.saveFilters = saveFilters;
	    $scope.cancelChangeFilters = cancelChangeFilters;
	
	    activate();
	
	    function activate() {
	        // Change mode
	        $scope.$emit('event:mode:change', 'activity');
	        // Set the page title
	        $translate('nav.activity').then(function (title) {
	            $scope.$emit('setPageTitle', title);
	        });
	
	        Features.loadFeatures().then(function () {
	            $scope.isActivityAvailable = Features.isViewEnabled('activity');
	        });
	
	        update();
	    }
	
	    function saveFilters() {
	        $scope.currentInterval = $scope.editableInterval;
	        update();
	        $scope.filtersMenuOpen = false;
	    }
	
	    function cancelChangeFilters() {
	        $scope.editableInterval = $scope.currentInterval;
	        $scope.filtersMenuOpen = false;
	    }
	
	    function update() {
	        //$scope.currentInterval = interval;
	        setDateRange($scope.currentInterval);
	    }
	
	    /**
	     * Util func to get date range when given an interval like
	     * @param  {String} interval month|week|all
	     * @return {Object}
	     */
	    function setDateRange(interval) {
	        switch (interval) {
	            case 'month':
	                $scope.filters.created_after = moment().startOf('month').toDate();
	                $scope.filters.created_before = null;
	                break;
	            case 'all':
	                $scope.filters.created_after = null;
	                $scope.filters.created_before = null;
	                break;
	            case 'custom':
	                // Do nothing?
	                $scope.filters.created_after = $scope.createdAfter;
	                $scope.filters.created_before = $scope.createdBefore;
	                break;
	            // case 'week':
	            default:
	                // Default to this week
	                $scope.filters.created_after = moment().startOf('week').toDate();
	                $scope.filters.created_before = null;
	        }
	        // Copy range to editable values
	        $scope.createdAfter = $scope.filters.created_after;
	        $scope.createdBefore = $scope.filters.created_before;
	        return $scope.filters;
	    }
	}

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div> <layout-class layout=a></layout-class> <div class=\"mode-context init\" ng-controller=\"navigation as nav\" dropdown> <header class=mode-context-header ng-class=\"{ 'has-logo' : nav.site.image_header }\"> <h1 class=mode-context-title><a href=/ ng-bind=nav.site.name></a></h1> <img ng-if=nav.site.image_header ng-src=\"{{ nav.site.image_header }}\" class=deployment-logo /> </header> <span class=mode-context-trigger dropdown-toggle> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> <span class=\"label hidden\" translate>app.show_more_less</span> </span> <div class=mode-context-body> <p markdown-to-html=nav.site.description></p> </div> </div> <main role=main> <div class=toolbar ng-show=isActivityAvailable> <form role=search class=searchbar name=searchForm ng-submit=saveFilters()> <div class=searchbar-options> <fieldset class=\"custom-fieldset init\" data-fieldset-type=date-range dropdown auto-close=disabled is-open=filtersMenuOpen> <legend class=\"dropdown-trigger init\" dropdown-toggle> <span class=legend-label ng-show=\"currentInterval !== 'custom'\" translate=\"{{'graph.' + currentInterval }}\">Date range</span> <span class=legend-label ng-show=\"currentInterval == 'custom'\" translate=graph.custom_display translate-values=\"{\n                                    start: (filters.created_after | date:'mediumDate'),\n                                    end: (filters.created_before | date:'mediumDate') }\" translate-compile>Date range</span> <svg class=\"iconic chevron\"><use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use></svg> </legend> <div class=\"dropdown-menu init\" dropdown-menu> <div class=\"form-field radio\"> <label> <input ng-model=editableInterval type=radio name=editableInterval value=all> <span translate=graph.all>All time<span> </span></span></label> </div> <div class=\"form-field radio\"> <label> <input ng-model=editableInterval type=radio name=editableInterval value=week> <span translate=graph.week>This week<span> </span></span></label> </div> <div class=\"form-field radio\"> <label> <input ng-model=editableInterval type=radio name=editableInterval value=month> <span translate=graph.month>This month<span> </span></span></label> </div> <div class=\"form-field radio\"> <label> <input ng-model=editableInterval type=radio name=editableInterval value=custom> <span translate=graph.custom>Custom date range<span> </span></span></label> <div class=form-fieldgroup> <div class=\"form-field date\" ng-show=\"editableInterval == 'custom'\"> <label class=hidden translate=global_filter.filter_tabs.created_after>Start date</label> <div class=input-with-icon> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#calendar></use> </svg> <input type=date pick-a-date=createdAfter pick-a-date-options=dateOptions placeholder=\"{{ 'global_filter.filter_tabs.created_after' | translate }}\" ng-model=createdAfter /> </div> <span class=date-joiner>to</span> </div> <div class=\"form-field date\" ng-show=\"editableInterval == 'custom'\"> <label class=hidden translate=global_filter.filter_tabs.created_before>End date</label> <div class=input-with-icon> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#calendar></use> </svg> <input type=date pick-a-date=createdBefore pick-a-date-options=dateOptions placeholder=\"{{ 'global_filter.filter_tabs.created_before' | translate }}\" ng-model=createdBefore> </div> </div> </div> </div> <div class=form-field> <button type=button class=button-link ng-click=cancelChangeFilters() translate=app.cancel>Cancel</button> <button type=submit class=button-alpha translate=app.apply_filters>Apply filter</button> </div> </div> </fieldset> </div> </form> </div> <post-view-unavailable ng-hide=isActivityAvailable view=\"'nav.activity' | translate\"></post-view-unavailable> <div ng-show=isActivityAvailable class=main-col> <div class=\"listing card init\"> <div class=\"listing-item active\"> <div class=listing-item-secondary> <button ng-show=todo type=button class=\"button-beta button-flat\"> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#share></use> </svg> <span class=hidden translate=app.share>Share</span> </button> </div> <div class=listing-item-primary> <h2 class=listing-item-title translate=activity.activity_over_time>Activity over time</h2> </div> <div class=listing-item-body> <activity-time-chart filters=filters> </activity-time-chart></div> </div> <div class=\"listing-item active\"> <div class=listing-item-secondary> <button ng-show=todo type=button class=\"button-beta button-flat\"> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#share></use> </svg> <span class=hidden translate=app.share>Share</span> </button> </div> <div class=listing-item-primary> <h2 class=listing-item-title translate=activity.activity_by_volume>Activity by volume</h2> </div> <div class=listing-item-body> <activity-bar-chart filters=filters> </activity-bar-chart></div> </div> </div> </div> <aside class=secondary-col role=complementary> </aside> </main> </div> ";

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = [function () {
	    var controller = ['$scope', '$q', '$translate', 'PostEndpoint', 'UserEndpoint', '_', function ($scope, $q, $translate, PostEndpoint, UserEndpoint, _) {
	
	        /*
	        Helper function to produce human friendly timestamps
	        */
	        $scope.timeSince = function (date) {
	
	            var seconds = Math.floor((new Date() - date) / 1000);
	
	            var interval = Math.floor(seconds / 31536000);
	
	            if (interval > 1) {
	                return interval + ' years';
	            }
	            interval = Math.floor(seconds / 2592000);
	            if (interval > 1) {
	                return interval + ' months';
	            }
	            interval = Math.floor(seconds / 86400);
	            if (interval > 1) {
	                return interval + ' days';
	            }
	            interval = Math.floor(seconds / 3600);
	            if (interval > 1) {
	                return interval + ' hours';
	            }
	            interval = Math.floor(seconds / 60);
	            if (interval > 1) {
	                return interval + ' minutes';
	            }
	            return Math.floor(seconds) + ' seconds';
	        };
	
	        var getPostsForPagination = function getPostsForPagination(query) {
	            query = query || { status: 'all' };
	            var postQuery = _.extend({}, query, {
	                offset: ($scope.currentPage - 1) * $scope.itemsPerPage,
	                limit: $scope.itemsPerPage
	            });
	
	            $scope.isLoading = true;
	            PostEndpoint.query(postQuery).$promise.then(function (postsResponse) {
	                $scope.posts = postsResponse.results;
	                $scope.isLoading = false;
	
	                /*
	                cool looking friendly timestamp - only appears
	                start of timeline.
	                */
	                var firspost_timestamp = new Date($scope.posts[0].created);
	                $scope.start_timestamp = $scope.timeSince(firspost_timestamp);
	
	                /*
	                quick hack to get user names but not efficient
	                since we end up making duplicate queries
	                */
	                $scope.posts.forEach(function (post) {
	                    post.user = UserEndpoint.get({ id: post.user.id });
	                });
	            });
	        };
	
	        // --- start: initialization
	        $scope.pageChanged = getPostsForPagination;
	        $scope.currentPage = 1;
	        $scope.itemsPerPageOptions = [10, 20, 50];
	        $scope.itemsPerPage = $scope.itemsPerPageOptions[0];
	        $scope.start_timestamp = null;
	        // Initial load
	        getPostsForPagination();
	    }];
	
	    return {
	        restrict: 'E',
	        replace: true,
	        scope: {},
	        controller: controller,
	        template: __webpack_require__(823)
	    };
	}];

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div> <div class=main-col> <div class=listing> <article class=postcard> <div class=post-band ng-style=\"{backgroundColor: form.color}\"></div> <div class=listing-item-select> <input type=checkbox> </div> <div class=postcard-body> <h1 class=postcard-title><a href=\"\">Overcrowding between 5th St. &amp; Salem Ave.</a></h1> <span class=postcard-metadata><a href=\"\" class=postcard-author><img src=https://api.adorable.io/avatars/40/abott@adorable.io.png class=avatar />Jess Shorland</a>, 45 mins, via SMS</span> <div class=postcard-field> <p>Forms are the standard way to receive user inputted data. The transitions and smoothness of these elements are very important because of the inherent user interaction associated with forms.</p> </div> </div> <span class=postcard-actions-trigger data-toggle=dropdown-menu> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> </span> <ul class=dropdown-menu> <li> <a href=\"\"> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#pencil></use> </svg> <span class=label>Edit</span> </a> </li> <li> <a href=\"\"> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#grid-three-up></use> </svg> <span class=label>Add to Collection</span> </a> </li> <li> <a href=\"\"> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#share></use> </svg> <span class=label>Share</span> </a> </li> <li> <a href=\"\"> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#task></use> </svg> <span class=label>Assign to...</span> </a> </li> <li> <a href=\"\"> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#trash></use> </svg> <span class=label>Delete</span> </a> </li> </ul> </article> <article class=postcard> <div class=post-band ng-style=\"{ backgroundColor: form.color}\"></div> <div class=listing-item-select> <input type=checkbox> </div> <div class=postcard-body> <h1 class=postcard-title><a href=\"\">Overcrowding between 5th St. &amp; Salem Ave.</a></h1> <span class=postcard-metadata><a href=\"\" class=postcard-author><img src=https://api.adorable.io/avatars/40/abott@adorable.io.png class=avatar />Jess Shorland</a>, 45 mins, via SMS</span> <div class=postcard-field> <img src=http://lorempixel.com/400/300/ class=postcard-image /> </div> </div> <span class=postcard-actions-trigger data-toggle=dropdown-menu> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> </span> <ul class=dropdown-menu> <li> <a href=\"\"> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#pencil></use> </svg> <span class=label>Edit</span> </a> </li> <li> <a href=\"\"> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#grid-three-up></use> </svg> <span class=label>Add to Collection</span> </a> </li> <li> <a href=\"\"> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#share></use> </svg> <span class=label>Share</span> </a> </li> <li> <a href=\"\"> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#task></use> </svg> <span class=label>Assign to...</span> </a> </li> <li> <a href=\"\"> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#trash></use> </svg> <span class=label>Delete</span> </a> </li> </ul> </article> <div class=listing-toolbar> <div class=listing-toolbar-summary> <strong><span class=total></span> selected</strong> <button class=button-link>Deselect</button> </div> <div class=listing-toolbar-actions> <fieldset class=custom-fieldset> <legend>Mark as</legend> <div class=\"form-field radio\"> <label for=contributor> <input type=radio name=role id=contributor> Spam </label> </div> <div class=\"form-field radio\"> <label for=editor> <input type=radio name=role id=editor> Duplicates </label> </div> </fieldset> <fieldset class=custom-fieldset> <legend> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#grid-three-up></use> </svg> Add to Collection </legend> <div class=\"form-field radio\"> <label for=contributor> <input type=radio name=role id=contributor> Spam </label> </div> <div class=\"form-field radio\"> <label for=editor> <input type=radio name=role id=editor> Duplicates </label> </div> </fieldset> <button type=button> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#external-link></use> </svg> <span class=button-label>Export</span> </button> <button type=button class=button-destructive> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#trash></use> </svg> <span class=\"button-label hidden\">Delete</span> </button> <button type=button class=\"listing-toolbar-toggle more\"> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#ellipses></use> </svg> <span class=button-label>Show more</span> </button> <button type=button class=\"listing-toolbar-toggle less\"> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#x></use> </svg> <span class=button-label>Show less</span> </button> </div> </div> </div> <uib-pagination ng-model=currentPage items-per-page=itemsPerPage total-items=totalItems ng-change=pageChanged() max-size=5 boundary-links=false rotate=false></uib-pagination> </div> <div> <h3 translate>activity.recent_activity_timeline</h3> <div ng-show=isLoading><i class=\"fa fa-refresh fa-4 fa-spin\"></i></div> <div class=activity-timeline ng-hide=isLoading> <div class=timestamp><span ng-bind=start_timestamp></span> AGO</div> <div class=activity-listing ng-repeat=\"post in ::posts\"> <div class=\"activity-type post\" translate> activity.new_post </div> <div class=listing-summary> <h3> <a ng-href=/posts/{{::post.id}} ng-bind=::post.title></a> </h3> <p translate>activity.by <a ng-href=\"\" ng-bind=::post.user.realname></a></p> </div> <div class=clearfix></div> </div> </div> </div> </div> ";

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = ActivityBarChart;
	
	function ActivityBarChart() {
	    return {
	        restrict: 'E',
	        scope: {
	            filters: '='
	        },
	        controller: ActivityBarChartController,
	        template: __webpack_require__(825)
	    };
	}
	
	ActivityBarChartController.$inject = ['$scope', '$translate', 'PostEndpoint', 'd3', '_', 'PostFilters'];
	function ActivityBarChartController($scope, $translate, PostEndpoint, d3, _, PostFilters) {
	    $scope.data = [{
	        values: []
	    }];
	
	    $scope.groupByOptions = {
	        'tags': 'nav.categories',
	        'form': 'app.surveys',
	        'status': 'post.status'
	    };
	
	    $scope.groupBy = {
	        value: 'tags'
	    };
	
	    $scope.options = {
	        chart: {
	            type: 'multiBarHorizontalChart',
	            height: 450,
	            margin: {
	                top: 0,
	                right: 40,
	                bottom: 40,
	                left: 5
	            },
	            x: function x(d) {
	                return d.label;
	            },
	            y: function y(d) {
	                return d.total;
	            },
	            showValues: false,
	            showControls: false,
	            valueFormat: d3.format('d'),
	            transitionDuration: 500,
	            xAxis: {
	                axisLabel: $translate.instant('post.categories'),
	                tickPadding: -10,
	                axisLabelDistance: 0
	            },
	            yAxis: {
	                axisLabel: $translate.instant('graph.post_count'),
	                tickFormat: d3.format('d')
	            },
	            tooltip: {
	                contentGenerator: function contentGenerator(data) {
	                    return '<h3>' + data.value + '</h3>' + '<p>' + data.data.total + '</p>';
	                }
	            },
	            forceY: 0,
	            barColor: d3.scale.category20().range(),
	            noData: $translate.instant('graph.no_data')
	        }
	    };
	
	    $scope.reload = getPostStats;
	
	    activate();
	
	    function activate() {
	        // whenever the filters changes, update the current list of posts
	        $scope.$watch('filters', function () {
	            getPostStats();
	        }, true);
	        PostFilters.setMode('activity');
	    }
	
	    function getPostStats(query) {
	        query = query || PostFilters.getQueryParams($scope.filters);
	        var postQuery = _.extend({}, query, {
	            'group_by': $scope.groupBy.value
	        });
	
	        $scope.isLoading = true;
	        PostEndpoint.stats(postQuery).$promise.then(function (results) {
	            $scope.options.chart.xAxis.axisLabel = $translate.instant($scope.groupByOptions[$scope.groupBy.value]);
	            if (results.totals[0]) {
	                results.totals[0].key = $scope.options.chart.yAxis.axisLabel;
	            }
	            $scope.data = results.totals;
	            $scope.isLoading = false;
	        });
	    }
	}

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=graph-view> <fieldset class=\"custom-fieldset init\" dropdown is-open=compareIsOpen> <legend class=\"dropdown-trigger init\" data-toggle=dropdown-menu dropdown-toggle> <span class=legend-label translate=graph.compare ng-show=compareIsOpen>Compare...</span> <span class=legend-label translate=\"graph.compare_{{groupBy.value || 'all'}}\" ng-hide=compareIsOpen>Compare...</span> <svg class=\"iconic chevron\"> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> </legend> <div class=\"dropdown-menu init\" dropdown-menu> <div class=\"form-field radio\" ng-repeat=\"(key, value) in groupByOptions\"> <label> <input type=radio ng-value=key ng-model=groupBy.value ng-change=reload()> {{::value | translate}} </label> </div> </div> </fieldset> <nvd3 options=options data=data></nvd3> </div> ";

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = ActivityTimeChart;
	
	function ActivityTimeChart() {
	    return {
	        restrict: 'E',
	        scope: {
	            filters: '='
	        },
	        controller: ActivityTimeChartController,
	        template: __webpack_require__(827)
	    };
	}
	
	ActivityTimeChartController.$inject = ['$scope', '$translate', 'PostEndpoint', 'd3', '_', 'PostFilters'];
	function ActivityTimeChartController($scope, $translate, PostEndpoint, d3, _, PostFilters) {
	    var yAxisLabelCumulative = $translate.instant('graph.cumulative_post_count'),
	        yAxisLabel = $translate.instant('graph.new_post_count'),
	        xAxisLabel = $translate.instant('graph.post_date');
	
	    $scope.showCumulative = true;
	    $scope.isLoading = true;
	    $scope.timelineAttribute = 'created';
	
	    $scope.data = [{
	        values: []
	    }];
	
	    $scope.groupByOptions = {
	        '': 'graph.all_posts',
	        'tags': 'nav.categories',
	        'form': 'app.surveys',
	        'status': 'post.status'
	    };
	
	    $scope.groupBy = {
	        value: ''
	    };
	
	    $scope.options = {
	        chart: {
	            type: 'lineChart',
	            height: 450,
	            margin: {
	                top: 0,
	                right: 65,
	                bottom: 40,
	                left: 65
	            },
	            showControls: false,
	            x: function x(d) {
	                return new Date(parseInt(d.label) * 1000);
	            },
	            y: function y(d) {
	                return d[$scope.showCumulative ? 'cumulative_total' : 'total'];
	            },
	            transitionDuration: 500,
	            xAxis: {
	                axisLabel: xAxisLabel,
	                tickFormat: function tickFormat(d) {
	                    //uses unambiguous time format ex: 8 Sep 2014
	                    return d3.time.format('%e %b %Y')(new Date(d));
	                }
	            },
	            yAxis: {
	                axisLabel: yAxisLabel,
	                tickFormat: d3.format('d')
	            },
	            forceY: 0,
	            tooltip: {
	                contentGenerator: function contentGenerator(data) {
	                    return '<h3>' + data.series[0].key + '</h3>' + '<p>' + data.point.y + ' posts at ' + d3.time.format('%e %b %Y')(new Date(data.point.x)) + '</p>';
	                }
	            },
	            noData: $translate.instant('graph.no_data')
	        }
	    };
	
	    $scope.reload = getPostStats;
	
	    activate();
	
	    function activate() {
	        // whenever filters change, reload
	        $scope.$watch('filters', function () {
	            getPostStats();
	        }, true);
	        $scope.$watch('showCumulative', updateAxisLabel);
	        PostFilters.setMode('activity');
	    }
	
	    function getPostStats(query) {
	        query = query || PostFilters.getQueryParams($scope.filters);
	        var postQuery = _.extend({}, query, {
	            'timeline': 1,
	            'timeline_attribute': $scope.timelineAttribute,
	            'group_by': $scope.groupBy.value
	        });
	
	        $scope.isLoading = true;
	        PostEndpoint.stats(postQuery).$promise.then(function (results) {
	            if (!results.totals.length || _.chain(results.totals).pluck('values').pluck('length').max().value() < 3) {
	                // Don't render a time chart with less than 3 points
	                $scope.data = [{
	                    values: []
	                }];
	            } else {
	                $scope.data = results.totals;
	            }
	            $scope.isLoading = false;
	        });
	    }
	
	    function updateAxisLabel(cumulative) {
	        if (cumulative) {
	            $scope.options.chart.yAxis.axisLabel = yAxisLabelCumulative;
	        } else {
	            $scope.options.chart.yAxis.axisLabel = yAxisLabel;
	        }
	    }
	}

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=timeline-view> <fieldset class=\"custom-fieldset init\" dropdown is-open=compareIsOpen> <legend class=\"dropdown-trigger init\" data-toggle=dropdown-menu dropdown-toggle> <span class=legend-label translate=graph.compare ng-show=compareIsOpen>Compare...</span> <span class=legend-label translate=\"graph.compare_{{groupBy.value || 'all'}}\" ng-hide=compareIsOpen>Compare...</span> <svg class=\"iconic chevron\"> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> </legend> <div class=\"dropdown-menu init\" dropdown-menu> <div class=\"form-field radio\" ng-repeat=\"(key, value) in groupByOptions\"> <label> <input type=radio ng-value=key ng-model=groupBy.value ng-change=reload()> {{::value | translate}} </label> </div> <div class=form-fieldgroup> <div class=\"form-field checkbox\"> <label> <input type=checkbox name=showCumulative ng-model=showCumulative ng-change=reload()> <span translate=graph.cumulative>Show cumulative totals</span> </label> </div> </div> </div> </fieldset> <div class=nvd3-wrapper> <nvd3 options=options data=data></nvd3> </div> </div> ";

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('ushahidi.settings', []).directive('afterImportCsv', __webpack_require__(829)).directive('importerCsv', __webpack_require__(830)).service('ImportNotify', __webpack_require__(831)).directive('surveyEditor', __webpack_require__(833)).directive('surveyTaskCreate', __webpack_require__(835)).directive('surveyAttributeCreate', __webpack_require__(837)).directive('surveyAttributeEditor', __webpack_require__(839)).service('SurveyNotify', __webpack_require__(841)).directive('settingsList', __webpack_require__(843)).directive('settingsMap', __webpack_require__(845)).directive('settingsEditor', __webpack_require__(847)).directive('filterUsers', __webpack_require__(849)).directive('customRoles', __webpack_require__(851)).directive('customRolesEditor', __webpack_require__(852)).directive('customWebhooks', __webpack_require__(853)).directive('customWebhooksEditor', __webpack_require__(854)).config(__webpack_require__(855));

/***/ }),
/* 829 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$rootScope', '$translate', '$location', 'Notify', 'Features', function ($rootScope, $translate, $location, Notify, Features) {
	    return {
	        restrict: 'A',
	        link: function link($scope, $element, $attrs) {
	            $scope.importComplete = false;
	
	            $rootScope.$on('event:import:complete', function (event, args) {
	                $scope.collectionId = args.collectionId;
	                $scope.filename = args.filename;
	                $scope.form = args.form;
	                $scope.importComplete = true;
	            });
	        }
	    };
	}];

/***/ }),
/* 830 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$translate', '$rootScope', '$q', '$location', 'FormEndpoint', 'FormStageEndpoint', 'FormAttributeEndpoint', 'DataImportEndpoint', 'Notify', 'ImportNotify', 'Features', 'CollectionEndpoint', 'moment', '_', function ($translate, $rootScope, $q, $location, FormEndpoint, FormStageEndpoint, FormAttributeEndpoint, DataImportEndpoint, Notify, ImportNotify, Features, CollectionEndpoint, moment, _) {
	    return {
	        restrict: 'A',
	        link: function link($scope, $element, $attrs) {
	
	            $scope.setStatus = setStatus;
	            $scope.setStatusOption = setStatusOption;
	            $scope.isStatusOption = isStatusOption;
	            $scope.isStatusSelected = isStatusSelected;
	            $scope.setSelectedForm = setSelectedForm;
	            $scope.isSelectedForm = isSelectedForm;
	            $scope.cancelImport = cancelImport;
	            $scope.deleteDataImport = deleteDataImport;
	            $scope.isActiveStep = isActiveStep;
	            $scope.completeStepOne = completeStepOne;
	            $scope.completeStepTwo = completeStepTwo;
	
	            activate();
	
	            function activate() {
	                $scope.selectedForm;
	                $scope.activeStep = 1;
	                $scope.stepOneComplete = false;
	                $scope.stepTwoComplete = false;
	                $scope.maps_to = {};
	                $scope.required_fields = [];
	                $scope.required_fields_map = {};
	                $scope.hasRequiredTask = false;
	
	                Features.loadFeatures().then(function () {
	                    $scope.csvEnabled = Features.isFeatureEnabled('data-import');
	                });
	            }
	
	            function setStatus(status) {
	                $scope.selectedStatus = status;
	            }
	
	            function setStatusOption(option) {
	                $scope.statusOption = option;
	            }
	
	            function isStatusOption(option) {
	                return $scope.statusOption === option;
	            }
	
	            function isStatusSelected(status) {
	                return $scope.selectedStatus === status;
	            }
	
	            function setSelectedForm(form) {
	                $scope.selectedForm = form;
	            }
	
	            function isSelectedForm(form) {
	                if ($scope.selectedForm) {
	                    return $scope.selectedForm.id === form.id;
	                }
	                return false;
	            }
	
	            function cancelImport() {
	                Notify.confirm('notify.data_import.csv_import_cancel_confirm').then(function () {
	                    Notify.notify('notify.data_import.csv_import_cancel');
	                    deleteDataImport($scope.csv);
	                    $location.url('/settings/data-import/');
	                });
	            }
	
	            function deleteDataImport() {
	                DataImportEndpoint.delete($scope.csv);
	            }
	
	            function isActiveStep(step) {
	                return $scope.activeStep === step;
	            }
	
	            function completeStepOne() {
	                if (!$scope.fileContainer.file) {
	                    Notify.error('notify.data_import.file_missing');
	                    return;
	                }
	
	                if (!$scope.selectedForm) {
	                    Notify.error('notify.data_import.form_missing');
	                    return;
	                }
	                var formData = new FormData();
	                formData.append('file', $scope.fileContainer.file);
	                formData.append('form_id', $scope.selectedForm.id);
	
	                DataImportEndpoint.upload(formData).then(function (csv) {
	                    Notify.notify('notify.data_import.csv_upload', { name: $scope.fileContainer.file.name });
	                    $scope.stepOneComplete = true;
	                    $scope.activeStep = 2;
	                    $scope.csv = csv;
	
	                    loadStepTwo();
	                }, function (errorResponse) {
	                    Notify.apiErrors(errorResponse);
	                });
	            }
	
	            function loadStepTwo(results) {
	                // Retrieve tasks and attributes
	                $q.all([FormStageEndpoint.getFresh({ form_id: $scope.selectedForm.id }).$promise, FormAttributeEndpoint.getFresh({ form_id: $scope.selectedForm.id }).$promise]).then(function (results) {
	                    $scope.selectedForm.tasks = results[0].results;
	                    $scope.selectedForm.attributes = transformAttributes(results[1].results);
	                    setRequiredFields($scope.selectedForm.attributes);
	                    setRequiredTasks($scope.selectedForm.tasks);
	                });
	            }
	
	            function transformAttributes(attributes) {
	                // Split locations into lat/lon
	                var points = _.chain(attributes).where({ 'type': 'point' }).reduce(function (collection, item) {
	                    return collection.concat({
	                        key: item.key + '.lat',
	                        label: item.label + ' (Latitude)',
	                        priority: item.priority,
	                        required: item.required
	                    }, {
	                        key: item.key + '.lon',
	                        label: item.label + ' (Longitude)',
	                        priority: item.priority,
	                        required: item.required
	                    });
	                }, []).value();
	
	                var titleAttr = _.find(attributes, { type: 'title' });
	                var descAttr = _.find(attributes, { type: 'description' });
	
	                var titleLabel = titleAttr ? titleAttr.label : $translate.instant('post.modify.form.title');
	                var descLabel = descAttr ? descAttr.label : $translate.instant('post.modify.form.description');
	
	                attributes = _.chain(attributes).reject({ type: 'point' }).reject({ type: 'title' }).reject({ type: 'description' }).concat(points)
	                // Add in the Post specific mappable fields
	                .push({
	                    'key': 'title',
	                    'label': titleLabel,
	                    'priority': 0,
	                    'required': true
	                }, {
	                    'key': 'content',
	                    'label': descLabel,
	                    'priority': 1,
	                    'required': true
	                }).sortBy('priority').value();
	                return attributes;
	            }
	
	            function setRequiredTasks(tasks) {
	                _.each(tasks, function (task) {
	                    if (task.required) {
	                        $scope.hasRequiredTask = true;
	                    }
	                });
	            }
	
	            function setRequiredFields(attributes) {
	                _.each(attributes, function (attribute, index) {
	                    if (attribute.required) {
	                        $scope.required_fields.push(attribute.key);
	                        $scope.required_fields_map[attribute.key] = attribute.label;
	                    }
	                });
	            }
	
	            function completeStepTwo() {
	                // First we must remap the csv.maps_to array so that
	                // it is in terms of csv column indexes
	                $scope.csv.maps_to = remapColumns();
	                if (!validateCSV()) {
	                    return;
	                }
	
	                $scope.csv.fixed = {
	                    'form': $scope.selectedForm.id
	                };
	
	                // Check if status has been set
	                if ($scope.selectedStatus) {
	                    if ($scope.isStatusOption('mark_as')) {
	                        // If status explicitly set
	                        $scope.csv.fixed.status = $scope.selectedStatus;
	                    } else {
	                        // If status set by csv column mapping
	                        $scope.csv.maps_to[$scope.selectedStatus] = 'status';
	                    }
	                }
	
	                updateAndImport($scope.csv);
	            }
	
	            function validateCSV() {
	                var csvIsValid = true;
	
	                if (_.every($scope.csv.maps_to, _.isEmpty)) {
	                    Notify.error('notify.data_import.no_mappings');
	                    return false;
	                }
	
	                var duplicateVars = checkForDuplicates();
	
	                // third, warn the user which keys have been duplicated
	                if (duplicateVars.length > 0) {
	                    Notify.error('notify.data_import.duplicate_fields', { duplicates: duplicateVars.join(', ') });
	                    return false;
	                }
	
	                //Check required fields are set
	                var missing = checkRequiredFields($scope.csv.maps_to);
	                if (!_.isEmpty(missing)) {
	                    Notify.error('notify.data_import.required_fields', { required: missing.join(', ') });
	                    return false;
	                }
	
	                return csvIsValid;
	            }
	
	            function createPostCollection(post_ids) {
	                var deferred = $q.defer();
	
	                var now = moment().format('h:mm a MMM Do YYYY');
	
	                var collection = {};
	                collection.name = 'Imported ' + now;
	                collection.view = 'list';
	                collection.visible_to = ['admin'];
	                var calls = [];
	                CollectionEndpoint.save(collection).$promise.then(function (collection) {
	                    _.each(post_ids, function (id) {
	                        calls.push(CollectionEndpoint.addPost({ 'collectionId': collection.id, 'id': id }));
	                    });
	                    $q.all(calls).then(function () {
	                        deferred.resolve(collection);
	                    });
	                });
	                return deferred.promise;
	            }
	
	            function updateAndImport(csv) {
	                DataImportEndpoint.update(csv).$promise.then(function () {
	                    DataImportEndpoint.import({ id: csv.id, action: 'import' }).$promise.then(function (response) {
	                        var processed = response.processed,
	                            errors = response.errors,
	                            post_ids = response.created_ids;
	
	                        createPostCollection(post_ids).then(function (collection) {
	                            ImportNotify.importComplete({
	                                processed: processed,
	                                errors: errors,
	                                collectionId: collection.id,
	                                form_name: $scope.selectedForm.name,
	                                filename: csv.filename
	                            });
	
	                            $rootScope.$emit('event:import:complete', { form: $scope.form, filename: csv.filename, collectionId: collection.id });
	                        });
	                    }, function (errorResponse) {
	                        Notify.apiErrors(errorResponse);
	                    });
	                }, function (errorResponse) {
	                    Notify.apiErrors(errorResponse);
	                });
	                // Go to after import page
	                $location.url('/settings/data-after-import');
	            }
	
	            // Check for missing required fields and return the missing fields
	            function checkRequiredFields(fields) {
	                var missing = [];
	                var difference = _.difference($scope.required_fields, _.toArray(fields));
	
	                if (!_.isEmpty(difference)) {
	                    _.each(difference, function (field) {
	                        missing.push($scope.required_fields_map[field]);
	                    });
	                }
	
	                return missing;
	            }
	
	            function remapColumns() {
	                var map = _.clone($scope.maps_to);
	                // First we invert the mappings so they are in terms of csv column
	                // indices
	                map = _.invert(map);
	                // Remove empty values
	                map = _.omit(map, '');
	                // Then we set null values for unmapped columns
	                var keys = _.keys(map);
	                _.each($scope.csv.columns, function (column, index) {
	                    map[index] = _.contains(keys, index.toString()) ? map[index] : null;
	                });
	
	                return map;
	            }
	
	            function checkForDuplicates() {
	                // Check to make sure the user hasn't double mapped a key
	                // First, collect the counts for all keys
	                // Remove empty fields
	                var map = _.omit($scope.maps_to, function (value, key, object) {
	                    return value === '';
	                });
	                return _.chain(map).map(function (item) {
	                    return $scope.csv.columns[item];
	                }).countBy(function (item) {
	                    return item;
	                }).pick(function (value, key) {
	                    return value > 1;
	                }).allKeys().value();
	            }
	        }
	    };
	}];

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = ImportNotify;
	
	var scope;
	
	ImportNotify.$inject = ['_', '$q', '$rootScope', '$translate', 'SliderService', 'ModalService'];
	function ImportNotify(_, $q, $rootScope, $translate, SliderService, ModalService) {
	    return {
	        importComplete: importComplete
	    };
	
	    function importComplete(values) {
	        var scope = getScope();
	
	        scope = _.extend(scope, values);
	
	        showSlider();
	
	        function showSlider() {
	            SliderService.openTemplate(__webpack_require__(832), 'thumb-up', 'confirmation', scope, false, false);
	        }
	    }
	
	    function getScope() {
	        if (scope) {
	            scope.$destroy();
	        }
	        scope = $rootScope.$new();
	        return scope;
	    }
	}

/***/ }),
/* 832 */
/***/ (function(module, exports) {

	module.exports = "<p translate-values=\"{processed: processed, errors: errors}\" translate=notify.data_import.csv_import_processed_errors> <strong>Your CSV import</strong> is complete. {{processed}} records imported, {{errors}} records failed. </p> <p translate-values=\"{from_name: form_name, filename: filename}\" translate=notify.data_import.csv_import_success_info> The data from your CSV spreadsheet, <em>{{filename}}</em>, was successfully imported into your <a ng-href=/views/list>{{form_name}}</a> survey. </p> <a class=\"button button-alpha\" ng-click=close() ng-href=/collections/{{collectionId}} translate=notify.data_import.see_imported_posts>See imported posts</a> <a ng-click=close() ng-href=/settings/data-import class=\"button button-gamma button-flat\" translate=data_import.import_another_csv>Import another CSV file</a> <button class=\"button-flat message-trigger\" ng-click=close() translate=message.button.dismiss> Dismiss </button> ";

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = SurveyEditor;
	
	SurveyEditor.$inject = [];
	function SurveyEditor() {
	    return {
	        restrict: 'E',
	        scope: {
	            surveyId: '=',
	            actionType: '='
	        },
	        controller: SurveyEditorController,
	        template: __webpack_require__(834)
	    };
	}
	
	SurveyEditorController.$inject = ['$scope', '$q', '$location', '$translate', 'FormEndpoint', 'FormRoleEndpoint', 'FormStageEndpoint', 'FormAttributeEndpoint', 'RoleEndpoint', 'TagEndpoint', '_', 'Notify', 'SurveyNotify', 'ModalService', 'Features'];
	function SurveyEditorController($scope, $q, $location, $translate, FormEndpoint, FormRoleEndpoint, FormStageEndpoint, FormAttributeEndpoint, RoleEndpoint, TagEndpoint, _, Notify, SurveyNotify, ModalService, Features) {
	    $scope.saving = false;
	    $scope.currentInterimId = 0;
	    $scope.survey = {
	        color: null
	    };
	    $scope.canReorderTask = canReorderTask;
	    $scope.moveTaskUp = moveTaskUp;
	    $scope.moveTaskDown = moveTaskDown;
	    $scope.isFirstTask = isFirstTask;
	    $scope.isLastTask = isLastTask;
	    $scope.deleteTask = deleteTask;
	    $scope.duplicateSection = duplicateSection;
	    $scope.openTaskModal = openTaskModal;
	    $scope.addNewTask = addNewTask;
	
	    $scope.openAttributeModal = openAttributeModal;
	    $scope.openAttributeEditModal = openAttributeEditModal;
	    $scope.addNewAttribute = addNewAttribute;
	
	    $scope.moveAttributeUp = moveAttributeUp;
	    $scope.moveAttributeDown = moveAttributeDown;
	    $scope.isFirstAttribute = isFirstAttribute;
	    $scope.isLastAttribute = isLastAttribute;
	
	    $scope.deleteAttribute = deleteAttribute;
	    $scope.saving_survey = false;
	    $scope.saveSurvey = saveSurvey;
	    $scope.cancel = cancel;
	
	    $scope.toggleTaskRequired = toggleTaskRequired;
	    $scope.toggleAttributeRequired = toggleAttributeRequired;
	    $scope.toggleTaskPublic = toggleTaskPublic;
	
	    $scope.changeTaskLabel = changeTaskLabel;
	
	    $scope.getInterimId = getInterimId;
	    $scope.removeInterimIds = removeInterimIds;
	
	    $scope.allowedToggleOrder = allowedToggleOrder;
	
	    $scope.switchTab = switchTab;
	
	    $scope.loadRoleData = loadRoleData;
	    $scope.roles_allowed = [];
	    $scope.roles = [];
	
	    $scope.onlyOptional = onlyOptional;
	
	    activate();
	
	    function activate() {
	        $scope.tab_history = {};
	
	        // Set initial menu tab
	        $scope.switchTab('post', 'survey-build');
	
	        $scope.loadRoleData();
	        $scope.save = $translate.instant('app.save');
	        $scope.saving = $translate.instant('app.saving');
	
	        if ($scope.surveyId) {
	            loadFormData();
	        } else {
	            // When creating new survey
	            // pre-fill object with default tasks and attributes
	            $scope.survey = {
	                color: null,
	                require_approval: true,
	                everyone_can_create: true,
	                tasks: [{
	                    label: 'Post',
	                    priority: 0,
	                    required: false,
	                    type: 'post',
	                    show_when_published: 1,
	                    attributes: [{
	                        cardinality: 0,
	                        input: 'text',
	                        label: 'Title',
	                        priority: 1,
	                        required: true,
	                        type: 'title',
	                        options: [],
	                        config: {},
	                        form_stage_id: getInterimId()
	                    }, {
	                        cardinality: 0,
	                        input: 'text',
	                        label: 'Description',
	                        priority: 2,
	                        required: true,
	                        type: 'description',
	                        options: [],
	                        config: {},
	                        form_stage_id: getInterimId()
	                    }],
	                    is_public: true
	                }]
	            };
	
	            $scope.survey.tasks[0].id = $scope.getInterimId();
	        }
	
	        loadAvailableForms();
	        loadAvailableCategories();
	
	        if (!$scope.surveyId) {
	            $q.all([Features.loadFeatures(), FormEndpoint.queryFresh().$promise]).then(function (data) {
	                var forms_limit = Features.getLimit('forms');
	                // When limit is TRUE , it means no limit
	                // @todo run check before render
	                if (forms_limit !== true && forms_limit <= data[1].length) {
	                    Notify.limit('limit.post_type_limit_reached');
	                    $location.path('settings/surveys');
	                }
	            });
	        }
	    }
	
	    function onlyOptional(editAttribute) {
	        return editAttribute.type !== 'title' && editAttribute.type !== 'description';
	    }
	
	    function switchTab(section, tab) {
	
	        // First unset last active tab
	        var old_tab = $scope.tab_history[section];
	        if (old_tab) {
	            var old_tab_li = old_tab + '-li';
	            angular.element(document.getElementById(old_tab)).removeClass('active');
	            angular.element(document.getElementById(old_tab_li)).removeClass('active');
	        }
	        // Set new active tab
	        tab = tab + '-' + section;
	        $scope.tab_history[section] = tab;
	        var tab_li = tab + '-li';
	        angular.element(document.getElementById(tab)).addClass('active');
	        angular.element(document.getElementById(tab_li)).addClass('active');
	    }
	
	    function allowedToggleOrder(attribute) {
	        return attribute.type !== 'title' && attribute.type !== 'description';
	    }
	
	    function getInterimId() {
	        var id = 'interim_id_' + $scope.currentInterimId;
	        $scope.currentInterimId++;
	        return id;
	    }
	
	    function removeInterimIds() {
	        _.each($scope.survey.tasks, function (task) {
	            task.id = !_.isString(task.id) ? task.id : undefined;
	        });
	    }
	
	    function loadAvailableForms() {
	        // Get available forms for relation field
	        FormEndpoint.queryFresh().$promise.then(function (forms) {
	            $scope.availableForms = forms;
	        });
	    }
	    function loadAvailableCategories() {
	        // Get available tags for selected for or all tags if new form
	        TagEndpoint.queryFresh().$promise.then(function (tags) {
	            // adding children to parents
	            $scope.availableCategories = _.map(_.where(tags, { parent_id: null }), function (tag) {
	                if (tag && tag.children) {
	                    tag.children = _.map(tag.children, function (child) {
	                        return _.findWhere(tags, { id: parseInt(child.id) });
	                    });
	                }
	                return tag;
	            });
	        });
	    }
	
	    function loadFormData() {
	        // If we're editing an existing survey,
	        // load the survey info and all the fields.
	        $q.all([FormEndpoint.getFresh({ id: $scope.surveyId }).$promise, FormStageEndpoint.queryFresh({ formId: $scope.surveyId }).$promise, FormAttributeEndpoint.queryFresh({ formId: $scope.surveyId }).$promise, FormRoleEndpoint.queryFresh({ formId: $scope.surveyId }).$promise]).then(function (results) {
	            var survey = results[0];
	            survey.tasks = _.sortBy(results[1], 'priority');
	            var attributes = _.chain(results[2]).sortBy('priority').value();
	            _.each(attributes, function (attr) {
	                if (attr.type === 'tags') {
	                    attr.options = _.map(attr.options, function (option) {
	                        return parseInt(option);
	                    });
	                }
	            });
	            _.each(survey.tasks, function (task) {
	                // Set initial menu tab
	                $scope.switchTab(task.id, 'section-build');
	                task.attributes = _.filter(attributes, function (attribute) {
	                    return attribute.form_stage_id === task.id;
	                });
	            });
	            //survey.grouped_attributes = _.sortBy(survey.attributes, 'form_stage_id');
	            $scope.survey = survey;
	
	            var roles_allowed = results[3];
	
	            $scope.roles_allowed = _.pluck(roles_allowed, 'role_id');
	
	            // Remove source survey information
	            if ($scope.actionType === 'duplicate') {
	
	                $scope.survey.name = undefined;
	                $scope.survey.description = undefined;
	
	                delete $scope.survey.id;
	                delete $scope.survey.created;
	                delete $scope.survey.updated;
	                delete $scope.survey.url;
	                delete $scope.survey.can_create;
	                delete $scope.survey.tags;
	
	                // Reset Task and Attribute IDs
	                _.each($scope.survey.tasks, function (task) {
	                    task.form_id = undefined;
	                    task.id = $scope.getInterimId();
	                    delete task.url;
	
	                    _.each(task.attributes, function (attribute) {
	                        attribute.form_stage_id = task.id;
	                        delete attribute.id;
	                        delete attribute.url;
	                        delete attribute.key;
	                    });
	                });
	            }
	        });
	    }
	
	    function loadRoleData() {
	        $q.all([RoleEndpoint.query().$promise]).then(function (results) {
	            $scope.roles = results[0];
	        });
	    }
	
	    function cancel() {
	        $location.url('/settings/surveys');
	    }
	
	    function handleResponseErrors(errorResponse) {
	        $scope.saving_survey = false;
	        Notify.apiErrors(errorResponse);
	    }
	
	    // START -- Reorder tasks
	    // This function assumes the default
	    // Post task is unmoveable
	    function isFirstTask(task) {
	        var tasks = $scope.survey.tasks,
	
	        // Find our current stage
	        index = _.indexOf(tasks, task);
	        return index === 1;
	    }
	
	    function isLastTask(task) {
	        var tasks = $scope.survey.tasks,
	
	        // Find our current stage
	        index = _.indexOf(tasks, task);
	        return index === tasks.length - 1;
	    }
	
	    // START -- Reorder tasks
	    function isFirstAttribute(task, attribute) {
	        var attributes = task.attributes,
	
	        // Find our current attribute
	        index = _.indexOf(attributes, attribute);
	        return index === 0;
	    }
	
	    function isLastAttribute(task, attribute) {
	        var attributes = task.attributes,
	
	        // Find our current attribute
	        index = _.indexOf(attributes, attribute);
	        return index === attributes.length - 1;
	    }
	
	    function canReorderTask(task) {
	        //Only the Post task can not be reordered
	        return task.label !== 'Post';
	    }
	
	    function moveTaskUp(task) {
	        changeTaskPriority(task, -1);
	    }
	
	    function moveTaskDown(task) {
	        changeTaskPriority(task, 1);
	    }
	
	    function moveAttributeUp(task, attribute) {
	        changeAttributePriority(task, attribute, -1);
	    }
	
	    function moveAttributeDown(task, attribute) {
	        changeAttributePriority(task, attribute, 1);
	    }
	
	    function changeAttributePriority(task, attribute, increment) {
	        var attributes = task.attributes,
	
	        // Find our current stage
	        index = _.indexOf(attributes, attribute),
	
	        // Grab prev/next stage
	        next = attributes[index + increment];
	
	        // Check we're not at the end of the list
	        if (_.isUndefined(next)) {
	            return;
	        }
	        // Swap priorities
	        next.priority = attribute.priority;
	        attribute.priority = attribute.priority + increment;
	
	        // Resort attribute list
	        task.attributes = _.sortBy(attributes, 'priority');
	    }
	
	    function changeTaskPriority(task, increment) {
	        var tasks = $scope.survey.tasks,
	
	        // Find our current stage
	        index = _.indexOf(tasks, task),
	
	        // Grab prev/next stage
	        next = tasks[index + increment];
	
	        // Check we're not at the end of the list
	        if (_.isUndefined(next)) {
	            return;
	        }
	        // Swap priorities
	        next.priority = task.priority;
	        task.priority = task.priority + increment;
	
	        // Resort stage list
	        $scope.survey.tasks = _.sortBy(tasks, 'priority');
	    }
	
	    function changeTaskLabel(task) {
	        // Task labels must be unique
	
	        // If the task is not yet saved we need to make sure to update
	        // it's attributes form_stage_id as this is their linkage
	        if (!task.id) {
	            _.each(task.attributes, function (attribute) {
	                attribute.form_stage_id = task.label;
	            });
	        }
	    }
	    // END - reorder tasks
	
	    // Start Modify Tasks
	    function openTaskModal() {
	        ModalService.openTemplate('<survey-task-create></survey-task-create>', 'survey.add_task', '', $scope, true, true);
	    }
	
	    function getNewTaskPriority() {
	        return $scope.survey.tasks.length ? _.last($scope.survey.tasks).priority + 1 : 0;
	    }
	
	    function getNewAttributePriority(task) {
	        return task.attributes.length ? _.last(task.attributes).priority + 1 : 0;
	    }
	
	    function addNewTask(task) {
	        ModalService.close();
	        // Set task priority
	        task.priority = getNewTaskPriority();
	        task.id = $scope.getInterimId();
	        $scope.survey.tasks.push(task);
	        $scope.switchTab(task.id, 'section-build');
	    }
	
	    function openAttributeModal(task) {
	        // Set active task so we know who this attribute will belong to
	        $scope.activeTask = task;
	        ModalService.openTemplate('<survey-attribute-create></survey-attribute-create>', 'survey.add_field', '', $scope, true, true);
	    }
	
	    function openAttributeEditModal(task, attribute) {
	        // If creating a new attribute we need to close
	        // the type picker first
	        $scope.activeTask = task;
	        if (!attribute.form_stage_id) {
	            ModalService.close();
	        }
	        $scope.editAttribute = attribute;
	        var title = attribute.id ? 'survey.edit_field' : 'survey.add_field';
	        ModalService.openTemplate('<survey-attribute-editor></survey-attribute-editor>', title, '', $scope, true, true);
	    }
	
	    function addNewAttribute(attribute, task) {
	        ModalService.close();
	        // Set active task as form_stage_id
	        // If this task is new and has not been saved
	        // it won't have an id so in this instance we use its label
	        // Labels are not guaranteed to be unique
	        // TODO refactor this
	        if (!attribute.form_stage_id) {
	            // Set attribute priority
	            attribute.priority = getNewAttributePriority(task);
	            attribute.form_stage_id = task.id ? task.id : task.label;
	            task.attributes.push(attribute);
	        }
	    }
	
	    function deleteAttribute(attribute, task) {
	        Notify.confirmDelete('notify.form.delete_attribute_confirm', 'notify.form.delete_attribute_confirm_desc').then(function () {
	            // If we have not yet saved this attribute
	            // we can drop it immediately
	            if (!attribute.id) {
	                task.attributes = _.filter(task.attributes, function (item) {
	                    return item.label !== attribute.label;
	                });
	                // Attribute delete is currently only available in modal
	                // so close the modal
	                ModalService.close();
	                return;
	            }
	
	            FormAttributeEndpoint.delete({
	                formId: $scope.survey.id,
	                id: attribute.id
	            }).$promise.then(function (attribute) {
	                // Remove attribute from scope, binding should take care of the rest
	                var index = _.findIndex(task.attributes, function (item) {
	                    return item.id === attribute.id;
	                });
	
	                task.attributes.splice(index, 1);
	
	                FormStageEndpoint.invalidateCache();
	
	                Notify.notify('notify.form.destroy_attribute_success', { name: attribute.label });
	
	                // Attribute is only available in modal so
	                // close the modal
	                ModalService.close();
	            });
	        });
	    }
	
	    function duplicateSection(task) {
	        var dup = angular.copy(task);
	        dup.label = undefined;
	        dup.description = undefined;
	        dup.id = getInterimId();
	        _.each(dup.attributes, function (attribute) {
	            delete attribute.id;
	            delete attribute.url;
	            delete attribute.key;
	            attribute.form_stage_id = dup.id;
	        });
	        $scope.survey.tasks.push(dup);
	        $scope.switchTab(dup.id, 'section-build');
	    }
	
	    function deleteTask(task) {
	
	        Notify.confirmDelete('notify.form.delete_stage_confirm', 'notify.form.delete_stage_confirm_desc').then(function () {
	            // If we haven't saved the task yet then we can just drop it
	            if (!task.id || _.isString(task.id)) {
	                $scope.survey.tasks = _.filter($scope.survey.tasks, function (item) {
	                    return item.label !== task.label;
	                });
	                return;
	            }
	
	            FormStageEndpoint.delete({
	                formId: $scope.survey.id,
	                id: task.id
	            }).$promise.then(function () {
	                // Remove stage from scope, binding should take care of the rest
	                Notify.notify('notify.form.destroy_stage_success', { name: task.label });
	
	                $scope.survey.tasks = _.filter($scope.survey.tasks, function (item) {
	                    return item.id !== task.id;
	                });
	            });
	        });
	    }
	    // END - modify task
	
	    //Start - modify Survey
	
	    function saveSurvey() {
	        // Set saving to true to disable user actions
	        $scope.saving_survey = true;
	        // Save the survey
	        FormEndpoint.saveCache($scope.survey).$promise.then(function (survey) {
	            // If the survey is new, cache the new id
	            if ($scope.survey.id !== survey.id) {
	                $scope.survey.id = survey.id;
	            }
	            // Save tasks and roles and return promises
	            return $q.all([saveTasks(), saveRoles()]);
	        }).then(function () {
	            // Save attributes and return promises
	            return saveAttributes();
	        }).then(function () {
	            // Display success message
	            SurveyNotify.success('notify.form.edit_form_success', { name: $scope.survey.name }, { formId: $scope.survey.id });
	            // Redirect to survey list
	            $location.url('settings/surveys');
	        })
	        // Catch and handle errors
	        .catch(handleResponseErrors);
	    }
	
	    function saveTasks() {
	        var promises = [];
	        // Remove interim ids from tasks
	        $scope.removeInterimIds();
	        _.each($scope.survey.tasks, function (task) {
	            // Assign survey id to each task
	            task.form_id = $scope.survey.id;
	            // Add each task to promise array
	            promises.push(FormStageEndpoint.saveCache(_.extend(task, { formId: $scope.survey.id })).$promise);
	        });
	        return $q.all(promises).then(function (tasks) {
	            // Ensure tasks are ordered by priority
	            tasks = _.sortBy(tasks, 'priority');
	            // Associate tasks to preserve attributes
	            _.each(tasks, function (task, index) {
	                _.extend($scope.survey.tasks[index], task);
	            });
	        });
	    }
	
	    function saveAttributes() {
	        var promises = [];
	        _.each($scope.survey.tasks, function (task) {
	            _.each(task.attributes, function (attribute) {
	                // Remove faulty category ids from each attribute
	                if (attribute.type === 'tags') {
	                    attribute.options = _.filter(attribute.options, function (option) {
	                        return !isNaN(option);
	                    });
	                }
	                // Assign stage id to each attribute
	                attribute.form_stage_id = task.id;
	                // Add each attribute to promise array
	                promises.push(FormAttributeEndpoint.saveCache(_.extend(attribute, { formId: $scope.survey.id })).$promise);
	            });
	        });
	        return $q.all(promises);
	    }
	
	    function saveRoles() {
	        return FormRoleEndpoint.saveCache(_.extend({ roles: $scope.roles_allowed }, { formId: $scope.survey.id })).$promise;
	    }
	
	    function toggleTaskRequired(task) {
	        task.required = !task.required;
	    }
	
	    function toggleTaskPublic(task) {
	        task.is_public = !task.is_public;
	    }
	
	    function toggleAttributeRequired(attribute) {
	        attribute.required = !attribute.required;
	    }
	
	    // Options functions
	    $scope.hasOptions = function (attribute) {
	        return _.contains(['checkbox', 'radio', 'select'], attribute.input);
	    };
	    $scope.removeOption = function (attribute, key) {
	        attribute.options.splice(key, 1);
	    };
	    $scope.addOption = function (attribute) {
	        attribute.options.push('');
	    };
	}

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div> <div class=\"mode-context init\" dropdown> <header class=mode-context-header> <ol class=breadcrumbs> <li><a href=/ ng-controller=\"navigation as nav\">{{nav.site.name}}</a></li> <li><a href=/settings translate>app.settings</a></li> <li><a href=/settings/surveys translate>app.surveys</a></li> </ol> <h1 ng-show=survey.id class=mode-context-title translate>app.edit_survey</h1> <h1 ng-show=!survey.id class=mode-context-title translate>app.add_survey</h1> </header> <span class=mode-context-trigger dropdown-toggle> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> <span class=\"label hidden\" translate>app.show_more_less</span> </span> </div> <main role=main> <div class=toolbar> <div class=button-group> <button type=button class=button-flat ng-click=cancel() translate>app.cancel</button> <button type=submit class=button-alpha ng-if=!saving_survey ng-click=saveSurvey()>{{save}}</button> <button type=submit class=button-alpha disabled=disabled ng-if=saving_survey>{{saving}} <div class=loading> <div class=line></div> <div class=line></div> <div class=line></div> </div> </button> </div> </div> <div class=full-col> <section class=form-sheet> <span class=post-band ng-style=\"{backgroundColor: survey.color}\"></span> <div class=\"form-field title survey-title\"> <label class=hidden translate>survey.survey_name</label> <input type=text placeholder=\"{{ 'survey.survey_name' | translate }}\" ng-model=survey.name> <label class=hidden translate>app.description</label> <textarea placeholder=\"{{ 'survey.describe_your_survey' | translate }}\" ng-model=survey.description>Reports about streets that need resurfacing, repairs, or the removal of a hazard.</textarea> </div> <nav class=\"tabs-menu init\" data-tabs=survey-details> <ul> <li id=survey-build-post-li> <a ng-click=\"switchTab('post', 'survey-build')\" translate=survey.build> Build </a> </li> <li id=survey-configure-post-li> <a ng-click=\"switchTab('post', 'survey-configure')\" translate=survey.configure> Configure </a> </li> <li id=survey-share-post-li> <a ng-click=\"switchTab('post', 'survey-share')\" ng-show=survey.id translate=survey.share> Share </a> </li> </ul> </nav> <div id=survey-build-post class=\"survey-details tabs-target\"> <div class=\"listing init\" style=margin-left:4px> <h3 class=\"listing-heading hidden\" translate=survey.post_fields>Fields</h3> <div class=listing-item ng-repeat=\"attribute in survey.tasks[0].attributes track by $index\"> <div class=listing-item-select ng-show=allowedToggleOrder(attribute)> <div class=buttons-updown> <button type=button class=button-beta ng-disabled=\"isFirstAttribute(survey.tasks[0], attribute)\" ng-click=\"moveAttributeUp(survey.tasks[0], attribute)\"> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#chevron-top></use> </svg> <span class=\"label hidden\">Move up</span> </button> <button type=button class=button-beta ng-disabled=\"isLastAttribute(survey.tasks[0], attribute)\" ng-click=\"moveAttributeDown(survey.tasks[0], attribute)\"> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> <span class=\"label hidden\">Move down</span> </button> </div> </div> <div class=listing-item-secondary ng-show=onlyOptional(attribute)> <button class=\"button-beta button-flat\" ng-click=\"deleteAttribute(attribute, survey.tasks[0])\"> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#trash></use> </svg> <span class=hidden>Delete</span> </button> </div> <div class=listing-item-primary> <div class=listing-item-image> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#ic_short_text_24px></use> </svg> </div> <h2 class=listing-item-title> <a ng-click=\"openAttributeEditModal(survey.tasks[0], attribute)\"> {{attribute.label}} </a> <span class=\"listing-item-image tooltip\" ng-show=attribute.response_private> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#lock-locked></use> </svg> <span class=bug translate=survey.response_private_desc>Only people with permission to edit responses can see responses to this field</span> </span> </h2> </div> </div> <div class=listing-item> <div class=listing-item-primary> <h2 class=listing-item-title> <a ng-click=openAttributeModal(survey.tasks[0]) class=\"button button-beta\" data-modal=add-field> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#plus></use> </svg> <span translate=survey.add_field>Add field</span> </a> </h2> </div> </div> </div> </div> <div id=survey-configure-post class=\"survey-details tabs-target\"> <div class=\"form-field switch\"> <label translate=survey.require_review>Require posts be reviewed before they're published</label> <p data-fieldgroup-target=require-review-message ng-show=survey.require_approval translate=survey.require_review_desc>New responses to this survey will be put \"under review,\" and therefore not immediately visible to the public. Users with permission to review the response can review and \"publish\" them, which would then make them visible to everyone.</p> <div class=toggle-switch> <input class=tgl id=post-review type=checkbox ng-model=survey.require_approval> <label class=tgl-btn for=post-review></label> </div> </div> <div class=\"form-field switch\"> <label translate=survey.hide_author_information>Hide author information</label> <p ng-show=survey.hide_author data-fieldgroup-target=hide-author-message translate=survey.hide_author_information_desc>Only people with permission to edit responses will be able to see who submitted them; and only when editing them.</p> <div class=toggle-switch> <input class=\"tgl init\" id=hide-author type=checkbox data-fieldgroup-toggle=hide-author-message ng-model=survey.hide_author> <label class=tgl-btn for=hide-author></label> </div> </div> <fieldset> <legend translate=survey.who_can_add>Who can add to this survey</legend> <div class=\"form-field radio icon-input\" ng-class=\"{ 'checked': survey.everyone_can_create }\"> <label for=survey-add_everyone> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#globe></use> </svg> <input name=survey-add id=survey-add_everyone ng-value=true checked=\"\" type=radio ng-model=survey.everyone_can_create> <span class=label translate=nav.everyone>Everyone</span> </label> </div> <div class=\"form-field radio icon-input\" ng-class=\"{ 'checked': !survey.everyone_can_create }\"> <label for=survey-add_roles> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#people></use> </svg> <input class=init name=survey-add id=survey-add_roles ng-value=false ng-modaldata-fieldgroup-toggle=survey-add_roles type=radio ng-model=survey.everyone_can_create> <span translate=app.specific_roles>Specific roles...</span> </label> <div class=\"form-fieldgroup init\" data-fieldgroup-target=survey-add_roles ng-class=\"{true:'', false:'active'}[survey.everyone_can_create]\"> <div class=\"form-field checkbox\" ng-repeat=\"role in roles\"> <label> <input type=checkbox checklist-model=roles_allowed checklist-value=role.id> {{role.display_name}} </label> </div> </div> </div> </fieldset> <color-picker color-container=survey></color-picker> </div> <div id=survey-share-post class=\"survey-details tabs-target\" ng-show=survey.id> <share-menu survey-id=survey.id></share-menu> </div> </section> <section class=form-sheet ng-repeat=\"task in survey.tasks | limitTo: 1 - survey.tasks.length\"> <div class=\"form-field title section-title\"> <label class=hidden translate=survey.task_name>Section name</label> <input type=text placeholder=\"{{ 'survey.untitled_task' | translate }}\" ng-change=changeTaskLabel(task) ng-model=task.label> <label class=hidden translate=survey.task_description>Section description</label> <textarea name=description placeholder=\"{{ 'survey.describe_this_task' | translate }}\" rows=1 ng-model=task.description></textarea> <div class=section-title-actions dropdown> <button class=\"button-beta button-flat init\" data-toggle=dropdown-menu dropdown-toggle> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#ellipses></use> </svg> <span class=hidden>More</span> </button> <ul class=\"dropdown-menu init\" dropdown-menu> <li> <a href=\"\" data-modal=delete-post ng-click=duplicateSection(task)> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(753) + "#ic_content_copy_24px></use> </svg> <span class=label translate=survey.duplicate_task>Duplicate task</span> </a> </li> <li> <a href=\"\" data-modal=delete-post ng-click=deleteTask(task)> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#trash></use> </svg> <span class=label translate=survey.delete_task>Delete task</span> </a> </li> </ul> </div> </div> <nav class=\"tabs-menu init\" data-tabs=section-1-details> <ul> <li class=active ng-attr-id=\"{{ 'section-build-' + task.id + '-li'}}\"> <a ng-click=\"switchTab(task.id, 'section-build')\" translate=survey.build> Build </a> </li> <li ng-attr-id=\"{{ 'section-configure-' + task.id + '-li'}}\"> <a ng-click=\"switchTab(task.id, 'section-configure')\" translate=survey.configure> Configure </a> </li> </ul> </nav> <div ng-attr-id=\"{{ 'section-build-' + task.id }}\" class=\"section-1-details tabs-target active\"> <div class=\"listing init\"> <div class=listing-item ng-repeat=\"attribute in task.attributes track by $index\"> <div class=listing-item-select> <div class=buttons-updown> <button type=button class=button-beta ng-disabled=\"isFirstAttribute(task, attribute)\" ng-click=\"moveAttributeUp(task, attribute)\"> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#chevron-top></use> </svg> <span class=\"label hidden\">Move up</span> </button> <button type=button class=button-beta ng-disabled=\"isLastAttribute(task, attribute)\" ng-click=\"moveAttributeDown(task, attribute)\"> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> <span class=\"label hidden\">Move down</span> </button> </div> </div> <div class=listing-item-secondary ng-show=onlyOptional(attribute)> <button class=\"button-beta button-flat\" ng-click=\"deleteAttribute(attribute, task)\"> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#trash></use> </svg> <span class=hidden>Delete</span> </button> </div> <div class=listing-item-primary> <div class=listing-item-image> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#ic_short_text_24px></use> </svg> </div> <h2 class=listing-item-title> <a ng-click=\"openAttributeEditModal(task, attribute)\"> {{attribute.label}} </a> <span class=\"listing-item-image tooltip\" ng-show=attribute.response_private> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#lock-locked></use> </svg> <span class=bug translate=survey.response_private_desc>Only people with permission to edit responses can see responses to this field</span> </span> </h2> </div> </div> <div class=listing-item> <div class=listing-item-primary> <h2 class=listing-item-title> <a ng-click=openAttributeModal(task) class=\"button button-beta\" data-modal=add-field> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#plus></use> </svg> <span translate=survey.add_field>Add field</span> </a> </h2> </div> </div> </div> </div> <div ng-attr-id=\"{{ 'section-configure-' + task.id }}\" class=\"section-1-details tabs-target\"> <div class=\"form-field switch\"> <label translate=survey.required>Required</label> <p data-fieldgroup-target=require-review-message ng-show=task.required translate=survey.required_desc>Require this section be completed before a post can be visible to the public.</p> <div class=toggle-switch ng-attr-id=\"{{ 'toggle-switch-required-' + task.id }}\"> <input class=tgl ng-attr-id=\"{{ 'task-required-' + task.id }}\" type=checkbox ng-model=task.required> <label class=tgl-btn for=task-required-{{task.id}} ng-attr-id=\"{{ 'task-required-label-' + task.id }}\"></label> </div> </div> <div class=\"form-field switch checked\"> <label translate=survey.show_this_task_to>Show this task to everyone when published</label> <p data-fieldgroup-target=show_section-message class=active ng-show=task.show_when_published translate=survey.show_this_task_to_desc>When a survey response is published, data from this section will be displayed.</p> <div class=toggle-switch ng-attr-id=\"{{ 'toggle-switch-show-' + task.id }}\"> <input class=\"tgl init\" ng-attr-id=\"{{ 'show_section-' + task.id }}\" type=checkbox data-fieldgroup-toggle=show_section-message ng-model=task.show_when_published> <label class=tgl-btn for=show_section-{{task.id}} ng-attr-id=\"{{ 'show_section-label-' + task.id }}\"></label> </div> </div> </div> </section> <div class=listing-item> <div class=listing-item-primary> <button ng-click=openTaskModal() class=\"button-gamma init\" data-toggle=field-type> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#plus></use> </svg> <span class=button-label translate=survey.add_task>Add task</span> </button> </div> </div> </div> </main> </div> ";

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = ['$rootScope', 'ModalService', function ($rootScope, ModalService) {
	    return {
	        restrict: 'E',
	        template: __webpack_require__(836),
	        link: function link($scope, $element, $attrs) {
	
	            // Init an empty saved search
	            $scope.newTask = {
	                required: false,
	                attributes: [],
	                type: 'task',
	                show_when_published: 1
	            };
	
	            $scope.closeModal = function () {
	                ModalService.close();
	            };
	        }
	    };
	}];

/***/ }),
/* 836 */
/***/ (function(module, exports) {

	module.exports = "<div> <div class=\"form-field title\"> <label translate=survey.task_name>task name</label> <input type=text placeholder=\"{{ 'survey.name_this_task' | translate }}\" ng-model=newTask.label> </div> <div class=form-field> <label for=task_description translate=survey.task_description> task description </label> <textarea id=task_description placeholder=\"{{ 'survey.describe_this_task' | translate }}\" name=description data-min-rows=1 rows=1 ng-model=newTask.description></textarea> </div> <div class=\"form-field switch\"> <label translate=survey.require_section>Require this section be completed before a post can be visible to the public</label> <div class=toggle-switch> <input class=tgl id=require-toggle type=checkbox ng-model=newTask.required> <label class=tgl-btn for=require-toggle></label> </div> </div> <div class=form-field> <button type=button class=\"button-link modal-trigger\" ng-click=closeModal() translate=app.cancel>Cancel</button> <button type=button class=\"button-alpha modal-trigger\" ng-click=addNewTask(newTask) translate=app.add_and_close>Add &amp; close</button> </div> </div> ";

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = ['$rootScope', '$translate', 'ModalService', '_', function ($rootScope, $translate, ModalService, _) {
	    return {
	        restrict: 'E',
	        template: __webpack_require__(838),
	        link: function link($scope, $element, $attrs) {
	
	            // Init an empty saved search
	            $scope.newAttribute = {
	                required: false,
	                options: [],
	                config: {},
	                priority: 0
	            };
	
	            $scope.createNewAttribute = function (type) {
	                // Set initial label name based on type
	                type.label = 'New ' + type.label.toLowerCase() + ' field';
	                $scope.openAttributeEditModal($scope.activeTask, _.extend($scope.newAttribute, type));
	            };
	
	            $scope.closeModal = function () {
	                ModalService.close();
	            };
	
	            $scope.availableAttrTypes = [{
	                label: 'Short text',
	                type: 'varchar',
	                input: 'text',
	                description: $translate.instant('survey.text_desc')
	            }, {
	                label: 'Long text',
	                type: 'text',
	                input: 'textarea',
	                description: $translate.instant('survey.textarea_desc')
	            }, {
	                label: 'Number (Decimal)',
	                type: 'decimal',
	                input: 'number',
	                description: $translate.instant('survey.decimal_desc')
	            }, {
	                label: 'Number (Integer)',
	                type: 'int',
	                input: 'number',
	                description: $translate.instant('survey.integer_desc')
	            }, {
	                label: 'Location',
	                type: 'point',
	                input: 'location',
	                description: $translate.instant('survey.location_desc')
	            },
	            // {
	            //     label: 'Geometry',
	            //     type: 'geometry',
	            //     input: 'text'
	            // },
	            {
	                label: 'Date',
	                type: 'datetime',
	                input: 'date',
	                description: $translate.instant('survey.date_desc')
	            }, {
	                label: 'Date & time',
	                type: 'datetime',
	                input: 'datetime',
	                description: $translate.instant('survey.datetime_desc')
	            },
	            // {
	            //     label: 'Time',
	            //     type: 'datetime',
	            //     input: 'time'
	            // },
	            {
	                label: 'Select',
	                type: 'varchar',
	                input: 'select',
	                description: $translate.instant('survey.select_desc')
	            }, {
	                label: 'Radio Buttons(s)',
	                type: 'varchar',
	                input: 'radio',
	                description: $translate.instant('survey.radio_desc')
	            }, {
	                label: 'Checkbox(es)',
	                type: 'varchar',
	                input: 'checkbox',
	                cardinality: 0,
	                description: $translate.instant('survey.checkbox_desc')
	            }, {
	                label: 'Related Post',
	                type: 'relation',
	                input: 'relation',
	                description: $translate.instant('survey.relation_desc')
	            }, {
	                label: 'Image',
	                type: 'media',
	                input: 'upload',
	                description: $translate.instant('survey.upload_desc')
	            }, {
	                label: 'Embed video',
	                type: 'varchar',
	                input: 'video',
	                description: $translate.instant('survey.video_desc')
	            }, {
	                label: 'Markdown',
	                type: 'markdown',
	                input: 'markdown',
	                description: $translate.instant('survey.markdown_desc')
	            }, {
	                label: 'Categories',
	                type: 'tags',
	                cardinality: 0,
	                input: 'tags',
	                description: $translate.instant('settings.settings_list.categories_desc')
	            }];
	        }
	    };
	}];

/***/ }),
/* 838 */
/***/ (function(module, exports) {

	module.exports = "<dl class=modal-body> <dt class=list-item ng-repeat-start=\"type in availableAttrTypes\"> <a ng-click=createNewAttribute(type) data-modal=edit-field> {{type.label}} </a> </dt> <dd ng-repeat-end=\"\">{{type.description}}</dd> </dl> ";

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = ['$rootScope', 'ModalService', '_', function ($rootScope, ModalService, _) {
	    return {
	        restrict: 'E',
	        template: __webpack_require__(840),
	        link: function link($scope, $element, $attrs) {
	            $scope.defaultValueToggle = false;
	            $scope.descriptionToggle = false;
	            $scope.editName = function () {
	                if (!$scope.editAttribute.id) {
	                    $scope.editAttribute.label = '';
	                }
	            };
	            $scope.closeModal = function () {
	                ModalService.close();
	            };
	
	            $scope.onlyOptional = function () {
	                return $scope.editAttribute.type !== 'title' && $scope.editAttribute.type !== 'description';
	            };
	
	            $scope.canDisplay = function () {
	                return $scope.editAttribute.input !== 'upload' && $scope.editAttribute.type !== 'title' && $scope.editAttribute.type !== 'description' && $scope.editAttribute.input !== 'tags';
	            };
	            $scope.selectChild = function (child) {
	                if (!_.contains($scope.editAttribute.options, child.parent.id) && _.contains($scope.editAttribute.options, child.id)) {
	                    $scope.editAttribute.options.push(child.parent.id);
	                }
	            };
	
	            $scope.canMakePrivate = function () {
	                return $scope.editAttribute.type !== 'tags';
	            };
	        }
	    };
	}];

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = " <div class=modal-body> <div class=form-field> <label translate=app.name>Name</label> <input type=text ng-model=editAttribute.label ng-click=editName()> </div> <div class=\"form-field switch\"> <label translate=survey.show_field_description>Show field description</label> <div class=toggle-switch> <input class=\"tgl init\" id=show-field-description-new type=checkbox data-fieldgroup-toggle=field-description-new ng-click=\"descriptionToggle=!descriptionToggle\"> <label class=tgl-btn for=show-field-description-new></label> </div> <div class=form-field data-fieldgroup-target=field-description-new ng-show=descriptionToggle> <input type=text placeholder=\"Explain this field...\" ng-model=editAttribute.instructions> </div> </div> <div ng-if=canDisplay()> <div class=form-field ng-if=hasOptions(editAttribute)> <label translate>form.field_options</label> <div class=input-inline ng-repeat=\"(key, option) in editAttribute.options track by $index\"> <input type=text placeholder=\"{{ 'form.field_option_placeholder'|translate }}\" ng-model=editAttribute.options[key]> <button type=button class=\"button-flat button-beta\" ng-if=\"editAttribute.options.length > 1\" ng-click=\"removeOption(editAttribute, key)\"> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#trash></use> </svg> <span class=\"button-label hidden\">Remove</span> </button> </div> <button type=button class=\"button-secondary alt\" ng-click=addOption(editAttribute)><i class=\"fa fa-plus\"></i> <span translate>form.field_add_option</span></button> </div> </div> <div class=form-field ng-if=\"editAttribute.input ==='tags'\"> <label translate>Which categories should be available</label> <div class=\"form-field checkbox\" ng-repeat=\"category in availableCategories\"> <label> <input type=checkbox checklist-model=editAttribute.options checklist-value=category.id /> {{category.tag}} </label> <div class=\"form-field checkbox\" ng-if=category.children ng-repeat=\"child in category.children\"> <label> <input type=checkbox checklist-model=editAttribute.options checklist-value=child.id ng-click=selectChild(child) /> {{child.tag}} </label> </div> </div> </div> <div class=form-field ng-if=\"editAttribute.input === 'relation'\"> <label translate>survey.field_allowed_relation_survey</label> <ul name=visible-to> <li ng-repeat=\"relationForm in availableForms | filter : filterNotCurrentForm\"> <label> <input type=checkbox checklist-model=editAttribute.config.input.form checklist-value=relationForm.id /> {{relationForm.name}} </label> </li> </ul> </div> <div class=\"form-field switch\" ng-show=\"onlyOptional() && editAttribute.input !== 'tags'\"> <label translate=survey.required>Require this field be completed</label> <div class=toggle-switch> <input class=tgl id=switchnewattribute type=checkbox ng-model=editAttribute.required> <label class=tgl-btn for=switchnewattribute></label> </div> </div> <div class=\"form-field switch\" ng-show=canMakePrivate()> <label translate=survey.make_response_private>Make responses private</label> <p data-fieldgroup-target=field-private-message-3 class=\"init active\" translate=survey.response_private_desc ng-show=editAttribute.response_private> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#lock-locked></use> </svg> Only people with permission to edit responses will be able to see responses to this field. </p> <div class=toggle-switch> <input class=tgl id=switchprivateresponse type=checkbox ng-model=editAttribute.response_private> <label class=tgl-btn for=switchprivateresponse></label> </div> </div> <div class=\"form-field switch\" ng-if=canDisplay()> <label translate=app.default_value>Default value</label> <div class=toggle-switch> <input class=\"tgl init\" id=include-default-value-new type=checkbox data-fieldgroup-toggle=field-default-value-new ng-click=\"defaultValueToggle=!defaultValueToggle\"> <label class=tgl-btn for=include-default-value-new></label> </div> <div class=form-field data-fieldgroup-target=field-default-value-new ng-show=defaultValueToggle> <div ng-switch=editAttribute.input> <input ng-switch-when=location type=text placeholder=\"{{ 'form.default_location_placeholder'|translate }}\" ng-model=editAttribute.default> <input ng-switch-when=date type=text date-time=editAttribute.default ng-model=editAttribute.default> <input ng-switch-when=int type=number step=1 ng-model=editAttribute.default> <input ng-switch-when=decimal type=number ng-model=editAttribute.default> <input ng-switch-default type=text placeholder=\"{{ 'form.default_default_placeholder'|translate }}\" ng-model=editAttribute.default> </div> </div> </div> </div> <div class=form-field> <button ng-show=!editAttribute.id type=button class=\"button-alpha modal-trigger\" ng-click=\"addNewAttribute(editAttribute, activeTask)\" translate=app.add_and_close>Add &amp; close</button> <button ng-show=editAttribute.id type=button class=\"button-alpha modal-trigger\" ng-click=\"addNewAttribute(editAttribute, activeTask)\" translate=app.update_and_close>Update &amp; close</button> </div> ";

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = SurveyNotify;
	
	var scope;
	
	SurveyNotify.$inject = ['_', '$q', '$rootScope', '$translate', 'SliderService', 'ModalService'];
	function SurveyNotify(_, $q, $rootScope, $translate, SliderService, ModalService) {
	    return {
	        success: success
	    };
	
	    function success(successText, translateValues, values) {
	        var scope = getScope();
	
	        function showSlider(successText) {
	            values.successText = successText;
	            scope = _.extend(scope, values);
	
	            SliderService.openTemplate(__webpack_require__(842), 'thumb-up', 'confirmation', scope, false, false);
	        }
	
	        $translate(successText, translateValues).then(showSlider, showSlider);
	    }
	
	    function getScope() {
	        if (scope) {
	            scope.$destroy();
	        }
	        scope = $rootScope.$new();
	        return scope;
	    }
	}

/***/ }),
/* 842 */
/***/ (function(module, exports) {

	module.exports = "<p> {{successText}} </p> <a class=\"button button-beta\" ng-click=close() ng-href=/posts/create/{{formId}} translate=notify.form.add_to_survey>Add to survey</a> <button class=\"button-flat message-trigger\" ng-click=close() translate=message.button.dismiss> Dismiss </button> ";

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = ['$translate', '$rootScope', '_', 'ConfigEndpoint', 'Notify', 'Util', 'Languages', 'Features', function ($translate, $rootScope, _, ConfigEndpoint, Notify, Util, Languages, Features) {
	    return {
	        restrict: 'E',
	        replace: true,
	        scope: {},
	        template: __webpack_require__(844),
	        link: function link($scope, $element, $attrs) {
	            $scope.isAdmin = $rootScope.isAdmin;
	            $scope.hasPermission = $rootScope.hasPermission;
	            $scope.hasManageSettingsPermission = $rootScope.hasManageSettingsPermission;
	            $scope.tierNames = {
	                'free': 'Mapper',
	                'surveyor': 'Surveyor',
	                'responder': 'Responder',
	                'free-pre-jun-2016': 'Mapper (Legacy)',
	                'zerorated': 'Social Impact'
	            };
	
	            Features.loadFeatures().then(function () {
	                $scope.planIsAvailable = Features.isViewEnabled('plan');
	                ConfigEndpoint.get({ id: 'site' }).$promise.then(function (site) {
	                    $scope.tier = site.tier;
	                });
	            });
	        }
	    };
	}];

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div> <layout-class layout=c></layout-class> <div class=\"mode-context init\" ng-controller=\"navigation as nav\" dropdown> <header class=mode-context-header ng-class=\"{ 'has-logo' : nav.site.image_header }\"> <h1 class=mode-context-title><a href=/ ng-bind=nav.site.name></a></h1> <img ng-if=nav.site.image_header ng-src=\"{{ nav.site.image_header }}\" class=deployment-logo /> </header> <span class=mode-context-trigger dropdown-toggle> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> <span class=\"label hidden\" translate>app.show_more_less</span> </span> <div class=mode-context-body> <p markdown-to-html=nav.site.description></p> </div> </div> <main role=main> <div class=main-col> <div class=\"listing card init\" ng-show=hasManageSettingsPermission()> <div class=listing-item ng-show=\"hasPermission('Manage Settings')\"> <div class=listing-item-primary> <h2 class=listing-item-title><a href=/settings/general translate>settings.settings_list.general</a></h2> <p class=listing-item-secondary translate>settings.settings_list.general_desc</p> </div> </div> <div class=listing-item ng-show=\"hasPermission('Manage Settings')\"> <div class=listing-item-primary> <h2 class=listing-item-title><a href=/settings/surveys translate>settings.settings_list.surveys</a></h2> <p class=listing-item-secondary translate>settings.settings_list.surveys_desc</p> </div> </div> <div class=listing-item ng-show=\"hasPermission('Manage Settings')\"> <div class=listing-item-primary> <h2 class=listing-item-title><a href=/settings/datasources translate>settings.settings_list.data_sources</a></h2> <p class=listing-item-secondary translate>settings.settings_list.data_sources_desc</p> </div> </div> <div class=listing-item ng-show=\"hasPermission('Bulk Data Import')\"> <div class=listing-item-primary> <h2 class=listing-item-title><a href=/settings/data-import translate>settings.settings_list.import</a></h2> <p class=listing-item-secondary translate>settings.settings_list.import_desc</p> </div> </div> <div class=listing-item ng-show=\"hasPermission('Manage Users')\"> <div class=listing-item-primary> <h2 class=listing-item-title><a href=/settings/users translate>settings.settings_list.users</a></h2> <p class=listing-item-secondary translate>settings.settings_list.users_desc</p> </div> </div> <div class=listing-item ng-show=isAdmin()> <div class=listing-item-primary> <h2 class=listing-item-title><a href=/settings/roles translate>settings.settings_list.roles</a></h2> <p class=listing-item-secondary translate>settings.settings_list.roles_desc</p> </div> </div> <div class=listing-item ng-show=\"hasPermission('Manage Settings')\"> <div class=listing-item-primary> <h2 class=listing-item-title><a href=/settings/categories translate>settings.settings_list.categories</a></h2> <p class=listing-item-secondary translate>settings.settings_list.categories_desc</p> </div> </div> <div class=listing-item ng-show=\"hasPermission('Manage Settings')\"> <div class=listing-item-primary> <h2 class=listing-item-title><a href=/settings/webhooks translate>settings.settings_list.webhooks</a></h2> <p class=listing-item-secondary translate>settings.settings_list.webhooks_desc</p> </div> </div> <div class=listing-item ng-show=planIsAvailable> <div class=listing-item-primary> <h2 class=listing-item-title><a href=/settings/plan translate>settings.settings_list.plans</a></h2> <p class=listing-item-secondary translate-values=\"{ current_plan: tierNames[tier] }\" translate>settings.settings_list.plan_desc</p> </div> </div> </div> </div> </main> </div> ";

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = ['$q', 'ConfigEndpoint', 'Leaflet', 'Maps', function ($q, ConfigEndpoint, L, Maps) {
	    return {
	        restrict: 'E',
	        scope: {
	            config: '='
	        },
	        template: __webpack_require__(846),
	        link: function link($scope, $element, $attrs) {
	            var map, marker;
	
	            $scope.patternDigitsOnly = /^[0-9]+$/;
	            $scope.patternFloat = /[-+]?(\d*[.])?\d+/;
	            $scope.minZoom = 0;
	            $scope.maxZoom = 18;
	            $scope.updateMapPreview = updateMapPreview;
	            $scope.updateMapPreviewLayer = updateMapPreviewLayer;
	
	            activate();
	
	            function activate() {
	                $scope.baselayers = Maps.getBaseLayers();
	
	                // Set initial map params
	                $q.all({
	                    map: Maps.createMap($element[0].querySelector('#settings-map')),
	                    config: Maps.getConfig(true)
	                }).then(function (data) {
	                    map = data.map;
	                    angular.extend($scope.config, data.config);
	
	                    marker = L.marker(map.getCenter(), {
	                        draggable: true,
	                        icon: Maps.pointIcon()
	                    });
	                    marker.addTo(map);
	
	                    // Get zoom limits from leaflet
	                    getMapZoomLevels();
	
	                    // Set up event handlers
	                    marker.on('dragend', handleDragEnd);
	                    map.on('zoomend', handleMoveEnd);
	                    map.on('click', handleClick);
	                });
	            }
	
	            // Get this map's available zoom levels.
	            function getMapZoomLevels() {
	                $scope.minZoom = map.getMinZoom();
	                $scope.maxZoom = map.getMaxZoom();
	            }
	
	            function updateMapPreviewLayer() {
	                // Set the preview map's tileset to the current default.
	                map.eachLayer(function (layer) {
	                    if (layer instanceof L.TileLayer) {
	                        layer.remove();
	                    }
	                });
	                Maps.getLayer($scope.config.default_view.baselayer).addTo(map);
	            }
	
	            // Update map view from config
	            function updateMapPreview() {
	                // Center the map at our current default.
	                // Set the zoom level to our default zoom.
	                map.setView([$scope.config.default_view.lat, $scope.config.default_view.lon], $scope.config.default_view.zoom);
	
	                // Update our draggable marker to the default.
	                marker.setLatLng([$scope.config.default_view.lat, $scope.config.default_view.lon]);
	            }
	
	            // Update our map defaults when the marker is dragged to a new spot.
	            function handleDragEnd(e) {
	                $scope.$evalAsync(function () {
	                    var latLng = e.target.getLatLng().wrap();
	                    $scope.config.default_view.lat = latLng.lat;
	                    $scope.config.default_view.lon = latLng.lng;
	
	                    $scope.updateMapPreview();
	                });
	            }
	
	            function handleClick(e) {
	                $scope.$evalAsync(function () {
	                    var latLng = e.latlng.wrap();
	                    $scope.config.default_view.lat = latLng.lat;
	                    $scope.config.default_view.lon = latLng.lng;
	
	                    $scope.updateMapPreview();
	                });
	            }
	
	            // Update our default zoom level when the preview map's is changed.
	            function handleMoveEnd(e) {
	                $scope.$evalAsync(function () {
	                    $scope.config.default_view.zoom = map.getZoom();
	                });
	            }
	        }
	    };
	}];

/***/ }),
/* 846 */
/***/ (function(module, exports) {

	module.exports = "<div> <div class=form-field> <label class=input-label translate>settings.map_default_location</label> <div id=settings-map style=height:300px;width:100%></div> </div> <div class=form-field> <label translate>settings.map_default_baselayer</label> <select id=map-settings-base-layer class=form-control ng-model=config.default_view.baselayer ng-change=updateMapPreviewLayer() ng-options=\"index as layer.name for (index, layer) in baselayers\"> </select> </div> <div class=form-field> <label class=input-label ng-class=\"{'error': map.latitude.$valid}\" for=map-settings-latitude translate>settings.map_default_latitude</label> <input name=latitude id=map-settings-latitude type=number step=any ng-min=-90 ng-max=90 required ng-class=\"{'error': map.latitude.$valid}\" ng-model=config.default_view.lat ng-pattern=patternFloat ng-change=updateMapPreview() /> </div> <div class=form-field> <label class=input-label ng-class=\"{'error': map.latitude.$valid}\" for=map-settings-longitude translate>settings.map_default_longitude</label> <input name=longitude id=map-settings-longitude type=number step=any ng-min=-180 ng-max=180 required ng-class=\"{'error': map.longitude.$valid}\" ng-model=config.default_view.lon ng-pattern=patternFloat ng-change=updateMapPreview() /> </div> <div class=form-field> <label class=input-label for=map-settings-zoom translate>settings.map_default_zoom_level</label> <input id=map-settings-zoom type=number ng-min=minZoom ng-max=maxZoom required class=form-control ng-model=config.default_view.zoom ng-pattern=onlyNumbers ng-change=updateMapPreview() /> </div> <div class=\"form-field checkbox\"> <input type=checkbox ng-model=config.clustering id=map-settings-clustering> <label for=map-settings-clustering translate>settings.map_clustering</label> </div> </div> ";

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = ['$q', '$http', '$translate', '$location', '$rootScope', 'ConfigEndpoint', '_', 'Notify', 'Maps', 'Util', 'Languages', 'Features', function ($q, $http, $translate, $location, $rootScope, ConfigEndpoint, _, Notify, Maps, Util, Languages, Features) {
	    return {
	        restrict: 'E',
	        replace: true,
	        scope: {
	            formId: '@',
	            formTemplate: '@'
	        },
	        template: __webpack_require__(848),
	        link: function link($scope, $element, $attrs) {
	            $scope.saving_config = false;
	
	            $scope.save = $translate.instant('app.save');
	            $scope.saving = $translate.instant('app.saving');
	            $scope.map = {};
	            $scope.fileContainer = {
	                file: null
	            };
	
	            Features.loadFeatures().then(function () {
	                $scope.isPrivateEnabled = Features.isFeatureEnabled('private');
	            });
	
	            $scope.site = ConfigEndpoint.get({ id: 'site' });
	
	            $scope.userSavedSettings = false;
	
	            $scope.clearHeader = function () {
	                $scope.site.image_header = null;
	            };
	
	            var updateSiteHeader = function updateSiteHeader() {
	                $rootScope.$broadcast('event:update:header');
	            };
	
	            var uploadHeaderImage = function uploadHeaderImage() {
	                var dfd = $q.defer();
	
	                if ($scope.fileContainer.file) {
	                    var formData = new FormData();
	                    formData.append('file', $scope.fileContainer.file);
	
	                    $http.post(Util.apiUrl('/media'), formData, {
	                        headers: {
	                            'Content-Type': undefined
	                        }
	                    }).then(function (response) {
	                        $scope.site.image_header = response.data.original_file_url;
	                        dfd.resolve();
	                    }, function (errorResponse) {
	                        dfd.reject(errorResponse);
	                    });
	                } else {
	                    dfd.resolve();
	                }
	
	                return dfd.promise;
	            };
	
	            $scope.updateConfig = function () {
	                $scope.saving_config = true;
	                uploadHeaderImage().then(function () {
	                    $q.all([ConfigEndpoint.saveCache($scope.site).$promise, ConfigEndpoint.saveCache($scope.map).$promise]).then(function (result) {
	                        $scope.saving_config = false;
	                        updateSiteHeader();
	                        Notify.notify('notify.general_settings.save_success');
	                    }, function (errorResponse) {
	                        Notify.apiErrors(errorResponse);
	                        $scope.saving_config = false;
	                    });
	                }, function (errorResponse) {
	                    Notify.apiErrors(errorResponse);
	                    $scope.saving_config = false;
	                });
	            };
	
	            $scope.cancel = function () {
	                $location.path('/settings');
	            };
	        }
	    };
	}];

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div> <div class=\"mode-context init\" dropdown> <header class=mode-context-header> <ol class=breadcrumbs> <li><a href=/ ng-controller=\"navigation as nav\">{{nav.site.name}}</a></li> <li><a href=/settings translate>app.settings</a></li> </ol> <h1 class=mode-context-title translate>app.general</h1> </header> <span class=mode-context-trigger dropdown-toggle> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> <span class=\"label hidden\" translate>app.show_more_less</span> </span> </div> <main role=main> <form id=site name=form ng-submit=updateConfig()> <div class=toolbar> <div class=button-group> <button type=button class=button-flat ng-click=cancel() translate>app.cancel</button> <button type=submit ng-click=updateConfig() class=button-alpha ng-if=!saving_config ng-disabled=\"form.$invalid || isUnchanged(site) || saving_config\">{{save}}</button> <button type=submit class=button-alpha ng-if=saving_config ng-disabled=\"form.$invalid || isUnchanged(site) || saving_config\" translate>{{saving}} <div class=loading> <div class=line></div> <div class=line></div> <div class=line></div> </div> </button> </div> </div> <div class=main-col> <div class=form-sheet> <div class=\"form-field title\"> <label class=hidden for=site-settings-name ng-class=\"{ 'success': !form.name.$invalid && form.name.$dirty, 'error' : form.name.$invalid && form.name.$dirty }\" translate>settings.deployment_name</label> <input id=name name=name type=text placeholder=\"{{'settings.deployment_name' | translate}}\" ng-model=site.name ng-class=\"{'error': form.name.$invalid && form.name.$dirty}\" required> <div class=\"alert error\" ng-repeat=\"(error, value) in form.name.$error\" ng-show=form.name.$dirty> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#warning></use> </svg> {{'settings.valid.name.' + error | translate}} </div> </div> <div class=form-field> <label for=site-settings-description translate>settings.site_description</label> <textarea id=site-settings-description name=description type=text ng-model=site.description placeholder=\"{{'settings.site_description_placeholder' | translate}}\" data-min-rows=1 rows=1></textarea> </div> <div class=form-field> <label translate>settings.deployment_logo</label> <figure ng-show=site.image_header> <img ng-src=\"{{ site.image_header }}\" class=\"postcard-image deployment-logo\"/> <button class=button-flat ng-click=clearHeader()>Delete logo</button> </figure> <file-upload container=fileContainer> </file-upload> </div> <div class=form-field> <label translate>settings.site_email</label> <p class=small translate>settings.site_email_note</p> <input id=site-settings-email type=email placeholder=name@domain.com value=brandon@ushahidi.com ng-model=site.email> </div> <div class=form-field> <label translate>settings.site_language</label> <language-switch site=site></language-switch> </div> <div class=\"form-field checkbox\" ng-show=isPrivateEnabled> <input id=private ng-model=site.private type=checkbox> <label for=private translate>settings.site_private</label> </div> <settings-map config=map></settings-map> </div> <div class=form-sheet ng-show=todo> {# TODO: not yet implemented #} <div class=form-sheet-summary> <h3 class=form-sheet-title translate>settings.deployment_delete_this</h3> </div> <div class=form-field> <p translate>settings.deployment_delete_info</p> <button class=button-destructive> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#trash></use> </svg> <span class=button-label translate>settings.deployment_delete</span> </button> </div> </div> </div> </form> </main> </div> ";

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Ushahidi Angular Filter System User directive
	 * Drop in directive for managing filters for users
	 */
	
	module.exports = [function () {
	    var controller = ['$scope', '$rootScope', '$translate', '$timeout', 'RoleEndpoint', 'UserEndpoint', '_', function ($scope, $rootScope, $translate, $timeout, RoleEndpoint, UserEndpoint, _) {
	        $scope.filtersMenuOpen = false;
	        $scope.cancel = function () {
	            // Reset filters
	            $scope.usersFiltersForm.$rollbackViewValue();
	            // and close dropdown
	            $scope.filtersMenuOpen = false;
	        };
	
	        $scope.applyFilters = function () {
	            // ngFormController automatically commits changes to the model ($scope.filters)
	            // Just close the dropdown
	            $scope.filtersMenuOpen = false;
	        };
	    }];
	    return {
	        restrict: 'E',
	        replace: true,
	        template: __webpack_require__(850),
	        scope: {
	            filters: '='
	        },
	        controller: controller
	    };
	}];

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<form name=usersFiltersForm role=search class=searchbar dropdown is-open=filtersMenuOpen auto-close=outsideClick ng-submit=applyFilters() ng-model-options=\"{ updateOn : 'submit' }\"> <filter-searchbar model=filters.q></filter-searchbar> <div class=searchbar-options> <a href=# id=toggleUserSearchFilters class=\"button searchbar-options-filter init\" data-toggle=search-filters dropdown-toggle> <span class=button-label translate>app.filters</span> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> </a> </div> <div class=\"dropdown-menu init\" data-toggle-target=search-filters dropdown-menu> <div class=dropdown-menu-body> <filter-role model=filters.role></filter-role> </div> <div class=form-field> <button type=button class=button-link ng-click=cancel() translate>app.cancel</button> <button type=submit class=button-alpha ng-disabled=applyEnabled translate>app.apply_filters</button> </div> </div> </form> ";

/***/ }),
/* 851 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$translate', '$rootScope', '$location', 'RoleEndpoint', 'Notify', '_', 'Features', function ($translate, $rootScope, $location, RoleEndpoint, Notify, _, Features) {
	    return {
	        restrict: 'A',
	        link: function link($scope, $element, $attrs) {
	            $rootScope.setLayout('layout-a');
	            $scope.refreshView = function () {
	                RoleEndpoint.queryFresh().$promise.then(function (roles) {
	                    $scope.roles = roles;
	                });
	            };
	
	            $scope.refreshView();
	            Features.loadFeatures().then(function () {
	                $scope.rolesEnabled = Features.isFeatureEnabled('roles');
	            });
	        }
	    };
	}];

/***/ }),
/* 852 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$translate', '$location', '$routeParams', '$route', 'RoleEndpoint', 'PermissionEndpoint', 'Notify', function ($translate, $location, $routeParams, $route, RoleEndpoint, PermissionEndpoint, Notify) {
	    return {
	        restrict: 'A',
	        link: function link($scope, $element, $attrs) {
	            $scope.whereToNext = 'settings/roles';
	            $scope.save = $translate.instant('app.save');
	            $scope.saving = $translate.instant('app.saving');
	            $scope.saving_role = false;
	            RoleEndpoint.getFresh({ id: $routeParams.id }).$promise.then(function (role) {
	                $scope.role = role;
	
	                $scope.title = $scope.role.id ? 'role.edit_role' : 'role.add_role';
	
	                $translate($scope.title).then(function (title) {
	                    $scope.title = title;
	                    $scope.$emit('setPageTitle', title);
	                });
	            });
	
	            PermissionEndpoint.query().$promise.then(function (permissions) {
	                $scope.permissions = permissions.results;
	            });
	
	            $scope.cancel = function () {
	                $location.path($scope.whereToNext);
	            };
	
	            $scope.saveRole = function (role) {
	                $scope.saving_role = true;
	                role.name = role.name ? role.name : role.display_name;
	
	                RoleEndpoint.saveCache(role).$promise.then(function (result) {
	                    Notify.notify('notify.role.save_success', { role: role.display_name });
	                    $location.path($scope.whereToNext);
	                }, function (errorResponse) {
	                    // error
	                    Notify.apiErrors(errorResponse);
	                });
	                $scope.saving_role = false;
	            };
	
	            var handleResponseErrors = function handleResponseErrors(errorResponse) {
	                Notify.apiErrors(errorResponse);
	            };
	
	            $scope.checkIfLastAdmin = function () {
	                var admins = 0;
	                _.each($scope.roles, function (role) {
	                    if (role.name === 'admin') {
	                        admins++;
	                    }
	                });
	
	                return admins === 1;
	            };
	
	            $scope.deleteRole = function (role) {
	                if (role.name === 'admin' && $scope.checkIfLastAdmin()) {
	                    Notify.error('notify.role.last_admin');
	                    return;
	                }
	
	                Notify.confirmDelete('notify.role.delete_question', {
	                    role: role.display_name
	                }).then(function () {
	                    RoleEndpoint.delete({ id: role.id }).$promise.then(function () {
	                        Notify.notify('notify.role.destroy_success', {
	                            role: role.display_name
	                        });
	                        $location.path($scope.whereToNext);
	                    }, handleResponseErrors);
	                });
	            };
	        }
	    };
	}];

/***/ }),
/* 853 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$translate', '$rootScope', '$location', 'WebhookEndpoint', 'Notify', '_', 'Features', function ($translate, $rootScope, $location, WebhookEndpoint, Notify, _, Features) {
	    return {
	        restrict: 'A',
	        link: function link($scope, $element, $attrs) {
	            $rootScope.setLayout('layout-a');
	
	            $scope.refreshView = function () {
	                WebhookEndpoint.queryFresh().$promise.then(function (webhooks) {
	                    $scope.webhooks = webhooks;
	                });
	            };
	
	            $scope.refreshView();
	            Features.loadFeatures().then(function () {
	                $scope.webhooksEnabled = Features.isFeatureEnabled('webhooks');
	            });
	        }
	    };
	}];

/***/ }),
/* 854 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$translate', '$location', '$routeParams', '$route', 'WebhookEndpoint', 'Notify', function ($translate, $location, $routeParams, $route, WebhookEndpoint, Notify) {
	    return {
	        restrict: 'A',
	        link: function link($scope, $element, $attrs) {
	            $scope.whereToNext = 'settings/webhooks';
	
	            // TODO: This should be set in the settings config table and retrieved from the API
	            $scope.event_types = ['create'];
	            $scope.entity_types = ['post'];
	            $scope.save = $translate.instant('app.save');
	            $scope.saving = $translate.instant('app.saving');
	            $scope.processing = false;
	            WebhookEndpoint.getFresh({ id: $routeParams.id }).$promise.then(function (webhook) {
	                $scope.webhook = webhook;
	
	                $scope.title = $scope.webhook.id ? 'webhook.edit_webhook' : 'webhook.add_webhook';
	
	                $translate($scope.title).then(function (title) {
	                    $scope.title = title;
	                    $scope.$emit('setPageTitle', title);
	                });
	            });
	
	            $scope.cancel = function () {
	                $location.path($scope.whereToNext);
	            };
	
	            $scope.saveWebhook = function (webhook) {
	                $scope.processing = true;
	                webhook.name = webhook.name ? webhook.name : webhook.display_name;
	
	                WebhookEndpoint.saveCache(webhook).$promise.then(function (result) {
	                    Notify.notify('notify.webhook.save_success', { webhook: webhook.display_name });
	                    $location.path($scope.whereToNext);
	                }, function (errorResponse) {
	                    // error
	                    Notify.apiErrors(errorResponse);
	                });
	                $scope.processing = false;
	            };
	
	            var handleResponseErrors = function handleResponseErrors(errorResponse) {
	                $scope.processing = false;
	                Notify.apiErrors(errorResponse);
	            };
	
	            $scope.deleteWebhook = function (webhook) {
	
	                Notify.confirmDelete('notify.webhook.delete_question', {
	                    webhook: webhook.display_name
	                }).then(function () {
	                    WebhookEndpoint.delete({ id: webhook.id }).$promise.then(function () {
	                        Notify.notify('notify.webhook.destroy_success', {
	                            webhook: webhook.display_name
	                        });
	                        $location.path($scope.whereToNext);
	                    }, handleResponseErrors);
	                });
	            };
	        }
	    };
	}];

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = ['$routeProvider', function ($routeProvider) {
	    /* todo: these routes should only exist when the user is admin! */
	    $routeProvider.when('/settings', {
	        controller: __webpack_require__(856),
	        template: __webpack_require__(857)
	    }).when('/settings/general', {
	        controller: __webpack_require__(858),
	        template: __webpack_require__(859)
	    }).when('/settings/data-import', {
	        controller: __webpack_require__(860),
	        template: __webpack_require__(861)
	    }).when('/settings/data-after-import', {
	        controller: __webpack_require__(862),
	        template: __webpack_require__(863)
	    }).when('/settings/surveys', {
	        controller: __webpack_require__(864),
	        template: __webpack_require__(865)
	    }).when('/settings/surveys/create', {
	        controller: __webpack_require__(866),
	        template: __webpack_require__(867)
	    }).when('/settings/surveys/:action/:id', {
	        controller: __webpack_require__(866),
	        template: __webpack_require__(867)
	    }).when('/settings/categories', {
	        controller: __webpack_require__(868),
	        template: __webpack_require__(869)
	    }).when('/settings/categories/create', {
	        controller: __webpack_require__(870),
	        template: __webpack_require__(871)
	    }).when('/settings/categories/:id', {
	        controller: __webpack_require__(870),
	        template: __webpack_require__(871)
	    }).when('/settings/users', {
	        controller: __webpack_require__(872),
	        template: __webpack_require__(873)
	    }).when('/settings/users/create', {
	        controller: __webpack_require__(874),
	        template: __webpack_require__(875)
	    }).when('/settings/users/:id', {
	        controller: __webpack_require__(876),
	        template: __webpack_require__(875)
	    }).when('/settings/roles', {
	        controller: __webpack_require__(877),
	        template: __webpack_require__(878)
	    }).when('/settings/roles/create', {
	        controller: __webpack_require__(877),
	        template: __webpack_require__(879)
	    }).when('/settings/roles/:id', {
	        controller: __webpack_require__(877),
	        template: __webpack_require__(879)
	    }).when('/settings/webhooks', {
	        controller: __webpack_require__(880),
	        template: __webpack_require__(881)
	    }).when('/settings/webhooks/create', {
	        controller: __webpack_require__(880),
	        template: __webpack_require__(882)
	    }).when('/settings/webhooks/:id', {
	        controller: __webpack_require__(880),
	        template: __webpack_require__(882)
	    }).when('/settings/datasources', {
	        controller: __webpack_require__(883),
	        template: __webpack_require__(884)
	    }).when('/settings/plan', {
	        controller: __webpack_require__(885),
	        template: __webpack_require__(886)
	    });
	}];

/***/ }),
/* 856 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$scope', '$translate', '$location', '$rootScope', function ($scope, $translate, $location, $rootScope) {
	
	    // Redirect to home if not authorized
	    if ($rootScope.hasManageSettingsPermission() === false) {
	        return $location.path('/');
	    }
	
	    $translate('tool.settings').then(function (title) {
	        $scope.title = title;
	        $scope.$emit('setPageTitle', title);
	    });
	    // Change mode
	    $scope.$emit('event:mode:change', 'settings');
	}];

/***/ }),
/* 857 */
/***/ (function(module, exports) {

	module.exports = "<settings-list></settings-list> ";

/***/ }),
/* 858 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$scope', '$rootScope', '$location', '$translate', function ($scope, $rootScope, $location, $translate) {
	
	    // Redirect to home if not authorized
	    if ($rootScope.hasManageSettingsPermission() === false) {
	        return $location.path('/');
	    }
	
	    $rootScope.setLayout('layout-a');
	    $translate('tool.site_settings').then(function (title) {
	        $scope.title = title;
	        $rootScope.$emit('setPageTitle', title);
	    });
	    // Change mode
	    $scope.$emit('event:mode:change', 'settings');
	}];

/***/ }),
/* 859 */
/***/ (function(module, exports) {

	module.exports = "<settings-editor></settings-editor> ";

/***/ }),
/* 860 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$scope', '$rootScope', '$location', '$translate', 'FormEndpoint', 'Notify', '_', function ($scope, $rootScope, $location, $translate, FormEndpoint, Notify, _) {
	
	    // Redirect to home if not authorized
	    if ($rootScope.hasManageSettingsPermission() === false) {
	        return $location.path('/');
	    }
	
	    // Change layout class
	    $rootScope.setLayout('layout-c');
	    // Change mode
	    $scope.$emit('event:mode:change', 'settings');
	
	    $scope.fileContainer = {
	        file: null
	    };
	
	    FormEndpoint.queryFresh().$promise.then(function (response) {
	        $scope.forms = response;
	    });
	}];

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div> <div class=\"mode-context init\" dropdown> <header class=mode-context-header> <ol class=breadcrumbs> <li><a href=/ ng-controller=\"navigation as nav\">{{nav.site.name}}</a></li> <li><a href=/settings translate>app.settings</a></li> </ol> <h1 class=mode-context-title translate>app.import</h1> </header> <span class=mode-context-trigger dropdown-toggle> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> <span class=\"label hidden\" translate>app.show_more_less</span> </span> </div> <main role=main> <div class=main-col importer-csv> <div class=alert translate=feature_limits.view_unavailable translate-values=\"{value: 'Bulk data import'}\" ng-show=!csvEnabled> </div> <form name=upload ng-show=csvEnabled> <div class=form-sheet> <div class=form-sheet-summary> <h2 class=form-sheet-title translate=data_import.csv>CSV</h2> <p translate=data_import.import_explanation_csv>Import the data from a CSV spreadsheet into your deployment as posts belonging to a specific survey.</p> </div> <div class=stepper> <div class=stepper-item ng-class=\"{'complete': stepOneComplete, 'active' : isActiveStep(1), 'disabled' : !isActiveStep(1) }\"> <h2 class=stepper-heading> <span class=stepper-badge ng-show=!stepOneComplete>1</span> <span class=stepper-badge ng-show=stepOneComplete> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#check></use> </svg> </span> <div translate=data_import.choose_csv_file> Choose CSV file </div> </h2> <div ng-show=!stepOneComplete> <div class=form-field> <file-upload container=fileContainer required> </file-upload> </div> <fieldset class=\"custom-fieldset init\" dropdown auto-close=outsideClick> <legend data-toggle=dropdown-menu class=\"dropdown-trigger init\" dropdown-toggle> <span class=legend-label> <span tranlate=data_import.import_to> Import to </span> <span class=custom-fieldset-value ng-show=!selectedForm.id translate=data_import.which_survey> which survey? </span> <span class=custom-fieldset-value> {{selectedForm.name}} </span> </span> <svg class=\"iconic chevron\"> <use xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> </legend> <div class=\"dropdown-menu init\" dropdown-menu> <div class=\"form-field radio\" ng-repeat=\"form in forms\" ng-class=\"{'checked' : isSelectedForm(form)}\" ng-click=setSelectedForm(form)> <label for=import-to-{{form.id}}> <input id=import-to-{{form.id}} name=import-to type=radio> {{form.name}} </label> </div> </div> </fieldset> <div class=form-field> <button class=button-alpha type=submit ng-disabled=upload.$invalid ng-click=completeStepOne() translate=settings.continue>Continue</button> </div> </div> </div> <div class=stepper-item ng-class=\"{'complete': stepTwoComplete, 'active' : isActiveStep(2), 'disabled' : !isActiveStep(2) }\"> <h2 class=stepper-heading> <span class=stepper-badge>2</span> <span translate=data_import.configure_imported_posts> Configure imported posts </span> </h2> <div ng-show=stepOneComplete> <ol class=metadata> <li>{{fileContainer.file.name}}</li> <li>{{selectedForm.name}}</li> </ol> <fieldset> <legend translate=data_import.imported_posts_status>Imported posts should have their status...</legend> <div class=\"form-field radio\"> <label for=status-model-mark> <input type=radio id=status-model-mark name=status-model ng-model=statusOption value=mark_as /> <span translate=data_import.marked_as>Marked as...</span> </label> <fieldset data-fieldgroup-target=status-model-mark ng-show=\"isStatusOption('mark_as')\"> <legend class=hidden>Post status</legend> <div class=\"form-field radio icon-input\" ng-class=\"{'checked' : isStatusSelected('published')}\"> <label for=status-published ng-click=\"setStatus('published')\"> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#globe></use> </svg> <input type=radio name=status id=status-published checked=checked data-fieldgroup-toggle=status-model-mark-published /> <span translate=post.published>Published</span> </label> <p ng-show=hasRequiredTask class=alert data-fieldgroup-target=status-model-mark-published>Your survey, <strong>{{selectedForm.name}}</strong>, includes tasks that typically must be completed for each post before they can be marked 'published.' During this import, all of your imported posts will have their tasks marked as 'incomplete', while still allowing their status to be marked as 'published.' If you edit any of these posts after they've been imported, however, you'll be asked to complete those tasks before re-publishing them.</p> </div> <div class=\"form-field radio icon-input\" ng-class=\"{'checked' : isStatusSelected('draft')}\"> <label for=status-review ng-click=\"setStatus('draft')\"> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#lock-locked></use> </svg> <input type=radio name=status id=status-review /> <span translate=post.draft>Under review</span> </label> </div> <div class=\"form-field radio icon-input\" ng-class=\"{'checked' : isStatusSelected('archived')}\"> <label for=status-archive ng-click=\"setStatus('archived')\"> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#box></use> </svg> <input type=radio name=status id=status-archive /> <span translate=post.archived>Archived</span> </label> </div> </fieldset> </div> <div class=\"form-field radio\"> <label for=status-model-columns> <input type=radio id=status-model-columns name=status-model data-fieldgroup-toggle=status-model-columns ng-model=statusOption value=defined_column /> <span translate=data_import.defined_column>Defined by a column in your CSV file...</span> </label> <div class=\"form-field select\" data-fieldgroup-target=status-model-columns ng-show=\"isStatusOption('defined_column')\"> <div class=custom-select> <select ng-model=selectedStatus> <option ng-repeat=\"column in csv.columns track by $index\" value={{$index}} label={{column}}> </option></select> </div> <p><em translate=data_import.status_explanation>Ushahidi recognizes one of three post statuses: Published, Under review, and Archived. So be sure that each entry in the column you select has one of those three values.</em></p> <p class=alert data-fieldgroup-target=status-model-mark-published>Your survey, <strong>{{selectedForm.name}}</strong>, includes tasks that typically must be completed for each post before they can be marked 'published.' During this import, all of your imported posts will have their tasks marked as 'incomplete', even if their status is marked as 'published.' If you edit any of these posts after they've been imported, however, you'll be asked to complete those tasks before re-publishing them.</p> </div> </div> </fieldset> <fieldset> <legend translate=data_import.choose_which_column>Choose which CSV column should be assigned to each survey field</legend> <p translate=data_import.each_survey_field>Each of the survey's fields are listed below. Choose the column from your CSV file that you'd like to use to populate each of those fields.</p> <table> <thead> <tr> <th translate=data_import.survey_field>Survey field</th> <th translate=data_import.csv_column>CSV column</th> </tr> </thead> <tbody> <tr ng-repeat=\"attribute in selectedForm.attributes\"> <td><span ng-class=\"{'required' : attribute.required}\">{{attribute.label}}</span></td> <td> <div class=custom-select> <select ng-model=maps_to[attribute.key]> <option selected=selected value=\"\" translate=data_import.leave_empty> Leave empty </option> <option ng-repeat=\"column in csv.columns track by $index\" value={{$index}} label={{column}}> </option></select> </div> </td> </tr> </tbody> </table> </fieldset> <div class=form-field> <button class=\"button-beta button-flat\" data-accordion-trigger=0 ng-click=cancelImport() translate=data_import.cancel_import>Cancel</button> <button type=submit class=button-alpha ng-click=completeStepTwo(csv) translate=data_import.finish_import>Finish import</button> </div> </div> </div> </div> </div> </form> </div> </main> </div> ";

/***/ }),
/* 862 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$scope', '$rootScope', '$location', '$translate', '$q', 'Notify', '_', function ($scope, $rootScope, $location, $translate, $q, Notify, _) {
	
	    // Redirect to home if not authorized
	    if ($rootScope.hasManageSettingsPermission() === false) {
	        return $location.path('/');
	    }
	
	    // Change layout class
	    $rootScope.setLayout('layout-c');
	    // Change mode
	    $scope.$emit('event:mode:change', 'settings');
	}];

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div> <div class=\"mode-context init\" dropdown> <header class=mode-context-header> <ol class=breadcrumbs> <li><a href=/ ng-controller=\"navigation as nav\">{{nav.site.name}}</a></li> <li><a href=/settings translate>app.settings</a></li> </ol> <h1 class=mode-context-title translate>app.import</h1> </header> <span class=mode-context-trigger dropdown-toggle> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> <span class=\"label hidden\" translate>app.show_more_less</span> </span> </div> <main role=main> <div class=main-col after-import-csv> <div class=form-sheet ng-show=!importComplete> <div class=form-sheet-summary> <h2 class=form-sheet-title translate=data_import.nearly_complete>Your import is nearly complete</h2> <progress max=100 value=60> <div class=progress-bar> <span style=width:60%>Progress: 60%</span> </div> </progress> <p translate=data_import.finish_info>The data from your CSV spreadsheet is still being processed. You're welcome to leave this page or wait until the process is complete. Either way, we'll notify you when your data is ready.</p> </div> <div class=form-field> <a href=/settings/data-import class=\"button button-gamma button-flat\" translate=data_import.import_another>Import another CSV file</a> </div> </div> <div class=form-sheet ng-show=importComplete> <div class=form-sheet-summary> <h2 class=form-sheet-title translate=data_import.import_complete>Your import is complete</h2> <p translate-values=\"{form_name: form.name, form_id: form.id, filename: filename}\" translate=data_import.complete_info>The data from your CSV spreadsheet, <em>filename.csv</em>, was successfully imported into your <a href=\"\">Street Maintenance</a> survey.</p> </div> <div class=form-field> <a ng-href=/collections/{{collectionId}} class=\"button button-alpha\" translate=data_import.see_imported_posts>See imported posts</a> <a href=/settings/data-import class=\"button button-gamma button-flat\" translate=data_import.import_another_csv>Import another CSV file</a> </div> </div> </div></main> </div> ";

/***/ }),
/* 864 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$scope', '$rootScope', '$translate', '$location', '$q', 'FormEndpoint', 'FormStageEndpoint', 'Notify', '_', function ($scope, $rootScope, $translate, $location, $q, FormEndpoint, FormStageEndpoint, Notify, _) {
	
	    // Change layout class
	    $rootScope.setLayout('layout-b');
	    // Redirect to home if not authorized
	    if ($rootScope.hasManageSettingsPermission() === false) {
	        return $location.path('/');
	    }
	
	    $translate('nav.posts_and_entities').then(function (title) {
	        $scope.title = title;
	        $scope.$emit('setPageTitle', title);
	    });
	    // Change mode
	    $scope.$emit('event:mode:change', 'settings');
	
	    // Get all the forms for display
	    $scope.refreshForms = function () {
	        FormEndpoint.queryFresh().$promise.then(function (response) {
	            $scope.forms = response;
	        });
	    };
	
	    $scope.deleteSurvey = function (survey) {
	        Notify.confirmDelete('notify.form.delete_form_confirm', 'notify.form.delete_form_confirm_desc').then(function () {
	            // If we haven't saved the survey
	            // just go back to the surveys views
	            if (!survey.id) {
	                $location.url('/settings/surveys');
	                return;
	            }
	
	            FormEndpoint.delete({
	                id: survey.id
	            }).$promise.then(function () {
	                Notify.notify('notify.form.destroy_form_success', { name: survey.name });
	                $scope.refreshForms();
	            }, $scope.handleResponseErrors);
	        });
	    };
	
	    $scope.handleResponseErrors = function (errorResponse) {
	        Notify.apiErrors(errorResponse);
	    };
	
	    $scope.refreshForms();
	}];

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div> <layout-class layout=a></layout-class> <div class=\"mode-context init\" dropdown> <header class=mode-context-header> <ol class=breadcrumbs> <li><a href=/ ng-controller=\"navigation as nav\">{{nav.site.name}}</a></li> <li><a href=/settings translate>app.settings</a></li> </ol> <h1 class=mode-context-title translate>app.surveys</h1> </header> <span class=mode-context-trigger dropdown-toggle> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> <span class=\"label hidden\" translate>app.show_more_less</span> </span> </div> <main role=main> <div class=toolbar> <div class=fab> <a ng-href=/settings/surveys/create type=button class=\"button button-alpha button-fab\"> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#plus></use> </svg> <span class=hidden translate>form.add_post_type</span> </a> </div> </div> <div class=main-col> <div class=\"listing card\"> <div class=listing-item ng-show=forms.length ng-repeat=\"form in forms\"> <span class=post-band ng-style=\"{backgroundColor: form.color}\"></span> <div class=listing-item-secondary dropdown> <button class=\"button-beta button-flat\" data-toggle=dropdown-menu dropdown-toggle> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#ellipses></use> </svg> <span class=hidden>More</span> </button> <ul class=\"dropdown-menu init\" dropdown-menu> <li> <a href=/settings/surveys/duplicate/{{form.id}}> <svg class=iconic> <use xlink:href=" + __webpack_require__(753) + "#ic_content_copy_24px></use> </svg> <span class=label>Duplicate</span> </a> </li> <li> <a ng-click=deleteSurvey(form)> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#trash></use> </svg> <span class=label>Delete</span> </a> </li> </ul> </div> <div class=listing-item-primary> <h2 class=listing-item-title><a href=/settings/surveys/edit/{{form.id}}>{{form.name}}</a></h2> <p class=listing-item-secondary>{{form.description}}</p> </div> </div> </div> </div> </main> </div> ";

/***/ }),
/* 866 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$scope', '$rootScope', '$routeParams', function ($scope, $rootScope, $routeParams) {
	    $scope.surveyId = $routeParams.id;
	    $scope.actionType = $routeParams.action;
	}];

/***/ }),
/* 867 */
/***/ (function(module, exports) {

	module.exports = "<survey-editor survey-id=surveyId action-type=actionType></survey-editor> ";

/***/ }),
/* 868 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$scope', '$translate', '$rootScope', '$location', '$q', 'TagEndpoint', 'Notify', '_', function ($scope, $translate, $rootScope, $location, $q, TagEndpoint, Notify, _) {
	
	    // Redirect to home if not authorized
	    if ($rootScope.hasManageSettingsPermission() === false) {
	        return $location.path('/');
	    }
	
	    $translate('tool.manage_tags').then(function (title) {
	        $scope.title = title;
	        $scope.$emit('setPageTitle', title);
	    });
	    // Change mode
	    $scope.$emit('event:mode:change', 'settings');
	
	    $scope.refreshView = function () {
	        TagEndpoint.queryFresh().$promise.then(function (tags) {
	            $scope.allCategories = tags;
	            $scope.categories = _.map(_.where(tags, { parent_id: null }), function (tag) {
	                if (tag && tag.children) {
	                    tag.children = _.map(tag.children, function (child) {
	                        return _.findWhere(tags, { id: parseInt(child.id) });
	                    });
	                }
	                return tag;
	            });
	        });
	        $scope.selectedCategories = [];
	    };
	    $scope.refreshView();
	
	    $scope.deleteCategory = function (tag) {
	        Notify.confirmDelete('notify.category.destroy_confirm', 'notify.category.destroy_confirm_desc').then(function () {
	            TagEndpoint.delete(tag).$promise.then(function () {
	                Notify.notify('notify.category.destroy_success', { name: tag.tag });
	                $scope.refreshView();
	            }, handleResponseErrors);
	        });
	    };
	
	    $scope.deleteCategories = function () {
	        Notify.confirmDelete('notify.category.bulk_destroy_confirm', 'notify.category.bulk_destroy_confirm_desc', { count: $scope.selectedCategories.length }).then(function () {
	            var calls = [];
	            angular.forEach($scope.selectedCategories, function (tagId) {
	                calls.push(TagEndpoint.delete({ id: tagId }).$promise);
	            });
	            $q.all(calls).then(function () {
	                Notify.notify('notify.category.bulk_destroy_success', { count: $scope.selectedCategories.length });
	                $scope.refreshView();
	            }, handleResponseErrors);
	        });
	    };
	
	    $scope.isToggled = function (tag) {
	        return $scope.selectedCategories.indexOf(tag.id) > -1;
	    };
	
	    $scope.toggleCategory = function (tag) {
	        var idx = $scope.selectedCategories.indexOf(tag.id);
	        if (idx > -1) {
	            $scope.selectedCategories.splice(idx, 1);
	        } else {
	            $scope.selectedCategories.push(tag.id);
	        }
	    };
	
	    function handleResponseErrors(errorResponse) {
	        Notify.apiErrors(errorResponse);
	    }
	}];

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = " <div> <layout-class layout=b></layout-class> <div class=\"mode-context init\" dropdown> <header class=mode-context-header> <ol class=breadcrumbs> <li><a href=/ ng-controller=\"navigation as nav\">{{nav.site.name}}</a></li> <li><a href=/settings translate>app.settings</a></li> </ol> <h1 class=mode-context-title translate>app.categories</h1> </header> <span class=mode-context-trigger dropdown-toggle> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> <span class=\"label hidden\" translate>app.show_more_less</span> </span> </div> <main role=main> <div class=toolbar> <div class=fab> <a ng-href=/settings/categories/create type=button class=\"button button-alpha button-fab\" ng-class=\"{'disabled': selectedCategories.length}\"> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#plus></use> </svg> <span class=hidden translate>category.add_category</span> </a> </div> </div> <div class=main-col> <div class=\"listing card\" ng-class=\"{'toolbar-active': selectedCategories.length}\"> <div class=alert ng-hide=categories.length> <p ng-hide=categories.length><em translate>empty.category</em></p> </div> <div id=category-{{category.id}} class=listing-item ng-repeat=\"category in categories\" ng-class=\"{ 'warning': isToggled(category) }\"> <div class=listing-item-select ng-click=toggleCategory(category)> <input type=checkbox value={{category.id}} ng-checked=isToggled(category)> </div> <div class=listing-item-primary> <h2 class=listing-item-title><a ng-href=/settings/categories/{{category.id}}>{{category.tag}}</a></h2> </div> <div class=listing-item-secondary> <button class=\"button-beta button-flat\" ng-click=deleteCategory(category)> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#trash></use> </svg> <span class=hidden>Delete</span> </button> </div> <div id=category-{{child.id}} class=listing-item ng-repeat=\"child in category.children\" ng-class=\"{ 'warning': isToggled(child) }\" ng-click=toggleCategory(child) ng-style=\"{'marginLeft': '50px', 'border': 'none'}\" ng-if=category.children> <div class=listing-item-select> <input type=checkbox value={{child.id}} ng-checked=isToggled(child)> </div> <div class=listing-item-primary> <h2 class=listing-item-title><a ng-href=/settings/categories/{{child.id}}>{{child.tag}}</a></h2> </div> <div class=listing-item-secondary> <button class=\"button-beta button-flat\" ng-click=deleteCategory(child)> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#trash></use> </svg> <span class=hidden>Delete</span> </button> </div> </div> </div> <listing-toolbar entities=allCategories selected-set=selectedCategories> <button type=button class=button-destructive ng-disabled=!selectedCategories.length ng-click=deleteCategories()> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#trash></use> </svg> <span class=\"button-label hidden\">nav.delete</span> </button> </listing-toolbar> </div> <uib-pagination ng-model=currentPage items-per-page=itemsPerPage total-items=totalItems ng-change=pageChanged() max-size=5 boundary-links=false rotate=false></uib-pagination> </div> </main> </div> ";

/***/ }),
/* 870 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$scope', '$rootScope', '$translate', '$location', 'RoleEndpoint', 'TagEndpoint', 'FormEndpoint', 'Notify', '_', 'Util', '$routeParams', '$q', function ($scope, $rootScope, $translate, $location, RoleEndpoint, TagEndpoint, FormEndpoint, Notify, _, Util, $routeParams, $q) {
	
	    // Redirect to home if not authorized
	    if ($rootScope.hasManageSettingsPermission() === false) {
	        return $location.path('/');
	    }
	
	    // Set initial category properties and page title
	    if ($location.path() === '/settings/categories/create') {
	        // Set initial category properties
	        $scope.category = {
	            type: 'category',
	            icon: 'tag',
	            color: '',
	            parent_id: null
	        };
	        // Allow parent category selector
	        $scope.isParent = false;
	        // Translate and set add category page title
	        $translate('category.add_tag').then(function (title) {
	            $scope.title = title;
	            $scope.$emit('setPageTitle', title);
	        });
	    } else {
	        // Get and set initial category properties
	        getCategory();
	        // Translate and set edit category page title
	        $translate('category.edit_tag').then(function (title) {
	            $scope.title = title;
	            $rootScope.$emit('setPageTitle', title);
	        });
	    }
	
	    // Change mode
	    $scope.$emit('event:mode:change', 'settings');
	
	    $scope.addParent = addParent;
	    $scope.deleteCategory = deleteCategory;
	    $scope.getParentName = getParentName;
	    $scope.saveCategory = saveCategory;
	
	    $scope.cancel = cancel;
	
	    $scope.processing = false;
	    $scope.save = $translate.instant('app.save');
	    $scope.saving = $translate.instant('app.saving');
	
	    activate();
	
	    function activate() {
	        getRoles();
	        getParentCategories();
	    }
	
	    function getRoles() {
	        RoleEndpoint.query().$promise.then(function (roles) {
	            $scope.roles = roles;
	        });
	    }
	
	    function getParentCategories() {
	        TagEndpoint.queryFresh({ level: 'parent' }).$promise.then(function (tags) {
	            // Remove current tag to avoid circular reference
	            $scope.parents = _.filter(tags, function (tag) {
	                return tag.id !== parseInt($routeParams.id);
	            });
	        });
	    }
	
	    function getCategory() {
	        TagEndpoint.getFresh({ id: $routeParams.id }).$promise.then(function (tag) {
	            $scope.category = tag;
	            // Normalize parent category
	            if ($scope.category.parent) {
	                $scope.category.parent_id = $scope.category.parent.id;
	                $scope.category.parent_id_original = $scope.category.parent.id;
	                delete $scope.category.parent;
	            }
	            if ($scope.category.children && $scope.category.children.length) {
	                $scope.isParent = true;
	            }
	        });
	    }
	
	    function addParent(id) {
	        return TagEndpoint.getFresh({ id: id });
	    }
	
	    function getParentName() {
	        var parentName = 'Nothing';
	        if ($scope.category && $scope.parents) {
	            $scope.parents.forEach(function (parent) {
	                if (parent.id === $scope.category.parent_id) {
	                    parentName = parent.tag;
	                }
	            });
	        }
	        return parentName;
	    }
	
	    function saveCategory(category) {
	        // Set processing to disable user actions
	        $scope.processing = true;
	        // Save category
	        $q.when(TagEndpoint.saveCache(category).$promise).then(function (result) {
	            // If parent category, apply parent category permisions to child categories
	            if (result.children && result.children.length) {
	                return updateChildrenPermissions(result);
	            }
	            // If child category with new parent, apply new permissions to child category
	            if (result.parent && result.parent.id !== $scope.category.parent_id_original) {
	                return updateWithParentPermissions(result);
	            }
	        }).then(function () {
	            // Display success message
	            Notify.notify('notify.category.save_success', { name: $scope.category.tag });
	            // Redirect to categories list
	            $location.path('/settings/categories');
	        })
	        // Catch and handle errors
	        .catch(handleResponseErrors);
	    }
	
	    function updateChildrenPermissions(category) {
	        var promises = [];
	        _.each(category.children, function (child) {
	            promises.push(TagEndpoint.saveCache({ id: child.id, role: category.role }).$promise);
	        });
	        return $q.all(promises);
	    }
	
	    function updateWithParentPermissions(category) {
	        return TagEndpoint.getFresh({ id: category.parent.id }).$promise.then(function (parent) {
	            return TagEndpoint.saveCache({ id: category.id, role: parent.role }).$promise;
	        });
	    }
	
	    function deleteCategory(category) {
	        Notify.confirmDelete('notify.category.destroy_confirm', 'notify.category.destroy_confirm_desc').then(function () {
	            return TagEndpoint.delete({ id: category.id }).$promise.then(function () {
	                Notify.notify('notify.category.destroy_success');
	                $location.url('/settings/categories');
	            });
	        }).catch(handleResponseErrors);
	    }
	
	    function handleResponseErrors(errorResponse) {
	        $scope.processing = false;
	        Notify.apiErrors(errorResponse);
	    }
	
	    function cancel() {
	        $location.path('/settings/categories');
	    }
	}];

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div> <div class=\"mode-context init\" dropdown> <header class=mode-context-header> <ol class=breadcrumbs> <li><a href=/ ng-controller=\"navigation as nav\">{{nav.site.name}}</a></li> <li><a href=/settings translate>app.settings</a></li> <li><a href=/settings/categories translate>app.categories</a></li> </ol> <h1 class=mode-context-title ng-show=category.id translate>app.edit_category</h1> <h1 class=mode-context-title ng-show=!category.id translate>app.add_category</h1> </header> <span class=mode-context-trigger dropdown-toggle> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> <span class=\"label hidden\" translate>app.show_more_less</span> </span> <div class=mode-context-body> </div> </div> <main role=main> <div class=toolbar> <div class=button-group> <button type=button class=button-flat ng-click=cancel() translate>app.cancel</button> <button class=button-alpha type=button ng-click=saveCategory(category) type=submit ng-disabled=form.$invalid ng-if=!processing> {{save}}</button> <button type=submit class=button-alpha disabled=disabled ng-if=processing>{{saving}} <div class=loading> <div class=line></div> <div class=line></div> <div class=line></div> </div> </button> </div> </div> <div class=full-col> <form name=form> <div class=form-sheet> <div class=\"form-field title\"> <label class=hidden translate=category.editor.name></label> <input type=text placeholder=\"{{'category.editor.name' | translate}}\" ng-minlength=3 ng-maxlength=150 ng-model=category.tag required> </div> <div class=form-field> <label translate>category.editor.description</label> <textarea name=description data-min-rows=1 rows=1 ng-maxlength=150 ng-model=category.description></textarea> </div> <fieldset class=\"custom-fieldset init\" dropdown ng-show=!isParent> <legend class=\"dropdown-trigger init active\" data-toggle=dropdown-menu dropdown-toggle> <span class=legend-label translate=app.this_category_is_child_to translate-values=\"{ parent: getParentName() }\">This category is a child to</span> <svg class=\"iconic chevron\"> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> </legend> <div class=\"dropdown-menu init\" dropdown-menu> <div class=\"form-field radio\"> <label for=parent_label-nothing> <input type=radio name=parent_label id=parent_label-nothing ng-value=null ng-checked=\"category.parent_id === null\" ng-model=category.parent_id /> <span translate=app.nothing>Nothing</span> </label> </div> <div class=\"form-field radio\" ng-repeat=\"parent in parents\"> <label for=parent_label-{{parent.id}}> <input type=radio name=parent_label id=parent_label-{{parent.id}} ng-checked=\"parent.id === category.parent_id\" ng-value=parent.id ng-model=category.parent_id /> {{parent.tag}} </label> </div> </div> </fieldset> <role-selector model=category title=\"'app.who_can_see_this_category'\" ng-show=!category.parent_id></role-selector> <div class=form-field ng-show=category.parent_id> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#people></use> </svg> <span translate>category.child_permissions</span> </div> </div> </form> <div class=form-sheet ng-show=category.id> <div class=form-sheet-summary> <h3 class=form-sheet-title translate>category.delete_this_category</h3> </div> <div class=form-field> <p translate>category.delete_category_desc</p> <button class=button-destructive ng-click=deleteCategory(category)> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#trash></use> </svg> <span class=button-label translate>category.delete_category</span> </button> </div> </div> </div> </main> </div> ";

/***/ }),
/* 872 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$scope', '$rootScope', '$translate', '$q', '$location', '_', '$window', 'Session', 'UserEndpoint', 'RoleEndpoint', 'Notify', function ($scope, $rootScope, $translate, $q, $location, _, $window, Session, UserEndpoint, RoleEndpoint, Notify) {
	
	    // Redirect to home if not authorized
	    if ($rootScope.hasManageSettingsPermission() === false) {
	        return $location.path('/');
	    }
	
	    var handleResponseErrors, checkAndNotifyAboutManipulateOwnUser;
	    $rootScope.setLayout('layout-a');
	    $translate('tool.manage_users').then(function (title) {
	        $scope.title = title;
	        $scope.$emit('setPageTitle', title);
	    });
	
	    RoleEndpoint.query().$promise.then(function (roles) {
	        $scope.roles = _.indexBy(roles, 'name');
	    });
	
	    $scope.filters = {
	        role: [],
	        q: ''
	    };
	
	    $scope.selectedUsers = [];
	
	    $scope.isToggled = function (user) {
	        return $scope.selectedUsers.indexOf(user.id) > -1;
	    };
	
	    $scope.toggleUser = function (user) {
	        var idx = $scope.selectedUsers.indexOf(user.id);
	        if (idx > -1) {
	            $scope.selectedUsers.splice(idx, 1);
	        } else {
	            $scope.selectedUsers.push(user.id);
	        }
	    };
	
	    handleResponseErrors = function handleResponseErrors(errorResponse) {
	        Notify.apiErrors(errorResponse);
	    };
	
	    checkAndNotifyAboutManipulateOwnUser = function checkAndNotifyAboutManipulateOwnUser(translationKey) {
	        var currentUserId = Session.getSessionDataEntry('userId');
	        if (_.contains($scope.selectedUsers, currentUserId)) {
	            Notify.error(translationKey);
	            return true;
	        }
	        return false;
	    };
	
	    $scope.addUser = function () {
	        $location.path('/settings/users/create');
	    };
	
	    $scope.deleteUsers = function () {
	
	        if (checkAndNotifyAboutManipulateOwnUser('user.cannot_delete_yourself')) {
	            return;
	        }
	        Notify.confirmDelete('notify.user.bulk_destroy_confirm', {
	            count: $scope.selectedUsers.length
	        }).then(function () {
	            var calls = [];
	            angular.forEach($scope.selectedUsers, function (userId) {
	                calls.push(UserEndpoint.delete({ id: userId }).$promise);
	            });
	
	            $q.all(calls).then(function () {
	                Notify.notify('notify.user.bulk_destroy_success');
	                $scope.getUsersForPagination();
	            }, handleResponseErrors).finally($scope.filterRole);
	        }, function () {});
	    };
	
	    $scope.changeRole = function (role) {
	        if (checkAndNotifyAboutManipulateOwnUser('user.cannot_change_your_own_role')) {
	            return;
	        }
	
	        Notify.confirm('notify.user.bulk_role_change_confirm', {
	            count: $scope.selectedUsers.length,
	            role: role.display_name
	        }).then(function () {
	            var calls = [];
	            angular.forEach($scope.selectedUsers, function (userId) {
	                calls.push(UserEndpoint.saveCache({ id: userId, role: role.name }).$promise);
	            });
	            $q.all(calls).then(function () {
	                Notify.notify('notify.user.bulk_role_change_success', { role_name: role.name });
	                $scope.getUsersForPagination();
	            }, handleResponseErrors).finally($scope.filterRole);
	        });
	    };
	
	    $scope.itemsPerPageChanged = function (count) {
	        $scope.itemsPerPage = count;
	        $scope.getUsersForPagination();
	    };
	
	    // // hydrate!
	    // $scope.users = UserEndpoint.query();
	
	
	    // --- start: definitions
	    $scope.getUsersForPagination = function () {
	        var filters = _.extend({
	            offset: ($scope.currentPage - 1) * $scope.itemsPerPage,
	            limit: $scope.itemsPerPage,
	            orderby: 'realname'
	        }, $scope.filters);
	        UserEndpoint.queryFresh(filters).$promise.then(function (usersResponse) {
	            $scope.users = usersResponse.results;
	            $scope.totalItems = usersResponse.total_count;
	        });
	    };
	
	    $scope.pageChanged = $scope.getUsersForPagination;
	    $scope.applyFilters = function () {
	        $scope.getUsersForPagination();
	    };
	    // --- end: definitions
	
	
	    // --- start: initialization
	    $scope.filteredRole = '';
	    $scope.currentPage = 1;
	    $scope.itemsPerPageOptions = [10, 20, 50];
	    $scope.itemsPerPage = $scope.itemsPerPageOptions[0];
	    // untill we have the correct total_count value from backend request:
	    $scope.totalItems = $scope.itemsPerPage;
	
	    $scope.getUsersForPagination();
	    // --- end: initialization
	    $scope.$watch('filters', function () {
	        $scope.getUsersForPagination();
	    }, true);
	}];

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div> <div class=\"mode-context init\" dropdown> <header class=mode-context-header> <ol class=breadcrumbs> <li><a href=/ ng-controller=\"navigation as nav\">{{nav.site.name}}</a></li> <li><a href=/settings translate>app.settings</a></li> </ol> <h1 class=mode-context-title translate>app.users</h1> </header> <span class=mode-context-trigger dropdown-toggle> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> <span class=\"label hidden\" translate>app.show_more_less</span> </span> </div> <main role=main> <div class=toolbar> <div class=fab> <a ng-href=/settings/users/create type=button class=\"button button-alpha button-fab\" ng-class=\"{'disabled': selectedUsers.length}\"> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#plus></use> </svg> <span class=hidden translate>user.add_user</span> </a> </div> <filter-users filters=filters></filter-users> <div class=button-group ng-show=todo> <button type=button> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#external-link></use> </svg> <span class=button-label translate>nav.export</span> </button> </div> </div> <div class=main-col> <div class=\"listing card\" ng-class=\"{'toolbar-active': selectedUsers.length}\"> <div class=alert ng-hide=users.length> <p ng-hide=users.length><em translate>empty.user</em></p> </div> <div id=user-{{user.id}} class=listing-item ng-repeat=\"user in users | orderBy:'realname'\" ng-class=\"{ 'warning': isToggled(user) }\" ng-click=toggleUser(user)> <div class=listing-item-select> <input type=checkbox value={{user.id}} ng-checked=isToggled(user)> </div> <div class=listing-item-primary> <div class=listing-item-image> <img class=avatar ng-src=\"https://www.gravatar.com/avatar/{{ user.gravatar || '00000000000000000000000000000000' }}?d=retro\" alt=\"{{ user.realname }}\"> </div> <h2 class=listing-item-title><a ng-href=/settings/users/{{user.id}}>{{user.realname}}</a></h2> <p class=listing-item-secondary>{{ roles[user.role].display_name }}</p> </div> </div> <listing-toolbar entities=users selected-set=selectedUsers> <fieldset class=\"custom-fieldset init\" dropdown> <legend class=\"dropdown-trigger init\" data-toggle=dropdown-menu dropdown-toggle> <span class=legend-label translate> user.change_role </span> <svg class=\"iconic chevron\"> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> </legend> <div class=\"dropdown-menu init\" dropdown-menu> <div class=\"form-field radio\" ng-repeat=\"role in roles\"> <label> <input type=radio name=role ng-click=changeRole(role)> {{role.display_name}} </label> </div> </div> </fieldset> <button type=button class=button-destructive ng-disabled=!selectedUsers.length ng-click=deleteUsers()> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#trash></use> </svg> <span class=\"button-label hidden\">nav.delete</span> </button> </listing-toolbar> </div> <uib-pagination ng-model=currentPage items-per-page=itemsPerPage total-items=totalItems ng-change=pageChanged() max-size=5 boundary-links=false rotate=false></uib-pagination> </div> </main> </div> ";

/***/ }),
/* 874 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$scope', '$rootScope', '$translate', '$location', '$route', 'UserEndpoint', 'Notify', '_', 'RoleEndpoint', function ($scope, $rootScope, $translate, $location, $route, UserEndpoint, Notify, _, RoleEndpoint) {
	
	    // Redirect to home if not authorized
	    if ($rootScope.hasManageSettingsPermission() === false) {
	        return $location.path('/');
	    }
	
	    $translate('user.add_user').then(function (title) {
	        $scope.title = title;
	        $rootScope.$emit('setPageTitle', title);
	    });
	
	    $scope.passwordShown = true;
	    $scope.user = { role: 'user' }; // @todo don't hardcode default role
	    $scope.save = $translate.instant('app.save');
	    $scope.saving = $translate.instant('app.saving');
	    $scope.saving_user = false;
	    $scope.saveUser = function (user, addAnother) {
	        $scope.saving_user = true;
	        var whereToNext = '/settings/users';
	
	        UserEndpoint.saveCache(user).$promise.then(function (response) {
	            if (response.id) {
	                Notify.notify('notify.user.save_success', { name: user.realname });
	                $scope.saving_user = false;
	                $scope.userSavedUser = true;
	                $scope.user.id = response.id;
	                addAnother ? $route.reload() : $location.path(whereToNext);
	            }
	        }, function (errorResponse) {
	            // error
	            var validationErrors = [],
	                limitError = false;
	            // @todo refactor limit handling
	            _.each(errorResponse.data.errors, function (value, key) {
	                // Ultimately this should check individual status codes
	                // for the moment just check for the message we expect
	                if (value.title === 'limit::admin') {
	                    limitError = 'limit.admin_limit_reached';
	                } else {
	                    validationErrors.push(value);
	                }
	            });
	
	            if (limitError) {
	                Notify.limit(limitError);
	            } else {
	                Notify.errors(_.pluck(validationErrors, 'message'));
	            }
	            $scope.saving_user = false;
	        });
	    };
	
	    $scope.cancel = function () {
	        $location.path('/settings/users');
	    };
	
	    RoleEndpoint.query().$promise.then(function (roles) {
	        $scope.roles = _.indexBy(roles, 'name');
	    });
	}];

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div> <div class=\"mode-context init\" dropdown> <header class=mode-context-header> <ol class=breadcrumbs> <li><a href=/ ng-controller=\"navigation as nav\">{{nav.site.name}}</a></li> <li><a href=/settings translate>app.settings</a></li> <li><a href=/settings/users translate>app.users</a></li> </ol> <h1 class=mode-context-title ng-show=user.id translate>app.edit_user</h1> <h1 class=mode-context-title ng-show=!user.id translate>app.add_user</h1> </header> <span class=mode-context-trigger dropdown-toggle> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> <span class=\"label hidden\" translate>app.show_more_less</span> </span> </div> <main role=main> <div custom-users-editor class=main-col> <div class=toolbar> <div class=button-group> <button type=button class=button-flat ng-click=cancel() translate>app.cancel</button> <button class=button-alpha type=button ng-click=saveUser(user) type=submit ng-disabled=form.$invalid ng-if=!saving_user>{{save}}</button> <button type=submit class=button-alpha disabled=disabled ng-if=saving_user>{{saving}} <div class=loading> <div class=line></div> <div class=line></div> <div class=line></div> </div> </button> </div> </div> <form name=form> <div class=form-sheet> <div class=\"form-field title\" ng-class=\"{ 'error': form.full_name.$invalid && form.full_name.$dirty }\"> <label class=hidden translate>user.full_name</label> <input type=text placeholder=\"{{'user_create.full_name' | translate}}\" ng-maxlength=150 ng-model=user.realname name=full_name required> <div ng-repeat=\"(error, value) in form.full_name.$error\" ng-show=form.full_name.$dirty class=\"alert error\"> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#warning></use> </svg> <span translate=\"{{'user.valid.full_name.' + error}}\" translate-default={{error}}></span> </div> </div> <div class=form-field ng-class=\"{ 'error': form.email.$invalid && form.email.$dirty }\"> <label class=hidden translate>user.email</label> <input type=email placeholder=\"{{'user_create.email' | translate}}\" ng-maxlength=150 ng-model=user.email name=email required> <div ng-repeat=\"(error, value) in form.email.$error\" ng-show=form.email.$dirty class=\"alert error\"> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#warning></use> </svg> <span translate=\"{{'user.valid.email.' + error}}\" translate-default={{error}}></span> </div> </div> <div class=form-field ng-class=\"{ 'error': form.password.$invalid && form.password.$dirty }\"> <label class=hidden translate>user.password</label> <a class=\"button button-flat\" ng-show=!passwordShown ng-click=showPassword() translate>user.update_password</a> <input type=password ng-show=passwordShown placeholder=\"{{'user.password' | translate}}\" ng-minlength=7 ng-maxlength=72 ng-model=user.password name=password ng-required=!user.id> <div ng-repeat=\"(error, value) in form.password.$error\" ng-show=form.password.$dirty class=\"alert error\"> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#warning></use> </svg> <span translate=\"{{'user.valid.password.' + error}}\" translate-default={{error}}></span> </div> </div> <fieldset class=\"custom-fieldset init\" dropdown> <legend class=\"dropdown-trigger init\" data-toggle=dropdown-menu dropdown-toggle> <span class=legend-label translate> user.role </span> <span class=legend-label ng-show=user.role> {{ roles[user.role].display_name }} </span> <svg class=\"iconic chevron\"> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> </legend> <div class=\"dropdown-menu init\" dropdown-menu> <div class=\"form-field radio\" ng-repeat=\"role in roles\"> <input type=radio id=role{{role.id}} name=role ng-model=user.role ng-value=role.name required> <label for=role{{role.id}}> {{role.display_name}} </label> </div> </div> </fieldset> </div> <div class=form-sheet ng-show=user.id> <div class=form-sheet-summary> <h3 class=form-sheet-title translate>user.delete_user</h3> </div> <div class=form-field> <p translate>user.delete_user_desc</p> <button class=button-destructive ng-click=deleteUser(user)> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#trash></use> </svg> <span class=button-label translate>user.delete_user</span> </button> </div> </div> </form> </div> </main> </div> ";

/***/ }),
/* 876 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$scope', '$rootScope', '$translate', '$location', '$routeParams', 'UserEndpoint', 'Notify', '_', 'RoleEndpoint', 'Session', function ($scope, $rootScope, $translate, $location, $routeParams, UserEndpoint, Notify, _, RoleEndpoint, Session) {
	
	    // Redirect to home if not authorized
	    if ($rootScope.hasManageSettingsPermission() === false) {
	        return $location.path('/');
	    }
	
	    $translate('user.edit_user').then(function (title) {
	        $scope.title = title;
	        $scope.$emit('setPageTitle', title);
	    });
	
	    $scope.passwordShown = true;
	    $scope.save = $translate.instant('app.save');
	    $scope.saving = $translate.instant('app.saving');
	    $scope.saving_user = false;
	
	    UserEndpoint.getFresh({ id: $routeParams.id }).$promise.then(function (user) {
	        $scope.$emit('setPageTitle', $scope.title + ' - ' + user.realname);
	        $scope.user = user;
	        $scope.passwordShown = false;
	    });
	
	    $scope.showPassword = function () {
	        $scope.passwordShown = true;
	    };
	
	    $scope.saveUser = function (user) {
	        $scope.saving_user = true;
	        UserEndpoint.saveCache(user).$promise.then(function (response) {
	            if (response.id) {
	                Notify.notify('notify.user.edit_success', { name: user.realname });
	                $scope.saving_user = false;
	                $scope.userSavedUser = true;
	                $scope.user.id = response.id;
	            }
	            $location.path('/settings/users');
	        }, function (errorResponse) {
	            // error
	            var validationErrors = [],
	                limitError = false;
	            // @todo refactor limit handling
	            _.each(errorResponse.data.errors, function (value, key) {
	                // Ultimately this should check individual status codes
	                // for the moment just check for the message we expect
	                if (value.title === 'limit::admin') {
	                    limitError = 'limit.admin_limit_reached';
	                } else {
	                    validationErrors.push(value);
	                }
	            });
	
	            if (limitError) {
	                Notify.limit(limitError);
	            } else {
	                Notify.errors(_.pluck(validationErrors, 'message'));
	            }
	            $scope.saving_user = false;
	        });
	    };
	
	    var handleResponseErrors = function handleResponseErrors(errorResponse) {
	        Notify.apiErrors(errorResponse);
	    };
	
	    var checkAndNotifyAboutManipulateOwnUser = function checkAndNotifyAboutManipulateOwnUser(translationKey) {
	        var currentUserId = Session.getSessionDataEntry('userId');
	        if (_.contains($scope.selectedUsers, currentUserId)) {
	            Notify.error(translationKey);
	            return true;
	        }
	        return false;
	    };
	
	    $scope.deleteUser = function (user) {
	        if (checkAndNotifyAboutManipulateOwnUser('user.cannot_delete_yourself')) {
	            return;
	        }
	        Notify.confirmDelete('notify.user.destroy_confirm').then(function () {
	            UserEndpoint.delete({ id: user.id }).$promise.then(function () {
	                Notify.notify('notify.user.destroy_success');
	            }, handleResponseErrors);
	            $location.url('/settings/users');
	        }, function () {});
	    };
	
	    $scope.cancel = function () {
	        $location.path('/settings/users');
	    };
	
	    RoleEndpoint.query().$promise.then(function (roles) {
	        $scope.roles = _.indexBy(roles, 'name');
	    });
	}];

/***/ }),
/* 877 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$scope', '$translate', '$rootScope', '$location', 'RoleEndpoint', 'PermissionEndpoint', function ($scope, $translate, $rootScope, $location, RoleEndpoint, PermissionEndpoint) {
	
	    // Redirect to home if not authorized
	    if ($rootScope.hasManageSettingsPermission() === false) {
	        return $location.path('/');
	    }
	
	    $translate('tool.manage_roles').then(function (title) {
	        $scope.title = title;
	        $scope.$emit('setPageTitle', title);
	    });
	    // Change mode
	    $scope.$emit('event:mode:change', 'settings');
	}];

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div> <div class=\"mode-context init\" dropdown> <header class=mode-context-header> <ol class=breadcrumbs> <li><a href=/ ng-controller=\"navigation as nav\">{{nav.site.name}}</a></li> <li><a href=/settings translate>app.settings</a></li> </ol> <h1 class=mode-context-title translate>app.roles</h1> </header> <span class=mode-context-trigger dropdown-toggle> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> <span class=\"label hidden\" translate>app.show_more_less</span> </span> </div> <main role=main> <div class=toolbar> <div class=fab ng-show=rolesEnabled> <a ng-href=/settings/roles/create type=button class=\"button button-alpha button-fab\"> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#plus></use> </svg> <span class=hidden translate>role.add_role</span> </a> </div> </div> <div custom-roles class=main-col> <div class=alert ng-show=!rolesEnabled translate=feature_limits.view_unavailable translate-values=\"{value: 'Custom roles'}\"></div> <div class=alert ng-hide=roles.length> <p ng-hide=roles.length><em translate>empty.role</em></p> </div> <div class=\"listing card\" ng-show=roles.length ng-show=rolesEnabled> <div class=listing-item ng-repeat=\"role in roles | orderBy:'role'\"> <div class=listing-item-primary> <h2 class=listing-item-title><a ng-href=/settings/roles/{{role.id}}>{{role.display_name}}</a></h2> </div> </div> </div> <uib-pagination ng-model=currentPage items-per-page=itemsPerPage total-items=totalItems ng-change=pageChanged() max-size=5 boundary-links=false rotate=false></uib-pagination> </div> </main> </div> ";

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div> <div class=\"mode-context init\" dropdown> <header class=mode-context-header> <ol class=breadcrumbs> <li><a href=/ ng-controller=\"navigation as nav\">{{nav.site.name}}</a></li> <li><a href=/settings translate>app.settings</a></li> <li><a href=/settings/roles translate>app.roles</a></li> </ol> <h1 class=mode-context-title ng-show=role.id translate>app.edit_role</h1> <h1 class=mode-context-title ng-show=!role.id translate>app.add_role</h1> </header> <span class=mode-context-trigger dropdown-toggle> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> <span class=\"label hidden\" translate>app.show_more_less</span> </span> </div> <main role=main> <div custom-roles-editor class=main-col> <div class=toolbar> <div class=button-group> <button type=button class=button-flat ng-click=cancel() translate>app.cancel</button> <button type=submit class=button-alpha ng-if=!saving_role ng-click=saveRole(role)>{{save}}</button> <button type=submit class=button-alpha disabled=disabled ng-if=saving_role>{{saving}} <div class=loading> <div class=line></div> <div class=line></div> <div class=line></div> </div> </button> </div> </div> <form> <div class=form-sheet> <div class=\"form-field title\"> <label class=hidden translate>role.name</label> <input type=text placeholder=\"{{'role.name' | translate}}\" ng-minlength=3 ng-maxlength=150 ng-model=role.display_name required> </div> <div class=form-field> <label translate>role.description</label> <textarea name=description data-min-rows=1 rows=1 ng-maxlength=150 ng-model=role.description></textarea> </div> <fieldset> <legend translate>role.permissions</legend> <div class=alert ng-hide=permissions.length> <p ng-hide=permissions.length><em translate>empty.permission</em></p> </div> <div class=\"form-field checkbox\" ng-repeat=\"permission in permissions\" ng-if=\"role.name == 'admin'\"> <label for={{permission.id}}> <input id={{permission.id}} type=checkbox disabled=disabled checked=checked> {{permission.name}} </label> </div> <div class=\"form-field checkbox\" ng-repeat=\"permission in permissions\" ng-if=\"role.name != 'admin'\"> <label for={{permission.id}}> <input id={{permission.id}} type=checkbox value=permission.name checklist-model=role.permissions checklist-value=permission.name> {{permission.name}} </label> </div> </fieldset> </div> <div ng-if=!role.protected class=form-sheet ng-show=role.id> <div class=form-sheet-summary> <h3 class=form-sheet-title translate>role.delete_role</h3> </div> <div class=form-field> <p translate>role.delete_role_desc</p> <button class=button-destructive ng-click=deleteRole(role)> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#trash></use> </svg> <span class=button-label translate>role.delete_role</span> </button> </div> </div> </form> </div> </main> </div> ";

/***/ }),
/* 880 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$scope', '$translate', '$rootScope', '$location', 'WebhookEndpoint', function ($scope, $translate, $rootScope, $location, WebhookEndpoint) {
	
	    // Redirect to home if not authorized
	    if ($rootScope.hasManageSettingsPermission() === false) {
	        return $location.path('/');
	    }
	
	    $translate('tool.manage_webhooks').then(function (title) {
	        $scope.title = title;
	        $scope.$emit('setPageTitle', title);
	    });
	    // Change mode
	    $scope.$emit('event:mode:change', 'settings');
	}];

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div> <div class=\"mode-context init\" dropdown> <header class=mode-context-header> <ol class=breadcrumbs> <li><a href=/ ng-controller=\"navigation as nav\">{{nav.site.name}}</a></li> <li><a href=/settings translate>app.settings</a></li> </ol> <h1 class=mode-context-title translate>app.webhooks</h1> </header> <span class=mode-context-trigger dropdown-toggle> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> <span class=\"label hidden\" translate>app.show_more_less</span> </span> </div> <main role=main> <div class=toolbar> <div class=fab ng-show=webhooksEnabled> <a ng-href=/settings/webhooks/create type=button class=\"button button-alpha button-fab\"> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#plus></use> </svg> <span class=hidden translate>webhook.add_webhook</span> </a> </div> </div> <div custom-webhooks class=main-col> <div class=alert ng-show=!webhooksEnabled translate=feature_limits.view_unavailable translate-values=\"{value: 'Custom webhooks'}\"></div> <div ng-show=webhooksEnabled> <div class=alert ng-hide=webhooks.length> <p ng-hide=webhooks.length><em translate>empty.webhook</em></p> </div> <div class=\"listing card\" ng-show=webhooks.length> <div class=listing-item ng-repeat=\"webhook in webhooks | orderBy:'webhook'\"> <div class=listing-item-primary> <h2 class=listing-item-title><a ng-href=/settings/webhooks/{{webhook.id}}>{{webhook.name}}</a></h2> </div> </div> </div> <uib-pagination ng-model=currentPage items-per-page=itemsPerPage total-items=totalItems ng-change=pageChanged() max-size=5 boundary-links=false rotate=false></uib-pagination> </div> </div> </main> </div> ";

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div> <div class=\"mode-context init\" dropdown> <header class=mode-context-header> <ol class=breadcrumbs> <li><a href=/ ng-controller=\"navigation as nav\">{{nav.site.name}}</a></li> <li><a href=/settings translate>app.settings</a></li> <li><a href=/settings/webhooks translate>app.webhooks</a></li> </ol> <h1 class=mode-context-title ng-show=webhook.id translate>app.edit_webhook</h1> <h1 class=mode-context-title ng-show=!webhook.id translate>app.add_webhook</h1> </header> <span class=mode-context-trigger dropdown-toggle> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> <span class=\"label hidden\" translate>app.show_more_less</span> </span> </div> <main role=main> <div custom-webhooks-editor class=main-col> <div class=toolbar> <div class=button-group> <button type=button class=button-flat ng-click=cancel() translate>app.cancel</button> <button class=button-alpha type=button ng-click=saveWebhook(webhook) type=submit ng-disabled=form.$invalid ng-if=!processing>{{save}}</button> <button type=submit class=button-alpha disabled=disabled ng-if=processing>{{saving}} <div class=loading> <div class=line></div> <div class=line></div> <div class=line></div> </div> </button> </div> </div> <form name=form> <div class=form-sheet> <div class=\"form-field title\"> <label class=hidden translate>webhook.name</label> <input type=text placeholder=\"{{'webhook.name' | translate}}\" ng-minlength=3 ng-maxlength=150 ng-model=webhook.name required> </div> <div class=form-field> <label translate>webhook.shared_secret</label> <textarea name=description data-min-rows=1 rows=1 ng-model=webhook.shared_secret required></textarea> </div> <div class=form-field> <label translate>webhook.url</label> <input type=text placeholder=\"{{'webhook.url' | translate}}\" ng-model=webhook.url required> </div> <div class=form-field> <label translate>webhook.event_type</label> <div class=custom-select> <select ng-model=webhook.event_type required> <option ng-repeat=\"type in event_types\" value={{type}}>{{type}}</option> </select> </div> </div> <div class=form-field> <label translate>webhook.entity_type</label> <div class=custom-select> <select ng-model=webhook.entity_type required> <option ng-repeat=\"type in entity_types\" value={{type}}>{{type}}</option> </select> </div> </div> </div> <div ng-if=!webhook.protected class=form-sheet ng-show=webhook.id> <div class=form-sheet-summary> <h3 class=form-sheet-title translate>webhook.delete_webhook</h3> </div> <div class=form-field> <p translate>webhook.delete_webhook_desc</p> <button class=button-destructive ng-click=deleteWebhook(webhook)> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#trash></use> </svg> <span class=button-label translate>webhook.delete_webhook</span> </button> </div> </div> </form> </div> </main> </div> ";

/***/ }),
/* 883 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$q', '$scope', '$rootScope', '$location', '$translate', 'ConfigEndpoint', 'DataProviderEndpoint', 'Notify', '_', 'Features', function ($q, $scope, $rootScope, $location, $translate, ConfigEndpoint, DataProviderEndpoint, Notify, _, Features) {
	
	    // Redirect to home if not authorized
	    if ($rootScope.hasManageSettingsPermission() === false) {
	        return $location.path('/');
	    }
	
	    // Change layout class
	    $rootScope.setLayout('layout-c');
	    // Change mode
	    $scope.$emit('event:mode:change', 'settings');
	
	    // Displays a loading indicator when busy querying endpoints.
	    $scope.saving = false;
	    $scope.settings = {};
	    $scope.available_providers = [];
	    $scope.forms = {};
	    $scope.formsSubmitted = {};
	    $scope.panelVisible = {};
	
	    // Translate and set page title.
	    $translate('settings.data_sources.data_sources').then(function (title) {
	        $scope.title = title;
	        $scope.$emit('setPageTitle', title);
	    });
	
	    $scope.saveProviderSettings = function (provider) {
	        if ($scope.saving) {
	            return false;
	        }
	
	        var form = $scope.forms[provider];
	
	        if (form.$valid) {
	            $scope.saving = true;
	
	            // Enable data provider when saved for the first time
	            if (!$scope.savedProviders[provider]) {
	                $scope.settings.providers[provider] = true;
	            }
	
	            $scope.settings.id = 'data-provider';
	            ConfigEndpoint.saveCache($scope.settings).$promise.then(function (result) {
	                $scope.saving = false;
	                Notify.notify('notify.datasource.save_success');
	
	                // Track saved provider
	                addSavedProvider(provider);
	            }, function (errorResponse) {
	                // error
	                Notify.apiErrors(errorResponse);
	            });
	
	            // No errors found; disable this.
	            $scope.formsSubmitted[provider] = false;
	        } else {
	            // Force the accordian group for the form is pop open, to display field errors.
	            $scope.formsSubmitted[provider] = true;
	            $scope.panelVisible[provider] = true;
	        }
	    };
	
	    var addSavedProvider = function addSavedProvider(provider) {
	        if (!$scope.savedProviders[provider]) {
	            $scope.savedProviders[provider] = true;
	        }
	    };
	
	    $q.all([DataProviderEndpoint.queryFresh().$promise, ConfigEndpoint.get({ id: 'data-provider' }).$promise]).then(function (response) {
	        $scope.providers = response[0];
	        $scope.settings = response[1];
	
	        // Keep track of providers with saved settings
	        $scope.savedProviders = {};
	
	        _.forEach($scope.providers.results, function (provider) {
	            if ($scope.settings[provider.id]) {
	                addSavedProvider(provider.id);
	            }
	        });
	    });
	
	    Features.loadFeatures().then(function (features) {
	        $scope.available_providers = features['data-providers'];
	    });
	}];

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div> <div class=\"mode-context init\" dropdown> <header class=mode-context-header> <ol class=breadcrumbs> <li><a href=/ ng-controller=\"navigation as nav\">{{nav.site.name}}</a></li> <li><a href=/settings translate>app.settings</a></li> </ol> <h1 class=mode-context-title translate>app.data_sources</h1> </header> <span class=mode-context-trigger dropdown-toggle> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> <span class=\"label hidden\" translate>app.show_more_less</span> </span> </div> <main role=main> <div class=main-col> <div class=alert> <p><em translate>settings.data_sources.hint_turn_on_off</em></p> </div> <div class=\"listing card\"> <div class=\"listing-item active\" ng-repeat=\"provider in providers.results | orderBy:'name'\" is-open=panelVisible[provider.id] dropdown auto-close=disabled ng-if=available_providers[provider.id]> <div class=listing-item-secondary> <button type=button class=\"button-beta button-flat listing-item-toggle\" dropdown-toggle> <svg class=iconic> <use xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> <span class=button-label translate>settings.data_sources.configure</span> </button> </div> <div class=listing-item-primary> <h2 class=listing-item-title> {{provider.name}} <span class=status-indicator ng-class=\"{ 'green' : available_providers[provider.id] && settings.providers[provider.id] }\"></span> </h2> </div> <div class=listing-item-body dropdown-menu> <div class=\"alert error\" ng-if=forms[provider.id].$invalid> <p translate>settings.data_sources.hint_plugin_needs_configuring</p> </div> <div class=alert ng-if=!available_providers[provider.id]> <p translate translate-values=\"{value: '{{provider.name}}'}\"> settings.data_sources.unavailable </p> </div> <form name=forms.{{provider.id}} ng-submit=saveProviderSettings(provider.id) ng-if=available_providers[provider.id]> <div class=\"form-field switch\" ng-if=forms[provider.id].$valid> <label translate>settings.data_sources.enable_provider_message</label> <div class=toggle-switch> <input class=tgl id={{provider.id}}_enable type=checkbox ng-model=settings.providers[provider.id] ng-change=saveProviderSettings(provider.id)> <label class=tgl-btn for={{provider.id}}_enable></label> </div> </div> <div ng-repeat=\"(option_key, option) in provider.options track by option_key\" ng-class=\"{ error : formsSubmitted[provider.id] && forms[provider.id][option_key].$invalid, 'form-field' : option.input !== 'radio', 'required' : option.rules.indexOf('required') > -1 }\"> <div class=\"\" ng-if=\"option.input == 'read-only-text'\"> <label ng-if=option.label class=input-label>{{option.label}}</label> <p ng-bind-html=option.description></p> </div> <div class=form-field ng-if=\"option.input == 'text'\"> <label ng-if=option.label> {{option.label}} </label> <p ng-if=option.description> {{option.description}} </p> <input ng-if=\"option.rules.indexOf('number') > -1\" id={{provider.id}}_{{option_key}} name={{option_key}} type=number ng-pattern=/^\\d+$/ ng-model=settings[provider.id][option_key] ng-required=\"option.rules.indexOf('required') > -1\" ng-disabled=saving ng-class=\"{error:formsSubmitted[provider.id] && forms[provider.id][option_key].$invalid}\"> <input ng-if=\"option.rules.indexOf('email') > -1\" id={{provider.id}}_{{option_key}} name={{option_key}} type=email ng-pattern=/^[a-z]+[a-z0-9._]+@[a-z]+\\.[a-z.]{2,5}$/ ng-model=settings[provider.id][option_key] ng-required=\"option.rules.indexOf('required') > -1\" ng-disabled=saving ng-class=\"{error:formsSubmitted[provider.id] && forms[provider.id][option_key].$invalid}\"> <input ng-if=\"option.rules.indexOf('password') > -1\" id={{provider.id}}_{{option_key}} name={{option_key}} type=password ng-model=settings[provider.id][option_key] ng-required=\"option.rules.indexOf('required') > -1\" ng-disabled=saving ng-class=\"{error:formsSubmitted[provider.id] && forms[provider.id][option_key].$invalid}\"> <input ng-if=\"option.rules.indexOf('number') == -1 && option.rules.indexOf('email') == -1 && option.rules.indexOf('password') == -1\" id={{provider.id}}_{{option_key}} name={{option_key}} type={{option.input}} ng-model=settings[provider.id][option_key] ng-required=\"option.rules.indexOf('required') > -1\" ng-disabled=saving ng-class=\"{error:formsSubmitted[provider.id] && forms[provider.id][option_key].$invalid}\"> </div> <fieldset ng-if=\"option.input == 'radio'\"> <label ng-if=option.label> {{option.label}} </label> <p ng-if=option.description> {{option.description}} </p> <div class=\"form-field radio\" ng-repeat=\"radio_option in option.options track by $index\"> <label for={{provider.id}}_{{option_key}}_{{$index}}> <input id={{provider.id}}_{{option_key}}_{{$index}} type={{option.input}} name={{option_key}} ng-value=radio_option ng-model=settings[provider.id][option_key] ng-required=\"option.rules.indexOf('required') > -1\" ng-disabled=saving>{{radio_option}} </label> </div> </fieldset> <div class=\"alert error\" ng-if=\"formsSubmitted[provider.id] && forms[provider.id][option_key].$invalid\"> <p translate>settings.generic_field_error</p> </div> </div> <button type=submit class=button-alpha> <div class=loading ng-show=saving> <div class=line></div> <div class=line></div> <div class=line></div> </div> <span ng-hide=saving translate>app.save</span> </button> </form> </div> </div> </div> </div> </main> </div> ";

/***/ }),
/* 885 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$scope', '$translate', '$rootScope', 'CONST', 'ConfigEndpoint', function ($scope, $translate, $rootScope, CONST, ConfigEndpoint) {
	    $rootScope.setLayout('layout-c');
	    $translate('nav.plan_settings').then(function (title) {
	        $scope.title = title;
	        $rootScope.$emit('setPageTitle', title);
	    });
	    $scope.legacyPlan = false;
	    var standardTiers = ['free', 'surveyor', 'responder'];
	
	    ConfigEndpoint.get({ id: 'site' }).$promise.then(function (site) {
	        $scope.tier = site.tier;
	        if (standardTiers.indexOf(site.tier) === -1) {
	            $scope.specialPlan = site.tier;
	        }
	    });
	    $scope.username = ($rootScope.currentUser || {}).email;
	    /* globals apiDomain, deploymentsDomain */
	    $scope.cloudDomain = typeof deploymentsDomain !== 'undefined' ? deploymentsDomain : 'ushahidi.io';
	    $scope.subdomain = typeof apiDomain !== 'undefined' ? CONST.BACKEND_URL.replace('.' + apiDomain, '').replace(/http[s]?:\/\//, '') : CONST.BACKEND_URL;
	}];

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div> <div class=\"mode-context init\" dropdown> <header class=mode-context-header> <ol class=breadcrumbs> <li><a href=/ ng-controller=\"navigation as nav\">{{nav.site.name}}</a></li> <li><a href=/settings translate>app.settings</a></li> </ol> <h1 class=mode-context-title translate>app.plans</h1> </header> <span class=mode-context-trigger dropdown-toggle> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + __webpack_require__(412) + "#chevron-bottom></use> </svg> <span class=\"label hidden\" translate>app.show_more_less</span> </span> </div> <main role=main> <div class=full-col> <div class=tiers> <div class=tier ng-if=\"specialPlan == 'free-pre-jun-2016'\"> <div class=tier-header> <h2 class=tier-name>Mapper (Legacy)</h2> <p>This is a legacy plan, you can upgrade any time.</p> <strong class=tier-price>Free</strong> </div> <div class=tier-action> <a class=\"button button-alpha\" disabled=disabled>&check; Subscribed</a> </div> <div class=tier-feature-list> <ul> <li><strong>Unlimited</strong> posts</li> <li><strong>1</strong> survey</li> <li><strong>1</strong> user</li> <li><strong>Web, email, SMS, &amp; Twitter</strong> <br/>data collection</li> <li><strong>Map &amp; timeline</strong> <br/>data visualization</li> </ul> </div> </div> <div class=tier ng-if=!specialPlan> <div class=tier-header> <h2 class=tier-name>Mapper</h2> <p>Put your cause on the map</p> <strong class=tier-price>Free</strong> </div> <div class=tier-action> <a class=\"button button-alpha\" ng-show=\"tier == 'free'\" disabled=disabled>&check; Subscribed</a> <a href=\"//{{ cloudDomain }}/settings/login?subdomain={{ subdomain }}&username={{ username }}&tier=free\" class=\"button button-alpha\" ng-hide=\"tier == 'free'\">Choose Mapper</a> </div> <div class=tier-feature-list> <ul> <li><strong>Unlimited</strong> posts</li> <li><strong>1</strong> survey</li> <li><strong>1</strong> user</li> <li><strong>Web &amp; email</strong> <br/>data collection</li> <li><strong>Map &amp; timeline</strong> <br/>data visualization</li> </ul> </div> </div> <div class=tier> <div class=tier-header> <h2 class=tier-name>Surveyor</h2> <p>Collect and monitor data</p> <strong class=tier-price>$99 <em>/mo</em> </strong> </div> <div class=tier-action> <a href=\"//{{ cloudDomain }}/settings/login?subdomain={{ subdomain }}&username={{ username }}&tier=surveyor\" class=\"button button-alpha\" ng-show=\"tier == 'surveyor'\" disabled=disabled>&check; Subscribed</a> <a href=\"//{{ cloudDomain }}/settings/login?subdomain={{ subdomain }}&username={{ username }}&tier=surveyor\" class=\"button button-alpha\" ng-hide=\"tier == 'surveyor'\" data-modal=payment>Choose Surveyor</a> </div> <div class=tier-feature-list> <ul> <li><strong>Unlimited</strong> posts</li> <li><strong>Unlimited</strong> surveys</li> <li><strong>5</strong> users <em>+ $10/mo per additional user</em></li> <li><strong>Web, email, SMS, &amp; Twitter</strong> <br/>data collection</li> <li><strong>Map, timeline, bar chart, &amp; line chart</strong> <br/>data visualization</li> <li><strong>Import &amp; Export</strong> data</li> </ul> </div> </div> <div class=tier> <div class=tier-header> <h2 class=tier-name>Responder</h2> <p>Respond to real-time incidents as a team</p> <strong class=tier-price>$499 <em>/mo</em> </strong> </div> <div class=tier-action> <a href=\"//{{ cloudDomain }}/settings/login?subdomain={{ subdomain }}&username={{ username }}&tier=responder\" class=\"button button-alpha\" ng-show=\"tier == 'responder'\" disabled=disabled>&check; Subscribed</a> <a ng-hide=\"tier == 'responder'\" class=\"button button-alpha\" href=\"//{{ cloudDomain }}/settings/login?subdomain={{ subdomain }}&username={{ username }}&tier=responder\">Choose Responder</a> </div> <div class=tier-feature-list> <ul> <li><strong>Unlimited</strong> posts</li> <li><strong>Unlimited</strong> surveys</li> <li><strong>25</strong> users <em>+ $10/mo per additional user</em></li> <li><strong>Web, email, SMS, &amp; Twitter</strong> <br/>data collection</li> <li><strong>Map, timeline, bar chart, &amp; line chart</strong> <br/>data visualization</li> <li><strong>Import &amp; Export</strong> data</li> <li><strong>Custom roles</strong> and permissions</li> <li><strong>Private</strong> deployments</li> </ul> </div> </div> <div class=tier ng-if=\"specialPlan == 'zerorated'\"> <div class=tier-header> <h2 class=tier-name>Social Impact</h2> <p>Grassroots organizations, individuals and community groups with a mission</p> <strong class=tier-price>Free</strong> </div> <div class=tier-action> <a class=\"button button-alpha\" disabled=disabled>&check; Subscribed</a> </div> <div class=tier-feature-list> <ul> <li><strong>Unlimited</strong> posts</li> <li><strong>Unlimited</strong> surveys</li> <li><strong>25</strong> users</li> <li><strong>Web, email, SMS, &amp; Twitter</strong> <br/>data collection</li> <li><strong>Map, timeline, bar chart, &amp; line chart</strong> <br/>data visualization</li> <li><strong>Import &amp; Export</strong> data</li> <li><strong>Custom roles</strong> and permissions</li> <li><strong>Private</strong> deployments</li> </ul> </div> </div> <div class=tier ng-if=\"specialPlan == 'zerorated-surveyor'\"> <div class=tier-header> <h2 class=tier-name>Social Impact</h2> <p>Grassroots organizations, individuals and community groups with a mission</p> <strong class=tier-price>Free</strong> </div> <div class=tier-action> <a class=\"button button-alpha\" disabled=disabled>&check; Subscribed</a> </div> <div class=tier-feature-list> <ul> <li><strong>Unlimited</strong> posts</li> <li><strong>Unlimited</strong> surveys</li> <li><strong>5</strong> users</li> <li><strong>Web, email, SMS, &amp; Twitter</strong> <br/>data collection</li> <li><strong>Map, timeline, bar chart, &amp; line chart</strong> <br/>data visualization</li> <li><strong>Import &amp; Export</strong> data</li> </ul> </div> </div> <div class=tier> <div class=tier-header> <h2 class=tier-name>Solutions</h2> <p>Enterprise service from the data crowdsourcing experts</p> <h3 class=tier-feature>Contact us about a custom solution for your project</h3> </div> <form id=form7 name=form7 class=\"wufoo topLabel tier-form\" accept-charset=UTF-8 autocomplete=off enctype=multipart/form-data method=post novalidate action=https://ushah.wufoo.com/forms/pb6wq340260j75/#public> <div class=form-field> <label class=desc id=title1 for=Field1>Your name <span id=req_1 class=req>*</span></label> <input placeholder=\"Your name\" id=Field1 name=Field1 type=text class=\"field text medium\" value=\"\" maxlength=255 tabindex=1 onkeyup=\"\" required> </div> <div class=form-field> <label class=\"desc nodisplay\" id=title2 for=Field2>Your email <span id=req_2 class=req>*</span></label> <input placeholder=you@organization.com id=Field2 name=Field2 type=email spellcheck=false class=\"field text medium\" value=\"\" maxlength=255 tabindex=2 required> </div> <div class=form-field> <label class=\"desc nodisplay\" id=title3 for=Field3>Your organization</label> <input placeholder=\"Your organization\" id=Field3 name=Field3 type=text class=\"field text medium\" value=\"\" maxlength=255 tabindex=3 onkeyup=\"\"> </div> <div class=form-field> <button id=saveForm name=saveForm class=\"button btTxt submit\" type=submit>Continue</button> </div> <div class=nodisplay> <label for=comment>Do Not Fill This Out</label> <textarea name=comment id=comment rows=1 cols=1></textarea> <input type=hidden id=idstamp name=idstamp value=\"zkhl5vdgevIPMx9QV0j5WIpon8aq8lW5GuXOYyAWb/k=\"> </div> </form> <div class=tier-feature-list> <p><em>Projects include all Responder features, plus:</em></p> <ul> <li><strong>Unlimited</strong> users</li> <li><strong>Secure</strong> private server</li> <li><strong>Setup</strong> and training</li> <li><strong>Custom feature</strong> development</li> </ul> </div> </div> </div> </div> </main> </div> ";

/***/ }),
/* 887 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "794fdb644430b318ed4a3bebf79e3db4.svg";

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d2eae2774c1948a13da28e2ca9bf09ac.svg";

/***/ })
]);


// WEBPACK FOOTER //
// app.6e6803a8dd8b6119278f.bundle.js